
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5nRL1", function(module, exports) {

$parcel$export(module.exports, "collectSSRPlaceholderDimensions", () => $b8b2d306bbe1b8cb$export$aee7516e57289027);
// lightweight script to scan the SSR response and collect all elements with data-ssr-placeholder attribute
// and save their size/positions in a map __SSR_PLACEHOLDERS_DIMENSIONS__ on the Window object. Each placeholderId is
// unique and maps to its corresponding elements bounding client rectangle dimensions.
function $b8b2d306bbe1b8cb$export$aee7516e57289027(document, window, enablePageLayoutPlaceholder = false) {
    const ssrPlaceholders = document?.querySelectorAll('[data-ssr-placeholder]');
    ssrPlaceholders.forEach((elem)=>{
        const placeholderId = elem.getAttribute('data-ssr-placeholder');
        const boundingClient = elem.getBoundingClientRect();
        if (placeholderId) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__[placeholderId] = boundingClient;
        }
    });
    if (enablePageLayoutPlaceholder) {
        const pageLayoutRoot = document?.getElementById('unsafe-design-system-page-layout-root');
        if (pageLayoutRoot) {
            const boundingClient = pageLayoutRoot.getBoundingClientRect();
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__['page-layout.root'] = boundingClient;
        }
    }
}

});

parcelRegister("3ay3Q", function(module, exports) {

$parcel$export(module.exports, "init", () => $726cef1959388e45$export$2cd8252107eb640b);

var $dh538 = parcelRequire("dh538");

var $baiQV = parcelRequire("baiQV");

var $53d5Q = parcelRequire("53d5Q");

var $aqLdL = parcelRequire("aqLdL");

var $jJ2Ec = parcelRequire("jJ2Ec");

var $4u5NT = parcelRequire("4u5NT");

var $gXiqn = parcelRequire("gXiqn");

var $i328h = parcelRequire("i328h");

var $2DIgf = parcelRequire("2DIgf");

var $jkXCL = parcelRequire("jkXCL");
let $726cef1959388e45$var$initialized = false;
function $726cef1959388e45$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $jkXCL.default)(onIdle);
    }
    (0, $4u5NT.sinkInteractionHandler)(sinkFn);
}
function $726cef1959388e45$var$sinkExperimentalInteractionMetrics(instance, payloadPackage) {
    function experimentalMetricsSinkFn(interactionId, interaction) {
        function experimentalMetricsOnIdle() {
            const payloadPromise = payloadPackage.createExperimentalMetricsPayload(interactionId, interaction);
            payloadPromise.then((payload)=>{
                if (payload) {
                    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                    if ((0, $dh538.fg)('enable_ufo_devtools_api_for_extra_events')) {
                        // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                        const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                        if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    }
                    instance.sendOperationalEvent(payload);
                }
            });
        }
        (0, $jkXCL.default)(experimentalMetricsOnIdle);
    }
    (0, $aqLdL.sinkExperimentalHandler)(experimentalMetricsSinkFn);
}
function $726cef1959388e45$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $4u5NT.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $jkXCL.default)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and also by Criterion
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                if ((0, $dh538.fg)('enable_ufo_devtools_api_for_extra_events')) {
                    const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                }
                instance.sendOperationalEvent(payload);
            }
        });
    });
}


function $726cef1959388e45$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    if ($726cef1959388e45$var$initialized) return;
    if ((0, $dh538.fg)('platform_ufo_report_cpu_usage')) (0, $i328h.initialisePressureObserver)();
    (0, $53d5Q.setUFOConfig)(config);
    if (config.vc?.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            disableSizeAndPositionCheck: config.vc.disableSizeAndPositionCheck
        };
        (0, $2DIgf.getVCObserver)(vcOptions).start({
            startTime: 0
        });
        (0, $4u5NT.postInteractionLog).initializeVCObserver(vcOptions);
        (0, $4u5NT.postInteractionLog).startVCObserver({
            startTime: 0
        });
        if (config?.experimentalInteractionMetrics?.enabled) (0, $aqLdL.experimentalVC).initialize(vcOptions).start({
            startTime: 0
        });
    }
    (0, $jJ2Ec.setupHiddenTimingCapture)();
    (0, $baiQV.startLighthouseObserver)();
    $726cef1959388e45$var$initialized = true;
    if ((0, $dh538.fg)('platform_ufo_enable_events_observer') || (0, $dh538.fg)('platform_ufo_enable_interactivity_jsm')) {
        if (typeof PerformanceObserver !== 'undefined') {
            const observer = (0, $gXiqn.getPerformanceObserver)();
            observer.observe({
                type: 'event',
                buffered: true,
                durationThreshold: 16
            });
        }
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("jaRbf")),
        (parcelRequire("fmu38"))
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $726cef1959388e45$var$sinkInteraction(instance, payloadPackage);
            if (config?.experimentalInteractionMetrics?.enabled) $726cef1959388e45$var$sinkExperimentalInteractionMetrics(instance, payloadPackage);
            if (config.postInteractionLog?.enabled) $726cef1959388e45$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
        });
        else if (awc.sendOperationalEvent) {
            $726cef1959388e45$var$sinkInteraction(awc, payloadPackage);
            if (config?.experimentalInteractionMetrics?.enabled) $726cef1959388e45$var$sinkExperimentalInteractionMetrics(awc, payloadPackage);
            if (config.postInteractionLog?.enabled) $726cef1959388e45$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
        }
    });
}

});
parcelRegister("baiQV", function(module, exports) {

$parcel$export(module.exports, "startLighthouseObserver", () => $507b4d71ea76a7a5$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $507b4d71ea76a7a5$export$b46cecdf698e4bb5);

var $lEtUJ = parcelRequire("lEtUJ");

var $c8byN = parcelRequire("c8byN");

var $33SNp = parcelRequire("33SNp");

var $jtcEN = parcelRequire("jtcEN");

var $7kmLO = parcelRequire("7kmLO");
function $507b4d71ea76a7a5$export$5ecf2aafafee3e0() {
    (0, $7kmLO.startLSObserver)();
    (0, $7kmLO.startLTObserver)();
}
function $507b4d71ea76a7a5$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $33SNp.getTBT)(start, stop, (0, $jtcEN.EntriesBuffer)[(0, $c8byN.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $lEtUJ.getCLS)(start, stop, (0, $jtcEN.EntriesBuffer)[(0, $c8byN.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

});
parcelRegister("lEtUJ", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $5ee5d57771f6c7fe$export$fc6227831ee7c7);
function $5ee5d57771f6c7fe$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

});

parcelRegister("c8byN", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $f98053df596c1c19$export$a4def92db6fc8e17);
const $f98053df596c1c19$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("33SNp", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $3d4a3152b88eeea8$export$2d6e933b35bd3407);
const $3d4a3152b88eeea8$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $3d4a3152b88eeea8$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $3d4a3152b88eeea8$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $3d4a3152b88eeea8$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $3d4a3152b88eeea8$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

});

parcelRegister("jtcEN", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $3bf1fc6946af5f4a$export$f7dc16cbd16f7bbe);

var $c8byN = parcelRequire("c8byN");
class $3bf1fc6946af5f4a$export$2c6e86519c9e8188 {
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
    constructor(maxLength = 1000){
        this.buffer = [];
        this.maxLength = void 0;
        this.full = false;
        this.maxLength = maxLength;
    }
}
const $3bf1fc6946af5f4a$export$f7dc16cbd16f7bbe = {
    [(0, $c8byN.PerformanceObserverEntryTypes).LongTask]: new $3bf1fc6946af5f4a$export$2c6e86519c9e8188(),
    [(0, $c8byN.PerformanceObserverEntryTypes).LayoutShift]: new $3bf1fc6946af5f4a$export$2c6e86519c9e8188()
};

});

parcelRegister("7kmLO", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $e20935e0f33fbf41$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $e20935e0f33fbf41$export$54fb8b6aaf70ec9c);

var $c8byN = parcelRequire("c8byN");

var $jtcEN = parcelRequire("jtcEN");
let $e20935e0f33fbf41$var$pe = null;
function $e20935e0f33fbf41$var$getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($e20935e0f33fbf41$var$pe !== null) return $e20935e0f33fbf41$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $c8byN.PerformanceObserverEntryTypes).LayoutShift) (0, $jtcEN.EntriesBuffer)[(0, $c8byN.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $c8byN.PerformanceObserverEntryTypes).LongTask) (0, $jtcEN.EntriesBuffer)[(0, $c8byN.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $e20935e0f33fbf41$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $e20935e0f33fbf41$var$pe;
}
function $e20935e0f33fbf41$export$768ccc3ab7bac3ea() {
    $e20935e0f33fbf41$var$getObserver()?.observe({
        type: (0, $c8byN.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}
function $e20935e0f33fbf41$export$54fb8b6aaf70ec9c() {
    $e20935e0f33fbf41$var$getObserver()?.observe({
        type: (0, $c8byN.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}

});


parcelRegister("gXiqn", function(module, exports) {

$parcel$export(module.exports, "getPerformanceObserver", () => $d5a6c732cffb1707$export$17afbba0f16b4b19);

var $4u5NT = parcelRequire("4u5NT");
let $d5a6c732cffb1707$var$performanceEventObserver;
const $d5a6c732cffb1707$export$17afbba0f16b4b19 = ()=>{
    $d5a6c732cffb1707$var$performanceEventObserver = $d5a6c732cffb1707$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $d5a6c732cffb1707$export$e6be05b411ce21a6(entry);
    });
    return $d5a6c732cffb1707$var$performanceEventObserver;
};
const $d5a6c732cffb1707$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (interaction?.type === 'press') {
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already been set up
        interaction.responsiveness = {
            ...interaction.responsiveness,
            experimentalInputToNextPaint: interaction.responsiveness?.experimentalInputToNextPaint || entry.duration,
            inputDelay: interaction.responsiveness?.inputDelay || entry.processingStart - entry.startTime
        };
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        interaction.start = Math.min(interaction.start, entry.startTime);
    }
};

});

parcelRegister("i328h", function(module, exports) {

$parcel$export(module.exports, "createPressureStateReport", () => $1b7ceb7dea9fa404$export$1f0ff35da084986e);
$parcel$export(module.exports, "initialisePressureObserver", () => $1b7ceb7dea9fa404$export$117ebc554c6e9f2f);
const $1b7ceb7dea9fa404$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $1b7ceb7dea9fa404$var$pressureRecordBuffer = [];
let $1b7ceb7dea9fa404$var$pressureObserver = null;
function $1b7ceb7dea9fa404$export$6c1060bed5fea050() {
    $1b7ceb7dea9fa404$var$pressureRecordBuffer.length = 0;
}
function $1b7ceb7dea9fa404$export$a9d8e463e719c4bd(filter) {
    $1b7ceb7dea9fa404$var$pressureRecordBuffer = $1b7ceb7dea9fa404$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $1b7ceb7dea9fa404$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $1b7ceb7dea9fa404$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $1b7ceb7dea9fa404$export$a9d8e463e719c4bd(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $1b7ceb7dea9fa404$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $1b7ceb7dea9fa404$var$pressureObserver = new PressureObserver((records)=>{
                if ($1b7ceb7dea9fa404$var$pressureRecordBuffer.length + records.length <= $1b7ceb7dea9fa404$var$BUFFER_MAX_LENGTH) $1b7ceb7dea9fa404$var$pressureRecordBuffer.push(...records);
            });
            $1b7ceb7dea9fa404$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            })?.catch();
        }
    } catch (err) {
    /* do nothing, this is a best efforts metric */ }
}
function $1b7ceb7dea9fa404$export$b9fdd785f0fc1d40() {
    $1b7ceb7dea9fa404$var$pressureObserver?.disconnect();
}

});

parcelRegister("jkXCL", function(module, exports) {

$parcel$export(module.exports, "default", () => $89fa2b1673704460$export$2e2bcd8739ae039);

var $dudgj = parcelRequire("dudgj");

var $dh538 = parcelRequire("dh538");
function $89fa2b1673704460$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $dh538.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $dudgj.unstable_scheduleCallback)((0, $dudgj.unstable_IdlePriority), work);
}
var $89fa2b1673704460$export$2e2bcd8739ae039 = $89fa2b1673704460$var$scheduleIdleCallback;

});

parcelRegister("jaRbf", function(module, exports) {

let $df5834000c9330b9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $df5834000c9330b9$var$load("fzdx8"),
    $df5834000c9330b9$var$load("813OY")
]).then(()=>parcelRequire('kGADV'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});



parcelRegister("fmu38", function(module, exports) {

let $b2f0384ca7ea9ce8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b2f0384ca7ea9ce8$var$load("fzdx8"),
    $b2f0384ca7ea9ce8$var$load("gQfqa")
]).then(()=>parcelRequire('bprG4'));

});


parcelRegister("hPcrh", function(module, exports) {

$parcel$export(module.exports, "configure", () => $9d50b67dcef9fae2$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $9d50b67dcef9fae2$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $9d50b67dcef9fae2$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRPhaseSuccess", () => $9d50b67dcef9fae2$export$5eade9354185583d);
$parcel$export(module.exports, "getSSRDoneTime", () => $9d50b67dcef9fae2$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $9d50b67dcef9fae2$export$1c4a9b5e6e22393d);

var $dh538 = parcelRequire("dh538");
const $9d50b67dcef9fae2$var$NESTED_METRIC_SEPARATOR = '/';
function $9d50b67dcef9fae2$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $9d50b67dcef9fae2$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size && (0, $dh538.fg)('platform_ufo_ssr_size_field') ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $9d50b67dcef9fae2$var$SSR_PREFIX = 'ssr';
function $9d50b67dcef9fae2$var$mapKey(key) {
    if (key === 'total') return $9d50b67dcef9fae2$var$SSR_PREFIX;
    return `${$9d50b67dcef9fae2$var$SSR_PREFIX}${$9d50b67dcef9fae2$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $9d50b67dcef9fae2$var$config;
function $9d50b67dcef9fae2$export$8d21e34596265fa2(ssrConfig) {
    $9d50b67dcef9fae2$var$config = ssrConfig;
}
function $9d50b67dcef9fae2$export$bf7408e83532dcd0() {
    if (!$9d50b67dcef9fae2$var$config?.getTimings) return {};
    const timings = $9d50b67dcef9fae2$var$config.getTimings();
    if (!timings) return {};
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($9d50b67dcef9fae2$var$filterEntry(entry[1])) acc[$9d50b67dcef9fae2$var$mapKey(entry[0])] = $9d50b67dcef9fae2$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $9d50b67dcef9fae2$export$c7ad864055e75537() {
    return !!$9d50b67dcef9fae2$var$config?.getDoneMark();
}
function $9d50b67dcef9fae2$export$5eade9354185583d() {
    return $9d50b67dcef9fae2$var$config?.getSsrPhaseSuccess?.();
}
function $9d50b67dcef9fae2$export$3def7672244bab0c() {
    return $9d50b67dcef9fae2$var$config?.getDoneMark() ?? undefined;
}
function $9d50b67dcef9fae2$export$1c4a9b5e6e22393d() {
    if (!$9d50b67dcef9fae2$var$config?.getFeatureFlags) return undefined;
    try {
        return $9d50b67dcef9fae2$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return undefined;
}

});

parcelRegister("9tNjS", function(module, exports) {

let $6e6d1455d05df8b0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6e6d1455d05df8b0$var$load("9SyhI"),
    $6e6d1455d05df8b0$var$load("76XJy")
]).then(()=>parcelRequire('a4qOe'));

});

parcelRegister("jD74V", function(module, exports) {

let $e4a7267d6ef6e85f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e4a7267d6ef6e85f$var$load("gSXIX").then(()=>parcelRequire('kWFOs'));

});

parcelRegister("3bcaN", function(module, exports) {

$parcel$export(module.exports, "preloadSpaceOverview", () => $79570d1de8e3464e$export$2fae7b45037154b8);

var $aBowN = parcelRequire("aBowN");

var $iwjRE = parcelRequire("iwjRE");

var $iq03p = parcelRequire("iq03p");

var $lcQ5b = parcelRequire("lcQ5b");

var $iV8Fk = parcelRequire("iV8Fk");

var $fyUox = parcelRequire("fyUox");

var $g9fWM = parcelRequire("g9fWM");

var $9wGTI = parcelRequire("9wGTI");

var $33AJK = parcelRequire("33AJK");

var $ivyMZ = parcelRequire("ivyMZ");

var $6anVB = parcelRequire("6anVB");

var $5iG5Q = parcelRequire("5iG5Q");

var $jLfE2 = parcelRequire("jLfE2");
var $kkLBe = parcelRequire("kkLBe");
var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $cEgMD = parcelRequire("cEgMD");

var $aOmVc = parcelRequire("aOmVc");

var $IGlEW = parcelRequire("IGlEW");

var $82xkT = parcelRequire("82xkT");

var $2a3Pf = parcelRequire("2a3Pf");
const $79570d1de8e3464e$var$preloadHomepageId = async (spaceKey)=>{
    const { result: result, hasErrors: hasErrors } = await (0, $aBowN.preloadSpaceOverviewId)(spaceKey);
    return !hasErrors && result?.data?.space?.homepageId || null;
};
const $79570d1de8e3464e$export$ba9b2fb7540ef84 = (spaceKey)=>(0, $dYU3e.query)({
        query: (0, $82xkT.SpaceOverviewQuery),
        variables: {
            spaceKey: spaceKey,
            excludeOperations: Boolean(!(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey))
        }
    });
const $79570d1de8e3464e$var$preloadSpaceOverviewQueries = async ({ homepageId: homepageId = '', homepageIdPromise: homepageIdPromiseInitial, spaceKey: spaceKey, previousMatch: previousMatch, versionOverride: versionOverride })=>{
    const { userId: userId, featureFlags: featureFlags, isLicensed: isLicensed } = await (0, $jLfE2.getPreloaderFnContext)();
    const tasks = [];
    let contentNodesPromiseResolve = undefined;
    const contentNodesPromise = new Promise((resolve)=>{
        contentNodesPromiseResolve = resolve;
    });
    let homepageIdPromise = homepageId ? undefined : homepageIdPromiseInitial;
    if (homepageId) {
        // If we know the homepageId, preload early
        tasks.push((0, $IGlEW.preloadSideNavigationNeedsContentId)(spaceKey, homepageId));
        if ((0, $9wGTI.fg)('dlp_space_overview_classification_ssr_preload')) tasks.push((0, $iwjRE.preloadClassificationContextForViewContent)(homepageId, spaceKey));
    }
    if (homepageIdPromise && (0, $9wGTI.fg)('confluence_optimize_space_macro_preloading')) tasks.push((0, $kkLBe.prepareGuardExceptionTask)('Macros', ()=>homepageIdPromise.then((resolvedHomepageId)=>{
            if (resolvedHomepageId) return (0, $g9fWM.preloadMacrosSSR)({
                contentId: resolvedHomepageId,
                useMultipleMacrosQuery: true,
                contentNodes: contentNodesPromise
            });
        })));
    tasks.push((0, $kkLBe.prepareGuardExceptionTask)('ContentAndMacros', ()=>(0, $iq03p.preloadContent)({
            contentId: homepageId,
            spaceKey: spaceKey,
            isBlog: false,
            featureFlags: featureFlags,
            versionOverride: versionOverride
        }).then(({ result: result, hasErrors: hasErrors })=>{
            const contentId = homepageId || result?.data?.content?.nodes[0]?.id;
            // in the event that there are errors (no id from result) and the homepageId is not valid (error when loading the space),
            // bypass preloadContentPrereqs since contentId is undefined
            if (!contentId) return;
            if ((0, $9wGTI.fg)('cc_macro_preload_early_exit')) contentNodesPromiseResolve?.(result?.data?.content?.nodes);
            const promises = [];
            if (!homepageId) {
                // If we don't know the homepageId, preloadContent will tell us the id
                promises.push((0, $IGlEW.preloadSideNavigationNeedsContentId)(spaceKey, contentId));
                if (!(0, $9wGTI.fg)('confluence_optimize_space_macro_preloading') || !homepageIdPromise) promises.push((0, $g9fWM.preloadMacrosSSR)({
                    contentId: contentId,
                    useMultipleMacrosQuery: true,
                    contentNodes: result?.data?.content?.nodes
                }));
                if ((0, $9wGTI.fg)('dlp_space_overview_classification_ssr_preload')) tasks.push((0, $iwjRE.preloadClassificationContextForViewContent)(contentId, spaceKey));
            }
            if (hasErrors) promises.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey, {
                versionOverride: versionOverride
            }));
            return (0, $lyWac.waitForAllReturnWhenError)(promises);
        })), (0, $2a3Pf.preloadGroupedButtons)({
        contentId: homepageId,
        spaceKey: spaceKey,
        userId: userId,
        isLicensed: isLicensed
    }));
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: homepageId,
        spaceKey: spaceKey
    }));
    const shouldPreloadPageTree = previousMatch && previousMatch?.params?.spaceKey !== spaceKey && (0, $9wGTI.fg)('confluence_preload_pagetree_space_transition'); // preload page tree on transition if the previous space key is different from the new space key
    if (shouldPreloadPageTree) tasks.push((0, $6anVB.preloadPageTree)({
        contentId: homepageId,
        spaceKey: spaceKey,
        statuses: (0, $ivyMZ.PAGE_TREE_STATUSES),
        isSuperAdmin: false
    }), (0, $5iG5Q.preloadBlogTree)({
        spaceKey: spaceKey
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
async function $79570d1de8e3464e$export$2fae7b45037154b8({ spaceKey: spaceKey, homepageId: homepageId, homepageIdPromise: homepageIdPromise, previousMatch: previousMatch, versionOverride: versionOverride }) {
    const promises = [
        (0, $aOmVc.preloadScreen)(spaceKey),
        (0, $33AJK.preloadSpace)(spaceKey),
        (0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey)
    ];
    if (homepageId || homepageIdPromise) // In some case we append homepageId as a query param. Then preload with it.
    // next/packages/space-overview/src/SpaceOverview.tsx still needs SpaceOverviewQuery but others are not depending on it
    promises.push($79570d1de8e3464e$export$ba9b2fb7540ef84(spaceKey), $79570d1de8e3464e$var$preloadSpaceOverviewQueries({
        homepageId: homepageId,
        homepageIdPromise: homepageIdPromise,
        spaceKey: spaceKey,
        previousMatch: previousMatch,
        versionOverride: versionOverride
    }));
    else if (Boolean(undefined)) // Use new query to preload as space key then transform to the old queries.
    // next/packages/space-overview/src/SpaceOverview.tsx still needs SpaceOverviewQuery but others are not depending on it
    promises.push($79570d1de8e3464e$export$ba9b2fb7540ef84(spaceKey), $79570d1de8e3464e$var$preloadSpaceOverviewQueries({
        spaceKey: spaceKey
    }));
    else // If we have no information on home id and yet using old query, we need to fetch it first.
    promises.push($79570d1de8e3464e$export$ba9b2fb7540ef84(spaceKey).then((res)=>{
        // Because homepageId was provided by the function caller, it may or may
        // not be out of sync with backend:
        const actualHomepageId = res?.data?.space?.homepage?.id;
        if (actualHomepageId) return $79570d1de8e3464e$var$preloadSpaceOverviewQueries({
            homepageId: actualHomepageId,
            spaceKey: spaceKey,
            previousMatch: previousMatch,
            versionOverride: versionOverride
        });
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
}

});
parcelRegister("aBowN", function(module, exports) {

$parcel$export(module.exports, "preloadSpaceOverviewId", () => $12a2f5ca95176b67$export$c390629d140bb37e);

var $hpnxK = parcelRequire("hpnxK");

var $2GGOW = parcelRequire("2GGOW");
var $dYU3e = parcelRequire("dYU3e");

var $8A6OJ = parcelRequire("8A6OJ");
function $12a2f5ca95176b67$export$c390629d140bb37e(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $8A6OJ.SpaceOverviewIdQuery),
        variables: {
            spaceKey: spaceKey
        }
    }).then((result)=>{
        const hasErrors = result?.errors?.length > 0;
        result?.errors?.forEach((error)=>{
            // The "Cannot find space" condition is handled by redirecting to the correct space even if
            // the error is not propagated to ContentPrerequisites where it is normally handled.
            // And we use implicit dependency on GraphqlErrorProcessor from "@confluence/graphql" to
            // avoid direct import of this package into preloader bundle.
            if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $hpnxK.isNotFoundSpaceError)(error)) window?.__GRAPHQL_ERROR_PROCESSOR__?.markErrorAsHandled(error);
        });
        return {
            result: result,
            hasErrors: hasErrors
        };
    });
}

});
parcelRegister("8A6OJ", function(module, exports) {

$parcel$export(module.exports, "SpaceOverviewIdQuery", () => $c958f3980bc3f97b$export$93f1ddb751c9753);

var $d2LG0 = parcelRequire("d2LG0");
const $c958f3980bc3f97b$export$93f1ddb751c9753 = (0, $d2LG0.default)`query SpaceOverviewIdQuery($spaceKey:String){space(key:$spaceKey){id homepageId}}`;

});


parcelRegister("iwjRE", function(module, exports) {

$parcel$export(module.exports, "preloadClassificationContextForViewContent", () => $c7f6674d8ea135ae$export$137d64ae0bf4fe94);

var $dh538 = parcelRequire("dh538");

var $lyWac = parcelRequire("lyWac");

var $7tHGa = parcelRequire("7tHGa");

var $fBanN = parcelRequire("fBanN");

var $3rhBJ = parcelRequire("3rhBJ");

var $9NZgb = parcelRequire("9NZgb");
async function $c7f6674d8ea135ae$export$137d64ae0bf4fe94(contentId, spaceKey) {
    const queries = [];
    if ((0, $dh538.fg)('dlp_chained_classification_ssr_preload')) {
        const result = await (0, $fBanN.preloadDataClassificationEnabled)();
        const isDataClassificationEnabled = result?.data?.isDataClassificationEnabled;
        if (isDataClassificationEnabled) {
            queries.push((0, $3rhBJ.preloadContentDataClassification)(contentId, (0, $7tHGa.ContentStatus).CURRENT));
            if (spaceKey && !(0, $dh538.fg)('dlp_cc-minimize-classifications-queries')) queries.push((0, $9NZgb.preloadDefaultAndSpaceClassificationLevels)(spaceKey));
        }
    } else {
        queries.push((0, $3rhBJ.preloadContentDataClassification)(contentId, (0, $7tHGa.ContentStatus).CURRENT));
        queries.push((0, $fBanN.preloadDataClassificationEnabled)());
        if (spaceKey && !(0, $dh538.fg)('dlp_cc-minimize-classifications-queries')) queries.push((0, $9NZgb.preloadDefaultAndSpaceClassificationLevels)(spaceKey));
    }
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}

});
parcelRegister("fBanN", function(module, exports) {

$parcel$export(module.exports, "preloadDataClassificationEnabled", () => $8ae9d41ffef0e01d$export$3ac98e53839cf12f);

var $dYU3e = parcelRequire("dYU3e");

var $hqBgv = parcelRequire("hqBgv");
function $8ae9d41ffef0e01d$export$3ac98e53839cf12f() {
    return (0, $dYU3e.query)({
        query: (0, $hqBgv.DataClassificationEnabledQuery)
    });
}

});

parcelRegister("3rhBJ", function(module, exports) {

$parcel$export(module.exports, "preloadContentDataClassification", () => $2257f3db82626244$export$fc412545d4d6ad12);

var $dYU3e = parcelRequire("dYU3e");

var $gSfo4 = parcelRequire("gSfo4");

var $2xSF7 = parcelRequire("2xSF7");
function $2257f3db82626244$export$fc412545d4d6ad12(contentId, contentStatus) {
    return (0, $dYU3e.query)({
        query: (0, $2xSF7.ContentDataClassificationQuery),
        variables: {
            contentId: contentId,
            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)([
                contentStatus
            ])
        }
    });
}

});


parcelRegister("iq03p", function(module, exports) {

$parcel$export(module.exports, "preloadContent", () => $1acff4ea84553836$export$97ce9ab4bdd6b3fc);

var $lpxTx = parcelRequire("lpxTx");
var $61vTv = parcelRequire("61vTv");
var $1jUHX = parcelRequire("1jUHX");

var $hpnxK = parcelRequire("hpnxK");

var $2GGOW = parcelRequire("2GGOW");
var $dYU3e = parcelRequire("dYU3e");

var $9wGTI = parcelRequire("9wGTI");

var $PrCoC = parcelRequire("PrCoC");
const $1acff4ea84553836$export$1e36de371b2e3d5a = (result)=>{
    // NOTES:
    // 1. Preloading is "fire and forget" operation on a client as well, so we can mute
    //    some known errors, but we can't really do anything about them as they're not
    //    make it to the Apollo cache anyway and therefore don't pop at where they can
    //    be handled.
    // 2. We use implicit dependency on GraphqlErrorProcessor from "@confluence/graphql"
    //    to avoid direct import of this package into preloader bundle.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        // The "Cannot find space" condition is handled by redirecting to the correct space
        // even if error is not propagated to ContentPrerequisites where it is normally handled.
        if ((0, $2GGOW.isUnauthorizedError)(error)) {
            window?.__GRAPHQL_ERROR_PROCESSOR__?.markErrorAsHandled(error);
            if ((0, $9wGTI.fg)('confluence_ssr_permissions_error_handler')) (0, $PrCoC.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('view', error);
        }
        if ((0, $hpnxK.isNotFoundSpaceError)(error)) window?.__GRAPHQL_ERROR_PROCESSOR__?.markErrorAsHandled(error);
    });
    return hasErrors;
};
const $1acff4ea84553836$export$dba3e11e87da376f = (data)=>{
    const transformedData = {
        content: data?.spaceHomepage ? {
            nodes: [
                data?.spaceHomepage
            ],
            // @ts-ignore
            __typename: 'PaginatedContentListWithChild'
        } : null,
        space: data?.space || null
    };
    return transformedData;
};
function $1acff4ea84553836$export$97ce9ab4bdd6b3fc({ contentId: contentId, spaceKey: spaceKey, isBlog: isBlog, versionOverride: versionOverride = null }) {
    window.performance.mark('CFP-63.preloadContent.start');
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    // Space overview
    if (spaceKey && !contentId) return (0, $dYU3e.query)({
        query: (0, $1jUHX.ContentUnifiedWithSpaceKeyQuery),
        variables: {
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            isSSR: isSSR,
            useNewContentTopper: true
        },
        errorPolicy: 'all'
    }).then((result)=>{
        const hasErrors = $1acff4ea84553836$export$1e36de371b2e3d5a(result);
        // Record the end mark and timestamp to track *both* duration of preloading
        // and timestamp of the moment when preloading finished
        window.performance.mark('CFP-63.preloadContent.end');
        window.performance.mark('CFP-63.preloadContentEnd');
        const data = result?.data;
        const homepageId = data?.spaceHomepage?.id;
        if (homepageId) {
            // update result with transformed data
            result.data = $1acff4ea84553836$export$dba3e11e87da376f(data);
            (0, $dYU3e.writeQuery)({
                query: (0, $61vTv.ContentUnifiedQuery),
                variables: {
                    contentId: homepageId,
                    spaceKey: spaceKey,
                    versionOverride: versionOverride,
                    isSSR: isSSR,
                    useNewContentTopper: true
                },
                data: {
                    ...result.data
                }
            });
        }
        return {
            result: result,
            hasErrors: hasErrors
        };
    });
    let chooseContentUnifiedQuery = (0, $61vTv.ContentUnifiedQuery);
    const queryVariables = {
        contentId: contentId,
        spaceKey: spaceKey,
        versionOverride: versionOverride,
        isSSR: isSSR,
        useNewContentTopper: true
    };
    if (isBlog) chooseContentUnifiedQuery = (0, $lpxTx.ContentBlogUnifiedQuery);
    if (isSSR && !(0, $9wGTI.fg)('confluence_frontend_remove_labels')) queryVariables.preloadLabels = true;
    return (0, $dYU3e.query)({
        query: chooseContentUnifiedQuery,
        variables: queryVariables,
        errorPolicy: 'all'
    }).then((result)=>{
        const hasErrors = $1acff4ea84553836$export$1e36de371b2e3d5a(result);
        // Record the end mark and timestamp to track *both* duration of preloading
        // and timestamp of the moment when preloading finished
        window.performance.mark('CFP-63.preloadContent.end');
        window.performance.mark('CFP-63.preloadContentEnd');
        return {
            result: result,
            hasErrors: hasErrors
        };
    });
}

});
parcelRegister("1jUHX", function(module, exports) {

$parcel$export(module.exports, "ContentUnifiedWithSpaceKeyQuery", () => $4727114abcb2cba4$export$4b6471b3bef7aea6);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $4727114abcb2cba4$export$4b6471b3bef7aea6 = (0, $d2LG0.default)`query ContentUnifiedWithSpaceKeyQuery($spaceKey:String!$versionOverride:Int$isSSR:Boolean=false$useNewContentTopper:Boolean=false$preloadLabels:Boolean=false)@SLA{spaceHomepage(spaceKey:$spaceKey version:$versionOverride){id status type subType title space{id key alias}version{confRev number}properties(keys:["cover-picture-id-published" "editor" "import-source" "imported-page-modified-date"]){nodes{id key value version{number}}}pageTitlePublished:properties(key:"page-title-property-published")@include(if:$useNewContentTopper){nodes{id key value version{number}}}metadata{lastModifiedDate frontend{fabricEditorSupported coverPictureWidth@include(if:$useNewContentTopper)}}macroRenderedOutput@include(if:$isSSR){key value{value representation webresource{tags{js css}}}}body{dynamic{representation value webresource{superbatch{tags{js css}}tags{js css}}}}appearancePublished:properties(key:"content-appearance-published"){nodes{id key value version{number}}}labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING})@include(if:$preloadLabels){count nodes{id label name prefix}}operations@include(if:$preloadLabels){operation targetType}}space(key:$spaceKey){id theme{name themeKey}lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}settings{routeOverrideEnabled}currentUser{isAnonymouslyAuthorized}}}`;

});


parcelRegister("g9fWM", function(module, exports) {

$parcel$export(module.exports, "preloadMacrosSSR", () => $7411787db12277fb$export$64dcb3aec0dc81b3);

var $4VJDS = parcelRequire("4VJDS");

var $ld6xp = parcelRequire("ld6xp");

var $hnaHi = parcelRequire("hnaHi");

var $8gb27 = parcelRequire("8gb27");

var $6JwPA = parcelRequire("6JwPA");
const $7411787db12277fb$export$64dcb3aec0dc81b3 = async ({ contentId: contentId, useMultipleMacrosQuery: useMultipleMacrosQuery, contentNodes: contentNodes, numberOfExtensionsToSSR: numberOfExtensionsToSSR = (0, $6JwPA.DEFAULT_PRELOAD_COUNT) })=>{
    const legacyBlocklistedExtensions = (0, $4VJDS.default).getString((0, $6JwPA.FG_SSR_EXTENSIONS_BLOCKLIST), '');
    if (useMultipleMacrosQuery) return (0, $8gb27.preloadMacrosSSRMultiple)(contentId, contentNodes);
    else {
        // if we're using MacrosQuery but this is the call for the old query, we need to
        // check if there are any blocklisted (for the Macros query) macros on the page
        // and attempt to use the old queries to render them instead
        const blocklistedExtensions = (0, $ld6xp.getMultiMacroQueryBlocklistFF)();
        return (0, $hnaHi.preloadMacrosSSRIndividual)(contentId, contentNodes, legacyBlocklistedExtensions, numberOfExtensionsToSSR, blocklistedExtensions);
    }
    return (0, $hnaHi.preloadMacrosSSRIndividual)(contentId, contentNodes, legacyBlocklistedExtensions, numberOfExtensionsToSSR);
};

});
parcelRegister("hnaHi", function(module, exports) {

$parcel$export(module.exports, "preloadMacrosSSRIndividual", () => $64a1b8a95751bd5c$export$f860aab1074a1289);

var $csnse = parcelRequire("csnse");

var $lcuos = parcelRequire("lcuos");

var $bSXAs = parcelRequire("bSXAs");

var $6aq5c = parcelRequire("6aq5c");

var $ODlve = parcelRequire("ODlve");

var $8pcS0 = parcelRequire("8pcS0");

var $6mEZ3 = parcelRequire("6mEZ3");

var $dYU3e = parcelRequire("dYU3e");

var $6Cce7 = parcelRequire("6Cce7");
var $92uc5 = parcelRequire("92uc5");
var $8mIlz = parcelRequire("8mIlz");
var $9p5st = parcelRequire("9p5st");

var $6JwPA = parcelRequire("6JwPA");

var $gGkCt = parcelRequire("gGkCt");
const $64a1b8a95751bd5c$var$knownExtensionSet = new Set((0, $8pcS0.serverRenderedExtensions));
const $64a1b8a95751bd5c$var$getMacroId = (node)=>node.attrs?.parameters?.macroMetadata?.macroId?.value;
const $64a1b8a95751bd5c$var$extractExtensions = (adf)=>(0, $lcuos.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $64a1b8a95751bd5c$var$augmentWithMarks = (marks)=>{
    if (!marks?.length) return {};
    const fragments = marks.filter((mark)=>mark.type === 'fragment');
    if (fragments.length) return {
        fragmentLocalId: fragments[0].attrs.localId
    };
    return {};
};
const $64a1b8a95751bd5c$var$blocklistCache = new Map();
const $64a1b8a95751bd5c$export$80c99e8065c92427 = ()=>$64a1b8a95751bd5c$var$blocklistCache.clear();
const $64a1b8a95751bd5c$var$isBlocklisted = (blocklist, extensionKey)=>{
    if (blocklist.length === 0) return false;
    if ($64a1b8a95751bd5c$var$blocklistCache.has(extensionKey)) return $64a1b8a95751bd5c$var$blocklistCache.get(extensionKey);
    const isBlocked = blocklist.length > 0 && blocklist.some((block)=>{
        try {
            const blockRegex = new RegExp(block, 'ig');
            return blockRegex.test(extensionKey);
        } catch (err) {
            // Malformed regex/input, consider extension being not blocked
            return false;
        }
    });
    $64a1b8a95751bd5c$var$blocklistCache.set(extensionKey, isBlocked);
    return isBlocked;
};
// The rule of excluding extensions from querying in the prepare phase of SSR are the following:
//  - extension should be located at the top of the page, assuming extensions returned by the
//    adf-utils/filter are in the order from top to down of the page;
//  - extension should be common/legacy, i.e. of type "com.atlassian.confluence.macro.core";
//  - extension should not be a part of those we have a special handling in SPA (excepting children macro);
//  - extensions shouldn't have an output in a content query.
const $64a1b8a95751bd5c$var$byExcluded = (excludeExtensionIdSet, numberOfExtensionsToSSR = 0)=>(node, index)=>{
        const { parameters: parameters, extensionKey: extensionKey, extensionType: extensionType } = node.attrs || {};
        return index < numberOfExtensionsToSSR && extensionType === (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE && (!$64a1b8a95751bd5c$var$knownExtensionSet.has(extensionKey) || extensionKey === 'children') && !parameters.macroOutput && !excludeExtensionIdSet.has($64a1b8a95751bd5c$var$getMacroId(node));
    };
const $64a1b8a95751bd5c$var$getSchema = (0, $csnse.default)(()=>(0, $ODlve.getSchemaBasedOnStage)((0, $bSXAs.ADFStages).STAGE_0));
const $64a1b8a95751bd5c$var$createMacroQueryParamsProvider = (documentADF)=>{
    // This code (both `getRendererDocument` and `getRendererNodeContent`) inspired by `renderDocument`
    // function in `platform/packages/editor/renderer/src/render-document.ts`
    // Here we convert the `content` of our adf node to renderer/editor/ProseMirror node,
    // which ensures `content` in preloader and in SSR render would match and would not cause apollo cache mismatch.
    const getRendererDocument = (0, $csnse.default)(()=>{
        const schema = $64a1b8a95751bd5c$var$getSchema();
        const validDocumentADF = (0, $6aq5c.validateADFEntity)(schema, documentADF);
        const pnDoc = schema.nodeFromJSON(validDocumentADF);
        return {
            version: 1,
            type: 'doc',
            content: pnDoc.content.toJSON()
        };
    });
    const getRendererNodeContent = (macroId)=>{
        const rendererDocument = getRendererDocument();
        const [rendererNode] = (0, $lcuos.filter)(rendererDocument, (n)=>$64a1b8a95751bd5c$var$getMacroId(n) === macroId);
        return rendererNode.content || [];
    };
    return (node)=>{
        const requestADF = (0, $6mEZ3.extensionToADF)(node);
        requestADF.attrs = {
            ...requestADF.attrs,
            ...$64a1b8a95751bd5c$var$augmentWithMarks(node.marks)
        };
        if (requestADF.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) requestADF.content = getRendererNodeContent($64a1b8a95751bd5c$var$getMacroId(node));
        delete requestADF.attrs.layout;
        return {
            ...requestADF,
            type: node.type
        };
    };
};
const $64a1b8a95751bd5c$var$preloadMacrosSSRAndReturnTopXFailed = async (contentId, contentNodes, numberOfExtensionsToSSR, renderOnlyExtensionKeys, extensionsBlocklist)=>{
    if (renderOnlyExtensionKeys && renderOnlyExtensionKeys.length === 0) return {};
    const blocklistedExtensions = extensionsBlocklist.split(',').map((extensionName)=>extensionName.trim()).filter(Boolean);
    // Catch error if contentNodes is empty
    if (!contentNodes || !contentNodes[0]) return {
        general: 'contentNodesEmpty'
    };
    // Leave early when there's TinyMCE or borked content
    if (contentNodes[0].body.dynamic?.representation !== 'atlas_doc_format') return {};
    // Exclude extensions that are included into the content response as we don't need
    // to load any data for these extensions.
    const excludeExtensionIdSet = new Set((contentNodes[0].macroRenderedOutput || []).map((ext)=>ext.key));
    let documentADF;
    try {
        documentADF = JSON.parse(contentNodes[0].body.dynamic.value);
    } catch (err) {
        // While contentNodes[0].body.dynamic.value should be defined in all valid cases,
        // and should it not, the experience for the user will be broken anyway, we want
        // to swallow this error, skip macros preloading and let SPA handle the case, as
        // SPA already have proper experience tracking.
        return;
    }
    const toMacroQueryParams = $64a1b8a95751bd5c$var$createMacroQueryParamsProvider(documentADF);
    const extensions = $64a1b8a95751bd5c$var$extractExtensions(documentADF).filter($64a1b8a95751bd5c$var$byExcluded(excludeExtensionIdSet, numberOfExtensionsToSSR || (0, $6JwPA.DEFAULT_PRELOAD_COUNT))).filter((node)=>!renderOnlyExtensionKeys || renderOnlyExtensionKeys.includes(node?.attrs?.extensionKey)).map(toMacroQueryParams);
    if (numberOfExtensionsToSSR === 0) return extensions.length === 0 ? {} : undefined;
    // eslint-disable-next-line check-preloaders/no-promise-all
    const preloadResult = await Promise.all(extensions.map(async (extensionADF)=>{
        const { isMacroContentAndBody: isMacroContentAndBody, ...variables } = (0, $8mIlz.getMacroQueryVariables)({
            adf: extensionADF,
            contentId: contentId
        });
        const attr = extensionADF.attrs;
        const extensionKey = attr?.extensionKey;
        const failure = (reason)=>({
                [`${extensionKey}:${$64a1b8a95751bd5c$var$getMacroId(extensionADF)}`]: reason
            });
        const failureIfNotSuccess = (reason)=>(success)=>success ? undefined : failure(reason);
        // we may block some extensions via feature flags
        if ($64a1b8a95751bd5c$var$isBlocklisted(blocklistedExtensions, extensionKey)) return failure('blocklist');
        let macroBodyPreloadPromise = Promise.resolve(undefined);
        if (extensionADF.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) macroBodyPreloadPromise = (0, $gGkCt.macroPreloadGuard)(`ExtensionContentConverter_${extensionKey || 'unknown'}`, ()=>(0, $dYU3e.query)({
                variables: (0, $92uc5.getContentConverterVariables)({
                    content: extensionADF.content,
                    contentId: contentId
                }),
                query: (0, $6Cce7.ContentConverterQuery),
                context: {
                    single: true
                }
            })).then(failureIfNotSuccess('timeout-macrobody'));
        const macroPreloadPromise = (0, $gGkCt.macroPreloadGuard)(`Extension_${extensionKey || 'unknown'}`, ()=>{
            return (0, $dYU3e.query)({
                variables: variables,
                query: isMacroContentAndBody ? (0, $9p5st.MacroBodyRendererQueryWithTags) : (0, $9p5st.MacroContentRendererQueryWithTags),
                context: {
                    single: true
                }
            });
        }).then(failureIfNotSuccess('timeout'));
        // eslint-disable-next-line check-preloaders/no-promise-all
        const [macroPreloadResult, macroBodyPreloadResult] = await Promise.all([
            macroPreloadPromise,
            macroBodyPreloadPromise
        ]);
        return {
            ...macroPreloadResult || {},
            ...macroBodyPreloadResult || {}
        };
    }));
    const preloadFailures = preloadResult ? preloadResult.filter((item)=>!!item) : [];
    return Object.assign({}, ...preloadFailures);
};
async function $64a1b8a95751bd5c$export$f860aab1074a1289(contentId, contentNodes, extensionsBlocklist, numberOfExtensionsToSSR = (0, $6JwPA.DEFAULT_PRELOAD_COUNT), renderOnlyExtensionIds) {
    // Function has early return so we extracted it out to avoid setting global in every return
    return window['__SSR_MACRO_PRELOAD_TOPX_FAILS__'] = await $64a1b8a95751bd5c$var$preloadMacrosSSRAndReturnTopXFailed(contentId, contentNodes, numberOfExtensionsToSSR, renderOnlyExtensionIds, extensionsBlocklist);
}

});
parcelRegister("6JwPA", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PRELOAD_COUNT", () => $cd2d56ef117b2819$export$e87714e2a0c200ee);
$parcel$export(module.exports, "FG_SSR_EXTENSIONS_BLOCKLIST", () => $cd2d56ef117b2819$export$717eaf20c85e91ca);
const $cd2d56ef117b2819$export$e87714e2a0c200ee = 8;
const $cd2d56ef117b2819$export$717eaf20c85e91ca = 'confluence-extensions-server-render-blocklist';

});

parcelRegister("gGkCt", function(module, exports) {

$parcel$export(module.exports, "macroPreloadGuard", () => $0c324658d339d2cd$export$3023e3e089da4eb0);

var $9wGTI = parcelRequire("9wGTI");

var $9WAeG = parcelRequire("9WAeG");

var $4VJDS = parcelRequire("4VJDS");
// 500 ms timeout for each macro loading task, as this is the value the feature
// was rolled out with. On staging, we use 1000 ms to avoid test flakiness.
const $0c324658d339d2cd$var$TIMEOUT = 500;
const $0c324658d339d2cd$export$3023e3e089da4eb0 = async (name, task, noExtensionsSignal = new Promise(()=>{}))=>{
    const timeout = (0, $4VJDS.default).getNumber('confluence_frontend_prealod_macro_timeout', $0c324658d339d2cd$var$TIMEOUT);
    const timeoutPromise = new Promise((resolve)=>setTimeout(()=>{
            // eslint-disable-next-line no-console
            console.error(`SSR macro preload task "${name}" timed out after ${timeout}ms`);
            resolve(false);
        }, timeout));
    const runTask = async ()=>{
        await (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/macroPreloadGuard:${name}`, task);
        return true;
    };
    const noExtensionsSignalPromise = noExtensionsSignal.then(()=>true);
    return Promise.race((0, $9wGTI.fg)('cc_macro_preload_early_exit') ? [
        timeoutPromise,
        noExtensionsSignalPromise,
        runTask()
    ] : [
        timeoutPromise,
        runTask()
    ]);
};

});


parcelRegister("8gb27", function(module, exports) {

$parcel$export(module.exports, "preloadMacrosSSRMultiple", () => $eb281dfded33b271$export$b470c165ef60e727);

var $lcuos = parcelRequire("lcuos");

var $8pcS0 = parcelRequire("8pcS0");

var $ld6xp = parcelRequire("ld6xp");
var $g1f2M = parcelRequire("g1f2M");

var $dYU3e = parcelRequire("dYU3e");

var $9wGTI = parcelRequire("9wGTI");

var $6JwPA = parcelRequire("6JwPA");

var $gGkCt = parcelRequire("gGkCt");
const $eb281dfded33b271$var$extractExtensions = (adf)=>(0, $lcuos.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $eb281dfded33b271$var$hasExtensions = (contentNodes)=>{
    try {
        const adf = JSON.parse(contentNodes[0].body.dynamic.value);
        const extensions = $eb281dfded33b271$var$extractExtensions(adf);
        return extensions.length > 0;
    } catch (e) {
        return false;
    }
};
const $eb281dfded33b271$var$failureIfNotSuccess = (reason)=>(success)=>success ? undefined : {
            MacrosQuery_extensions: reason
        };
const $eb281dfded33b271$var$preloadMacrosSSRAndReturnTopXFailed = async (contentId, contentNodesOrPromise)=>{
    const blocklist = (0, $ld6xp.getMultiMacroQueryBlocklistFF)();
    let noExtensionsSignal = undefined;
    if ((0, $9wGTI.fg)('cc_macro_preload_early_exit')) {
        const isContentNodePromise = typeof contentNodesOrPromise?.then === 'function';
        if (contentNodesOrPromise && !isContentNodePromise) {
            if (!$eb281dfded33b271$var$hasExtensions(contentNodesOrPromise)) return {};
        }
        noExtensionsSignal = new Promise((resolve)=>{
            if (isContentNodePromise) contentNodesOrPromise.then((contentNodes)=>{
                if (!$eb281dfded33b271$var$hasExtensions(contentNodes)) resolve();
            });
        });
    }
    const preloadResult = await (0, $gGkCt.macroPreloadGuard)('MacrosQuery_preload', ()=>{
        return (0, $dYU3e.query)({
            variables: {
                first: (0, $6JwPA.DEFAULT_PRELOAD_COUNT),
                contentId: contentId,
                blocklist: blocklist
            },
            query: (0, $g1f2M.MacrosQuery),
            context: {
                single: true
            }
        });
    }, noExtensionsSignal).then($eb281dfded33b271$var$failureIfNotSuccess('timeout-rendered-macros'));
    return preloadResult ? Object.assign({}, ...[
        preloadResult
    ]) : {};
};
async function $eb281dfded33b271$export$b470c165ef60e727(contentId, contentNodesOrPromise) {
    // Function has early return so we extracted it out to avoid setting global in every return
    const topXFailed = await $eb281dfded33b271$var$preloadMacrosSSRAndReturnTopXFailed(contentId, contentNodesOrPromise);
    window['__SSR_MACRO_PRELOAD_TOPX_FAILS__'] = topXFailed;
    return topXFailed;
}

});


parcelRegister("33AJK", function(module, exports) {

$parcel$export(module.exports, "preloadSpace", () => $e1c1a581f9cef1d6$export$f73e4f65960ffd6e);

var $dYU3e = parcelRequire("dYU3e");

var $lumgz = parcelRequire("lumgz");
function $e1c1a581f9cef1d6$export$f73e4f65960ffd6e(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $lumgz.spaceForBaseSpaceQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
}

});

parcelRegister("aOmVc", function(module, exports) {

$parcel$export(module.exports, "preloadScreen", () => $7df05aa0881398cb$export$ac86736f8ee66015);

var $dYU3e = parcelRequire("dYU3e");

var $5jrGM = parcelRequire("5jrGM");
function $7df05aa0881398cb$export$ac86736f8ee66015(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $5jrGM.ScreenQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
}

});

parcelRegister("2a3Pf", function(module, exports) {

$parcel$export(module.exports, "preloadGroupedButtons", () => $428e758fdbd08d59$export$9a90cdaf2bd47339);

var $lyWac = parcelRequire("lyWac");

var $9WAeG = parcelRequire("9WAeG");

var $4vyfK = parcelRequire("4vyfK");

var $3D1KL = parcelRequire("3D1KL");

var $kb8ij = parcelRequire("kb8ij");

var $cEgMD = parcelRequire("cEgMD");

var $c5PJ2 = parcelRequire("c5PJ2");
function $428e758fdbd08d59$export$9a90cdaf2bd47339({ contentId: contentId, spaceKey: spaceKey, userId: userId, isLicensed: isLicensed = false }) {
    /**
	 * Watch dialog button:
	 * next/packages/ssr-app/src/module-replacements/@confluence/watch-dialog.js
	 *
	 * "..." button:
	 * See next/packages/ssr-app/src/module-replacements/@confluence/content-tools.js
	 *
	 * Share button:
	 * See next/packages/ssr-app/src/module-replacements/@confluence/share.js
	 */ return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:pageButtons', async ()=>{
        const tasks = [
            (0, $3D1KL.preloadEditButton)({
                spaceKey: spaceKey,
                contentId: contentId
            })
        ];
        const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        if (!isCompanyHub) // Determine whether to show restriction and share button
        tasks.push((0, $4vyfK.preloadWebItemLocation)({
            location: 'system.content.button',
            // Special case when we know the content id the code in SpaceOverviewGroupedButtons only cares about content id
            ...contentId ? {
                contentId: contentId
            } : {
                spaceKey: spaceKey
            }
        }), (0, $kb8ij.preloadWatchDialog)({
            spaceKey: spaceKey,
            isLicensed: isLicensed,
            userId: userId,
            contentId: contentId
        }), (0, $c5PJ2.preloadSpaceStarTextButton)(spaceKey));
        return (0, $lyWac.waitForAllReturnWhenError)(tasks);
    });
}

});
parcelRegister("c5PJ2", function(module, exports) {

$parcel$export(module.exports, "preloadSpaceStarTextButton", () => $281f296bea45b91b$export$61b87ca9f0bb7f96);

var $dYU3e = parcelRequire("dYU3e");

var $7C95e = parcelRequire("7C95e");
function $281f296bea45b91b$export$61b87ca9f0bb7f96(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $7C95e.FavouriteSpaceQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
}

});



parcelRegister("2iJnA", function(module, exports) {

$parcel$export(module.exports, "DatabaseUnifiedQuery", () => $7de465164a80c8f0$export$c3eaa35ce91217cd);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $7de465164a80c8f0$export$c3eaa35ce91217cd = (0, $d2LG0.default)`query DatabaseUnifiedQuery($contentId:ID!$spaceKey:String$contentVersion:Int!){content(id:$contentId){nodes{id referenceId title operations{operation targetType}hasRestrictions hasViewRestrictions hasInheritedRestrictions space{id name key type alias}type status ancestors{id type title status}}}spaces(spaceKey:$spaceKey first:10){nodes{id name homepage{id}}}user:confluence_atlassianUser(current:true){id displayName photos{value isPrimary}emails{value isPrimary}locale confluence{space{id}}}dataSecurityPolicy{isActionEnabledForContent(action:PAGE_EXPORT contentId:$contentId contentStatus:CURRENT spaceKey:$spaceKey contentVersion:$contentVersion){allowed}}}`;

});

parcelRegister("ahDyi", function(module, exports) {

$parcel$export(module.exports, "EmbedUnifiedQuery", () => $8b164b879bf4196d$export$4acf0a5706eccdf6);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $8b164b879bf4196d$export$4acf0a5706eccdf6 = (0, $d2LG0.default)`query EmbedUnifiedQuery($contentId:ID!$spaceKey:String!){content(id:$contentId){nodes{id title metadata{frontend{embedUrl}currentuser{favourited{isFavourite}}}operations{operation targetType}hasRestrictions hasViewRestrictions hasInheritedRestrictions space{id name key type alias}type status ancestors{id type title status}embeddedProduct}}spaces(spaceKey:$spaceKey first:10){nodes{id name homepage{id}}}user:confluence_atlassianUser(current:true){id confluence{space{id}}}}`;

});

parcelRegister("dPxOK", function(module, exports) {

$parcel$export(module.exports, "SpacePagesQuery", () => $808b815339a04d5e$export$a00e3b42c37910ac);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $808b815339a04d5e$export$a00e3b42c37910ac = (0, $d2LG0.default)`query SpacePagesQuery($searchText:String!$filters:ConfluenceSearchFilters!$first:Int!$maxNumberOfResults:Int!$token:String$sortBy:[ConfluenceContentSortField!]$isLicensed:Boolean!$includeRecommended:Boolean=false$spaceId:String=""$scopes:[ConfluenceContentSearchScope!]!)@allowHigherTimeout{confluenceContentSearch(query:$searchText scopes:$scopes filters:$filters first:$first token:$token sort:$sortBy sessionAttributes:{experience:"confluence.spacePages"}){nodes{...on ConfluenceContentSearchResult@include(if:$isLicensed){watchDialogContent:content{id currentUserIsWatching type space{id key currentUser{isWatched isWatchingBlogs}operations{operation targetType}}}}...on ConfluenceContentSearchResult{id title url excerpt lastModified{value}content{id type subType status blank links{editui}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}editorVersion:properties(key:"editor"){nodes{id key value}}space{id key alias name}history{createdBy{profilePicture{path}displayName ...on KnownUser{accountId}...on User{accountId}}ownedBy{profilePicture{path}displayName ...on KnownUser{accountId}...on User{accountId}}}metadata{currentuser{favourited{isFavourite}}comments{commentsCount}}likes{count}version{by{profilePicture{path}displayName ...on KnownUser{accountId}...on User{accountId}}}}}}totalCount pageInfo{hasNextPage nextPageToken}}objectRecommendations(context:{containerId:$spaceId product:"confluence"}modelRequestParams:{experience:"ConfSpacePages" caller:"confluence"}maxNumberOfResults:$maxNumberOfResults)@include(if:$includeRecommended){nodes{id content{id title type subType status blank excerpt(length:372)links{webui editui}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}editorVersion:properties(key:"editor"){nodes{id key value}}space{id key alias name}history{createdBy{profilePicture{path}displayName ...on KnownUser{accountId}...on User{accountId}}ownedBy{profilePicture{path}displayName ...on KnownUser{accountId}...on User{accountId}}}metadata{lastModifiedDate currentuser{favourited{isFavourite}}comments{commentsCount}}likes{count}version{by{profilePicture{path}displayName ...on KnownUser{accountId}...on User{accountId}}}}}}}`;

});

parcelRegister("f3nZa", function(module, exports) {

$parcel$export(module.exports, "PagesSpaceIdQuery", () => $7de58d80405ca3af$export$ba58eecec1482def);

var $d2LG0 = parcelRequire("d2LG0");
const $7de58d80405ca3af$export$ba58eecec1482def = (0, $d2LG0.default)`query PagesSpaceIdQuery($spaceKey:String){space(key:$spaceKey){id}}`;

});

parcelRegister("86moY", function(module, exports) {

$parcel$export(module.exports, "SpacePagesPersistenceQuery", () => $049755726a6450c1$export$d0409301e9db0143);

var $d2LG0 = parcelRequire("d2LG0");
const $049755726a6450c1$export$8d7f96aa1035fc87 = (0, $d2LG0.default)`mutation SpacePagesAppearanceMutation($persistenceOption:PagesDisplayPersistenceOption!){updateUserPreferences(userPreferences:{globalPageCardAppearancePreference:$persistenceOption}){globalPageCardAppearancePreference}}`;
const $049755726a6450c1$export$555fc20901eb87ef = (0, $d2LG0.default)`mutation SpacePagesSortMutation($spaceKey:String!$field:PagesSortField!$order:PagesSortOrder!){updateUserPreferences(userPreferences:{spacePagesSortView:{spaceKey:$spaceKey spacePagesSortPersistenceOption:{field:$field order:$order}}}){spacePagesSortView(spaceKey:$spaceKey){field order}}}`;
const $049755726a6450c1$export$d0409301e9db0143 = (0, $d2LG0.default)`query SpacePagesPersistenceQuery($spaceKey:String!){userPreferences{globalPageCardAppearancePreference spacePagesSortView(spaceKey:$spaceKey){field order}}}`;

});

parcelRegister("7AO3u", function(module, exports) {

$parcel$export(module.exports, "ConfluenceContentSearchScope", () => $9d70d443261cdb0a$export$503b60f723e366ca);
$parcel$export(module.exports, "ConfluenceContentSortingParameter", () => $9d70d443261cdb0a$export$e9da5e0f236e706a);
$parcel$export(module.exports, "ConfluenceSearchContentStatus", () => $9d70d443261cdb0a$export$3464374b402385fe);
$parcel$export(module.exports, "LabelNamespaceEnum", () => $9d70d443261cdb0a$export$285b07120e1d0458);
$parcel$export(module.exports, "SortOrder", () => $9d70d443261cdb0a$export$7ae723045d45777a);
/**
 * @generated SignedSource<<1cc5eb6c58a74933ad37c12ee40c2f89>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $9d70d443261cdb0a$export$503b60f723e366ca = /*#__PURE__*/ function(ConfluenceContentSearchScope) {
    ConfluenceContentSearchScope["PAGE"] = "PAGE";
    ConfluenceContentSearchScope["BLOGPOST"] = "BLOGPOST";
    ConfluenceContentSearchScope["ATTACHMENT"] = "ATTACHMENT";
    ConfluenceContentSearchScope["SPACE"] = "SPACE";
    ConfluenceContentSearchScope["WHITEBOARD"] = "WHITEBOARD";
    ConfluenceContentSearchScope["DATABASE"] = "DATABASE";
    ConfluenceContentSearchScope["EMBED"] = "EMBED";
    ConfluenceContentSearchScope["FOLDER"] = "FOLDER";
    return ConfluenceContentSearchScope;
}({});
var $9d70d443261cdb0a$export$e9da5e0f236e706a = /*#__PURE__*/ function(ConfluenceContentSortingParameter) {
    ConfluenceContentSortingParameter["LAST_MODIFIED_DATE"] = "LAST_MODIFIED_DATE";
    ConfluenceContentSortingParameter["TITLE"] = "TITLE";
    return ConfluenceContentSortingParameter;
}({});
var $9d70d443261cdb0a$export$3464374b402385fe = /*#__PURE__*/ function(ConfluenceSearchContentStatus) {
    ConfluenceSearchContentStatus["ARCHIVED"] = "ARCHIVED";
    ConfluenceSearchContentStatus["CURRENT"] = "CURRENT";
    ConfluenceSearchContentStatus["DRAFT"] = "DRAFT";
    return ConfluenceSearchContentStatus;
}({});
var $9d70d443261cdb0a$export$285b07120e1d0458 = /*#__PURE__*/ function(LabelNamespaceEnum) {
    LabelNamespaceEnum["GLOBAL"] = "GLOBAL";
    LabelNamespaceEnum["MY"] = "MY";
    LabelNamespaceEnum["TEAM"] = "TEAM";
    return LabelNamespaceEnum;
}({});
var $9d70d443261cdb0a$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
    return SortOrder;
}({});

});

parcelRegister("l6Wn6", function(module, exports) {

$parcel$export(module.exports, "FeedContentQuery", () => $a328d03c4f9c53d2$export$9aad4469e08acfd4);

var $d2LG0 = parcelRequire("d2LG0");
const $a328d03c4f9c53d2$export$9aad4469e08acfd4 = (0, $d2LG0.default)`query FeedContentQuery($first:Int$after:String$sortBy:String="relevant"){feed(first:$first after:$after sortBy:$sortBy)@connection(key:"homeFollowingFeed" filter:["sortBy"]){nodes{recentActionsCount summaryLineUpdate{datetime type groupSize ...on FeedEventCreate{user{...FeedContentUserFragment}}...on FeedEventEdit{version user{...FeedContentUserFragment}}...on FeedEventEditLive{version user{...FeedContentUserFragment}}...on FeedEventPublishLive{version user{...FeedContentUserFragment}}...on FeedEventComment{user{...FeedContentUserFragment}comment{id links{webui}location{type ...on InlineComment{inlineText}}body(representation:ATLAS_DOC_FORMAT){value}}}}source content{title id type subType emoji:properties(key:"emoji-title-published"){nodes{id value}}excerpt(length:350)links{webui}history{createdBy{...FeedContentUserFragment}ownedBy{type displayName profilePicture{path}...on KnownUser{accountId}...on User{accountId}}createdDate}space{alias id key name}metadata{lastModifiedDate comments{commentsCount}currentuser{favourited{isFavourite}}}}}pageInfo{hasNextPage endCursor}}getFeedUserConfig{spaces{id}users{...on KnownUser{accountId}...on User{accountId}...on UnknownUser{accountId}}servingRecommendations}}fragment FeedContentUserFragment on Person{type displayName profilePicture{path}...on KnownUser{accountId}...on User{accountId}...on UnknownUser{accountId}}`;

});

parcelRegister("iMMzj", function(module, exports) {

$parcel$export(module.exports, "FeedTypeSelectorRefreshQuery", () => $9b8a156a0cb355c5$export$aa59b2a09c5d71d);

var $d2LG0 = parcelRequire("d2LG0");
const $9b8a156a0cb355c5$export$aa59b2a09c5d71d = (0, $d2LG0.default)`query FeedTypeSelectorRefreshQuery{userPreferences{feedTab}}`;
const $9b8a156a0cb355c5$export$ed5ae1c50818ce2b = (0, $d2LG0.default)`mutation FeedTypeSelectorRefreshMutation($feedTab:String!){updateUserPreferences(userPreferences:{feedTab:$feedTab}){feedTab}}`;

});

parcelRegister("gdJfm", function(module, exports) {

$parcel$export(module.exports, "FeedPopularFeedQuery", () => $f53ac8265315b0e2$export$c5dff26507d19554);

var $d2LG0 = parcelRequire("d2LG0");
const $f53ac8265315b0e2$export$c5dff26507d19554 = (0, $d2LG0.default)`query FeedPopularFeedQuery($first:Int$after:String$timeGranularity:String="default"){popularFeed(first:$first after:$after timeGranularity:$timeGranularity)@connection(key:"homePopularFeed" filter:["timeGranularity"]){nodes{content{title id type subType emoji:properties(key:"emoji-title-published"){nodes{id value}}excerpt(length:350)labels{nodes{name}}links{webui}space{alias id key name}history{createdDate createdBy{type displayName profilePicture{path}...on KnownUser{accountId}...on User{accountId}...on UnknownUser{accountId}}ownedBy{type displayName profilePicture{path}...on KnownUser{accountId}...on User{accountId}}}metadata{lastModifiedDate comments{commentsCount}currentuser{favourited{isFavourite}}}version{friendlyWhen}}}pageInfo{hasNextPage endCursor}}}`;

});

parcelRegister("7OD0G", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetsQuery", () => $4564ce70ae4ed46b$export$67e44d402eae028);

var $d2LG0 = parcelRequire("d2LG0");
const $4564ce70ae4ed46b$export$67e44d402eae028 = (0, $d2LG0.default)`query HomeWidgetsQuery{userPreferences{homeWidgets{id state __typename}__typename}}`;

});

parcelRegister("7qrXq", function(module, exports) {

$parcel$export(module.exports, "getRecentWorkQueryOptions", () => $71128cfb63bfebb5$export$154132902c275093);

var $2lAwa = parcelRequire("2lAwa");

var $ctLrB = parcelRequire("ctLrB");

var $j1aTp = parcelRequire("j1aTp");
const $71128cfb63bfebb5$export$154132902c275093 = ({ cloudId: cloudId, isLoggedIn: isLoggedIn, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false, first: first = 10, isActivityV3MigrationEnabled: isActivityV3MigrationEnabled = false })=>({
        query: isActivityV3MigrationEnabled ? (0, $j1aTp.HomeRecentWorkV3Query) : (0, $j1aTp.HomeRecentWorkQuery),
        variables: {
            cloudId: isActivityV3MigrationEnabled ? (0, $2lAwa.PlatformSiteAri).create({
                siteId: cloudId
            }).toString() : cloudId,
            first: first,
            after: '',
            objectTypes: [
                (0, $ctLrB.ActivitiesObjectType).PAGE,
                (0, $ctLrB.ActivitiesObjectType).BLOGPOST,
                (0, $ctLrB.ActivitiesObjectType).EMBED,
                ...isWhiteboardViewedEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                ] : [],
                ...isDatabaseEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).DATABASE
                ] : [],
                ...isActivityV3MigrationEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).CONTENT
                ] : []
            ]
        },
        skip: !isLoggedIn
    });

});
parcelRegister("ctLrB", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $61e4e33a86012bad$export$62aa48085237e36f);
$parcel$export(module.exports, "HomeViewFilters", () => $61e4e33a86012bad$export$f5dd0176116f8854);
$parcel$export(module.exports, "ActivityEventType", () => $61e4e33a86012bad$export$132f858337fea016);
$parcel$export(module.exports, "ActivitiesObjectType", () => $61e4e33a86012bad$export$4edf00fad4b97379);
$parcel$export(module.exports, "untitled", () => $61e4e33a86012bad$export$232e7dd3cd551a33);
$parcel$export(module.exports, "getLoadingState", () => $61e4e33a86012bad$export$2786ecc2e2951fe3);
$parcel$export(module.exports, "notEmpty", () => $61e4e33a86012bad$export$b29ea735dcfba3c1);
$parcel$export(module.exports, "byTitle", () => $61e4e33a86012bad$export$4b0a6c95b9c45006);
$parcel$export(module.exports, "transformActivityData", () => $61e4e33a86012bad$export$c29c1699278467fe);
$parcel$export(module.exports, "notArchived", () => $61e4e33a86012bad$export$7105b33a95adadcf);
$parcel$export(module.exports, "notDeleted", () => $61e4e33a86012bad$export$d54a312242c6a930);
$parcel$export(module.exports, "isCreatorCurrentUser", () => $61e4e33a86012bad$export$78ba6bbd8fcbc43f);

var $aTqya = parcelRequire("aTqya");

var $2nPZH = parcelRequire("2nPZH");
var $61e4e33a86012bad$export$62aa48085237e36f = /*#__PURE__*/ function(LoadingState) {
    LoadingState[LoadingState["done"] = 0] = "done";
    LoadingState[LoadingState["initial"] = 1] = "initial";
    LoadingState[LoadingState["pagination"] = 2] = "pagination";
    return LoadingState;
}({});
var $61e4e33a86012bad$export$f5dd0176116f8854 = /*#__PURE__*/ function(HomeViewFilters) {
    HomeViewFilters["ALL"] = "ALL";
    HomeViewFilters["WORKED_ON"] = "WORKED_ON";
    HomeViewFilters["CREATED"] = "CREATED";
    HomeViewFilters["STARRED"] = "STARRED";
    HomeViewFilters["TASKS"] = "TASKS";
    HomeViewFilters["DRAFTS"] = "DRAFTS";
    return HomeViewFilters;
}({});
var $61e4e33a86012bad$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["EDITED"] = "EDITED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["SNAPSHOTTED"] = "SNAPSHOTTED";
    ActivityEventType["STARTED"] = "STARTED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["VIEWED"] = "VIEWED";
    return ActivityEventType;
}({});
var $61e4e33a86012bad$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["BLOGPOST"] = "BLOGPOST";
    ActivitiesObjectType["DATABASE"] = "DATABASE";
    ActivitiesObjectType["EMBED"] = "EMBED";
    ActivitiesObjectType["ISSUE"] = "ISSUE";
    ActivitiesObjectType["PAGE"] = "PAGE";
    ActivitiesObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivitiesObjectType["CONTENT"] = "CONTENT";
    ActivitiesObjectType["COMMENT"] = "COMMENT";
    return ActivitiesObjectType;
}({});
const $61e4e33a86012bad$var$i18n = (0, $2nPZH.defineMessages)({
    untitled: {
        id: "home.views.untitled",
        defaultMessage: "Untitled"
    }
});
const $61e4e33a86012bad$export$232e7dd3cd551a33 = $61e4e33a86012bad$var$i18n.untitled;
const $61e4e33a86012bad$export$2786ecc2e2951fe3 = (networkStatus)=>{
    if (networkStatus === (0, $aTqya.NetworkStatus).loading || networkStatus === (0, $aTqya.NetworkStatus).setVariables) return 1;
    if (networkStatus === (0, $aTqya.NetworkStatus).fetchMore) return 2;
    return 0;
};
function $61e4e33a86012bad$export$b29ea735dcfba3c1(value) {
    return value !== null && value !== undefined;
}
const $61e4e33a86012bad$export$4b0a6c95b9c45006 = (textFilter, title)=>{
    const trimmedTextFilter = textFilter.trim();
    if (trimmedTextFilter === '') return true;
    return (title || '').toUpperCase().indexOf(textFilter.toUpperCase()) > -1;
};
const $61e4e33a86012bad$export$c29c1699278467fe = (recent, isActivityV3HomeRecent)=>{
    if (recent?.object?.data?.commentId) {
        recent.event.eventType = 'commented';
        recent.object.data = recent?.object?.data?.container;
    }
    const content = recent?.object?.data;
    if (isActivityV3HomeRecent && content) {
        content.type = content.type?.toLowerCase();
        if (content.type === 'blog_post') content.type = 'blogpost';
        content.subtype = content.subtype?.toLowerCase();
        // The "status" field is ConfluencePage/ConfluenceBlogPost type for pages/blogs but is
        // ConfluenceContentStatus type for all other content types. To prevent the GraphQL
        // "returns different types" error, we are using the aliases "pageStatus" and "blogStatus"
        content.status = [
            content.status,
            content.pageStatus,
            content.blogStatus
        ].find((status)=>status)?.toLowerCase();
        // FE workaround for activity query returning "status: DRAFT" for published content with unpublished changes
        if (content.status === 'draft' && content.createdAt) content.status = 'current';
        recent.event.eventType = recent.event?.eventType.toUpperCase();
    }
    return recent;
};
const $61e4e33a86012bad$export$7105b33a95adadcf = (content)=>{
    return content?.status !== 'archived';
};
const $61e4e33a86012bad$export$d54a312242c6a930 = (content)=>{
    return content?.status !== 'trashed';
};
const $61e4e33a86012bad$export$78ba6bbd8fcbc43f = (userId, content)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    return userId === createdBy?.accountId;
};

});

parcelRegister("j1aTp", function(module, exports) {

$parcel$export(module.exports, "HomeRecentWorkQuery", () => $97a912758a44bf59$export$93fc89076fcc0c52);
$parcel$export(module.exports, "HomeRecentWorkV3Query", () => $97a912758a44bf59$export$cc29847299262653);

var $d2LG0 = parcelRequire("d2LG0");
const $97a912758a44bf59$export$93fc89076fcc0c52 = (0, $d2LG0.default)`query HomeRecentWorkQuery($cloudId:ID!$first:Int$after:String$objectTypes:[ActivitiesObjectType!]){activities{myActivities{all(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:$objectTypes cloudIds:[$cloudId]}}]first:$first after:$after){edges{cursor node{id timestamp object{id events{eventType}content{id title subType type links{webui editui}metadata{sourceTemplateEntityId}space{alias id key name}status blank emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}}}}}}}}}`;
const $97a912758a44bf59$export$cc29847299262653 = (0, $d2LG0.default)`query RecentListHomeRecentWorkV3Query($cloudId:ID!$first:Int$after:String$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND rootContainerIds:[$cloudId]arguments:{products:["CONFLUENCE"]objectTypes:$objectTypes}}first:$first after:$after){edges{cursor node{id object{id data{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}space{alias id key name}}...on ConfluenceBlogPost{id title type blogStatus:status createdAt links{webUi editUi}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}space{alias id key name}}...on ConfluenceWhiteboard{id title type status links{webUi}space{alias id key name}}...on ConfluenceDatabase{id title type status links{webUi}space{alias id key name}}...on ConfluenceEmbed{id title type status links{webUi}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}space{alias id key name}}}}event{timestamp eventType}}}}}}}`;

});


parcelRegister("1Qleo", function(module, exports) {

$parcel$export(module.exports, "ALL_RECENT_ITEMS_COUNT_HOME_REFRESH", () => $c9a56e1f8bd1d4b6$export$a1180afea81894e6);
const $c9a56e1f8bd1d4b6$export$a1180afea81894e6 = 6;

});

parcelRegister("iNq0h", function(module, exports) {

$parcel$export(module.exports, "HomeViewsUserPreferencesQuery", () => $c1632a1d98dd95be$export$c947bf9ea37af41f);

var $d2LG0 = parcelRequire("d2LG0");
const $c1632a1d98dd95be$export$c947bf9ea37af41f = (0, $d2LG0.default)`query HomeViewsUserPreferencesQuery{userPreferences{homePagesDisplayView}}`;
const $c1632a1d98dd95be$export$3563be99821d5f00 = (0, $d2LG0.default)`mutation HomeViewsUserPreferencesMutation($appearance:PagesDisplayPersistenceOption!){updateUserPreferences(userPreferences:{homePagesDisplayView:$appearance}){homePagesDisplayView}}`;

});

parcelRegister("k2RxH", function(module, exports) {

$parcel$export(module.exports, "getRecentQueryOptions", () => $355018d1e9284f84$export$c0883c47d72a59fc);

var $2lAwa = parcelRequire("2lAwa");

var $6mKj3 = parcelRequire("6mKj3");

var $1dnxO = parcelRequire("1dnxO");

var $ctLrB = parcelRequire("ctLrB");

var $dTFEh = parcelRequire("dTFEh");

var $fD3hS = parcelRequire("fD3hS");
// This list matches the event types Activity Platform uses for
// activities.myActivities.workedOn with CREATED and UPDATED
// removed as those events are only used in Jira
// https://bitbucket.org/atlassian/worklens/src/bff1a264119c0121e1e7ec7787442cdf0e177f40/src/main/java/com/atlassian/worklens/settings/EventsSettings.java#lines-38
const $355018d1e9284f84$var$WORKED_ON_EVENT_TYPES = [
    (0, $ctLrB.ActivityEventType).COMMENTED,
    (0, $ctLrB.ActivityEventType).EDITED,
    (0, $ctLrB.ActivityEventType).PUBLISHED,
    (0, $ctLrB.ActivityEventType).UPDATED
];
const $355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3 = [
    (0, $ctLrB.ActivityEventType).EDITED,
    (0, $ctLrB.ActivityEventType).PUBLISHED,
    (0, $ctLrB.ActivityEventType).UPDATED,
    (0, $ctLrB.ActivityEventType).CREATED,
    (0, $ctLrB.ActivityEventType).STARTED,
    (0, $ctLrB.ActivityEventType).SNAPSHOTTED
];
const $355018d1e9284f84$var$COLLABORATED_ON_EVENT_TYPES = [
    (0, $ctLrB.ActivityEventType).COMMENTED,
    ...$355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3
];
const $355018d1e9284f84$var$OBJECT_TYPES = [
    (0, $ctLrB.ActivitiesObjectType).PAGE,
    (0, $ctLrB.ActivitiesObjectType).BLOGPOST,
    (0, $ctLrB.ActivitiesObjectType).EMBED
];
const $355018d1e9284f84$var$PAGE_SIZE = 24;
const $355018d1e9284f84$export$c0883c47d72a59fc = ({ pill: pill, cloudId: cloudId, endCursor: endCursor, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled, isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled, isDatabaseEnabled: isDatabaseEnabled })=>{
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const userField = (0, $6mKj3.expVal)('confluence_frontend_page_ownership_recent_tab_page', 'isEnabled', false) ? 'owner' : 'creator';
    const createdDateFilter = isNav4Enabled ? 'and created >= startOfDay("-90d") ' : '';
    const activityQuery = (0, $6mKj3.expVal)('confluence_activity_v3_collaborated_on_experiment', 'isEnabled', false) ? (0, $fD3hS.HomeRecentActivityQuery) : (0, $dTFEh.HomeRecentActivitiesQuery);
    const activityCloudId = (0, $6mKj3.expVal)('confluence_activity_v3_collaborated_on_experiment', 'isEnabled', false) ? (0, $2lAwa.PlatformSiteAri).create({
        siteId: cloudId
    }).toString() : cloudId;
    switch(pill){
        case 'created':
            return {
                query: (0, $dTFEh.HomeRecentCreatedQuery),
                variables: {
                    cql: `type in (page, blogpost, embed${isWhiteboardUpdatedEnabled ? ', whiteboard' : ''}${isDatabaseEnabled ? ', database' : ''}) and ${userField}=currentUser() ${createdDateFilter}order by created desc`,
                    cqlcontext: `{"contentStatuses":["draft", "current"]}`,
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor
                }
            };
        case 'worked-on':
            return {
                query: activityQuery,
                variables: {
                    cloudId: activityCloudId,
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor,
                    eventTypes: (0, $6mKj3.expVal)('confluence_activity_v3_collaborated_on_experiment', 'isEnabled', false) ? $355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3 : $355018d1e9284f84$var$WORKED_ON_EVENT_TYPES,
                    objectTypes: [
                        ...$355018d1e9284f84$var$OBJECT_TYPES,
                        ...isWhiteboardUpdatedEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                        ] : [],
                        ...isDatabaseEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).DATABASE
                        ] : [],
                        ...(0, $6mKj3.expVal)('confluence_activity_v3_collaborated_on_experiment', 'isEnabled', false) ? [
                            (0, $ctLrB.ActivitiesObjectType).CONTENT
                        ] : []
                    ]
                }
            };
        case 'collaborated-on':
            return {
                query: activityQuery,
                variables: {
                    cloudId: (0, $2lAwa.PlatformSiteAri).create({
                        siteId: cloudId
                    }).toString(),
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor,
                    eventTypes: $355018d1e9284f84$var$COLLABORATED_ON_EVENT_TYPES,
                    objectTypes: [
                        ...$355018d1e9284f84$var$OBJECT_TYPES,
                        ...isWhiteboardUpdatedEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                        ] : [],
                        ...isDatabaseEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).DATABASE
                        ] : [],
                        (0, $ctLrB.ActivitiesObjectType).CONTENT,
                        (0, $ctLrB.ActivitiesObjectType).COMMENT
                    ]
                }
            };
        case 'all':
        default:
            return {
                query: activityQuery,
                variables: {
                    cloudId: activityCloudId,
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor,
                    eventTypes: [],
                    objectTypes: [
                        ...$355018d1e9284f84$var$OBJECT_TYPES,
                        ...isWhiteboardViewedEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                        ] : [],
                        ...isDatabaseEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).DATABASE
                        ] : [],
                        ...(0, $6mKj3.expVal)('confluence_activity_v3_collaborated_on_experiment', 'isEnabled', false) ? [
                            (0, $ctLrB.ActivitiesObjectType).CONTENT
                        ] : []
                    ]
                }
            };
    }
};

});
parcelRegister("dTFEh", function(module, exports) {

$parcel$export(module.exports, "HomeRecentUserPreferencesQuery", () => $27b84da9e4be640f$export$4cd16757ca3b8d2);
$parcel$export(module.exports, "HomeRecentActivitiesQuery", () => $27b84da9e4be640f$export$e31d4e9aea7e8eeb);
$parcel$export(module.exports, "HomeRecentCreatedQuery", () => $27b84da9e4be640f$export$1b405121a715cf1a);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $27b84da9e4be640f$export$4cd16757ca3b8d2 = (0, $d2LG0.default)`query HomeRecentUserPreferencesQuery{userPreferences{recentFilter}}`;
const $27b84da9e4be640f$export$5b0a6ecec307c73a = (0, $d2LG0.default)`mutation HomeRecentUserPreferencesMutation($filter:RecentFilter){updateUserPreferences(userPreferences:{recentFilter:$filter}){recentFilter}}`;
const $27b84da9e4be640f$export$e31d4e9aea7e8eeb = (0, $d2LG0.default)`query HomeRecentActivitiesQuery($cloudId:ID!$first:Int$after:String$eventTypes:[ActivityEventType!]$objectTypes:[ActivitiesObjectType!]){activities{myActivities{all(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:$objectTypes cloudIds:[$cloudId]eventTypes:$eventTypes}}]first:$first after:$after){edges{cursor node{id timestamp object{id events{eventType}content{id title type subType links{webui editui}excerpt(length:372)metadata{currentuser{favourited{isFavourite}}comments{commentsCount}}space{alias id key name}likes{count}status blank editorVersion:properties(key:"editor"){nodes{id key value}}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id value key}}}}}}pageInfo{hasNextPage}}}}}`;
const $27b84da9e4be640f$export$1b405121a715cf1a = (0, $d2LG0.default)`query HomeRecentCreatedQuery($cql:String!$cqlcontext:String!$first:Int$after:String){search:confluence_search(cql:$cql cqlcontext:$cqlcontext first:$first after:$after){nodes{content{id title type subType links{webui editui}excerpt(length:372)metadata{currentuser{favourited{isFavourite}}comments{commentsCount}}space{alias id key name}likes{count}status blank metadata{createdDate}editorVersion:properties(key:"editor"){nodes{id key value}}emoji:properties(keys:["emoji-title-published"]){nodes{id value key}}history{createdBy{...on KnownUser{accountId}...on User{accountId}}}version{by{...on KnownUser{accountId}...on User{accountId}}}}}pageInfo{hasNextPage endCursor}}}`;

});

parcelRegister("fD3hS", function(module, exports) {

$parcel$export(module.exports, "HomeRecentActivityQuery", () => $f2dd689bb1ecd7e4$export$2b6ee81eb817f811);

var $d2LG0 = parcelRequire("d2LG0");
const $f2dd689bb1ecd7e4$export$2b6ee81eb817f811 = (0, $d2LG0.default)`query HomeRecentActivityQuery($cloudId:ID!$first:Int$after:String$eventTypes:[String!]$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND rootContainerIds:[$cloudId]arguments:{products:["CONFLUENCE"]objectTypes:$objectTypes eventTypes:$eventTypes}}first:$first after:$after){edges{cursor node{id object{id data{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}body{excerpt}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}likesSummary{count}editorVersion:properties(keys:["editor"]){value}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceBlogPost{id title type blogStatus:status createdAt links{webUi editUi}body{excerpt}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}likesSummary{count}editorVersion:properties(keys:["editor"]){value}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceWhiteboard{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}}...on ConfluenceDatabase{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}}...on ConfluenceEmbed{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceInlineComment{id commentId container{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}body{excerpt}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}likesSummary{count}editorVersion:properties(keys:["editor"]){value}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceBlogPost{id title type blogStatus:status links{webUi editUi}body{excerpt}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}editorVersion:properties(keys:["editor"]){value}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceWhiteboard{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}}}}...on ConfluenceFooterComment{id commentId container{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}body{excerpt}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}likesSummary{count}editorVersion:properties(keys:["editor"]){value}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceBlogPost{id title type blogStatus:status links{webUi editUi}body{excerpt}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}editorVersion:properties(keys:["editor"]){value}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceWhiteboard{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}commentCountSummary{total}space{id alias key name}}}}}}event{timestamp eventType}}}pageInfo{hasNextPage endCursor}}}}}`;

});


parcelRegister("h6oqk", function(module, exports) {

$parcel$export(module.exports, "getStarredQueryOptions", () => $989c3fbcf8cb03b6$export$b5d0611211eebe41);

var $1Z8HH = parcelRequire("1Z8HH");
const $989c3fbcf8cb03b6$var$PAGE_SIZE = 24;
const $989c3fbcf8cb03b6$export$b5d0611211eebe41 = (_)=>({
        query: (0, $1Z8HH.HomeStarredPagesQuery),
        variables: {
            limit: $989c3fbcf8cb03b6$var$PAGE_SIZE,
            start: 0
        }
    });

});
parcelRegister("1Z8HH", function(module, exports) {

$parcel$export(module.exports, "HomeStarredPagesQuery", () => $0f962776926af63c$export$a0b606bd5fa7d090);

var $d2LG0 = parcelRequire("d2LG0");
const $0f962776926af63c$export$a0b606bd5fa7d090 = (0, $d2LG0.default)`query HomeStarredPagesQuery($limit:Int$start:Int)@allowHigherTimeout{favoriteContent(limit:$limit start:$start){nodes{id subType type title excerpt links{editui webui}history{lastUpdated{when}}editorVersion:properties(key:"editor"){nodes{id key value}}emoji:properties(keys:["emoji-title-published"]){nodes{id key value}}metadata{currentuser{favourited{isFavourite}viewed{lastSeen}}likes{count}comments{commentsCount}}space{alias id key name}}pageInfo{hasNextPage endCursor}}}`;

});


parcelRegister("kgC8N", function(module, exports) {

$parcel$export(module.exports, "getDraftsQueryOptions", () => $8494f2a7cbb1632a$export$c37c2a94b8c9c502);

var $i4C0a = parcelRequire("i4C0a");
const $8494f2a7cbb1632a$var$PAGE_SIZE = 24;
const $8494f2a7cbb1632a$export$c37c2a94b8c9c502 = (_)=>({
        query: (0, $i4C0a.HomeDraftsQuery),
        variables: {
            cqlcontext: `{"contentStatuses":["draft"]}`,
            first: $8494f2a7cbb1632a$var$PAGE_SIZE
        }
    });

});
parcelRegister("i4C0a", function(module, exports) {

$parcel$export(module.exports, "HomeDraftsQuery", () => $75d16630eeb20da5$export$c6036e96d07e5663);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $75d16630eeb20da5$export$c6036e96d07e5663 = (0, $d2LG0.default)`query HomeDraftsQuery($cqlcontext:String$first:Int$after:String){search:confluence_search(cql:"type in (page,blogpost) order by lastModified desc" cqlcontext:$cqlcontext first:$first after:$after){nodes{content{id title type subType links{webui editui}excerpt(length:372)metadata{currentuser{favourited{isFavourite}}comments{commentsCount}}space{alias id key name}likes{count}status blank metadata{lastModifiedDate}editorVersion:properties(key:"editor"){nodes{id key value}}emoji:properties(keys:["emoji-title-draft"]){nodes{id key value}}}}pageInfo{hasNextPage endCursor}}}`;

});


parcelRegister("01STT", function(module, exports) {

$parcel$export(module.exports, "View", () => $8357fd24c5d501e8$export$27a5bd065ad55220);
$parcel$export(module.exports, "SUPPORTED_ROUTES", () => $8357fd24c5d501e8$export$f183fe8f38c8cf4f);
var $8357fd24c5d501e8$export$27a5bd065ad55220 = /*#__PURE__*/ function(View) {
    View["OVERVIEW"] = "overview";
    View["RECENT"] = "recent";
    View["STARRED"] = "starred";
    View["WATCHING"] = "watching";
    View["DRAFTS"] = "drafts";
    View["TASKS"] = "tasks";
    return View;
}({});
const $8357fd24c5d501e8$export$f183fe8f38c8cf4f = [
    "recent",
    "starred",
    "watching",
    "drafts",
    "tasks"
];

});

parcelRegister("LSv6P", function(module, exports) {

let $08feaa9ddad42fe0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $08feaa9ddad42fe0$var$load("8rsL2"),
    $08feaa9ddad42fe0$var$load("iAaum"),
    $08feaa9ddad42fe0$var$load("3KV1Y"),
    $08feaa9ddad42fe0$var$load("ctZCD"),
    $08feaa9ddad42fe0$var$load("diPwe")
]).then(()=>parcelRequire('lGm9u'));

});

parcelRegister("4LIeq", function(module, exports) {

let $378ddcb23dc4b206$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $378ddcb23dc4b206$var$load("i3SEC"),
    $378ddcb23dc4b206$var$load("aYGIV"),
    $378ddcb23dc4b206$var$load("iMlqd"),
    $378ddcb23dc4b206$var$load("19XET"),
    $378ddcb23dc4b206$var$load("2svRO"),
    $378ddcb23dc4b206$var$load("ctZCD"),
    $378ddcb23dc4b206$var$load("iPz8n"),
    $378ddcb23dc4b206$var$load("ffEVr"),
    $378ddcb23dc4b206$var$load("kM6re")
]).then(()=>parcelRequire('bTu8V'));

});

parcelRegister("3X6Hs", function(module, exports) {

let $2e0c143a767b1a93$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2e0c143a767b1a93$var$load("2svRO"),
    $2e0c143a767b1a93$var$load("19XET"),
    $2e0c143a767b1a93$var$load("ctZCD"),
    $2e0c143a767b1a93$var$load("ffEVr"),
    $2e0c143a767b1a93$var$load("fRrg0")
]).then(()=>parcelRequire('7aApD'));

});

parcelRegister("hPi92", function(module, exports) {

let $cfa5464019b8c53f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $cfa5464019b8c53f$var$load("2svRO"),
    $cfa5464019b8c53f$var$load("aYGIV"),
    $cfa5464019b8c53f$var$load("iMlqd"),
    $cfa5464019b8c53f$var$load("19XET"),
    $cfa5464019b8c53f$var$load("ctZCD"),
    $cfa5464019b8c53f$var$load("iPz8n"),
    $cfa5464019b8c53f$var$load("ffEVr"),
    $cfa5464019b8c53f$var$load("iqdt6")
]).then(()=>parcelRequire('gu1SQ'));

});

parcelRegister("ibLA3", function(module, exports) {

let $d3de2993a907225a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d3de2993a907225a$var$load("i3SEC"),
    $d3de2993a907225a$var$load("aYGIV"),
    $d3de2993a907225a$var$load("iMlqd"),
    $d3de2993a907225a$var$load("19XET"),
    $d3de2993a907225a$var$load("2svRO"),
    $d3de2993a907225a$var$load("ctZCD"),
    $d3de2993a907225a$var$load("iPz8n"),
    $d3de2993a907225a$var$load("ffEVr"),
    $d3de2993a907225a$var$load("34wRu")
]).then(()=>parcelRequire('hja8R'));

});

parcelRegister("389Ps", function(module, exports) {

let $2479be4bbbbfcb34$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2479be4bbbbfcb34$var$load("aYGIV"),
    $2479be4bbbbfcb34$var$load("iMlqd"),
    $2479be4bbbbfcb34$var$load("19XET"),
    $2479be4bbbbfcb34$var$load("2svRO"),
    $2479be4bbbbfcb34$var$load("ctZCD"),
    $2479be4bbbbfcb34$var$load("iPz8n"),
    $2479be4bbbbfcb34$var$load("ffEVr"),
    $2479be4bbbbfcb34$var$load("eL8EA")
]).then(()=>parcelRequire('2QxAP'));

});

parcelRegister("hh1xX", function(module, exports) {

let $c935395584faf4fd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c935395584faf4fd$var$load("ctZCD"),
    $c935395584faf4fd$var$load("1hiqo")
]).then(()=>parcelRequire('8NiE4'));

});

parcelRegister("1woFf", function(module, exports) {

let $11bbe9712c2ef0d3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $11bbe9712c2ef0d3$var$load("ctZCD"),
    $11bbe9712c2ef0d3$var$load("1llHF")
]).then(()=>parcelRequire('hRgVC'));

});

parcelRegister("ldwIv", function(module, exports) {

let $f72430c5dc6cd7e4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f72430c5dc6cd7e4$var$load("ctZCD"),
    $f72430c5dc6cd7e4$var$load("53uoN")
]).then(()=>parcelRequire('1XcBd'));

});

parcelRegister("d3ihR", function(module, exports) {

let $9809bd98af04313b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9809bd98af04313b$var$load("ctZCD"),
    $9809bd98af04313b$var$load("deMui")
]).then(()=>parcelRequire('59bfh'));

});

parcelRegister("7IRes", function(module, exports) {

let $59f5ef4afcafd83c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $59f5ef4afcafd83c$var$load("ctZCD"),
    $59f5ef4afcafd83c$var$load("6jNWq")
]).then(()=>parcelRequire('5n8d3'));

});

parcelRegister("hxeLl", function(module, exports) {

let $034b5ed7cf9f975b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $034b5ed7cf9f975b$var$load("ctZCD"),
    $034b5ed7cf9f975b$var$load("3m9re")
]).then(()=>parcelRequire('hHfH9'));

});

parcelRegister("bUpIE", function(module, exports) {

let $8ab8dff998be3414$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8ab8dff998be3414$var$load("ctZCD"),
    $8ab8dff998be3414$var$load("2oglp")
]).then(()=>parcelRequire('84C2y'));

});

parcelRegister("1rd6h", function(module, exports) {

let $10c2798357b529c7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $10c2798357b529c7$var$load("ffEVr"),
    $10c2798357b529c7$var$load("ctZCD"),
    $10c2798357b529c7$var$load("dodbW")
]).then(()=>parcelRequire('gDcgd'));

});

parcelRegister("juVX6", function(module, exports) {

let $e31dc5c3855156d8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e31dc5c3855156d8$var$load("ctZCD"),
    $e31dc5c3855156d8$var$load("7tbBL")
]).then(()=>parcelRequire('ihnIJ'));

});

parcelRegister("8rflh", function(module, exports) {

let $624cbefb38a2752a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $624cbefb38a2752a$var$load("ctZCD"),
    $624cbefb38a2752a$var$load("2VVfz")
]).then(()=>parcelRequire('1phEn'));

});

parcelRegister("dh19o", function(module, exports) {

let $9a9dc16057d6ecb6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9a9dc16057d6ecb6$var$load("ctZCD"),
    $9a9dc16057d6ecb6$var$load("cuewJ")
]).then(()=>parcelRequire('71Pdv'));

});

parcelRegister("cv9ia", function(module, exports) {

let $919f968044998047$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $919f968044998047$var$load("ctZCD"),
    $919f968044998047$var$load("5NFhD")
]).then(()=>parcelRequire('011Nq'));

});

parcelRegister("3DZgu", function(module, exports) {
module.exports = JSON.parse("{\"confluence.lovability.survey.question\":[{\"type\":0,\"value\":\"To what extent do you agree or disagree with the following statement?\"}],\"confluence.lovability.survey.statement\":[{\"type\":0,\"value\":\"Confluence is a product I love using.\"}]}");

});

parcelRegister("6y7aV", function(module, exports) {

let $4c4b7beb47ae1916$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4c4b7beb47ae1916$var$load("dSI8s").then(()=>parcelRequire('jjmEp'));

});

parcelRegister("iuRsy", function(module, exports) {

let $d7747f4547a16ffc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d7747f4547a16ffc$var$load("3DO6J").then(()=>parcelRequire('gVDZW'));

});

parcelRegister("ilGcp", function(module, exports) {

let $d5baec060fafc523$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d5baec060fafc523$var$load("6B9n3").then(()=>parcelRequire('i0qHN'));

});

parcelRegister("aytiN", function(module, exports) {

let $7af3cf2392210f31$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7af3cf2392210f31$var$load("2QZgV").then(()=>parcelRequire('hzuXU'));

});

parcelRegister("iDf56", function(module, exports) {

let $d90791544119a1d0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d90791544119a1d0$var$load("izK4y").then(()=>parcelRequire('aHrqU'));

});

parcelRegister("dX7bz", function(module, exports) {

let $a2865bfd6d57fa49$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a2865bfd6d57fa49$var$load("e5PiI").then(()=>parcelRequire('2coqH'));

});

parcelRegister("a4jvV", function(module, exports) {

let $75496a298e01a16b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $75496a298e01a16b$var$load("9p06w").then(()=>parcelRequire('gs1hE'));

});

parcelRegister("4AUtH", function(module, exports) {

let $3586558d8066c050$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3586558d8066c050$var$load("2MJzn").then(()=>parcelRequire('3h8iV'));

});

parcelRegister("QfAjK", function(module, exports) {

let $09d0f240c71ddfd6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $09d0f240c71ddfd6$var$load("iKC5R").then(()=>parcelRequire('cMM78'));

});

parcelRegister("2TSO1", function(module, exports) {

let $21cb3b1d4e1e2a4e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $21cb3b1d4e1e2a4e$var$load("hBPLB").then(()=>parcelRequire('hkm6O'));

});

parcelRegister("5X1yU", function(module, exports) {

let $4553ac9cd075cf37$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4553ac9cd075cf37$var$load("dxZEv").then(()=>parcelRequire('hCPMa'));

});

parcelRegister("b4a4o", function(module, exports) {

let $80e7e11279cf1bbc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $80e7e11279cf1bbc$var$load("3RDXo").then(()=>parcelRequire('58H7V'));

});

parcelRegister("bdFY5", function(module, exports) {

let $82b176a042796707$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $82b176a042796707$var$load("3Ju5x").then(()=>parcelRequire('9LeHg'));

});

parcelRegister("koqHb", function(module, exports) {

let $ed8ac1b228a52d37$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ed8ac1b228a52d37$var$load("dFW2I").then(()=>parcelRequire('azBMk'));

});

parcelRegister("9cFEs", function(module, exports) {

let $6b358b2778d59fb2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6b358b2778d59fb2$var$load("fQeKR").then(()=>parcelRequire('cbFUi'));

});

parcelRegister("66Uoo", function(module, exports) {

let $472f0c001ddfa706$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $472f0c001ddfa706$var$load("5uwLG").then(()=>parcelRequire('gk8yZ'));

});

parcelRegister("8SgN2", function(module, exports) {

let $676063fe04b622a2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $676063fe04b622a2$var$load("8I3u9").then(()=>parcelRequire('8OnJM'));

});

parcelRegister("hVolH", function(module, exports) {

let $d0caa5c43a33b075$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d0caa5c43a33b075$var$load("3kvGa").then(()=>parcelRequire('2udCA'));

});

parcelRegister("j8YNs", function(module, exports) {

let $defdec9ea5f5a8c8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $defdec9ea5f5a8c8$var$load("kExOo").then(()=>parcelRequire('eV6wi'));

});

parcelRegister("ismoR", function(module, exports) {

let $d6fc37b4824c9eb2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d6fc37b4824c9eb2$var$load("k66R6").then(()=>parcelRequire('rtO87'));

});

parcelRegister("eXsNg", function(module, exports) {

let $ae3ce92c92c65e8c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ae3ce92c92c65e8c$var$load("cyJMM").then(()=>parcelRequire('h1nD1'));

});

parcelRegister("kEGya", function(module, exports) {

let $f0988ca093bb3d41$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f0988ca093bb3d41$var$load("awc0w").then(()=>parcelRequire('7sNOu'));

});

parcelRegister("knmab", function(module, exports) {

let $ed5725ccc925584f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ed5725ccc925584f$var$load("lt7x0").then(()=>parcelRequire('lXxaR'));

});

parcelRegister("7VXGD", function(module, exports) {

let $5c6c27cf6871b512$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5c6c27cf6871b512$var$load("dMT0A").then(()=>parcelRequire('65d4H'));

});

parcelRegister("fkdvI", function(module, exports) {

let $b283342b2e6c9d31$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b283342b2e6c9d31$var$load("ekNLf").then(()=>parcelRequire('5lW0v'));

});

parcelRegister("ekIdk", function(module, exports) {

let $a6f53aeb55af7324$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a6f53aeb55af7324$var$load("c62Vc").then(()=>parcelRequire('dOVKj'));

});

parcelRegister("jXV6x", function(module, exports) {

let $e88fd2c3668e8976$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e88fd2c3668e8976$var$load("icNgM").then(()=>parcelRequire('7wTIR'));

});

parcelRegister("kYtBN", function(module, exports) {

let $f45060e25c3cf336$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f45060e25c3cf336$var$load("hQGbe").then(()=>parcelRequire('6Mk27'));

});

parcelRegister("csosQ", function(module, exports) {

let $911b139fdca63ea1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $911b139fdca63ea1$var$load("1XO6O").then(()=>parcelRequire('ldYkp'));

});

parcelRegister("8eaIp", function(module, exports) {
module.exports = JSON.parse("{\"jira.jira-notify-reaction.message-template.text.single-reaction-with-name\":[{\"type\":0,\"value\":\":bell: *\"},{\"type\":1,\"value\":\"userName\"},{\"type\":0,\"value\":\" reacted to your comment*\"}],\"jira.jira-notify-reaction.message-template.text.view-comment\":[{\"type\":0,\"value\":\"View comment\"}]}");

});

parcelRegister("9nrLF", function(module, exports) {

let $6d3bcd257b48b52f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6d3bcd257b48b52f$var$load("ks76h").then(()=>parcelRequire('45V88'));

});

parcelRegister("072qY", function(module, exports) {

let $000575da7ec3b01d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $000575da7ec3b01d$var$load("fzTL1").then(()=>parcelRequire('7akKj'));

});

parcelRegister("f8DOr", function(module, exports) {

let $b0567c5148095495$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b0567c5148095495$var$load("42exk").then(()=>parcelRequire('lKCMg'));

});

parcelRegister("4JINB", function(module, exports) {

let $372e1d8abe12e575$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $372e1d8abe12e575$var$load("dkLpW").then(()=>parcelRequire('ijhOv'));

});

parcelRegister("hP2es", function(module, exports) {

let $cf98ee5cef0f301a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cf98ee5cef0f301a$var$load("eWmKu").then(()=>parcelRequire('cBAaP'));

});

parcelRegister("b9d2B", function(module, exports) {

let $81daa6a0dabc2dd7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $81daa6a0dabc2dd7$var$load("jt6Nc").then(()=>parcelRequire('1nEI6'));

});

parcelRegister("lPPqW", function(module, exports) {

let $041a2a5adcb1bd9e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $041a2a5adcb1bd9e$var$load("lqf4p").then(()=>parcelRequire('2DoLm'));

});

parcelRegister("2Jy3v", function(module, exports) {

let $1fda33792411527e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1fda33792411527e$var$load("c45pb").then(()=>parcelRequire('y1Wnl'));

});

parcelRegister("3GNuy", function(module, exports) {

let $2afbaf67e59a0a45$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2afbaf67e59a0a45$var$load("7eyPa").then(()=>parcelRequire('bvpLA'));

});

parcelRegister("iFq2c", function(module, exports) {

let $d9704040a2e2ffaf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d9704040a2e2ffaf$var$load("O2IGv").then(()=>parcelRequire('9lbqx'));

});

parcelRegister("eqrdf", function(module, exports) {

let $a8089a43c1188207$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a8089a43c1188207$var$load("62Ypr").then(()=>parcelRequire('cifrM'));

});

parcelRegister("4Z2v5", function(module, exports) {

let $3a0ecc6f59d986b8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3a0ecc6f59d986b8$var$load("csjms").then(()=>parcelRequire('21RiV'));

});

parcelRegister("5OCmX", function(module, exports) {

let $43bf629976bd45d6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $43bf629976bd45d6$var$load("1sYxz").then(()=>parcelRequire('ebWgz'));

});

parcelRegister("30V0g", function(module, exports) {

let $231d96d5e55a34db$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $231d96d5e55a34db$var$load("fzXBH").then(()=>parcelRequire('bK0aF'));

});

parcelRegister("6QQ5t", function(module, exports) {

let $4fd000d69d328e73$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4fd000d69d328e73$var$load("5wMyt").then(()=>parcelRequire('hh8kS'));

});

parcelRegister("l24m6", function(module, exports) {

let $f4fd29cd11a6711a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f4fd29cd11a6711a$var$load("cHRYh").then(()=>parcelRequire('cpvvm'));

});

parcelRegister("D4XYM", function(module, exports) {

let $07577edbb7862301$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $07577edbb7862301$var$load("1GUTB").then(()=>parcelRequire('8lmTs'));

});

parcelRegister("lJ8yA", function(module, exports) {

let $fd147024ca2149c8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fd147024ca2149c8$var$load("02nNU").then(()=>parcelRequire('ez1g9'));

});

parcelRegister("fMF98", function(module, exports) {

let $b7db41817377515f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b7db41817377515f$var$load("1mlos").then(()=>parcelRequire('jaOZS'));

});

parcelRegister("9froW", function(module, exports) {

let $6bbac5160b13f2d1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6bbac5160b13f2d1$var$load("6d23n").then(()=>parcelRequire('f9TVv'));

});

parcelRegister("baIoP", function(module, exports) {

let $822311b5e1915845$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $822311b5e1915845$var$load("he9IT").then(()=>parcelRequire('6ALbD'));

});

parcelRegister("deOSs", function(module, exports) {

let $9a340c5c0429f2e6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9a340c5c0429f2e6$var$load("bs9oy").then(()=>parcelRequire('iHbmF'));

});

parcelRegister("eN7sM", function(module, exports) {

let $ac4b6e5577cb0982$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ac4b6e5577cb0982$var$load("i3DnP").then(()=>parcelRequire('3vVaC'));

});

parcelRegister("kClRv", function(module, exports) {

let $f028509e896347d1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f028509e896347d1$var$load("6M7E7").then(()=>parcelRequire('DaM6a'));

});

parcelRegister("kvyHO", function(module, exports) {

let $eee19fb34d792ec5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $eee19fb34d792ec5$var$load("aJZ5d").then(()=>parcelRequire('ezVkX'));

});

parcelRegister("kOupr", function(module, exports) {

let $f27010d016bfbd41$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f27010d016bfbd41$var$load("jkveD").then(()=>parcelRequire('lLkdp'));

});

parcelRegister("9Bx7u", function(module, exports) {

let $6fe142a6ee5c53da$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6fe142a6ee5c53da$var$load("ib8vr").then(()=>parcelRequire('5L5lX'));

});

parcelRegister("2ysIi", function(module, exports) {

let $1dc507a3ad559056$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1dc507a3ad559056$var$load("llprT").then(()=>parcelRequire('58Kxq'));

});

parcelRegister("9hBAJ", function(module, exports) {

let $6c22dc7b57515ca7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6c22dc7b57515ca7$var$load("ftS0S").then(()=>parcelRequire('3XMWt'));

});

parcelRegister("8tEET", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("9takY", function(module, exports) {

let $6e4ed73bc6fab627$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6e4ed73bc6fab627$var$load("12mie").then(()=>parcelRequire('gHN26'));

});

parcelRegister("7T2Ab", function(module, exports) {

let $5bdfac4873498843$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5bdfac4873498843$var$load("lX3hU").then(()=>parcelRequire('dP4uk'));

});

parcelRegister("gx3gE", function(module, exports) {

let $c0924341c51e88ee$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c0924341c51e88ee$var$load("glVF0").then(()=>parcelRequire('gJP5f'));

});

parcelRegister("3A5UP", function(module, exports) {

let $29b9529f60a50e5f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $29b9529f60a50e5f$var$load("lTvyt").then(()=>parcelRequire('aYYK8'));

});

parcelRegister("5OZh8", function(module, exports) {

let $43d12741e73a4047$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $43d12741e73a4047$var$load("2hH31").then(()=>parcelRequire('iDdMo'));

});

parcelRegister("6o3f7", function(module, exports) {

let $4a677ff032eb6011$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4a677ff032eb6011$var$load("cmMrn").then(()=>parcelRequire('2Q4q0'));

});

parcelRegister("020UP", function(module, exports) {

let $0060e5d10ec70190$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0060e5d10ec70190$var$load("2DWrJ").then(()=>parcelRequire('ahzrV'));

});

parcelRegister("igBdr", function(module, exports) {

let $036e8ed21eb3483d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $036e8ed21eb3483d$var$load("Ddbkb").then(()=>parcelRequire('bPVDt'));

});

parcelRegister("4vr7a", function(module, exports) {

let $347f17125ba176dc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $347f17125ba176dc$var$load("h7KVv").then(()=>parcelRequire('3mjdz'));

});

parcelRegister("jpJlx", function(module, exports) {

let $e22386f7f64717f4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e22386f7f64717f4$var$load("9d1Ui").then(()=>parcelRequire('8QGBH'));

});

parcelRegister("4wfWo", function(module, exports) {

let $34a6841b9be8eea1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $34a6841b9be8eea1$var$load("6QOF8").then(()=>parcelRequire('mD7UB'));

});

parcelRegister("lEfnE", function(module, exports) {

let $fc2943aa07183a26$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fc2943aa07183a26$var$load("hELm2").then(()=>parcelRequire('evxEr'));

});

parcelRegister("cD0rk", function(module, exports) {

let $931977dd1552efa7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $931977dd1552efa7$var$load("jtL6y").then(()=>parcelRequire('7lu1B'));

});

parcelRegister("Ieb9P", function(module, exports) {

let $084f1bd25dadc694$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $084f1bd25dadc694$var$load("4kFYm").then(()=>parcelRequire('85PqM'));

});

parcelRegister("fGwXg", function(module, exports) {

let $b6b4576da2de432e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b6b4576da2de432e$var$load("etT7C").then(()=>parcelRequire('3NE6B'));

});

parcelRegister("99YE3", function(module, exports) {

let $6ab3ff2769ebc7a6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6ab3ff2769ebc7a6$var$load("6zH8Y").then(()=>parcelRequire('iikGX'));

});

parcelRegister("1dxyE", function(module, exports) {

let $0e31093a4b6c1eb3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0e31093a4b6c1eb3$var$load("ciUip").then(()=>parcelRequire('eEUNg'));

});

parcelRegister("avyvI", function(module, exports) {

let $7a6791b82e7eaa51$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7a6791b82e7eaa51$var$load("4SS6F").then(()=>parcelRequire('f9lx5'));

});

parcelRegister("c82Ts", function(module, exports) {

let $8d4879fdef207e3f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8d4879fdef207e3f$var$load("khomJ").then(()=>parcelRequire('9XVn7'));

});

parcelRegister("aVBSY", function(module, exports) {

let $7f4c9d942e14d3b9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7f4c9d942e14d3b9$var$load("l3PYj").then(()=>parcelRequire('3FpGZ'));

});

parcelRegister("k6kUh", function(module, exports) {

let $ea2495d1884c1a5f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ea2495d1884c1a5f$var$load("hLcol").then(()=>parcelRequire('eU6sn'));

});

parcelRegister("9qv27", function(module, exports) {

let $6dce9d5394d4c94b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6dce9d5394d4c94b$var$load("jZro9").then(()=>parcelRequire('ikdCz'));

});

parcelRegister("16MXq", function(module, exports) {

let $0cec53f0ad772bdd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0cec53f0ad772bdd$var$load("cfJp1").then(()=>parcelRequire('4yDJ1'));

});

parcelRegister("juoyx", function(module, exports) {

let $e303ddfa7aa2702e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e303ddfa7aa2702e$var$load("d5QGH").then(()=>parcelRequire('CVmAv'));

});

parcelRegister("dtGrc", function(module, exports) {

let $9cfee70f83e16a02$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9cfee70f83e16a02$var$load("9oxHW").then(()=>parcelRequire('DFtL7'));

});

parcelRegister("9nD6W", function(module, exports) {

let $6d4499af3c04cd6f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6d4499af3c04cd6f$var$load("emJGv").then(()=>parcelRequire('2l8UK'));

});

parcelRegister("jY3FI", function(module, exports) {

let $e89678102d843a41$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e89678102d843a41$var$load("8ToNm").then(()=>parcelRequire('ibM2P'));

});

parcelRegister("i4sMa", function(module, exports) {

let $d27eec05bfa6fe87$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d27eec05bfa6fe87$var$load("bs8sn").then(()=>parcelRequire('47EfI'));

});

parcelRegister("04jS0", function(module, exports) {

let $00cfc99976bacb7f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $00cfc99976bacb7f$var$load("a2brZ").then(()=>parcelRequire('evTqT'));

});

parcelRegister("8nApX", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("1twF8", function(module, exports) {

let $1131d5f277077708$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1131d5f277077708$var$load("gk64V").then(()=>parcelRequire('5IIdf'));

});

parcelRegister("h4zXj", function(module, exports) {

let $c6deb37378ea4c9c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c6deb37378ea4c9c$var$load("fsnzn").then(()=>parcelRequire('4vVNg'));

});

parcelRegister("BA2fD", function(module, exports) {

let $070f68ada0e3642f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $070f68ada0e3642f$var$load("8JWF2").then(()=>parcelRequire('9LjTG'));

});

parcelRegister("bCcp4", function(module, exports) {

let $874cdd5c979c049c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $874cdd5c979c049c$var$load("czxXO").then(()=>parcelRequire('04Nh9'));

});

parcelRegister("1nSTE", function(module, exports) {

let $102285babd7bc4df$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $102285babd7bc4df$var$load("2SHBN").then(()=>parcelRequire('6isq3'));

});

parcelRegister("Rymcn", function(module, exports) {

let $0a0f99f1dde3a229$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0a0f99f1dde3a229$var$load("8Vsnm").then(()=>parcelRequire('jHZA4'));

});

parcelRegister("8CPhn", function(module, exports) {

let $6479a65c1bb8e0f1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6479a65c1bb8e0f1$var$load("ll2xm").then(()=>parcelRequire('CHhGe'));

});

parcelRegister("k9OBz", function(module, exports) {

let $eacbe6fe10a518e4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $eacbe6fe10a518e4$var$load("30zeN").then(()=>parcelRequire('bLNg4'));

});

parcelRegister("lLPqK", function(module, exports) {

let $fd95e1bebc5231f5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fd95e1bebc5231f5$var$load("asSvh").then(()=>parcelRequire('24p1b'));

});

parcelRegister("6naQl", function(module, exports) {

let $4a3d4d4f669da687$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4a3d4d4f669da687$var$load("ko3ZY").then(()=>parcelRequire('felsP'));

});

parcelRegister("hPwRb", function(module, exports) {

let $cfb0afc99704ddba$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cfb0afc99704ddba$var$load("8hhkt").then(()=>parcelRequire('l8yVa'));

});

parcelRegister("ftDmR", function(module, exports) {

let $b4481a0a6dcf6ac2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b4481a0a6dcf6ac2$var$load("3hBeC").then(()=>parcelRequire('lVZTS'));

});

parcelRegister("5hkBs", function(module, exports) {

let $3d7e859fa4d5c16d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3d7e859fa4d5c16d$var$load("a6jC4").then(()=>parcelRequire('7GItp'));

});

parcelRegister("jKwev", function(module, exports) {

let $e60b5101446f5a28$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e60b5101446f5a28$var$load("aFMAu").then(()=>parcelRequire('10yxD'));

});

parcelRegister("hEy5s", function(module, exports) {

let $cda09d179d0933ae$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cda09d179d0933ae$var$load("8oLhH").then(()=>parcelRequire('kQgQ4'));

});

parcelRegister("5gaXr", function(module, exports) {

let $3d46f253b34cc3e5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3d46f253b34cc3e5$var$load("8cxcS").then(()=>parcelRequire('kzpl0'));

});

parcelRegister("38gmN", function(module, exports) {

let $247ed088a3b4ed67$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $247ed088a3b4ed67$var$load("20mGg").then(()=>parcelRequire('bQEeI'));

});

parcelRegister("6idDu", function(module, exports) {

let $494f004f95a5a5f3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $494f004f95a5a5f3$var$load("d4idW").then(()=>parcelRequire('3arua'));

});

parcelRegister("lnfmB", function(module, exports) {

let $f8f7a9d32c509ccd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f8f7a9d32c509ccd$var$load("9pe2W").then(()=>parcelRequire('iWqAW'));

});

parcelRegister("4CcQP", function(module, exports) {

let $35c4ae0308c0122e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $35c4ae0308c0122e$var$load("f9Y88").then(()=>parcelRequire('38lNl'));

});

parcelRegister("hf4xR", function(module, exports) {

let $c8d75cf8769b193b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c8d75cf8769b193b$var$load("h5YWz").then(()=>parcelRequire('jUTzs'));

});

parcelRegister("4S5lb", function(module, exports) {

let $38c0591e1574f1fe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $38c0591e1574f1fe$var$load("6zoXD").then(()=>parcelRequire('3FJdS'));

});

parcelRegister("1sJnj", function(module, exports) {

let $110b9a7c1eae72bd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $110b9a7c1eae72bd$var$load("jLmcr").then(()=>parcelRequire('dnrkl'));

});

parcelRegister("14RMm", function(module, exports) {

let $0c8fe18ad06d4e3e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0c8fe18ad06d4e3e$var$load("14wFt").then(()=>parcelRequire('3cCIn'));

});

parcelRegister("hlEdv", function(module, exports) {

let $ca13980dbd9b0de6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ca13980dbd9b0de6$var$load("88BSo").then(()=>parcelRequire('4RFM5'));

});

parcelRegister("2P62U", function(module, exports) {

let $20e508c54e4e7e70$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $20e508c54e4e7e70$var$load("i8jRD").then(()=>parcelRequire('k1d4Y'));

});

parcelRegister("cBK9i", function(module, exports) {

let $92dcbcf92d2469a7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $92dcbcf92d2469a7$var$load("bdOCZ").then(()=>parcelRequire('1JGyY'));

});

parcelRegister("8BN7t", function(module, exports) {

let $6447e1918a35d422$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6447e1918a35d422$var$load("e5Kbr").then(()=>parcelRequire('l9pzx'));

});

parcelRegister("66oq1", function(module, exports) {

let $47163eae2d5d8402$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $47163eae2d5d8402$var$load("Ck85q").then(()=>parcelRequire('lnuY1'));

});

parcelRegister("kHXyL", function(module, exports) {
module.exports = JSON.parse("{\"got-it\":[{\"type\":0,\"value\":\"Got it\"}],\"mercury.email.footer.sent-by\":[{\"type\":0,\"value\":\"This message was sent to you by Atlassian Focus\"}],\"mercury.email.footer.unsubscribe\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"mercury.focus-areas.arrow-icon.alt\":[{\"type\":0,\"value\":\"arrow-icon\"}],\"mercury.focus-areas.arrow-right-icon.alt\":[{\"type\":0,\"value\":\"arrow-right-icon\"}],\"mercury.focus-areas.calendar-icon.alt\":[{\"type\":0,\"value\":\"calendar-icon\"}],\"mercury.focus-areas.date-changed\":[{\"type\":0,\"value\":\"Date Changed\"}],\"mercury.focus-areas.focus-area.alt\":[{\"type\":0,\"value\":\"focus-area-icon\"}],\"mercury.focus-areas.focus-footer.alt\":[{\"type\":0,\"value\":\"Atlassian footer\"}],\"mercury.focus-areas.focus-icon.alt\":[{\"type\":0,\"value\":\"Focus area icon\"}],\"mercury.focus-areas.for\":[{\"type\":0,\"value\":\"for\"}],\"mercury.focus-areas.heading\":[{\"type\":0,\"value\":\"You're following \"},{\"type\":1,\"value\":\"total\"},{\"type\":0,\"value\":\" active focus areas, here's the breakdown.\"}],\"mercury.focus-areas.no-target-date.alt\":[{\"type\":0,\"value\":\"No target date set\"}],\"mercury.focus-areas.status-changed\":[{\"type\":0,\"value\":\"Status changed\"}],\"mercury.focus-areas.view-area\":[{\"type\":0,\"value\":\"View Focus Area\"}],\"mercury.focus.catch.up.link\":[{\"type\":0,\"value\":\"Jump into Atlassian Focus\"}],\"mercury.focus.catch.up.text\":[{\"type\":0,\"value\":\"Want to catch up on previous updates? \"},{\"type\":1,\"value\":\"link\"}],\"mercury.mercury-monthly-digest.message-template.email.subject.no-translate\":[{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\", here are your monthly focus area updates\"}],\"mercury.message-templates.edit-focus-area-heirarchy-spotlight-body\":[{\"type\":0,\"value\":\"Whenever you need to make changes to your hierarchy you can do so from settings.\"}],\"mercury.message-templates.edit-focus-area-heirarchy-spotlight-heading\":[{\"type\":0,\"value\":\"Edit your focus area hierarchy\"}]}");

});

parcelRegister("cZyB2", function(module, exports) {

let $975604a4aa5a4af8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $975604a4aa5a4af8$var$load("233DY").then(()=>parcelRequire('fKwU8'));

});

parcelRegister("1ltui", function(module, exports) {

let $0faea044aa569e06$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0faea044aa569e06$var$load("fPDWC").then(()=>parcelRequire('35reh'));

});

parcelRegister("l8ET7", function(module, exports) {

let $f63a0fd91d992df8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f63a0fd91d992df8$var$load("1nNbp").then(()=>parcelRequire('jvqSD'));

});

parcelRegister("jICO9", function(module, exports) {

let $e5b03ad72089d4fc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e5b03ad72089d4fc$var$load("kVG1M").then(()=>parcelRequire('kNDd8'));

});

parcelRegister("6C4fP", function(module, exports) {

let $4d09977e421aa6ab$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4d09977e421aa6ab$var$load("2dw9h").then(()=>parcelRequire('i7wi3'));

});

parcelRegister("l8ufW", function(module, exports) {

let $f631d08cdbe92d53$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f631d08cdbe92d53$var$load("eHGzF").then(()=>parcelRequire('dqYiy'));

});

parcelRegister("kQMWC", function(module, exports) {

let $f2dea1554170a983$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f2dea1554170a983$var$load("7ogxc").then(()=>parcelRequire('8OCzv'));

});

parcelRegister("iOZ24", function(module, exports) {

let $db3c3d49dc689152$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $db3c3d49dc689152$var$load("fDdMl").then(()=>parcelRequire('2Iidu'));

});

parcelRegister("f71EB", function(module, exports) {

let $b008cadee16d96c5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b008cadee16d96c5$var$load("aV0w9").then(()=>parcelRequire('eVkih'));

});

parcelRegister("d02qk", function(module, exports) {

let $976d27bc0cb971b5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $976d27bc0cb971b5$var$load("j1eUL").then(()=>parcelRequire('5KSuP'));

});

parcelRegister("7bAQx", function(module, exports) {

let $53b62469d1a36566$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $53b62469d1a36566$var$load("cc1H3").then(()=>parcelRequire('bDSsV'));

});

parcelRegister("g7Hoq", function(module, exports) {

let $bbcef5b77748921f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bbcef5b77748921f$var$load("iBJl3").then(()=>parcelRequire('iwR1g'));

});

parcelRegister("50xXm", function(module, exports) {

let $3a574adb691d20b7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3a574adb691d20b7$var$load("deZDr").then(()=>parcelRequire('mkvWp'));

});

parcelRegister("4VEmY", function(module, exports) {

let $396bccdcf2bfa363$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $396bccdcf2bfa363$var$load("iZvLM").then(()=>parcelRequire('3LR6X'));

});

parcelRegister("agzpj", function(module, exports) {

let $7796dd2ab2c41e00$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7796dd2ab2c41e00$var$load("ejFfH").then(()=>parcelRequire('7299x'));

});

parcelRegister("bgCiS", function(module, exports) {

let $833ee699070ea910$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $833ee699070ea910$var$load("9XWAe").then(()=>parcelRequire('ckkq8'));

});

parcelRegister("a5lac", function(module, exports) {

let $01e513c4c987d18c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $01e513c4c987d18c$var$load("cjEpc").then(()=>parcelRequire('4wXd5'));

});

parcelRegister("gRJCD", function(module, exports) {

let $c474fc2e645221b2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c474fc2e645221b2$var$load("fKD9g").then(()=>parcelRequire('1WAgc'));

});

parcelRegister("kbZao", function(module, exports) {

let $eb34482bcd2a60cc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $eb34482bcd2a60cc$var$load("4p1M4").then(()=>parcelRequire('7vChv'));

});

parcelRegister("giBKD", function(module, exports) {

let $bddb9c5e22428bd2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bddb9c5e22428bd2$var$load("6F9Q6").then(()=>parcelRequire('68T1m'));

});

parcelRegister("kUbBO", function(module, exports) {

let $f3820ae29132d88f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f3820ae29132d88f$var$load("eAqp7").then(()=>parcelRequire('8zEpB'));

});

parcelRegister("k0YJR", function(module, exports) {

let $e922ec29ccc9addc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e922ec29ccc9addc$var$load("eLnWW").then(()=>parcelRequire('hIbcI'));

});

parcelRegister("cbXCv", function(module, exports) {

let $8e04c2662ab6550d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8e04c2662ab6550d$var$load("gDItP").then(()=>parcelRequire('SCLJM'));

});

parcelRegister("hu14P", function(module, exports) {

let $cba612d753000e32$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cba612d753000e32$var$load("p1FD0").then(()=>parcelRequire('8vZ67'));

});

parcelRegister("2QkKc", function(module, exports) {

let $212087799329245e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $212087799329245e$var$load("4cWYg").then(()=>parcelRequire('cC6lI'));

});

parcelRegister("duNYv", function(module, exports) {

let $9d34d7b2dfff02b4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9d34d7b2dfff02b4$var$load("afWwx").then(()=>parcelRequire('dfKtg'));

});

parcelRegister("27bNl", function(module, exports) {

let $18a5626e52a226fe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $18a5626e52a226fe$var$load("1rCyU").then(()=>parcelRequire('6aXrQ'));

});

parcelRegister("jtwm0", function(module, exports) {

let $e2d9d28f56d1fbdd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e2d9d28f56d1fbdd$var$load("9iSQB").then(()=>parcelRequire('c3n3p'));

});

parcelRegister("5PGrx", function(module, exports) {

let $43f2a37a9c7e045d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $43f2a37a9c7e045d$var$load("anqUS").then(()=>parcelRequire('rAGPp'));

});

parcelRegister("jeVa2", function(module, exports) {
module.exports = JSON.parse('{"app.accept":[{"type":0,"value":"Accept"}],"app.reject":[{"type":0,"value":"Reject"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"ecosystem-forge-apps.ecosystem-forge-apps-in-app.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"jira.jira-project-pages-gdrive-deprecation.message-template.email.subject":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-1":[{"type":0,"value":"We\'re reaching out to notify you that from April 23rd 2024, syncing Google Drive shared drives will no longer be supported in Project Pages for the users in your site. Users will no longer be able to access their shared drives Jira as we are removing the feature, but they will still be able to sync Confluence spaces to Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-2":[{"type":0,"value":"Please note that we are not deleting any data within Google Drive itself. The change only affects the ability to sync, link, and access Google Shared Drives from Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-3":[{"type":0,"value":"This is part of our ongoing efforts to streamline our services and ensure the highest quality experience for our users."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-4":[{"type":0,"value":"Next steps:"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-5":[{"type":0,"value":"We are committed to providing you with the best possible experience, and appreciate your understanding as we make these necessary improvements. Thank you for your continued support."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-1":[{"type":0,"value":"No immediate action is required from your end regarding this deprecation. However, we understand that this change may impact your workflow, and we are here to support you through this transition."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-3":[{"type":0,"value":"For any feedback, or further questions and assistance with change management, please contact jnguyen2@atlassian.com"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.greeting":[{"type":0,"value":"Dear Admin,"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.title":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-weekly-digest.message-template.email.subject":[{"type":0,"value":"Your weekly digest for Jira project: "},{"type":1,"value":"projectName"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCompletion":[{"type":0,"value":"issues completed in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCreated":[{"type":0,"value":"issues created in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesUpdated":[{"type":0,"value":"issues updated in the past week"}],"jira.jira-weekly-digest.test-message.email.body.plusSign":[{"type":0,"value":"+"}],"jira.jira-weekly-digest.test-message.email.header":[{"type":0,"value":"Here\'s your weekly digest for Jira ("},{"type":1,"value":"projectName"},{"type":0,"value":") over the past week"}],"jira.jira-weekly-digest.test-message.email.headerDescription":[{"type":0,"value":"You\u2019re receiving this email because you have opted in to receive weekly updates for this project in Jira."}],"jira.jira-weekly-digest.test-message.email.playbookBodyText":[{"type":0,"value":"Atlassian Playbook"}],"jira.jira-weekly-digest.test-message.email.playbookHeader":[{"type":0,"value":"Has your team conducted a retrospective recently?"}],"jira.jira-weekly-digest.test-message.email.playbookSubheader":[{"type":0,"value":"A retrospective gives you an opportunity to review your latest project progress and make improvements for the future. Find out more at "},{"type":1,"value":"link"},{"type":0,"value":"."}],"jira.jira-weekly-digest.test-message.email.tableHeader":[{"type":0,"value":"Weekly Summary"}],"jira.suppression-email-notification-email.contact-us":[{"type":0,"value":"contact us"}],"jira.suppression-email-notification-email.email.body":[{"type":0,"value":"This is an automatated message to notify you that the jira "},{"type":1,"value":"emailType"},{"type":0,"value":" email \\n\\t\\t\\t\\t\\t\\tto "},{"type":1,"value":"affectedUserEmail"},{"type":0,"value":" has been suppressed. Please visit this "},{"type":1,"value":"unsuppressApiLink"},{"type":0,"value":" to unsuppress the user\'s email."}],"jira.suppression-email-notification-email.email.body.goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" if the issue persists, we\'re always happy to help."}],"jira.suppression-email-notification-email.email.body.regards":[{"type":0,"value":"Jira Notifications Team"}],"jira.suppression-email-notification-email.email.body.signoff":[{"type":0,"value":"Regards,"}],"jira.suppression-email-notification-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"jira.suppression-email-notification-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira.suppression-email-notification-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"playground.playground-local-execution-message.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.playground-local-execution-message.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.playground-local-execution-message.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hello, fellow child "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.playground-local-execution-message.test-message.email.body.no-translate":[{"type":0,"value":"We are currently trying to locally execute this message!"}],"playground.playground-local-execution-message.test-message.email.body.regards.no-translate":[{"type":0,"value":"Playground Team"}],"playground.playground-local-execution-message.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.playground-local-execution-message.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.commerce-common.unsuppress-email-link":[{"type":0,"value":"link"}],"post-office.jira-email.contact-us":[{"type":0,"value":"contact us"}],"post-office.playground.go-faster-techops-rollup-notifier.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.playground.test-playground-message.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}]}');

});

parcelRegister("f2p2B", function(module, exports) {

let $af2a778e670c88ff$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $af2a778e670c88ff$var$load("4naQb").then(()=>parcelRequire('7WEkG'));

});

parcelRegister("ht46J", function(module, exports) {

let $cb7854c6f1464103$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cb7854c6f1464103$var$load("dqLxh").then(()=>parcelRequire('azhMm'));

});

parcelRegister("69h1H", function(module, exports) {

let $47a0ca6f20a06761$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $47a0ca6f20a06761$var$load("8WeOJ").then(()=>parcelRequire('78ZfA'));

});

parcelRegister("kuzQN", function(module, exports) {

let $eeb26b2610a07690$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $eeb26b2610a07690$var$load("Ror2l").then(()=>parcelRequire('gdBO8'));

});

parcelRegister("cVInB", function(module, exports) {

let $969d3bc3c6be22e4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $969d3bc3c6be22e4$var$load("drAPP").then(()=>parcelRequire('3DBMU'));

});

parcelRegister("gUWuQ", function(module, exports) {

let $c50f4077037d60eb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c50f4077037d60eb$var$load("esJrS").then(()=>parcelRequire('1Ja9P'));

});

parcelRegister("lcJMw", function(module, exports) {

let $f6fe3b37f465e740$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f6fe3b37f465e740$var$load("lGAmz").then(()=>parcelRequire('biXgE'));

});

parcelRegister("dzgQz", function(module, exports) {

let $9e0b9cb588ab4855$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9e0b9cb588ab4855$var$load("khrIN").then(()=>parcelRequire('h4j8A'));

});

parcelRegister("jYtJC", function(module, exports) {

let $e8aaafa348409c02$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e8aaafa348409c02$var$load("jtHQR").then(()=>parcelRequire('cOAQ0'));

});

parcelRegister("4UFaq", function(module, exports) {

let $393c53556513000f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $393c53556513000f$var$load("ixtOF").then(()=>parcelRequire('f8gcV'));

});

parcelRegister("h9L2A", function(module, exports) {

let $c7d7c43ee0689494$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c7d7c43ee0689494$var$load("fIHQM").then(()=>parcelRequire('l9n03'));

});

parcelRegister("6TMXE", function(module, exports) {

let $505ddbcf8835a205$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $505ddbcf8835a205$var$load("kylxz").then(()=>parcelRequire('8k3Dp'));

});

parcelRegister("aPvxU", function(module, exports) {

let $7e272326c7ad77c9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7e272326c7ad77c9$var$load("dniwF").then(()=>parcelRequire('drxA7'));

});

parcelRegister("dh1Oe", function(module, exports) {

let $9a9e442eceac790a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9a9e442eceac790a$var$load("bxYVx").then(()=>parcelRequire('3usyN'));

});

parcelRegister("ebbqp", function(module, exports) {

let $a52af4812a3fc1aa$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a52af4812a3fc1aa$var$load("9y5Sq").then(()=>parcelRequire('kssqx'));

});

parcelRegister("5rgEX", function(module, exports) {

let $3f5c6598d3cb57ea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3f5c6598d3cb57ea$var$load("i2egy").then(()=>parcelRequire('6iScM'));

});

parcelRegister("3aChI", function(module, exports) {

let $24f000d1077bac5d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $24f000d1077bac5d$var$load("b55kW").then(()=>parcelRequire('eQ2gb'));

});

parcelRegister("9Xt6M", function(module, exports) {

let $7400340c9d86621c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7400340c9d86621c$var$load("hhVwh").then(()=>parcelRequire('jLy0N'));

});

parcelRegister("GLe4m", function(module, exports) {

let $08088e7172dd71b5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $08088e7172dd71b5$var$load("h3C0X").then(()=>parcelRequire('3QxlH'));

});

parcelRegister("lD1OE", function(module, exports) {

let $fbeea617488662a8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fbeea617488662a8$var$load("eo1Nf").then(()=>parcelRequire('1h2Il'));

});

parcelRegister("a3k8w", function(module, exports) {

let $7519cde1e2b3558c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7519cde1e2b3558c$var$load("l7vp6").then(()=>parcelRequire('hJpAP'));

});

parcelRegister("fg2Qv", function(module, exports) {

let $b1ba8ec77c918f1d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b1ba8ec77c918f1d$var$load("5dqQO").then(()=>parcelRequire('6sj97'));

});

parcelRegister("5xGAj", function(module, exports) {

let $4091113a3adeddec$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4091113a3adeddec$var$load("4xODr").then(()=>parcelRequire('iTbmt'));

});

parcelRegister("h8OJ6", function(module, exports) {

let $c7aa883dab876a35$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c7aa883dab876a35$var$load("75XmY").then(()=>parcelRequire('iG3jk'));

});

parcelRegister("2VF7p", function(module, exports) {

let $2220cce8fc77ef8b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2220cce8fc77ef8b$var$load("4qXPA").then(()=>parcelRequire('abn1m'));

});

parcelRegister("8NZtL", function(module, exports) {

let $669296c5d37225b8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $669296c5d37225b8$var$load("8yIqn").then(()=>parcelRequire('21Ujf'));

});

parcelRegister("brGsg", function(module, exports) {

let $855325f5f20042fe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $855325f5f20042fe$var$load("e0f4q").then(()=>parcelRequire('lHABM'));

});

parcelRegister("9zB1f", function(module, exports) {

let $6f8419254b16620b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6f8419254b16620b$var$load("726Hx").then(()=>parcelRequire('fjIWF'));

});

parcelRegister("5mCru", function(module, exports) {

let $3e7cd3b0ff6bda34$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3e7cd3b0ff6bda34$var$load("icq5C").then(()=>parcelRequire('9o7yY'));

});

parcelRegister("kMgxO", function(module, exports) {
module.exports = JSON.parse('{"feedback-collector.can-be-enrolled-label.text":[{"type":0,"value":"Atlassian can contact me about this feedback. See our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"feedback-collector.enroll-in-research-label.text":[{"type":0,"value":"I\'d like to help improve Atlassian products by joining the"},{"type":1,"value":"nbsp"},{"type":1,"value":"n"},{"type":1,"value":"t"},{"type":1,"value":"t"},{"children":[{"type":0,"value":"Atlassian Research Group"}],"type":8,"value":"enrollLink"}],"feedback-collector.feedback-title-details.component":[{"type":0,"value":"For help with billing or other issues, visit our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"documentation"}],"type":8,"value":"documentationLink"},{"type":1,"value":"nbsp"},{"type":0,"value":"or contact"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"support"}],"type":8,"value":"supportLink"}],"no-notifications-fallback.learn-more-link.text":[{"type":0,"value":"Learn more about this feature"}],"no-notifications-fallback.no-notifications.text":[{"type":0,"value":"Check back soon. No notifications yet."}],"notifications.error-fallback-error-reason.text":[{"type":0,"value":"We\'re unable to load notifications"}],"notifications.error-fallback-proposed-solution.text":[{"type":0,"value":"Refresh the page or try again later"}],"post-office-team.confluence-recommended-following-feed.add-comment-button":[{"type":0,"value":"Comment"}],"post-office-team.confluence-recommended-following-feed.add-emoji-button-alt-text":[{"type":0,"value":"Add Emoji"}],"post-office-team.confluence-recommended-following-feed.atlassian-logo":[{"type":0,"value":"Atlassian Logo"}],"post-office-team.confluence-recommended-following-feed.blog-icon":[{"type":0,"value":"Blog icon"}],"post-office-team.confluence-recommended-following-feed.clap-button-alt-text":[{"type":0,"value":"Clap"}],"post-office-team.confluence-recommended-following-feed.database-icon":[{"type":0,"value":"Database icon"}],"post-office-team.confluence-recommended-following-feed.email-unsubscribe-text":[{"children":[{"type":0,"value":"Update your email settings"}],"type":8,"value":"trackedLink"},{"type":0,"value":" to customize or stop receiving this email."}],"post-office-team.confluence-recommended-following-feed.email.body.hello":[{"type":0,"value":"G\'day "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.confluence-recommended-following-feed.email.body.summary":[{"type":0,"value":"Here are pages your team is reading, don\'t miss out on the conversation."}],"post-office-team.confluence-recommended-following-feed.email.ios-android-text":[{"type":0,"value":"Download the Confluence mobile app on "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"iosLink"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"androidLink"},{"type":0,"value":" to read notifications and comment on the go."}],"post-office-team.confluence-recommended-following-feed.email.privacy-policy-text":[{"type":0,"value":"This email was sent by Atlassian Confluence  \u2022  "},{"children":[{"type":0,"value":"Privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"post-office-team.confluence-recommended-following-feed.email.subject":[{"type":1,"value":"name"},{"type":0,"value":", your team is working on these pages -- join the conversation"}],"post-office-team.confluence-recommended-following-feed.email.subject.variant-a":[{"type":1,"value":"name"},{"type":0,"value":", "},{"type":1,"value":"pageTitle"},{"type":0,"value":" plus more pages your team is working on"}],"post-office-team.confluence-recommended-following-feed.header.confluence-icon.alt-text":[{"type":0,"value":"Confluence Icon"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted":[{"children":[{"type":1,"value":"firstUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"secondUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.no-comments":[{"type":0,"value":"Be the first to comment"}],"post-office-team.confluence-recommended-following-feed.no-reactions-text":[{"type":0,"value":"Be the first to react"}],"post-office-team.confluence-recommended-following-feed.number-of-comments":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comment"}]},"other":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comments"}]}},"pluralType":"cardinal","type":6,"value":"commentCount"}],"post-office-team.confluence-recommended-following-feed.number-of-users-reacted":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"reactionCount"}],"post-office-team.confluence-recommended-following-feed.owned-by":[{"type":0,"value":"Owned by "},{"type":1,"value":"ownerName"}],"post-office-team.confluence-recommended-following-feed.party-popper-button-alt-text":[{"type":0,"value":"Party Popper"}],"post-office-team.confluence-recommended-following-feed.read-more-link":[{"type":0,"value":"Read more"}],"post-office-team.confluence-recommended-following-feed.thumbs-up-button-alt-text":[{"type":0,"value":"Thumbs up"}],"post-office-team.confluence-recommended-following-feed.user-profile-picture-alt-text":[{"type":1,"value":"name"},{"type":0,"value":"\'s profile picture"}],"post-office-team.confluence-recommended-following-feed.whiteboard-icon":[{"type":0,"value":"Whiteboard icon"}],"post-office.admin-hub.end-of-notifications.description":[{"type":0,"value":"That\'s all your notifications from the last 90 days"}],"post-office.post-office-team-components.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"post-office.post-office-team-components.email.footer.office-address":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.post-office-team-components.email.footer.why-am-i-receiving-this-email":[{"type":0,"value":"You are receiving this email because this is an important message regarding your account and products you are using. You are not allowed to unsubscribe from this type of message."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.cta-link":[{"type":0,"value":"Get started"}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.description":[{"type":0,"value":"Help us improve messaging for Atlassian Admins! Answer a few short questions, and our\\n\\t\\t\\t\\t\\tResearch team will contact you for a 60-minute Zoom session if you qualify."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.header":[{"type":0,"value":"Share your experience for $120 USD"}]}');

});

parcelRegister("7WTpk", function(module, exports) {

let $5c98edf771eeae44$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5c98edf771eeae44$var$load("89k3K").then(()=>parcelRequire('Co4xy'));

});

parcelRegister("9dooa", function(module, exports) {

let $6b583f14d19d8285$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6b583f14d19d8285$var$load("i4TIz").then(()=>parcelRequire('iB0OS'));

});

parcelRegister("ij9bL", function(module, exports) {

let $d5412109f77ce67e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d5412109f77ce67e$var$load("aJTUh").then(()=>parcelRequire('kVtQW'));

});

parcelRegister("jcTLd", function(module, exports) {

let $dfba642fa8e9bb90$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dfba642fa8e9bb90$var$load("4UjsP").then(()=>parcelRequire('8SHH6'));

});

parcelRegister("obvEU", function(module, exports) {

let $048b2b93db4e2120$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $048b2b93db4e2120$var$load("eAMuS").then(()=>parcelRequire('4BKTu'));

});

parcelRegister("8tL0f", function(module, exports) {

let $62c57dfdd197dee5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $62c57dfdd197dee5$var$load("cgGsl").then(()=>parcelRequire('aA2px'));

});

parcelRegister("3BUd1", function(module, exports) {

let $2a106dc2143af6f4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2a106dc2143af6f4$var$load("jCHho").then(()=>parcelRequire('j1D9P'));

});

parcelRegister("flNwZ", function(module, exports) {

let $b2cf3d0a0efcc2e8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b2cf3d0a0efcc2e8$var$load("V9B1k").then(()=>parcelRequire('8sTMU'));

});

parcelRegister("1l4zu", function(module, exports) {

let $0f9b4c64afe875d5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0f9b4c64afe875d5$var$load("lHcdb").then(()=>parcelRequire('63U6R'));

});

parcelRegister("hlZ1E", function(module, exports) {

let $ca23bc3e0996dfdc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ca23bc3e0996dfdc$var$load("8GdFF").then(()=>parcelRequire('usVdc'));

});

parcelRegister("2IBih", function(module, exports) {

let $1fac9e9d4a0babd9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1fac9e9d4a0babd9$var$load("1RIZj").then(()=>parcelRequire('79vH0'));

});

parcelRegister("iLrRt", function(module, exports) {

let $da923a81116d4002$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $da923a81116d4002$var$load("6XajZ").then(()=>parcelRequire('5GSxA'));

});

parcelRegister("268pL", function(module, exports) {

let $1872ab40c1374c14$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1872ab40c1374c14$var$load("gr1Hg").then(()=>parcelRequire('2gvJk'));

});

parcelRegister("lKhlb", function(module, exports) {

let $fd4b585c558bd865$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fd4b585c558bd865$var$load("ex9RG").then(()=>parcelRequire('aJCau'));

});

parcelRegister("cSKrP", function(module, exports) {

let $960e8ebfa248da14$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $960e8ebfa248da14$var$load("lpnZh").then(()=>parcelRequire('aWdCQ'));

});

parcelRegister("djV8I", function(module, exports) {

let $9b295f6b551f54d8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9b295f6b551f54d8$var$load("79K0y").then(()=>parcelRequire('lPJba'));

});

parcelRegister("adlpo", function(module, exports) {

let $76fbb999c7e71acb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $76fbb999c7e71acb$var$load("bi09N").then(()=>parcelRequire('7rjx9'));

});

parcelRegister("5MMtL", function(module, exports) {

let $43670a6610af7dab$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $43670a6610af7dab$var$load("iwWXu").then(()=>parcelRequire('4Qx3O'));

});

parcelRegister("do7sW", function(module, exports) {

let $9bf34eccab135fcf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9bf34eccab135fcf$var$load("coHip").then(()=>parcelRequire('b85cr'));

});

parcelRegister("iJkP1", function(module, exports) {

let $da2c94c042bb0f3c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $da2c94c042bb0f3c$var$load("kiUGs").then(()=>parcelRequire('hEjEd'));

});

parcelRegister("EwpC0", function(module, exports) {

let $079ce0e8b09ce272$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $079ce0e8b09ce272$var$load("aHmyu").then(()=>parcelRequire('kMiOr'));

});

parcelRegister("1wmKm", function(module, exports) {

let $11ba6c9d968f1808$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $11ba6c9d968f1808$var$load("1vP6v").then(()=>parcelRequire('9znD6'));

});

parcelRegister("apoy6", function(module, exports) {

let $793f481b364d5f63$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $793f481b364d5f63$var$load("jE6NT").then(()=>parcelRequire('2yLDN'));

});

parcelRegister("124bV", function(module, exports) {

let $0c093aa39e72da32$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0c093aa39e72da32$var$load("jPFt3").then(()=>parcelRequire('3QGFD'));

});

parcelRegister("5h1r2", function(module, exports) {

let $3d6fa73deda18747$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3d6fa73deda18747$var$load("dchHI").then(()=>parcelRequire('7WQQ0'));

});

parcelRegister("h67tt", function(module, exports) {

let $c728cb7a83d9c0dd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c728cb7a83d9c0dd$var$load("7IGY8").then(()=>parcelRequire('htGib'));

});

parcelRegister("lj2SK", function(module, exports) {

let $f82d9ba775231137$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f82d9ba775231137$var$load("jTear").then(()=>parcelRequire('2Eg1T'));

});

parcelRegister("7Fmf9", function(module, exports) {

let $0170bc5a2221469c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0170bc5a2221469c$var$load("ilX2r").then(()=>parcelRequire('eAjlW'));

});

parcelRegister("ilu75", function(module, exports) {

let $d5b18c078624b629$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d5b18c078624b629$var$load("hbZkz").then(()=>parcelRequire('6ltFW'));

});

parcelRegister("aXjWU", function(module, exports) {

$parcel$export(module.exports, "TriggerContextProvider", () => $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3);
$parcel$export(module.exports, "useTrigger", () => $6d6c82fa2f331bd2$export$3b196fe93a948c18);
$parcel$export(module.exports, "useFirePostOfficeTrigger", () => $6d6c82fa2f331bd2$export$83b33e5fe4cce64);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $gwFzn.useState)($6d6c82fa2f331bd2$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $gwFzn.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $gwFzn.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $gwFzn.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
            value: triggerContexDispatchValue,
            children: children
        })
    });
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = ()=>(0, $gwFzn.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = ()=>(0, $gwFzn.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $gwFzn.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};

});

parcelRegister("djMdn", function(module, exports) {

$parcel$export(module.exports, "ConfluenceExperimentsContext", () => $ee867efa4e0f51e3$export$e5c6d63c1f3f867f);

var $gwFzn = parcelRequire("gwFzn");
const $ee867efa4e0f51e3$export$e5c6d63c1f3f867f = (0, $gwFzn.createContext)({
    usePageRecommendationData: ()=>({
            data: undefined,
            loading: false,
            hoverPageError: undefined,
            recPageError: undefined
        }),
    useInlineReactionsData: (_numberOfReactedUsers, _skip)=>({
            data: {
                authorName: undefined,
                authorAvatar: undefined,
                reactionsCount: undefined,
                reactionsSummary: undefined,
                reactedUsers: undefined,
                userId: undefined,
                activationId: undefined
            },
            loading: false,
            error: undefined
        }),
    getPageDataFromUrl: ()=>({
            contentId: undefined,
            contentType: undefined,
            spaceKey: undefined
        }),
    emojiProvider: undefined
});

});

parcelRegister("9Fonl", function(module, exports) {

let $709ad9e0b5e722f2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $709ad9e0b5e722f2$var$load("8rsL2"),
    $709ad9e0b5e722f2$var$load("iAaum"),
    $709ad9e0b5e722f2$var$load("d2Yg2"),
    $709ad9e0b5e722f2$var$load("bS0aO"),
    $709ad9e0b5e722f2$var$load("aj3n8"),
    $709ad9e0b5e722f2$var$load("ffEVr"),
    $709ad9e0b5e722f2$var$load("1or3R")
]).then(()=>parcelRequire('3Subp'));

});

parcelRegister("e9go2", function(module, exports) {

let $a4ce9e02c72688d3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a4ce9e02c72688d3$var$load("9gJO7"),
    $a4ce9e02c72688d3$var$load("c5krk"),
    $a4ce9e02c72688d3$var$load("dFNh6"),
    $a4ce9e02c72688d3$var$load("8rsL2"),
    $a4ce9e02c72688d3$var$load("iAaum"),
    $a4ce9e02c72688d3$var$load("hYWtF"),
    $a4ce9e02c72688d3$var$load("5JvKa"),
    $a4ce9e02c72688d3$var$load("1TOYq"),
    $a4ce9e02c72688d3$var$load("7lGj4"),
    $a4ce9e02c72688d3$var$load("h3VCR"),
    $a4ce9e02c72688d3$var$load("aQp8v"),
    $a4ce9e02c72688d3$var$load("ffEVr"),
    $a4ce9e02c72688d3$var$load("2jsRt"),
    $a4ce9e02c72688d3$var$load("7zPi7")
]).then(()=>parcelRequire('MVtCj'));

});

parcelRegister("4MlWS", function(module, exports) {

$parcel$export(module.exports, "ClientNetworkStatus", () => $5e721815b49d014a$export$491825b5144ba722);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $5e721815b49d014a$export$491825b5144ba722 = /*#__PURE__*/ function(ClientNetworkStatus) {
    ClientNetworkStatus["IP_BLOCKED"] = "IP_BLOCKED";
    ClientNetworkStatus["OFFLINE"] = "OFFLINE";
    ClientNetworkStatus["ONLINE"] = "ONLINE";
    ClientNetworkStatus["RATE_LIMITED"] = "RATE_LIMITED";
    ClientNetworkStatus["SESSION_EXPIRED"] = "SESSION_EXPIRED";
    return ClientNetworkStatus;
}({});

});

parcelRegister("gb3Lk", function(module, exports) {

let $bc70979242ae36ec$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bc70979242ae36ec$var$load("aWPe2").then(()=>parcelRequire('bDxwy'));

});

parcelRegister("bkwfe", function(module, exports) {

let $83fa9315d7db342d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $83fa9315d7db342d$var$load("8rsL2"),
    $83fa9315d7db342d$var$load("iAaum"),
    $83fa9315d7db342d$var$load("8k5W1")
]).then(()=>parcelRequire('42H7Z'));

});

parcelRegister("crKFl", function(module, exports) {

let $90fc347e4a002c78$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $90fc347e4a002c78$var$load("5zLU3").then(()=>parcelRequire('6nGVD'));

});

parcelRegister("i5Glc", function(module, exports) {

let $d2b989a850c774cb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d2b989a850c774cb$var$load("9dZCH").then(()=>parcelRequire('ghOyy'));

});

parcelRegister("5gmpn", function(module, exports) {

$parcel$export(module.exports, "MainLayout", () => $f6b55c9cc88888b7$export$93af822566053b3e);

var $jmjWc = parcelRequire("jmjWc");

const $f6b55c9cc88888b7$export$93af822566053b3e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "GCw5R",
    _reactTreeRootForServerPlaceholderId: true,
    name: 'MainLayout',
    loader: async ()=>(await (parcelRequire("keY6t"))).MainLayout
});

});
parcelRegister("keY6t", function(module, exports) {

let $ebc3bcc3c89a40f7$var$load = (parcelRequire("lhnSv"))(5);



module.exports = Promise.all([
    $ebc3bcc3c89a40f7$var$load("8rsL2"),
    $ebc3bcc3c89a40f7$var$load("iAaum"),
    $ebc3bcc3c89a40f7$var$load("1ISAt"),
    $ebc3bcc3c89a40f7$var$load("mKoWX"),
    $ebc3bcc3c89a40f7$var$load("2eUdC"),
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("cd7QD"), 5)),
    $ebc3bcc3c89a40f7$var$load("1jp8t"),
    $ebc3bcc3c89a40f7$var$load("8fhzw"),
    $ebc3bcc3c89a40f7$var$load("kmhnK"),
    $ebc3bcc3c89a40f7$var$load("4GE9S")
]).then(()=>parcelRequire('cmkWO'));

});
parcelRegister("di5rn", function(module, exports) {
"use strict";

var $jDpSy = parcelRequire("jDpSy");
module.exports = $jDpSy(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("jDpSy", function(module, exports) {
"use strict";
let $e4b5bbdb98dce921$var$cachedBundles = {};
let $e4b5bbdb98dce921$var$cachedPreloads = {};
let $e4b5bbdb98dce921$var$cachedPrefetches = {};
function $e4b5bbdb98dce921$var$getCache(type) {
    switch(type){
        case 'preload':
            return $e4b5bbdb98dce921$var$cachedPreloads;
        case 'prefetch':
            return $e4b5bbdb98dce921$var$cachedPrefetches;
        default:
            return $e4b5bbdb98dce921$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        let cache = $e4b5bbdb98dce921$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("7jLzw", function(module, exports) {

let $553f358db67dd700$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $553f358db67dd700$var$load("j2CBR"),
    $553f358db67dd700$var$load("fp9cm")
]).then(()=>parcelRequire('9ehFI'));

});

parcelRegister("fnTWu", function(module, exports) {

let $b334660119101855$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b334660119101855$var$load("8rsL2"),
    $b334660119101855$var$load("iAaum"),
    $b334660119101855$var$load("22Xly")
]).then(()=>parcelRequire('kQJNb'));

});

parcelRegister("l7cWL", function(module, exports) {

let $f5f44b6882874c83$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f5f44b6882874c83$var$load("8qrZ8"),
    $f5f44b6882874c83$var$load("8rsL2"),
    $f5f44b6882874c83$var$load("iAaum"),
    $f5f44b6882874c83$var$load("juVlo"),
    $f5f44b6882874c83$var$load("6ejFK"),
    $f5f44b6882874c83$var$load("jkTol"),
    $f5f44b6882874c83$var$load("iaNjn"),
    $f5f44b6882874c83$var$load("4ADTj"),
    $f5f44b6882874c83$var$load("jCNLy"),
    $f5f44b6882874c83$var$load("5epKi"),
    $f5f44b6882874c83$var$load("eEpXU"),
    $f5f44b6882874c83$var$load("4zTgj"),
    $f5f44b6882874c83$var$load("eXlRV"),
    $f5f44b6882874c83$var$load("g1nDL"),
    $f5f44b6882874c83$var$load("HLeeR"),
    $f5f44b6882874c83$var$load("fgAxa"),
    $f5f44b6882874c83$var$load("bZWqy"),
    $f5f44b6882874c83$var$load("iMSgb"),
    $f5f44b6882874c83$var$load("bkOZu"),
    $f5f44b6882874c83$var$load("9ZY0L"),
    $f5f44b6882874c83$var$load("iBm1B"),
    $f5f44b6882874c83$var$load("deXSb"),
    $f5f44b6882874c83$var$load("gLxW3"),
    $f5f44b6882874c83$var$load("ftJgg"),
    $f5f44b6882874c83$var$load("8xSXV"),
    $f5f44b6882874c83$var$load("c5krk"),
    $f5f44b6882874c83$var$load("7lGj4"),
    $f5f44b6882874c83$var$load("cUIjD"),
    $f5f44b6882874c83$var$load("joJy8"),
    $f5f44b6882874c83$var$load("aHE9G"),
    $f5f44b6882874c83$var$load("cMlHc"),
    $f5f44b6882874c83$var$load("eVYW1"),
    $f5f44b6882874c83$var$load("ls0Um"),
    $f5f44b6882874c83$var$load("020xd"),
    $f5f44b6882874c83$var$load("eTBsW"),
    $f5f44b6882874c83$var$load("1oiJ6"),
    $f5f44b6882874c83$var$load("dil5i"),
    $f5f44b6882874c83$var$load("2fk6g"),
    $f5f44b6882874c83$var$load("hPalR"),
    $f5f44b6882874c83$var$load("8059b"),
    $f5f44b6882874c83$var$load("3wmvj"),
    $f5f44b6882874c83$var$load("fe4be"),
    $f5f44b6882874c83$var$load("jDjSj"),
    $f5f44b6882874c83$var$load("kjZZD"),
    $f5f44b6882874c83$var$load("aQp8v"),
    $f5f44b6882874c83$var$load("ffEVr"),
    $f5f44b6882874c83$var$load("2jsRt"),
    $f5f44b6882874c83$var$load("bEnB5"),
    $f5f44b6882874c83$var$load("cYP30")
]).then(()=>parcelRequire('35RMv'));

});

parcelRegister("PWqGR", function(module, exports) {

let $09c21669fd72e03c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $09c21669fd72e03c$var$load("1ISAt"),
    $09c21669fd72e03c$var$load("mKoWX"),
    $09c21669fd72e03c$var$load("6u1HZ")
]).then(()=>parcelRequire('el3Ev'));

});

parcelRegister("bbXjt", function(module, exports) {

let $825ebb1d9a7efa26$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $825ebb1d9a7efa26$var$load("8rsL2"),
    $825ebb1d9a7efa26$var$load("iAaum"),
    $825ebb1d9a7efa26$var$load("joJy8"),
    $825ebb1d9a7efa26$var$load("aHE9G"),
    $825ebb1d9a7efa26$var$load("c6fAG")
]).then(()=>parcelRequire('jOztW'));

});

parcelRegister("dVLZi", function(module, exports) {

let $a245d2991982eda0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a245d2991982eda0$var$load("1ISAt"),
    $a245d2991982eda0$var$load("mKoWX"),
    $a245d2991982eda0$var$load("9gXki"),
    $a245d2991982eda0$var$load("jkTol"),
    $a245d2991982eda0$var$load("j87NQ"),
    $a245d2991982eda0$var$load("9gJO7"),
    $a245d2991982eda0$var$load("coYUy"),
    $a245d2991982eda0$var$load("cD1Dd"),
    $a245d2991982eda0$var$load("eXlRV"),
    $a245d2991982eda0$var$load("jRzT2"),
    $a245d2991982eda0$var$load("c7DhJ"),
    $a245d2991982eda0$var$load("ej4rO"),
    $a245d2991982eda0$var$load("6Nh0d"),
    $a245d2991982eda0$var$load("3XYal"),
    $a245d2991982eda0$var$load("g7pmM"),
    $a245d2991982eda0$var$load("lADvr"),
    $a245d2991982eda0$var$load("fc0Qy"),
    $a245d2991982eda0$var$load("7a4au"),
    $a245d2991982eda0$var$load("6OVfM"),
    $a245d2991982eda0$var$load("eh33y"),
    $a245d2991982eda0$var$load("jCu7l"),
    $a245d2991982eda0$var$load("1ZAFx"),
    $a245d2991982eda0$var$load("gLxW3"),
    $a245d2991982eda0$var$load("ftJgg"),
    $a245d2991982eda0$var$load("cixpG"),
    $a245d2991982eda0$var$load("hYWtF"),
    $a245d2991982eda0$var$load("7lGj4"),
    $a245d2991982eda0$var$load("cUIjD"),
    $a245d2991982eda0$var$load("8rsL2"),
    $a245d2991982eda0$var$load("iAaum"),
    $a245d2991982eda0$var$load("dUEf9"),
    $a245d2991982eda0$var$load("joJy8"),
    $a245d2991982eda0$var$load("aHE9G"),
    $a245d2991982eda0$var$load("eVYW1"),
    $a245d2991982eda0$var$load("ls0Um"),
    $a245d2991982eda0$var$load("020xd"),
    $a245d2991982eda0$var$load("eTBsW"),
    $a245d2991982eda0$var$load("1oiJ6"),
    $a245d2991982eda0$var$load("dil5i"),
    $a245d2991982eda0$var$load("2fk6g"),
    $a245d2991982eda0$var$load("hPalR"),
    $a245d2991982eda0$var$load("8059b"),
    $a245d2991982eda0$var$load("3wmvj"),
    $a245d2991982eda0$var$load("fe4be"),
    $a245d2991982eda0$var$load("jDjSj"),
    $a245d2991982eda0$var$load("kjZZD"),
    $a245d2991982eda0$var$load("bEnB5"),
    $a245d2991982eda0$var$load("bZxqd"),
    $a245d2991982eda0$var$load("ffEVr"),
    $a245d2991982eda0$var$load("6Z8WE"),
    $a245d2991982eda0$var$load("mK22p")
]).then(()=>parcelRequire('luNAU'));

});

parcelRegister("6gUNV", function(module, exports) {

let $49104cd828f0d1fe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $49104cd828f0d1fe$var$load("8rsL2"),
    $49104cd828f0d1fe$var$load("iAaum"),
    $49104cd828f0d1fe$var$load("iyAB9"),
    $49104cd828f0d1fe$var$load("hDfPU")
]).then(()=>parcelRequire('2mD8T'));

});

parcelRegister("izaXd", function(module, exports) {

let $d843fe1da56f3c70$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d843fe1da56f3c70$var$load("8rsL2"),
    $d843fe1da56f3c70$var$load("iAaum"),
    $d843fe1da56f3c70$var$load("ehDQZ"),
    $d843fe1da56f3c70$var$load("cUkCs"),
    $d843fe1da56f3c70$var$load("dMWJp")
]).then(()=>parcelRequire('eTW2b'));

});

parcelRegister("41sCE", function(module, exports) {

let $2edd75359f8f27fb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2edd75359f8f27fb$var$load("ceWcd"),
    $2edd75359f8f27fb$var$load("7HNNc"),
    $2edd75359f8f27fb$var$load("eFpF6"),
    $2edd75359f8f27fb$var$load("1ISAt"),
    $2edd75359f8f27fb$var$load("mKoWX"),
    $2edd75359f8f27fb$var$load("1m9tW"),
    $2edd75359f8f27fb$var$load("7J7Dl"),
    $2edd75359f8f27fb$var$load("931GG"),
    $2edd75359f8f27fb$var$load("2XL47"),
    $2edd75359f8f27fb$var$load("jmjAW"),
    $2edd75359f8f27fb$var$load("dJIkj"),
    $2edd75359f8f27fb$var$load("1Zo7q"),
    $2edd75359f8f27fb$var$load("iQFHB"),
    $2edd75359f8f27fb$var$load("32ARE"),
    $2edd75359f8f27fb$var$load("c62LN"),
    $2edd75359f8f27fb$var$load("8t38R"),
    $2edd75359f8f27fb$var$load("dkj9b"),
    $2edd75359f8f27fb$var$load("cFYwo"),
    $2edd75359f8f27fb$var$load("4p9Qk"),
    $2edd75359f8f27fb$var$load("3PQqe"),
    $2edd75359f8f27fb$var$load("2XCZ0"),
    $2edd75359f8f27fb$var$load("84iyu"),
    $2edd75359f8f27fb$var$load("c2m9M"),
    $2edd75359f8f27fb$var$load("esMxL"),
    $2edd75359f8f27fb$var$load("5IuQb"),
    $2edd75359f8f27fb$var$load("ehDQZ"),
    $2edd75359f8f27fb$var$load("kdcrE"),
    $2edd75359f8f27fb$var$load("8fhzw"),
    $2edd75359f8f27fb$var$load("2FvwL"),
    $2edd75359f8f27fb$var$load("1uT6p"),
    $2edd75359f8f27fb$var$load("4tTUt"),
    $2edd75359f8f27fb$var$load("3QAHI"),
    $2edd75359f8f27fb$var$load("4e15z"),
    $2edd75359f8f27fb$var$load("1jZDC"),
    $2edd75359f8f27fb$var$load("1wN7j"),
    $2edd75359f8f27fb$var$load("dTVzs"),
    $2edd75359f8f27fb$var$load("3S9pV"),
    $2edd75359f8f27fb$var$load("9u4sz"),
    $2edd75359f8f27fb$var$load("i3TSs"),
    $2edd75359f8f27fb$var$load("gm70k"),
    $2edd75359f8f27fb$var$load("kCTMZ"),
    $2edd75359f8f27fb$var$load("5w3tp"),
    $2edd75359f8f27fb$var$load("4T4bq"),
    $2edd75359f8f27fb$var$load("jPS1u"),
    $2edd75359f8f27fb$var$load("3UR1K"),
    $2edd75359f8f27fb$var$load("4Oj5y"),
    $2edd75359f8f27fb$var$load("jRzT2"),
    $2edd75359f8f27fb$var$load("58UdM"),
    $2edd75359f8f27fb$var$load("aLgYQ"),
    $2edd75359f8f27fb$var$load("4Qstt"),
    $2edd75359f8f27fb$var$load("kVNpE"),
    $2edd75359f8f27fb$var$load("5odbj"),
    $2edd75359f8f27fb$var$load("i5Fj1"),
    $2edd75359f8f27fb$var$load("lKccm"),
    $2edd75359f8f27fb$var$load("2ZlZi"),
    $2edd75359f8f27fb$var$load("ckJgn"),
    $2edd75359f8f27fb$var$load("2u53D"),
    $2edd75359f8f27fb$var$load("dLkMK"),
    $2edd75359f8f27fb$var$load("eRWKD"),
    $2edd75359f8f27fb$var$load("6vzdH"),
    $2edd75359f8f27fb$var$load("bdLqi"),
    $2edd75359f8f27fb$var$load("deXSb"),
    $2edd75359f8f27fb$var$load("c6MKV"),
    $2edd75359f8f27fb$var$load("aGZFn"),
    $2edd75359f8f27fb$var$load("8rsL2"),
    $2edd75359f8f27fb$var$load("iAaum"),
    $2edd75359f8f27fb$var$load("k0WnS"),
    $2edd75359f8f27fb$var$load("7a4au"),
    $2edd75359f8f27fb$var$load("iB9CC"),
    $2edd75359f8f27fb$var$load("6OVfM"),
    $2edd75359f8f27fb$var$load("fiwvK"),
    $2edd75359f8f27fb$var$load("1ZAFx"),
    $2edd75359f8f27fb$var$load("lm5in"),
    $2edd75359f8f27fb$var$load("7gjV3"),
    $2edd75359f8f27fb$var$load("ifr0h"),
    $2edd75359f8f27fb$var$load("l4Ek9"),
    $2edd75359f8f27fb$var$load("cdEjw"),
    $2edd75359f8f27fb$var$load("ipK41"),
    $2edd75359f8f27fb$var$load("2F69B"),
    $2edd75359f8f27fb$var$load("gkMTK"),
    $2edd75359f8f27fb$var$load("bGaMz"),
    $2edd75359f8f27fb$var$load("2eUdC"),
    $2edd75359f8f27fb$var$load("8yyrA"),
    $2edd75359f8f27fb$var$load("lHceO"),
    $2edd75359f8f27fb$var$load("8Sd4b"),
    $2edd75359f8f27fb$var$load("joJy8"),
    $2edd75359f8f27fb$var$load("aHE9G"),
    $2edd75359f8f27fb$var$load("7jSfd"),
    $2edd75359f8f27fb$var$load("6ACCg"),
    $2edd75359f8f27fb$var$load("4HZlX"),
    $2edd75359f8f27fb$var$load("fe4be"),
    $2edd75359f8f27fb$var$load("kDqHr"),
    $2edd75359f8f27fb$var$load("kjZZD"),
    $2edd75359f8f27fb$var$load("j87NQ"),
    $2edd75359f8f27fb$var$load("bZxqd"),
    $2edd75359f8f27fb$var$load("9gJO7"),
    $2edd75359f8f27fb$var$load("5rp59"),
    $2edd75359f8f27fb$var$load("ffEVr"),
    $2edd75359f8f27fb$var$load("6Z8WE"),
    $2edd75359f8f27fb$var$load("5rfwb")
]).then(()=>parcelRequire('bUMKD'));

});

parcelRegister("3bJ78", function(module, exports) {

let $252564e9baa26537$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $252564e9baa26537$var$load("8rsL2"),
    $252564e9baa26537$var$load("iAaum"),
    $252564e9baa26537$var$load("amygy")
]).then(()=>parcelRequire('iMfxO'));

});

parcelRegister("6TdGc", function(module, exports) {

let $50427da01992befc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $50427da01992befc$var$load("l46gH"),
    $50427da01992befc$var$load("jRzT2"),
    $50427da01992befc$var$load("ifr0h"),
    $50427da01992befc$var$load("7sZmN"),
    $50427da01992befc$var$load("8rsL2"),
    $50427da01992befc$var$load("iAaum"),
    $50427da01992befc$var$load("1ISAt"),
    $50427da01992befc$var$load("mKoWX"),
    $50427da01992befc$var$load("1m9tW"),
    $50427da01992befc$var$load("7J7Dl"),
    $50427da01992befc$var$load("b91tv"),
    $50427da01992befc$var$load("jqXtk"),
    $50427da01992befc$var$load("6vzdH"),
    $50427da01992befc$var$load("koo1l"),
    $50427da01992befc$var$load("j4POW"),
    $50427da01992befc$var$load("aZinD"),
    $50427da01992befc$var$load("ftJgg"),
    $50427da01992befc$var$load("h4Nf7"),
    $50427da01992befc$var$load("2BIkk"),
    $50427da01992befc$var$load("lJxwk"),
    $50427da01992befc$var$load("6ejFK"),
    $50427da01992befc$var$load("8DoxJ"),
    $50427da01992befc$var$load("ffEVr"),
    $50427da01992befc$var$load("joJy8"),
    $50427da01992befc$var$load("aHE9G"),
    $50427da01992befc$var$load("c6MKV"),
    $50427da01992befc$var$load("hA2SB"),
    $50427da01992befc$var$load("6ExNy")
]).then(()=>parcelRequire('iIJIO'));

});

parcelRegister("agglT", function(module, exports) {

$parcel$export(module.exports, "CompanyHubSettingsPageTabsType", () => $585d52ec7db54bb4$export$e0a694ad492b37fe);
var $585d52ec7db54bb4$export$e0a694ad492b37fe = /*#__PURE__*/ function(CompanyHubSettingsPageTabsType) {
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["GENERAL"] = 0] = "GENERAL";
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["ANALYTICS"] = 1] = "ANALYTICS";
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["USERS"] = 2] = "USERS";
    return CompanyHubSettingsPageTabsType;
}({});

});

parcelRegister("jlDGT", function(module, exports) {

let $e15ec4403eb37867$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e15ec4403eb37867$var$load("8rsL2"),
    $e15ec4403eb37867$var$load("iAaum"),
    $e15ec4403eb37867$var$load("6ejFK"),
    $e15ec4403eb37867$var$load("9gJO7"),
    $e15ec4403eb37867$var$load("jBK0b"),
    $e15ec4403eb37867$var$load("9MRDB"),
    $e15ec4403eb37867$var$load("9z63v"),
    $e15ec4403eb37867$var$load("fKpYd"),
    $e15ec4403eb37867$var$load("7sZmN"),
    $e15ec4403eb37867$var$load("1fLz7")
]).then(()=>parcelRequire('eBAks'));

});

parcelRegister("8usNm", function(module, exports) {

let $62e77630bcbfca5e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $62e77630bcbfca5e$var$load("1m9tW"),
    $62e77630bcbfca5e$var$load("7J7Dl"),
    $62e77630bcbfca5e$var$load("ll4CQ"),
    $62e77630bcbfca5e$var$load("5cXIN"),
    $62e77630bcbfca5e$var$load("6pZc8"),
    $62e77630bcbfca5e$var$load("amDM8"),
    $62e77630bcbfca5e$var$load("aO7Ry"),
    $62e77630bcbfca5e$var$load("ifr0h"),
    $62e77630bcbfca5e$var$load("7sZmN"),
    $62e77630bcbfca5e$var$load("8rsL2"),
    $62e77630bcbfca5e$var$load("iAaum"),
    $62e77630bcbfca5e$var$load("1ISAt"),
    $62e77630bcbfca5e$var$load("mKoWX"),
    $62e77630bcbfca5e$var$load("fRr4K"),
    $62e77630bcbfca5e$var$load("6xN9r"),
    $62e77630bcbfca5e$var$load("iQ0Jm"),
    $62e77630bcbfca5e$var$load("l4Ek9"),
    $62e77630bcbfca5e$var$load("lAtSO"),
    $62e77630bcbfca5e$var$load("jkoeR"),
    $62e77630bcbfca5e$var$load("8yyrA"),
    $62e77630bcbfca5e$var$load("8SLfD"),
    $62e77630bcbfca5e$var$load("joJy8"),
    $62e77630bcbfca5e$var$load("aHE9G"),
    $62e77630bcbfca5e$var$load("6ejFK"),
    $62e77630bcbfca5e$var$load("ffEVr"),
    $62e77630bcbfca5e$var$load("7DSUW")
]).then(()=>parcelRequire('54mQG'));

});

parcelRegister("2eDnn", function(module, exports) {

let $1a0b6eda286f22df$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1a0b6eda286f22df$var$load("8rsL2"),
    $1a0b6eda286f22df$var$load("iAaum"),
    $1a0b6eda286f22df$var$load("1ISAt"),
    $1a0b6eda286f22df$var$load("mKoWX"),
    $1a0b6eda286f22df$var$load("5JvKa"),
    $1a0b6eda286f22df$var$load("9MRDB"),
    $1a0b6eda286f22df$var$load("hpNBy"),
    $1a0b6eda286f22df$var$load("ffEVr"),
    $1a0b6eda286f22df$var$load("5ZaO3")
]).then(()=>parcelRequire('dpLKi'));

});

parcelRegister("lVWBn", function(module, exports) {

let $ff7c60ef38300f10$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ff7c60ef38300f10$var$load("gusFU"),
    $ff7c60ef38300f10$var$load("iIfud")
]).then(()=>parcelRequire('fi3dY'));

});

parcelRegister("8o0Cg", function(module, exports) {

let $61b10af6a222d4ca$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $61b10af6a222d4ca$var$load("8rsL2"),
    $61b10af6a222d4ca$var$load("iAaum"),
    $61b10af6a222d4ca$var$load("j4POW"),
    $61b10af6a222d4ca$var$load("ifr0h"),
    $61b10af6a222d4ca$var$load("6ejFK"),
    $61b10af6a222d4ca$var$load("4uUio")
]).then(()=>parcelRequire('ayZRr'));

});

parcelRegister("gXCXf", function(module, exports) {

let $c5905f9e530bbcc3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c5905f9e530bbcc3$var$load("ceWcd"),
    $c5905f9e530bbcc3$var$load("7CYot"),
    $c5905f9e530bbcc3$var$load("eFpF6"),
    $c5905f9e530bbcc3$var$load("1m9tW"),
    $c5905f9e530bbcc3$var$load("7J7Dl"),
    $c5905f9e530bbcc3$var$load("iPz8n"),
    $c5905f9e530bbcc3$var$load("931GG"),
    $c5905f9e530bbcc3$var$load("iwNdc"),
    $c5905f9e530bbcc3$var$load("5RkYA"),
    $c5905f9e530bbcc3$var$load("lSNJq"),
    $c5905f9e530bbcc3$var$load("dJIkj"),
    $c5905f9e530bbcc3$var$load("eVFYI"),
    $c5905f9e530bbcc3$var$load("iQFHB"),
    $c5905f9e530bbcc3$var$load("32ARE"),
    $c5905f9e530bbcc3$var$load("c62LN"),
    $c5905f9e530bbcc3$var$load("8t38R"),
    $c5905f9e530bbcc3$var$load("dkj9b"),
    $c5905f9e530bbcc3$var$load("4p9Qk"),
    $c5905f9e530bbcc3$var$load("3PQqe"),
    $c5905f9e530bbcc3$var$load("hRjg9"),
    $c5905f9e530bbcc3$var$load("2XCZ0"),
    $c5905f9e530bbcc3$var$load("84iyu"),
    $c5905f9e530bbcc3$var$load("c2m9M"),
    $c5905f9e530bbcc3$var$load("esMxL"),
    $c5905f9e530bbcc3$var$load("5IuQb"),
    $c5905f9e530bbcc3$var$load("1ISAt"),
    $c5905f9e530bbcc3$var$load("mKoWX"),
    $c5905f9e530bbcc3$var$load("hIYCb"),
    $c5905f9e530bbcc3$var$load("fNL1b"),
    $c5905f9e530bbcc3$var$load("cLErX"),
    $c5905f9e530bbcc3$var$load("hkGfe"),
    $c5905f9e530bbcc3$var$load("1Zo7q"),
    $c5905f9e530bbcc3$var$load("ehDQZ"),
    $c5905f9e530bbcc3$var$load("2RP81"),
    $c5905f9e530bbcc3$var$load("5xdIv"),
    $c5905f9e530bbcc3$var$load("jo5F7"),
    $c5905f9e530bbcc3$var$load("aoOM9"),
    $c5905f9e530bbcc3$var$load("a9OJ4"),
    $c5905f9e530bbcc3$var$load("jdmfD"),
    $c5905f9e530bbcc3$var$load("7X7qq"),
    $c5905f9e530bbcc3$var$load("3yiZb"),
    $c5905f9e530bbcc3$var$load("jqXtk"),
    $c5905f9e530bbcc3$var$load("kGIBm"),
    $c5905f9e530bbcc3$var$load("69J1q"),
    $c5905f9e530bbcc3$var$load("eb06U"),
    $c5905f9e530bbcc3$var$load("cyGuT"),
    $c5905f9e530bbcc3$var$load("feuOx"),
    $c5905f9e530bbcc3$var$load("aZinD"),
    $c5905f9e530bbcc3$var$load("5TfXH"),
    $c5905f9e530bbcc3$var$load("aGZFn"),
    $c5905f9e530bbcc3$var$load("6qah4"),
    $c5905f9e530bbcc3$var$load("6vzdH"),
    $c5905f9e530bbcc3$var$load("c6MKV"),
    $c5905f9e530bbcc3$var$load("1gUNx"),
    $c5905f9e530bbcc3$var$load("kdcrE"),
    $c5905f9e530bbcc3$var$load("k0Etr"),
    $c5905f9e530bbcc3$var$load("aPxU2"),
    $c5905f9e530bbcc3$var$load("8fhzw"),
    $c5905f9e530bbcc3$var$load("3QAHI"),
    $c5905f9e530bbcc3$var$load("4e15z"),
    $c5905f9e530bbcc3$var$load("1jZDC"),
    $c5905f9e530bbcc3$var$load("1wN7j"),
    $c5905f9e530bbcc3$var$load("dTVzs"),
    $c5905f9e530bbcc3$var$load("3S9pV"),
    $c5905f9e530bbcc3$var$load("9u4sz"),
    $c5905f9e530bbcc3$var$load("i3TSs"),
    $c5905f9e530bbcc3$var$load("gm70k"),
    $c5905f9e530bbcc3$var$load("kCTMZ"),
    $c5905f9e530bbcc3$var$load("5w3tp"),
    $c5905f9e530bbcc3$var$load("2AOLi"),
    $c5905f9e530bbcc3$var$load("4T4bq"),
    $c5905f9e530bbcc3$var$load("jPS1u"),
    $c5905f9e530bbcc3$var$load("8rsL2"),
    $c5905f9e530bbcc3$var$load("iAaum"),
    $c5905f9e530bbcc3$var$load("3UR1K"),
    $c5905f9e530bbcc3$var$load("4Oj5y"),
    $c5905f9e530bbcc3$var$load("jRzT2"),
    $c5905f9e530bbcc3$var$load("lKccm"),
    $c5905f9e530bbcc3$var$load("2ZlZi"),
    $c5905f9e530bbcc3$var$load("ckJgn"),
    $c5905f9e530bbcc3$var$load("2u53D"),
    $c5905f9e530bbcc3$var$load("eRWKD"),
    $c5905f9e530bbcc3$var$load("7a4au"),
    $c5905f9e530bbcc3$var$load("iB9CC"),
    $c5905f9e530bbcc3$var$load("6OVfM"),
    $c5905f9e530bbcc3$var$load("fiwvK"),
    $c5905f9e530bbcc3$var$load("1ZAFx"),
    $c5905f9e530bbcc3$var$load("bRD8g"),
    $c5905f9e530bbcc3$var$load("lm5in"),
    $c5905f9e530bbcc3$var$load("7gjV3"),
    $c5905f9e530bbcc3$var$load("k6XmX"),
    $c5905f9e530bbcc3$var$load("l4Ek9"),
    $c5905f9e530bbcc3$var$load("cdEjw"),
    $c5905f9e530bbcc3$var$load("ipK41"),
    $c5905f9e530bbcc3$var$load("2F69B"),
    $c5905f9e530bbcc3$var$load("gkMTK"),
    $c5905f9e530bbcc3$var$load("bGaMz"),
    $c5905f9e530bbcc3$var$load("2eUdC"),
    $c5905f9e530bbcc3$var$load("8yyrA"),
    $c5905f9e530bbcc3$var$load("lHceO"),
    $c5905f9e530bbcc3$var$load("8Sd4b"),
    $c5905f9e530bbcc3$var$load("joJy8"),
    $c5905f9e530bbcc3$var$load("aHE9G"),
    $c5905f9e530bbcc3$var$load("7jSfd"),
    $c5905f9e530bbcc3$var$load("6ACCg"),
    $c5905f9e530bbcc3$var$load("4HZlX"),
    $c5905f9e530bbcc3$var$load("fe4be"),
    $c5905f9e530bbcc3$var$load("kDqHr"),
    $c5905f9e530bbcc3$var$load("kjZZD"),
    $c5905f9e530bbcc3$var$load("j87NQ"),
    $c5905f9e530bbcc3$var$load("bZxqd"),
    $c5905f9e530bbcc3$var$load("9gJO7"),
    $c5905f9e530bbcc3$var$load("5rp59"),
    $c5905f9e530bbcc3$var$load("ffEVr"),
    $c5905f9e530bbcc3$var$load("6Z8WE"),
    $c5905f9e530bbcc3$var$load("27cgC")
]).then(()=>parcelRequire('fp8N8'));

});

parcelRegister("b8an5", function(module, exports) {

let $81a87c9824b20fd0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $81a87c9824b20fd0$var$load("ckJgn"),
    $81a87c9824b20fd0$var$load("j87NQ"),
    $81a87c9824b20fd0$var$load("9gJO7"),
    $81a87c9824b20fd0$var$load("7anKf"),
    $81a87c9824b20fd0$var$load("jSQlw"),
    $81a87c9824b20fd0$var$load("4zTgj"),
    $81a87c9824b20fd0$var$load("fKO1l"),
    $81a87c9824b20fd0$var$load("fNM8r"),
    $81a87c9824b20fd0$var$load("2FvwL"),
    $81a87c9824b20fd0$var$load("iwtoQ"),
    $81a87c9824b20fd0$var$load("2u53D"),
    $81a87c9824b20fd0$var$load("jCu7l"),
    $81a87c9824b20fd0$var$load("cixpG"),
    $81a87c9824b20fd0$var$load("7lGj4"),
    $81a87c9824b20fd0$var$load("6FSEq"),
    $81a87c9824b20fd0$var$load("8rsL2"),
    $81a87c9824b20fd0$var$load("iAaum"),
    $81a87c9824b20fd0$var$load("erM4f"),
    $81a87c9824b20fd0$var$load("buzXv"),
    $81a87c9824b20fd0$var$load("kPKOV"),
    $81a87c9824b20fd0$var$load("joJy8"),
    $81a87c9824b20fd0$var$load("aHE9G"),
    $81a87c9824b20fd0$var$load("kjZZD"),
    $81a87c9824b20fd0$var$load("ffEVr"),
    $81a87c9824b20fd0$var$load("76eNN"),
    $81a87c9824b20fd0$var$load("k1740"),
    $81a87c9824b20fd0$var$load("bZxqd"),
    $81a87c9824b20fd0$var$load("9SyhI"),
    $81a87c9824b20fd0$var$load("kksGF"),
    $81a87c9824b20fd0$var$load("ik9rg")
]).then(()=>parcelRequire('dg3UC'));

});

parcelRegister("lzjGS", function(module, exports) {

let $fb3c2403b02bd5c7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $fb3c2403b02bd5c7$var$load("9z63v"),
    $fb3c2403b02bd5c7$var$load("2FvwL"),
    $fb3c2403b02bd5c7$var$load("fKpYd"),
    $fb3c2403b02bd5c7$var$load("cixpG"),
    $fb3c2403b02bd5c7$var$load("cdEjw"),
    $fb3c2403b02bd5c7$var$load("9gJO7"),
    $fb3c2403b02bd5c7$var$load("8myCk"),
    $fb3c2403b02bd5c7$var$load("9ZY0L"),
    $fb3c2403b02bd5c7$var$load("hpNBy"),
    $fb3c2403b02bd5c7$var$load("4hOv8"),
    $fb3c2403b02bd5c7$var$load("1ZAFx"),
    $fb3c2403b02bd5c7$var$load("joJy8"),
    $fb3c2403b02bd5c7$var$load("aHE9G"),
    $fb3c2403b02bd5c7$var$load("aj3n8"),
    $fb3c2403b02bd5c7$var$load("jkTol"),
    $fb3c2403b02bd5c7$var$load("aQp8v"),
    $fb3c2403b02bd5c7$var$load("ffEVr"),
    $fb3c2403b02bd5c7$var$load("2jsRt"),
    $fb3c2403b02bd5c7$var$load("c6MKV"),
    $fb3c2403b02bd5c7$var$load("8rsL2"),
    $fb3c2403b02bd5c7$var$load("iAaum"),
    $fb3c2403b02bd5c7$var$load("gvaCb"),
    $fb3c2403b02bd5c7$var$load("egrVC"),
    $fb3c2403b02bd5c7$var$load("2NBvi"),
    $fb3c2403b02bd5c7$var$load("dUXgJ"),
    $fb3c2403b02bd5c7$var$load("eVJyV")
]).then(()=>parcelRequire('9yrtR'));

});

parcelRegister("5zmKh", function(module, exports) {

let $40e1dd65c45e2c20$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $40e1dd65c45e2c20$var$load("1ISAt"),
    $40e1dd65c45e2c20$var$load("mKoWX"),
    $40e1dd65c45e2c20$var$load("1m9tW"),
    $40e1dd65c45e2c20$var$load("7J7Dl"),
    $40e1dd65c45e2c20$var$load("jqXtk"),
    $40e1dd65c45e2c20$var$load("6vzdH"),
    $40e1dd65c45e2c20$var$load("8DoxJ"),
    $40e1dd65c45e2c20$var$load("hRWmb"),
    $40e1dd65c45e2c20$var$load("hmhwB"),
    $40e1dd65c45e2c20$var$load("fS2SK"),
    $40e1dd65c45e2c20$var$load("afNiU"),
    $40e1dd65c45e2c20$var$load("FNKrB"),
    $40e1dd65c45e2c20$var$load("1SiRe"),
    $40e1dd65c45e2c20$var$load("lnKog"),
    $40e1dd65c45e2c20$var$load("gCIfF"),
    $40e1dd65c45e2c20$var$load("koo1l"),
    $40e1dd65c45e2c20$var$load("ifr0h"),
    $40e1dd65c45e2c20$var$load("ikem6"),
    $40e1dd65c45e2c20$var$load("5Smk7"),
    $40e1dd65c45e2c20$var$load("h4Nf7"),
    $40e1dd65c45e2c20$var$load("lfEn7"),
    $40e1dd65c45e2c20$var$load("2BIkk"),
    $40e1dd65c45e2c20$var$load("lJxwk"),
    $40e1dd65c45e2c20$var$load("7VwsU"),
    $40e1dd65c45e2c20$var$load("fsZ6i"),
    $40e1dd65c45e2c20$var$load("hKqxh"),
    $40e1dd65c45e2c20$var$load("7sseo"),
    $40e1dd65c45e2c20$var$load("45SdR"),
    $40e1dd65c45e2c20$var$load("dTsOE"),
    $40e1dd65c45e2c20$var$load("6gqpV"),
    $40e1dd65c45e2c20$var$load("g9CVe"),
    $40e1dd65c45e2c20$var$load("6qah4"),
    $40e1dd65c45e2c20$var$load("aZinD"),
    $40e1dd65c45e2c20$var$load("hIYCb"),
    $40e1dd65c45e2c20$var$load("fNL1b"),
    $40e1dd65c45e2c20$var$load("8rsL2"),
    $40e1dd65c45e2c20$var$load("iAaum"),
    $40e1dd65c45e2c20$var$load("ffEVr"),
    $40e1dd65c45e2c20$var$load("joJy8"),
    $40e1dd65c45e2c20$var$load("aHE9G"),
    $40e1dd65c45e2c20$var$load("c6MKV"),
    $40e1dd65c45e2c20$var$load("ldtPf"),
    $40e1dd65c45e2c20$var$load("6unZM")
]).then(()=>parcelRequire('c0oNl'));

});

parcelRegister("iWtnm", function(module, exports) {

let $dca46e37a5070606$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dca46e37a5070606$var$load("7UdVV").then(()=>parcelRequire('kCK7c'));

});

parcelRegister("ft1IA", function(module, exports) {

let $b42ae5a84fd998ea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b42ae5a84fd998ea$var$load("ge3AN").then(()=>parcelRequire('iiG61'));

});

parcelRegister("2Tacf", function(module, exports) {

let $21a8a0a06254609c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $21a8a0a06254609c$var$load("4Yemz").then(()=>parcelRequire('3R3rh'));

});

parcelRegister("3Deu1", function(module, exports) {

let $2a503fb2196cbd8c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2a503fb2196cbd8c$var$load("8prF9").then(()=>parcelRequire('aJ0Cr'));

});

parcelRegister("5baWg", function(module, exports) {

let $3c56770b68ec401d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3c56770b68ec401d$var$load("8rsL2"),
    $3c56770b68ec401d$var$load("iAaum"),
    $3c56770b68ec401d$var$load("7sZmN"),
    $3c56770b68ec401d$var$load("ffEVr"),
    $3c56770b68ec401d$var$load("6ejFK"),
    $3c56770b68ec401d$var$load("aIuOE")
]).then(()=>parcelRequire('56n4X'));

});

parcelRegister("8wlfd", function(module, exports) {

let $6341ca93d82c3b55$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6341ca93d82c3b55$var$load("fV7Cf").then(()=>parcelRequire('gkSJt'));

});

parcelRegister("6RKjm", function(module, exports) {

let $4ffb9dc86517cf28$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4ffb9dc86517cf28$var$load("8rsL2"),
    $4ffb9dc86517cf28$var$load("iAaum"),
    $4ffb9dc86517cf28$var$load("7sZmN"),
    $4ffb9dc86517cf28$var$load("ffEVr"),
    $4ffb9dc86517cf28$var$load("6ejFK"),
    $4ffb9dc86517cf28$var$load("dezv5")
]).then(()=>parcelRequire('hD4yV'));

});

parcelRegister("iiV7G", function(module, exports) {

let $d53637d762fad0e7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d53637d762fad0e7$var$load("8rsL2"),
    $d53637d762fad0e7$var$load("iAaum"),
    $d53637d762fad0e7$var$load("1ISAt"),
    $d53637d762fad0e7$var$load("mKoWX"),
    $d53637d762fad0e7$var$load("1m9tW"),
    $d53637d762fad0e7$var$load("7J7Dl"),
    $d53637d762fad0e7$var$load("8eNS3"),
    $d53637d762fad0e7$var$load("50LrB"),
    $d53637d762fad0e7$var$load("iQ0Jm"),
    $d53637d762fad0e7$var$load("7sZmN"),
    $d53637d762fad0e7$var$load("l4Ek9"),
    $d53637d762fad0e7$var$load("bGaMz"),
    $d53637d762fad0e7$var$load("ffEVr"),
    $d53637d762fad0e7$var$load("2eiOk")
]).then(()=>parcelRequire('do0K0'));

});

parcelRegister("5oZuH", function(module, exports) {

let $3eeee51c109f8848$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3eeee51c109f8848$var$load("EEHCI").then(()=>parcelRequire('dtJ3H'));

});

parcelRegister("fjPoa", function(module, exports) {

let $b2707e1ab764b23a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b2707e1ab764b23a$var$load("fAUr9").then(()=>parcelRequire('7EJ9w'));

});

parcelRegister("wRQQ8", function(module, exports) {

let $062cc302f4ddf98f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $062cc302f4ddf98f$var$load("evWu5").then(()=>parcelRequire('8foBH'));

});

parcelRegister("dMDTH", function(module, exports) {

let $a08eb4d3f50888b6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a08eb4d3f50888b6$var$load("8rsL2"),
    $a08eb4d3f50888b6$var$load("iAaum"),
    $a08eb4d3f50888b6$var$load("1ISAt"),
    $a08eb4d3f50888b6$var$load("mKoWX"),
    $a08eb4d3f50888b6$var$load("1m9tW"),
    $a08eb4d3f50888b6$var$load("7J7Dl"),
    $a08eb4d3f50888b6$var$load("dvePS"),
    $a08eb4d3f50888b6$var$load("bO41X"),
    $a08eb4d3f50888b6$var$load("9gXki"),
    $a08eb4d3f50888b6$var$load("JoMnx"),
    $a08eb4d3f50888b6$var$load("kdcrE"),
    $a08eb4d3f50888b6$var$load("4Ig4q"),
    $a08eb4d3f50888b6$var$load("5w3tp"),
    $a08eb4d3f50888b6$var$load("jRzT2"),
    $a08eb4d3f50888b6$var$load("7gjV3"),
    $a08eb4d3f50888b6$var$load("gLxW3"),
    $a08eb4d3f50888b6$var$load("jkoeR"),
    $a08eb4d3f50888b6$var$load("8yyrA"),
    $a08eb4d3f50888b6$var$load("kjZZD"),
    $a08eb4d3f50888b6$var$load("ffEVr"),
    $a08eb4d3f50888b6$var$load("aDjtG")
]).then(()=>parcelRequire('fJXL7'));

});

parcelRegister("hT3pQ", function(module, exports) {

let $d05a390fddc2ce71$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d05a390fddc2ce71$var$load("8rsL2"),
    $d05a390fddc2ce71$var$load("iAaum"),
    $d05a390fddc2ce71$var$load("1ISAt"),
    $d05a390fddc2ce71$var$load("mKoWX"),
    $d05a390fddc2ce71$var$load("1m9tW"),
    $d05a390fddc2ce71$var$load("7J7Dl"),
    $d05a390fddc2ce71$var$load("9gJO7"),
    $d05a390fddc2ce71$var$load("9Q8Ik"),
    $d05a390fddc2ce71$var$load("3FG3M"),
    $d05a390fddc2ce71$var$load("b52u5"),
    $d05a390fddc2ce71$var$load("2ZlZi"),
    $d05a390fddc2ce71$var$load("fKpYd"),
    $d05a390fddc2ce71$var$load("aO7Ry"),
    $d05a390fddc2ce71$var$load("3pIYR"),
    $d05a390fddc2ce71$var$load("lm5in"),
    $d05a390fddc2ce71$var$load("7gjV3"),
    $d05a390fddc2ce71$var$load("8eNS3"),
    $d05a390fddc2ce71$var$load("ifr0h"),
    $d05a390fddc2ce71$var$load("7sZmN"),
    $d05a390fddc2ce71$var$load("kjZZD"),
    $d05a390fddc2ce71$var$load("bGaMz"),
    $d05a390fddc2ce71$var$load("joJy8"),
    $d05a390fddc2ce71$var$load("aHE9G"),
    $d05a390fddc2ce71$var$load("aQp8v"),
    $d05a390fddc2ce71$var$load("ffEVr"),
    $d05a390fddc2ce71$var$load("2jsRt"),
    $d05a390fddc2ce71$var$load("651dU")
]).then(()=>parcelRequire('gDZU2'));

});

parcelRegister("klRqn", function(module, exports) {

let $ed0f35d123e5f0dc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ed0f35d123e5f0dc$var$load("8rsL2"),
    $ed0f35d123e5f0dc$var$load("iAaum"),
    $ed0f35d123e5f0dc$var$load("1ISAt"),
    $ed0f35d123e5f0dc$var$load("mKoWX"),
    $ed0f35d123e5f0dc$var$load("16ht2"),
    $ed0f35d123e5f0dc$var$load("joJy8"),
    $ed0f35d123e5f0dc$var$load("aHE9G"),
    $ed0f35d123e5f0dc$var$load("lk8h1"),
    $ed0f35d123e5f0dc$var$load("kKNsN")
]).then(()=>parcelRequire('1vSpd'));

});

parcelRegister("5NkoD", function(module, exports) {

let $438159a1a7e1c8b3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $438159a1a7e1c8b3$var$load("aPxU2"),
    $438159a1a7e1c8b3$var$load("7cc9v"),
    $438159a1a7e1c8b3$var$load("eFpF6"),
    $438159a1a7e1c8b3$var$load("1ISAt"),
    $438159a1a7e1c8b3$var$load("mKoWX"),
    $438159a1a7e1c8b3$var$load("1m9tW"),
    $438159a1a7e1c8b3$var$load("7J7Dl"),
    $438159a1a7e1c8b3$var$load("93LE8"),
    $438159a1a7e1c8b3$var$load("2ZlZi"),
    $438159a1a7e1c8b3$var$load("dXcJg"),
    $438159a1a7e1c8b3$var$load("fc0Qy"),
    $438159a1a7e1c8b3$var$load("iB9CC"),
    $438159a1a7e1c8b3$var$load("fWP1X"),
    $438159a1a7e1c8b3$var$load("5IuQb"),
    $438159a1a7e1c8b3$var$load("jIshj"),
    $438159a1a7e1c8b3$var$load("fqHoN"),
    $438159a1a7e1c8b3$var$load("i2GTg"),
    $438159a1a7e1c8b3$var$load("4QfDA"),
    $438159a1a7e1c8b3$var$load("8fhzw"),
    $438159a1a7e1c8b3$var$load("demVD"),
    $438159a1a7e1c8b3$var$load("8Hf7M"),
    $438159a1a7e1c8b3$var$load("2UsgQ"),
    $438159a1a7e1c8b3$var$load("jtaMC"),
    $438159a1a7e1c8b3$var$load("jRzT2"),
    $438159a1a7e1c8b3$var$load("fowgN"),
    $438159a1a7e1c8b3$var$load("lADvr"),
    $438159a1a7e1c8b3$var$load("lk8h1"),
    $438159a1a7e1c8b3$var$load("jVHJJ"),
    $438159a1a7e1c8b3$var$load("tzKH7"),
    $438159a1a7e1c8b3$var$load("1Umv6"),
    $438159a1a7e1c8b3$var$load("deXSb"),
    $438159a1a7e1c8b3$var$load("7a4au"),
    $438159a1a7e1c8b3$var$load("6OVfM"),
    $438159a1a7e1c8b3$var$load("fiwvK"),
    $438159a1a7e1c8b3$var$load("jdiXm"),
    $438159a1a7e1c8b3$var$load("jCu7l"),
    $438159a1a7e1c8b3$var$load("6yUSO"),
    $438159a1a7e1c8b3$var$load("gZAYQ"),
    $438159a1a7e1c8b3$var$load("1ZAFx"),
    $438159a1a7e1c8b3$var$load("18XFi"),
    $438159a1a7e1c8b3$var$load("8rsL2"),
    $438159a1a7e1c8b3$var$load("iAaum"),
    $438159a1a7e1c8b3$var$load("ewSSf"),
    $438159a1a7e1c8b3$var$load("42PSc"),
    $438159a1a7e1c8b3$var$load("gUudp"),
    $438159a1a7e1c8b3$var$load("5zDuS"),
    $438159a1a7e1c8b3$var$load("jkoeR"),
    $438159a1a7e1c8b3$var$load("7lGj4"),
    $438159a1a7e1c8b3$var$load("6Y8Qe"),
    $438159a1a7e1c8b3$var$load("19KJH"),
    $438159a1a7e1c8b3$var$load("iPz8n"),
    $438159a1a7e1c8b3$var$load("jkTol"),
    $438159a1a7e1c8b3$var$load("gzdCt"),
    $438159a1a7e1c8b3$var$load("8Sd4b"),
    $438159a1a7e1c8b3$var$load("joJy8"),
    $438159a1a7e1c8b3$var$load("aHE9G"),
    $438159a1a7e1c8b3$var$load("7jSfd"),
    $438159a1a7e1c8b3$var$load("6ACCg"),
    $438159a1a7e1c8b3$var$load("4HZlX"),
    $438159a1a7e1c8b3$var$load("fe4be"),
    $438159a1a7e1c8b3$var$load("kDqHr"),
    $438159a1a7e1c8b3$var$load("kjZZD"),
    $438159a1a7e1c8b3$var$load("4PppF"),
    $438159a1a7e1c8b3$var$load("j87NQ"),
    $438159a1a7e1c8b3$var$load("bZxqd"),
    $438159a1a7e1c8b3$var$load("9gJO7"),
    $438159a1a7e1c8b3$var$load("5rp59"),
    $438159a1a7e1c8b3$var$load("ffEVr"),
    $438159a1a7e1c8b3$var$load("6Z8WE"),
    $438159a1a7e1c8b3$var$load("j6RYV")
]).then(()=>parcelRequire('5y7xd'));

});

parcelRegister("gui5I", function(module, exports) {

let $c00d7b39cb0e84a7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c00d7b39cb0e84a7$var$load("1ISAt"),
    $c00d7b39cb0e84a7$var$load("mKoWX"),
    $c00d7b39cb0e84a7$var$load("1Zo7q"),
    $c00d7b39cb0e84a7$var$load("hLeHa"),
    $c00d7b39cb0e84a7$var$load("9ZY0L"),
    $c00d7b39cb0e84a7$var$load("i9ToQ"),
    $c00d7b39cb0e84a7$var$load("gkMTK"),
    $c00d7b39cb0e84a7$var$load("9gJO7"),
    $c00d7b39cb0e84a7$var$load("32ARE"),
    $c00d7b39cb0e84a7$var$load("aZ3wY"),
    $c00d7b39cb0e84a7$var$load("70aiP"),
    $c00d7b39cb0e84a7$var$load("ej4rO"),
    $c00d7b39cb0e84a7$var$load("cmcKh"),
    $c00d7b39cb0e84a7$var$load("c5krk"),
    $c00d7b39cb0e84a7$var$load("dFNh6"),
    $c00d7b39cb0e84a7$var$load("8rsL2"),
    $c00d7b39cb0e84a7$var$load("iAaum"),
    $c00d7b39cb0e84a7$var$load("hYWtF"),
    $c00d7b39cb0e84a7$var$load("5JvKa"),
    $c00d7b39cb0e84a7$var$load("1TOYq"),
    $c00d7b39cb0e84a7$var$load("7lGj4"),
    $c00d7b39cb0e84a7$var$load("h3VCR"),
    $c00d7b39cb0e84a7$var$load("joJy8"),
    $c00d7b39cb0e84a7$var$load("aHE9G"),
    $c00d7b39cb0e84a7$var$load("aQp8v"),
    $c00d7b39cb0e84a7$var$load("ffEVr"),
    $c00d7b39cb0e84a7$var$load("2jsRt"),
    $c00d7b39cb0e84a7$var$load("dkIUD")
]).then(()=>parcelRequire('l2J3i'));

});

parcelRegister("hp6Gv", function(module, exports) {

let $cab9f4e85ad521fc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $cab9f4e85ad521fc$var$load("ceWcd"),
    $cab9f4e85ad521fc$var$load("eFpF6"),
    $cab9f4e85ad521fc$var$load("1ISAt"),
    $cab9f4e85ad521fc$var$load("mKoWX"),
    $cab9f4e85ad521fc$var$load("1m9tW"),
    $cab9f4e85ad521fc$var$load("7J7Dl"),
    $cab9f4e85ad521fc$var$load("931GG"),
    $cab9f4e85ad521fc$var$load("iQFHB"),
    $cab9f4e85ad521fc$var$load("1xV57"),
    $cab9f4e85ad521fc$var$load("c62LN"),
    $cab9f4e85ad521fc$var$load("8t38R"),
    $cab9f4e85ad521fc$var$load("dkj9b"),
    $cab9f4e85ad521fc$var$load("4p9Qk"),
    $cab9f4e85ad521fc$var$load("3PQqe"),
    $cab9f4e85ad521fc$var$load("2XCZ0"),
    $cab9f4e85ad521fc$var$load("84iyu"),
    $cab9f4e85ad521fc$var$load("c2m9M"),
    $cab9f4e85ad521fc$var$load("esMxL"),
    $cab9f4e85ad521fc$var$load("5IuQb"),
    $cab9f4e85ad521fc$var$load("kdcrE"),
    $cab9f4e85ad521fc$var$load("8fhzw"),
    $cab9f4e85ad521fc$var$load("3QAHI"),
    $cab9f4e85ad521fc$var$load("dTVzs"),
    $cab9f4e85ad521fc$var$load("9u4sz"),
    $cab9f4e85ad521fc$var$load("i3TSs"),
    $cab9f4e85ad521fc$var$load("gm70k"),
    $cab9f4e85ad521fc$var$load("5w3tp"),
    $cab9f4e85ad521fc$var$load("4T4bq"),
    $cab9f4e85ad521fc$var$load("jPS1u"),
    $cab9f4e85ad521fc$var$load("8rsL2"),
    $cab9f4e85ad521fc$var$load("iAaum"),
    $cab9f4e85ad521fc$var$load("3UR1K"),
    $cab9f4e85ad521fc$var$load("4Oj5y"),
    $cab9f4e85ad521fc$var$load("jRzT2"),
    $cab9f4e85ad521fc$var$load("lKccm"),
    $cab9f4e85ad521fc$var$load("2ZlZi"),
    $cab9f4e85ad521fc$var$load("lm5in"),
    $cab9f4e85ad521fc$var$load("7gjV3"),
    $cab9f4e85ad521fc$var$load("ifr0h"),
    $cab9f4e85ad521fc$var$load("l4Ek9"),
    $cab9f4e85ad521fc$var$load("cdEjw"),
    $cab9f4e85ad521fc$var$load("ipK41"),
    $cab9f4e85ad521fc$var$load("2F69B"),
    $cab9f4e85ad521fc$var$load("gkMTK"),
    $cab9f4e85ad521fc$var$load("2eUdC"),
    $cab9f4e85ad521fc$var$load("8yyrA"),
    $cab9f4e85ad521fc$var$load("joJy8"),
    $cab9f4e85ad521fc$var$load("aHE9G"),
    $cab9f4e85ad521fc$var$load("ffEVr"),
    $cab9f4e85ad521fc$var$load("fNffa")
]).then(()=>parcelRequire('7MAGI'));

});

parcelRegister("bG22E", function(module, exports) {

let $8805336140af6265$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8805336140af6265$var$load("8rsL2"),
    $8805336140af6265$var$load("iAaum"),
    $8805336140af6265$var$load("1ISAt"),
    $8805336140af6265$var$load("mKoWX"),
    $8805336140af6265$var$load("9gXki"),
    $8805336140af6265$var$load("549LV"),
    $8805336140af6265$var$load("kFOec"),
    $8805336140af6265$var$load("jPS1u"),
    $8805336140af6265$var$load("jRzT2"),
    $8805336140af6265$var$load("16ht2"),
    $8805336140af6265$var$load("70aiP"),
    $8805336140af6265$var$load("lk8h1"),
    $8805336140af6265$var$load("ifr0h"),
    $8805336140af6265$var$load("cS7dz")
]).then(()=>parcelRequire('ec8HN'));

});

parcelRegister("crxf7", function(module, exports) {

let $90f1cb007481af46$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $90f1cb007481af46$var$load("3Fa5l"),
    $90f1cb007481af46$var$load("7S9EX")
]).then(()=>parcelRequire('3VmKy'));

});

parcelRegister("3Up8V", function(module, exports) {

$parcel$export(module.exports, "SiteHomepageRedirectLoader", () => $9a92030a887a5e49$export$1fe963e8f052ccbb);
$parcel$export(module.exports, "GoToHomeLoader", () => $9a92030a887a5e49$export$c34c105fee6e8977);

var $jmjWc = parcelRequire("jmjWc");

const $9a92030a887a5e49$export$1fe963e8f052ccbb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "_BuCT",
    name: "SiteHomepageRedirectLoader",
    loader: async ()=>(await (parcelRequire("f69jJ"))).SiteHomepageRedirect
});

const $9a92030a887a5e49$export$c34c105fee6e8977 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fei0k",
    name: "GoToHomeLoader",
    loader: async ()=>(await (parcelRequire("jafU1"))).GoToHome
});

});
parcelRegister("f69jJ", function(module, exports) {

let $afdea4c09d7a6293$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $afdea4c09d7a6293$var$load("cgZOp").then(()=>parcelRequire('kkwpp'));

});

parcelRegister("jafU1", function(module, exports) {

let $df3b4969fabbeb86$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $df3b4969fabbeb86$var$load("8rsL2"),
    $df3b4969fabbeb86$var$load("iAaum"),
    $df3b4969fabbeb86$var$load("luyQ6"),
    $df3b4969fabbeb86$var$load("32ARE"),
    $df3b4969fabbeb86$var$load("c0lrw")
]).then(()=>parcelRequire('7QGXJ'));

});


parcelRegister("7nFWC", function(module, exports) {

let $55fb37ac6a0ec9d9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $55fb37ac6a0ec9d9$var$load("8rsL2"),
    $55fb37ac6a0ec9d9$var$load("iAaum"),
    $55fb37ac6a0ec9d9$var$load("gusFU"),
    $55fb37ac6a0ec9d9$var$load("6dqXI"),
    $55fb37ac6a0ec9d9$var$load("iO7VA")
]).then(()=>parcelRequire('4CchY'));

});

parcelRegister("9OZS4", function(module, exports) {

let $7268c6e51a93d6d1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7268c6e51a93d6d1$var$load("8rsL2"),
    $7268c6e51a93d6d1$var$load("iAaum"),
    $7268c6e51a93d6d1$var$load("1m9tW"),
    $7268c6e51a93d6d1$var$load("7J7Dl"),
    $7268c6e51a93d6d1$var$load("bFnHA"),
    $7268c6e51a93d6d1$var$load("hmhwB"),
    $7268c6e51a93d6d1$var$load("ifr0h"),
    $7268c6e51a93d6d1$var$load("3cI3U")
]).then(()=>parcelRequire('5CzWQ'));

});

parcelRegister("jTgA8", function(module, exports) {

let $e7b0043050127d35$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e7b0043050127d35$var$load("8rsL2"),
    $e7b0043050127d35$var$load("iAaum"),
    $e7b0043050127d35$var$load("1m9tW"),
    $e7b0043050127d35$var$load("7J7Dl"),
    $e7b0043050127d35$var$load("hmhwB"),
    $e7b0043050127d35$var$load("f0WOR"),
    $e7b0043050127d35$var$load("1SiRe"),
    $e7b0043050127d35$var$load("lnKog"),
    $e7b0043050127d35$var$load("8eNS3"),
    $e7b0043050127d35$var$load("50LrB"),
    $e7b0043050127d35$var$load("iQ0Jm"),
    $e7b0043050127d35$var$load("bGaMz"),
    $e7b0043050127d35$var$load("ffEVr"),
    $e7b0043050127d35$var$load("5n2uM")
]).then(()=>parcelRequire('bexnX'));

});

parcelRegister("i7tNq", function(module, exports) {

let $d30ffe54ef17b96c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d30ffe54ef17b96c$var$load("8rsL2"),
    $d30ffe54ef17b96c$var$load("iAaum"),
    $d30ffe54ef17b96c$var$load("bFnHA"),
    $d30ffe54ef17b96c$var$load("hmhwB"),
    $d30ffe54ef17b96c$var$load("lHNSl")
]).then(()=>parcelRequire('8fbPW'));

});

parcelRegister("bBT0W", function(module, exports) {

let $873dd317b1c405f6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $873dd317b1c405f6$var$load("8rsL2"),
    $873dd317b1c405f6$var$load("iAaum"),
    $873dd317b1c405f6$var$load("vlZ5n")
]).then(()=>parcelRequire('i5MLu'));

});

parcelRegister("c0zF3", function(module, exports) {

let $8be125af7c08258a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8be125af7c08258a$var$load("hsAS2").then(()=>parcelRequire('6PsK0'));

});

parcelRegister("4VJHa", function(module, exports) {

let $396fee6a491f1b36$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $396fee6a491f1b36$var$load("fiwvK"),
    $396fee6a491f1b36$var$load("8rsL2"),
    $396fee6a491f1b36$var$load("iAaum"),
    $396fee6a491f1b36$var$load("6OVfM"),
    $396fee6a491f1b36$var$load("2DNIK"),
    $396fee6a491f1b36$var$load("eIzhm"),
    $396fee6a491f1b36$var$load("5HLgX"),
    $396fee6a491f1b36$var$load("fqHoN"),
    $396fee6a491f1b36$var$load("2UsgQ"),
    $396fee6a491f1b36$var$load("6ltm2"),
    $396fee6a491f1b36$var$load("jtaMC"),
    $396fee6a491f1b36$var$load("lADvr"),
    $396fee6a491f1b36$var$load("lk8h1"),
    $396fee6a491f1b36$var$load("jVHJJ"),
    $396fee6a491f1b36$var$load("tzKH7"),
    $396fee6a491f1b36$var$load("1Umv6"),
    $396fee6a491f1b36$var$load("deXSb"),
    $396fee6a491f1b36$var$load("fc0Qy"),
    $396fee6a491f1b36$var$load("avCUM"),
    $396fee6a491f1b36$var$load("7a4au"),
    $396fee6a491f1b36$var$load("iB9CC"),
    $396fee6a491f1b36$var$load("1ZAFx"),
    $396fee6a491f1b36$var$load("7sZmN"),
    $396fee6a491f1b36$var$load("6Y8Qe"),
    $396fee6a491f1b36$var$load("19KJH"),
    $396fee6a491f1b36$var$load("iPz8n"),
    $396fee6a491f1b36$var$load("jkTol"),
    $396fee6a491f1b36$var$load("gzdCt"),
    $396fee6a491f1b36$var$load("8Sd4b"),
    $396fee6a491f1b36$var$load("joJy8"),
    $396fee6a491f1b36$var$load("aHE9G"),
    $396fee6a491f1b36$var$load("7jSfd"),
    $396fee6a491f1b36$var$load("6ACCg"),
    $396fee6a491f1b36$var$load("4HZlX"),
    $396fee6a491f1b36$var$load("fe4be"),
    $396fee6a491f1b36$var$load("kDqHr"),
    $396fee6a491f1b36$var$load("kjZZD"),
    $396fee6a491f1b36$var$load("4PppF"),
    $396fee6a491f1b36$var$load("j87NQ"),
    $396fee6a491f1b36$var$load("bZxqd"),
    $396fee6a491f1b36$var$load("9gJO7"),
    $396fee6a491f1b36$var$load("5rp59"),
    $396fee6a491f1b36$var$load("ffEVr"),
    $396fee6a491f1b36$var$load("6Z8WE"),
    $396fee6a491f1b36$var$load("faxwR")
]).then(()=>parcelRequire('eHKVU'));

});

parcelRegister("gbGOI", function(module, exports) {

let $bc8ee2f7f5cb4f46$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $bc8ee2f7f5cb4f46$var$load("8rsL2"),
    $bc8ee2f7f5cb4f46$var$load("iAaum"),
    $bc8ee2f7f5cb4f46$var$load("9gJO7"),
    $bc8ee2f7f5cb4f46$var$load("jBK0b"),
    $bc8ee2f7f5cb4f46$var$load("1wMt1"),
    $bc8ee2f7f5cb4f46$var$load("cxsa4"),
    $bc8ee2f7f5cb4f46$var$load("iXIx7"),
    $bc8ee2f7f5cb4f46$var$load("9gXki"),
    $bc8ee2f7f5cb4f46$var$load("9z63v"),
    $bc8ee2f7f5cb4f46$var$load("fKpYd"),
    $bc8ee2f7f5cb4f46$var$load("7sZmN"),
    $bc8ee2f7f5cb4f46$var$load("gLxW3"),
    $bc8ee2f7f5cb4f46$var$load("joJy8"),
    $bc8ee2f7f5cb4f46$var$load("aHE9G"),
    $bc8ee2f7f5cb4f46$var$load("kjZZD"),
    $bc8ee2f7f5cb4f46$var$load("ffEVr"),
    $bc8ee2f7f5cb4f46$var$load("gYbv6")
]).then(()=>parcelRequire('9qsRH'));

});

parcelRegister("1b4bl", function(module, exports) {

let $0dba0ffc506988aa$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0dba0ffc506988aa$var$load("83Dnz").then(()=>parcelRequire('1e8Au'));

});

parcelRegister("9TVBV", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $eb8c51b94819be10$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "i18nBulk", () => $eb8c51b94819be10$export$c4b5d6610bc5fc6e);
$parcel$export(module.exports, "BulkSpacePermissionsPage", () => $eb8c51b94819be10$export$405a6cc8f1c994c8);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $diswb = parcelRequire("diswb");

var $laHi9 = parcelRequire("laHi9");

var $ccHMk = parcelRequire("ccHMk");
var $7p4As = parcelRequire("7p4As");

var $inPa6 = parcelRequire("inPa6");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $1BYn9 = parcelRequire("1BYn9");

var $9wGTI = parcelRequire("9wGTI");

var $g3p2i = parcelRequire("g3p2i");
var $hpRYU = parcelRequire("hpRYU");

var $1NBp8 = parcelRequire("1NBp8");

var $dIouf = parcelRequire("dIouf");

var $7aRa9 = parcelRequire("7aRa9");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $lqf9t = parcelRequire("lqf9t");

var $c09s4 = parcelRequire("c09s4");

var $8A6YM = parcelRequire("8A6YM");

var $dWpPi = parcelRequire("dWpPi");

var $eIwUX = parcelRequire("eIwUX");

var $2Pnx9 = parcelRequire("2Pnx9");

var $kAGh9 = parcelRequire("kAGh9");
const $eb8c51b94819be10$var$BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation = (0, $d2LG0.default)`mutation BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation($spacePermissions:[SpacePermissionType]!$spaceTypes:[BulkSetSpacePermissionSpaceType]!$subjectId:ID!$subjectType:BulkSetSpacePermissionSubjectType!){bulkSetSpacePermissionAsync(input:{spacePermissions:$spacePermissions spaceTypes:$spaceTypes subjectId:$subjectId subjectType:$subjectType}){success errors{message extensions{errorType statusCode}}taskId}}`;
const $eb8c51b94819be10$export$f7109619a5e9e0d6 = 'bulkSpacePermissionsScreen';
const $eb8c51b94819be10$export$c4b5d6610bc5fc6e = (0, $2nPZH.defineMessages)({
    backToSpacePermissions: {
        id: "bulk-permissions.space-permissions-link",
        defaultMessage: "Space permissions"
    },
    bulkAddHeader: {
        id: "bulk-permissions.space.header",
        defaultMessage: "Add people to all spaces"
    },
    titleSubtext: {
        id: "bulk-permissions.space.title-subtext",
        defaultMessage: "Quickly add (or remove) an individual user or group to all spaces on your Confluence site. This will overwrite any existing access they have, which means it can also be a good way to change access for a user or group in all spaces."
    },
    userPickerHeader: {
        id: "bulk-permissions.space.user-picker-header",
        defaultMessage: "Choose who to add or remove<asterisk>*</asterisk>"
    },
    userPickerSubtext: {
        id: "bulk-permissions.space.user-picker-subtext",
        defaultMessage: "You may only select one for this action."
    },
    asyncSuccessFlagTitle: {
        id: "bulk-permissions.space.async.update.success-flag-title",
        defaultMessage: "Bulk permissions change processing"
    },
    asyncSuccessFlagDescription: {
        id: "bulk-permissions.space.async.update.success-flag-description",
        defaultMessage: "These changes can take a while. We\u2019ll notify you when it\u2019s finished."
    },
    errorFlagTitle: {
        id: "bulk-permissions.space.error-flag-title",
        defaultMessage: "Bulk permissions change failed"
    },
    errorFlagDescription: {
        id: "bulk-permissions.space.error-flag-description",
        defaultMessage: "We ran into a problem completing your bulk permissions change. Try again."
    },
    userPickerPlaceholder: {
        id: "bulk-permissions.space.user-picker-placeholder",
        defaultMessage: "Enter a person or group"
    },
    requirementMessage: {
        id: "bulk-permissions.space.requirement-message",
        defaultMessage: "<asterisk>* </asterisk> Required to perform action"
    },
    applyButtonTextAdd: {
        id: "bulk-permissions.space.apply-button-text-add",
        defaultMessage: "Add to all"
    },
    applyButtonTextRemove: {
        id: "bulk-permissions.space.apply-button-text-remove",
        defaultMessage: "Remove from all"
    }
});
const $eb8c51b94819be10$var$bulkAddHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$bulkSubtextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $eb8c51b94819be10$var$userPickerHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $eb8c51b94819be10$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $eb8c51b94819be10$var$userPickerFineTextStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.050',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $eb8c51b94819be10$var$contentStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.1000',
    marginRight: 'space.1000'
});
const $eb8c51b94819be10$var$backButtonStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.200',
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$userPickerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.050'
});
const $eb8c51b94819be10$var$requirementMessageStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$getPrincipalId = (principal)=>{
    return principal?.type === 'user' ? principal?.extra?.accountId : principal?.extra?.id;
};
const $eb8c51b94819be10$export$405a6cc8f1c994c8 = (0, $7aRa9.withFlags)((0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE
})(({ flags: flags })=>{
    const intl = (0, $dBxQj.default)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const [spacePermissions, setSpacePermissions] = (0, $gwFzn.useState)([
        (0, $lqf9t.SpacePermissionType).VIEW_SPACE
    ]);
    const [stagedPrincipal, setStagedPrincipal] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(undefined);
    const [spaceSelection, setSpaceSelection] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [showDialog, setShowDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(false);
    const isRemoval = !spacePermissions.includes((0, $lqf9t.SpacePermissionType).VIEW_SPACE);
    const closeDialog = (0, $gwFzn.useCallback)(()=>{
        setShowDialog(false);
    }, [
        setShowDialog
    ]);
    const setInitState = (0, $gwFzn.useCallback)(()=>{
        setStagedPrincipal(undefined);
        setSpaceSelection((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
        setSpacePermissions([
            (0, $lqf9t.SpacePermissionType).VIEW_SPACE
        ]);
    }, []);
    const onMutationErrored = (0, $gwFzn.useCallback)((error)=>{
        closeDialog();
        flags.showErrorFlag({
            id: 'bulk-space-permissions.add.error',
            title: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.errorFlagTitle),
            description: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.errorFlagDescription),
            isAutoDismiss: true
        });
        experienceTracker.stopOnError({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE),
            error: error
        });
    }, [
        closeDialog,
        flags,
        intl,
        experienceTracker
    ]);
    const onAsyncMutationSubmitted = (0, $gwFzn.useCallback)((data)=>{
        closeDialog();
        /**
     * The backend is counting the mutation as a success for some exceptions
     * but returning an error in the mutation response.  We need to check for
     * these here.
     */ if (data?.bulkSetSpacePermissionAsync?.errors?.length > 0) onMutationErrored(new Error('Bulk space permissions mutation failed', data?.bulkSetSpacePermissionAsync?.errors));
        else {
            flags.showSuccessFlag({
                id: 'bulk-space-permissions.async.update.success',
                title: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.asyncSuccessFlagTitle),
                description: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.asyncSuccessFlagDescription),
                isAutoDismiss: true
            });
            experienceTracker.succeed({
                name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
            });
        }
        setInitState();
    }, [
        closeDialog,
        setInitState,
        onMutationErrored,
        flags,
        intl,
        experienceTracker
    ]);
    const getBulkSpacePermissionSubjectType = (0, $gwFzn.useCallback)(()=>{
        return stagedPrincipal?.type === 'user' ? (0, $lqf9t.BulkSetSpacePermissionSubjectType).USER : (0, $lqf9t.BulkSetSpacePermissionSubjectType).GROUP;
    }, [
        stagedPrincipal
    ]);
    const getBulkSpacePermissionSpaceType = (0, $gwFzn.useCallback)(()=>{
        switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return [
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).GLOBAL,
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).COLLABORATION,
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).KNOWLEDGE_BASE
                ];
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return [
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).PERSONAL,
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).GLOBAL,
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).COLLABORATION,
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).KNOWLEDGE_BASE
                ];
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return [
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).PERSONAL
                ];
            default:
                return [
                    null
                ];
        }
    }, [
        spaceSelection
    ]);
    const [bulkUpdateAsync, { loading: asyncLoading, error: asyncError }] = (0, $diswb.useMutation)($eb8c51b94819be10$var$BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: (err)=>{
            closeDialog();
            onMutationErrored(err);
        },
        variables: {
            spacePermissions: spacePermissions,
            subjectType: getBulkSpacePermissionSubjectType(),
            subjectId: $eb8c51b94819be10$var$getPrincipalId(stagedPrincipal),
            spaceTypes: getBulkSpacePermissionSpaceType()
        }
    });
    const openDialog = (0, $gwFzn.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
        });
        setShowDialog(true);
    }, [
        setShowDialog,
        experienceTracker
    ]);
    const handleBackClick = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'defaultspaceperms',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onSpaceRadioChange = (0, $gwFzn.useCallback)((e)=>{
        setSpaceSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkSpacePermissionsType',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6,
                attributes: {
                    spaceSelection: e.target.value
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onPrincipalChange = (0, $gwFzn.useCallback)((received)=>{
        // Only send an analytic event if a principal isn't deselected
        if (received) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'principal',
                action: 'selected',
                actionSubjectId: 'bulkSpacePermissionsPrincipal',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6,
                attributes: {
                    principal: received.type
                }
            }
        }).fire();
        setStagedPrincipal(received);
    }, [
        createAnalyticsEvent
    ]);
    const onDialogConfirm = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'bulkSpacePermissionsConfirm',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6
            }
        }).fire();
        bulkUpdateAsync();
    }, [
        createAnalyticsEvent,
        bulkUpdateAsync
    ]);
    const onDialogCancel = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'bulkSpacePermissionsCancel',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6
            }
        }).fire();
        closeDialog();
        experienceTracker.abort({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE),
            reason: 'User closed the dialog'
        });
    }, [
        createAnalyticsEvent,
        experienceTracker,
        closeDialog
    ]);
    // Don't render the page until we know if the user is a product admin
    // to avoid a flicker of the restricted view.
    if (isAdminCheckLoading) return null;
    if (!isProductAdmin || edition === (0, $euL71.ConfluenceEdition).FREE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eIwUX.RestrictedView), null);
    return (0, $9wGTI.fg)('confluence_rbac_spaces_beta_opt_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kAGh9.BulkAccessManagementPage), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, asyncError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: asyncError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$contentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$backButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        onClick: handleBackClick,
        href: (0, $1NBp8.ADMIN_SITE_SPACE_PERMISSIONS).toUrl({
            tab: 'allspaces'
        }),
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                ...iconProps,
                size: "small"
            })
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.backToSpacePermissions))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$bulkAddHeaderStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.bulkAddHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$bulkSubtextStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.titleSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$userPickerHeaderStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $eb8c51b94819be10$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$userPickerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
        ariaLabel: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerPlaceholder),
        "data-test-id": "user-and-group-search",
        fieldId: "bulk-permissions-user-picker",
        includeGroup: true,
        withUsers: true,
        isMulti: false,
        smart: false,
        placeholder: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerPlaceholder),
        sitePermissionTypeFilter: (0, $g3p2i.SitePermissionTypeFilter).NONE,
        // @ts-ignore - Type 'null' is not assignable to type 'string | ((input: { inputValue: string; }) => string | null)'
        // Using `ts-ignore` and not `ts-expect-error` here as TypeScript will fail on this line without `ts-ignore` but with `ts-expect-error`
        // This error was introduced after upgrading to TypeScript 5
        noOptionsMessage: null,
        onChange: (received)=>{
            // @ts-ignore - Argument of type 'Value' is not assignable to parameter of type 'OptionData | undefined'
            // Using `ts-ignore` and not `ts-expect-error` here as TypeScript will fail on this line without `ts-ignore` but with `ts-expect-error`
            // This error was introduced after upgrading to TypeScript 5
            onPrincipalChange(received);
        },
        value: stagedPrincipal || [],
        filterSearchResults: (value)=>value?.extra?.permissionType !== (0, $g3p2i.SitePermissionType).EXTERNAL
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$userPickerFineTextStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8A6YM.SpaceSelectionRadioButtons), {
        spaceSelection: spaceSelection,
        onRadioChange: onSpaceRadioChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dWpPi.PermissionSelectionSection), {
        spacePermissions: spacePermissions,
        setSpacePermissions: setSpacePermissions
    }), isRemoval && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c09s4.RemovalWarning), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: openDialog,
        isDisabled: stagedPrincipal === undefined
    }, intl.formatMessage(isRemoval ? $eb8c51b94819be10$export$c4b5d6610bc5fc6e.applyButtonTextRemove : $eb8c51b94819be10$export$c4b5d6610bc5fc6e.applyButtonTextAdd)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        xcss: $eb8c51b94819be10$var$requirementMessageStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.requirementMessage, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $eb8c51b94819be10$var$asteriskStyle
            }, chunks)
    }))), showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Pnx9.BulkSpacePermissionsModal), {
        principalName: stagedPrincipal?.name || '',
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        isLoading: asyncLoading,
        onConfirm: onDialogConfirm,
        onCancel: onDialogCancel
    }));
}));

});
parcelRegister("lqf9t", function(module, exports) {

$parcel$export(module.exports, "BulkSetSpacePermissionSpaceType", () => $70228f3077c41fe6$export$e57870671ec2468e);
$parcel$export(module.exports, "BulkSetSpacePermissionSubjectType", () => $70228f3077c41fe6$export$8b2051573ac4b3d5);
$parcel$export(module.exports, "SpacePermissionType", () => $70228f3077c41fe6$export$a99f5dae9c149910);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $70228f3077c41fe6$export$e57870671ec2468e = /*#__PURE__*/ function(BulkSetSpacePermissionSpaceType) {
    BulkSetSpacePermissionSpaceType["COLLABORATION"] = "COLLABORATION";
    BulkSetSpacePermissionSpaceType["GLOBAL"] = "GLOBAL";
    BulkSetSpacePermissionSpaceType["KNOWLEDGE_BASE"] = "KNOWLEDGE_BASE";
    BulkSetSpacePermissionSpaceType["PERSONAL"] = "PERSONAL";
    return BulkSetSpacePermissionSpaceType;
}({});
var $70228f3077c41fe6$export$8b2051573ac4b3d5 = /*#__PURE__*/ function(BulkSetSpacePermissionSubjectType) {
    BulkSetSpacePermissionSubjectType["GROUP"] = "GROUP";
    BulkSetSpacePermissionSubjectType["USER"] = "USER";
    return BulkSetSpacePermissionSubjectType;
}({});
var $70228f3077c41fe6$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});

});

parcelRegister("c09s4", function(module, exports) {

$parcel$export(module.exports, "RemovalWarning", () => $0d65445224ec1da1$export$ebaaa2fd42680a02);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $aoVih = parcelRequire("aoVih");

var $6f0Oj = parcelRequire("6f0Oj");
const $0d65445224ec1da1$export$ebaaa2fd42680a02 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aoVih.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: 'bulk-permissions.space.removal-warning.non-final',
        defaultMessage: '<b>Permission to view is not selected. This will remove the user or group from all spaces.</b>',
        description: 'Warning text telling the user that they are removing permissions for a user or group.',
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
        }
    })));

});

parcelRegister("8A6YM", function(module, exports) {

$parcel$export(module.exports, "SpaceSelection", () => $ec94e17fe3441559$export$463c90b38fc542de);
$parcel$export(module.exports, "SpaceSelectionRadioButtons", () => $ec94e17fe3441559$export$1117068039e5ec07);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $4vzBZ = parcelRequire("4vzBZ");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $kZ5GD = parcelRequire("kZ5GD");

var $dh538 = parcelRequire("dh538");

var $1qfLF = parcelRequire("1qfLF");

var $3gadb = parcelRequire("3gadb");
const $ec94e17fe3441559$var$i18n = (0, $2nPZH.defineMessages)({
    archivedSpacesTooltip: {
        id: "bulk-permissions.space.archived-spaces-tooltip",
        defaultMessage: "Archived spaces are not included in bulk permissions actions."
    },
    archivedSpacesTooltipBulkAccess: {
        id: "bulk-permissions.space.archived-spaces-tooltip-bulk-access",
        defaultMessage: "Archived spaces are not included in bulk access actions."
    },
    archivedSpacesTooltipIconLabel: {
        id: "bulk-permissions.space.archived-spaces-tooltip-icon-label",
        defaultMessage: "Archived space information"
    },
    spaceSelectionHeader: {
        id: "bulk-permissions.space.space-selection-header",
        defaultMessage: "Choose which spaces"
    },
    spaceAccessSelectionHeader: {
        id: "bulk-permissions.space.space-access-selection-header",
        defaultMessage: "On which spaces<asterisk>*</asterisk>"
    },
    spaceSelectionOne: {
        id: "bulk-permissions.space.space-selection-one",
        defaultMessage: "All (excluding personal)"
    },
    spaceSelectionTwo: {
        id: "bulk-permissions.space.space-selection-two",
        defaultMessage: "All"
    },
    spaceSelectionThree: {
        id: "bulk-permissions.space.space-selection-three",
        defaultMessage: "Only personal"
    }
});
var $ec94e17fe3441559$export$463c90b38fc542de = /*#__PURE__*/ function(SpaceSelection) {
    SpaceSelection["AllExcludingPersonal"] = "all-excluding-personal";
    SpaceSelection["AllIncludingPersonal"] = "all-including-personal";
    SpaceSelection["OnlyPersonal"] = "only-personal";
    return SpaceSelection;
}({});
const $ec94e17fe3441559$var$spaceSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $ec94e17fe3441559$var$spaceSelectionRadioButtonStyle = (0, $ecnYn.xcss)({
    marginBottom: 'space.300'
});
const $ec94e17fe3441559$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $ec94e17fe3441559$export$1117068039e5ec07 = ({ spaceSelection: spaceSelection, onRadioChange: onRadioChange })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionHeaderStyle,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionHeaderStyle
    }, formatMessage((0, $dh538.fg)('confluence_rbac_spaces_beta_opt_in') ? $ec94e17fe3441559$var$i18n.spaceAccessSelectionHeader : $ec94e17fe3441559$var$i18n.spaceSelectionHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $ec94e17fe3441559$var$asteriskStyle
            }, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: (0, $dh538.fg)('confluence_rbac_spaces_beta_opt_in') ? formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltipBulkAccess) : formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltip),
        position: "right"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), {
                    ...iconProps,
                    size: "small"
                }),
            appearance: "subtle",
            label: formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltipIconLabel),
            spacing: "compact",
            shape: "circle",
            ...tooltipProps
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionRadioButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kZ5GD.default), {
        value: "all-excluding-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "all-excluding-personal",
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionOne)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kZ5GD.default), {
        value: "all-including-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "all-including-personal",
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionTwo)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kZ5GD.default), {
        value: "only-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "only-personal",
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionThree)
    })));
};

});

parcelRegister("dWpPi", function(module, exports) {

$parcel$export(module.exports, "PermissionSelectionSection", () => $ac9ac80a1cd63f38$export$15775f46ef52c627);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $dRCYF = parcelRequire("dRCYF");
const $ac9ac80a1cd63f38$var$i18n = (0, $2nPZH.defineMessages)({
    permissionsSelectionHeader: {
        id: "bulk-permissions.space.permissions-selection-header",
        defaultMessage: "Choose space permissions"
    },
    permissionsSelectionSubtext: {
        id: "bulk-permissions.space.permissions-selection-subtext",
        defaultMessage: "Select which permissions the user or group should have in all spaces. This will overwrite any existing permissions they have. <b>This can\u2019t be undone</b> so make sure to double check who you\u2019re adding and what permissions they should have."
    },
    permissionsSelectionSubtextAdditional: {
        id: "bulk-permissions.space.permissions-selection-subtext-additional",
        defaultMessage: "To remove permissions from all spaces, uncheck the view permission."
    }
});
const $ac9ac80a1cd63f38$var$permissionSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $ac9ac80a1cd63f38$var$subtextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $ac9ac80a1cd63f38$export$15775f46ef52c627 = ({ spacePermissions: spacePermissions, setSpacePermissions: setSpacePermissions })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $ac9ac80a1cd63f38$var$permissionSelectionHeaderStyle
    }, formatMessage($ac9ac80a1cd63f38$var$i18n.permissionsSelectionHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $ac9ac80a1cd63f38$var$subtextStyle
    }, formatMessage($ac9ac80a1cd63f38$var$i18n.permissionsSelectionSubtext, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingBlockStart: "space.200"
    }, formatMessage($ac9ac80a1cd63f38$var$i18n.permissionsSelectionSubtextAdditional))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dRCYF.BulkSpacePermissionsTable), {
        spacePermissions: spacePermissions,
        setSpacePermissions: setSpacePermissions
    }));
};

});
parcelRegister("dRCYF", function(module, exports) {

$parcel$export(module.exports, "BulkSpacePermissionsTable", () => $7a1206d786c0ab1b$export$2f227e4ea23eeffd);
/* BulkSpacePermissionsTable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gEpEw = parcelRequire("gEpEw");

var $7gpC4 = parcelRequire("7gpC4");

var $inPa6 = parcelRequire("inPa6");

var $eicAg = parcelRequire("eicAg");

var $yuLaV = parcelRequire("yuLaV");

var $jhwJP = parcelRequire("jhwJP");

var $lqf9t = parcelRequire("lqf9t");

var $9TVBV = parcelRequire("9TVBV");
const $7a1206d786c0ab1b$var$groupI18nBase = (0, $2nPZH.defineMessages)({
    selectAll: {
        id: "bulk-permissions.space.table.header.group.select-all",
        defaultMessage: "Select all"
    },
    all: {
        id: "bulk-permissions.space.table.header.group.all",
        defaultMessage: "All"
    },
    pages: {
        id: "bulk-permissions.space.table.header.group.pages",
        defaultMessage: "Pages"
    },
    pagesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-embeds",
        defaultMessage: "Pages and Smart Links"
    },
    pagesWhiteboardsDatabases: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases",
        defaultMessage: "Pages, whiteboards, and databases"
    },
    pagesWhiteboardsEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-embeds",
        defaultMessage: "Pages, whiteboards, and Smart Links"
    },
    pagesDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-databases-embeds",
        defaultMessage: "Pages, databases, and Smart Links"
    },
    pagesWhiteboardsDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases-embeds",
        defaultMessage: "Pages, whiteboards, databases, and Smart Links"
    },
    blogs: {
        id: "bulk-permissions.space.table.header.group.blogs",
        defaultMessage: "Blogs"
    },
    comments: {
        id: "bulk-permissions.space.table.header.group.comments",
        defaultMessage: "Comments"
    },
    attachments: {
        id: "bulk-permissions.space.table.header.group.attachments",
        defaultMessage: "Attachments"
    },
    restrictions: {
        id: "bulk-permissions.space.table.header.group.restrictions",
        defaultMessage: "Restrictions"
    },
    mail: {
        id: "bulk-permissions.space.table.header.group.mail",
        defaultMessage: "Mail"
    },
    space: {
        id: "bulk-permissions.space.table.header.group.space",
        defaultMessage: "Space"
    }
});
const $7a1206d786c0ab1b$var$groupI18nLiveDocs = (0, $2nPZH.defineMessages)({
    pages: {
        id: "bulk-permissions.space.table.header.group.pages.livedocs",
        defaultMessage: "Pages and live docs"
    },
    pagesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-embeds.livedocs",
        defaultMessage: "Pages, live docs, and Smart Links"
    },
    pagesWhiteboardsDatabases: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, and databases"
    },
    pagesWhiteboardsEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-embeds.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, databases, and Smart Links"
    },
    pagesDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-databases-embeds.livedocs",
        defaultMessage: "Pages, live docs, databases, and Smart Links"
    },
    pagesWhiteboardsDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases-embeds.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, databases, and Smart Links"
    }
});
const $7a1206d786c0ab1b$var$groupI18n = (0, $jhwJP.mergeLiveDocI18n)($7a1206d786c0ab1b$var$groupI18nBase, $7a1206d786c0ab1b$var$groupI18nLiveDocs);
const $7a1206d786c0ab1b$var$columnI18n = (0, $2nPZH.defineMessages)({
    view: {
        id: "bulk-permissions.space.table.header.column.view",
        defaultMessage: "View"
    },
    deleteOwn: {
        id: "bulk-permissions.space.table.header.column.delete-own",
        defaultMessage: "Delete own"
    },
    add: {
        id: "bulk-permissions.space.table.header.column.Add",
        defaultMessage: "Add"
    },
    delete: {
        id: "bulk-permissions.space.table.header.column.delete",
        defaultMessage: "Delete"
    },
    archive: {
        id: "bulk-permissions.space.table.header.column.archive",
        defaultMessage: "Archive"
    },
    addDelete: {
        id: "bulk-permissions.space.table.header.column.add-delete",
        defaultMessage: "Add/Delete"
    },
    export: {
        id: "bulk-permissions.space.table.header.column.export",
        defaultMessage: "Export"
    },
    admin: {
        id: "bulk-permissions.space.table.header.column.admin",
        defaultMessage: "Admin"
    }
});
const $7a1206d786c0ab1b$var$i18n = (0, $2nPZH.defineMessages)({
    allViewTooltipContent: {
        id: "bulk-permissions.space.table.header.allViewTooltipContent",
        defaultMessage: "View permission determines who has access to the space."
    },
    allViewTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.allViewTooltipIconLabel",
        defaultMessage: "Learn more about view permissions"
    },
    deleteOwnTooltipContent: {
        id: "bulk-permissions.space.table.header.deleteOwnTooltipContent",
        defaultMessage: "Lets users delete their own content and attachments. (For comments, the \u201CAdd\u201D permission includes \u201CDelete Own\u201D)"
    },
    deleteOwnTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.deleteOwnTooltipIconLabel",
        defaultMessage: "Learn more about delete own"
    },
    restrictionsTooltipContent: {
        id: "bulk-permissions.space.table.header.restrictionsTooltipContent",
        defaultMessage: "Lets users add and remove restrictions directly on content. Does not affect inherited restrictions."
    },
    restrictionsTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.restrictionsTooltipIconLabel",
        defaultMessage: "Restrictions Add/Delete tooltip"
    }
});
const $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL = 'SELECT_ALL';
const $7a1206d786c0ab1b$var$CELL_BORDER = {
    borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7a1206d786c0ab1b$var$TableWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1reo1wug _19pkv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7a1206d786c0ab1b$var$CheckboxWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $7a1206d786c0ab1b$export$92f022c5db01744 = {
    [(0, $lqf9t.SpacePermissionType).VIEW_SPACE]: false,
    [(0, $lqf9t.SpacePermissionType).REMOVE_OWN_CONTENT]: false,
    [(0, $lqf9t.SpacePermissionType).CREATE_EDIT_PAGE]: false,
    [(0, $lqf9t.SpacePermissionType).ARCHIVE_PAGE]: false,
    [(0, $lqf9t.SpacePermissionType).REMOVE_PAGE]: false,
    [(0, $lqf9t.SpacePermissionType).EDIT_BLOG]: false,
    [(0, $lqf9t.SpacePermissionType).REMOVE_BLOG]: false,
    [(0, $lqf9t.SpacePermissionType).COMMENT]: false,
    [(0, $lqf9t.SpacePermissionType).REMOVE_COMMENT]: false,
    [(0, $lqf9t.SpacePermissionType).CREATE_ATTACHMENT]: false,
    [(0, $lqf9t.SpacePermissionType).REMOVE_ATTACHMENT]: false,
    [(0, $lqf9t.SpacePermissionType).SET_PAGE_PERMISSIONS]: false,
    [(0, $lqf9t.SpacePermissionType).EXPORT_SPACE]: false,
    [(0, $lqf9t.SpacePermissionType).ADMINISTER_SPACE]: false
};
const $7a1206d786c0ab1b$export$2f227e4ea23eeffd = ({ spacePermissions: spacePermissions, setSpacePermissions: setSpacePermissions })=>{
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isSelectAllCheckbox, setSelectAllCheckbox] = (0, $gwFzn.useState)(false);
    spacePermissions.forEach((val)=>{
        $7a1206d786c0ab1b$export$92f022c5db01744[val] = true;
    });
    const [checkboxValues, setCheckboxValues] = (0, $gwFzn.useState)($7a1206d786c0ab1b$export$92f022c5db01744);
    (0, $gwFzn.useEffect)(()=>{
        Object.keys(checkboxValues).forEach((val)=>{
            checkboxValues[val] = false;
        });
        spacePermissions.forEach((val)=>{
            checkboxValues[val] = true;
        });
        setCheckboxValues(checkboxValues);
        checkSelectAllCheckbox(checkboxValues);
    }, [
        spacePermissions,
        checkboxValues
    ]);
    const getContentGroupName = (_isWhiteboardsEnabled, _isDatabasesEnabled)=>{
        if (!_isWhiteboardsEnabled && !_isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesEmbeds);
        else if (_isWhiteboardsEnabled && !_isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesWhiteboardsEmbeds);
        else if (!_isWhiteboardsEnabled && _isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesDatabasesEmbeds);
        else return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesWhiteboardsDatabasesEmbeds);
    };
    const groupNames = {
        SELECT_ALL: formatMessage($7a1206d786c0ab1b$var$groupI18n.selectAll),
        ALL: formatMessage($7a1206d786c0ab1b$var$groupI18n.all),
        CONTENT: getContentGroupName(isWhiteboardsEnabled, isDatabasesEnabled),
        BLOGS: formatMessage($7a1206d786c0ab1b$var$groupI18n.blogs),
        COMMENTS: formatMessage($7a1206d786c0ab1b$var$groupI18n.comments),
        ATTACHMENTS: formatMessage($7a1206d786c0ab1b$var$groupI18n.attachments),
        RESTRICTIONS: formatMessage($7a1206d786c0ab1b$var$groupI18n.restrictions),
        MAIL: formatMessage($7a1206d786c0ab1b$var$groupI18n.mail),
        SPACE: formatMessage($7a1206d786c0ab1b$var$groupI18n.space)
    };
    const columnNames = {
        VIEW: formatMessage($7a1206d786c0ab1b$var$columnI18n.view),
        DELETE_OWN: formatMessage($7a1206d786c0ab1b$var$columnI18n.deleteOwn),
        ADD: formatMessage($7a1206d786c0ab1b$var$columnI18n.add),
        DELETE: formatMessage($7a1206d786c0ab1b$var$columnI18n.delete),
        ARCHIVE: formatMessage($7a1206d786c0ab1b$var$columnI18n.archive),
        ADD_DELETE: formatMessage($7a1206d786c0ab1b$var$columnI18n.addDelete),
        EXPORT: formatMessage($7a1206d786c0ab1b$var$columnI18n.export),
        ADMIN: formatMessage($7a1206d786c0ab1b$var$columnI18n.admin)
    };
    const permissionsTableHeaders = [
        {
            key: $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: "",
                columnName: groupNames.SELECT_ALL
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).VIEW_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ALL,
                columnName: columnNames.VIEW,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.allViewTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.allViewTooltipIconLabel,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_OWN_CONTENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ALL,
                columnName: columnNames.DELETE_OWN,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.deleteOwnTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.deleteOwnTooltipIconLabel
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).CREATE_EDIT_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.CONTENT,
                columnName: columnNames.ADD
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).ARCHIVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                showGroupName: true,
                groupName: groupNames.CONTENT,
                columnName: columnNames.ARCHIVE,
                centerGroupName: true,
                setWidth: true
            }),
            inlineStyles: {
                maxWidth: "var(--ds-space-1000, 80px)"
            }
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.CONTENT,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).EDIT_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.BLOGS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.BLOGS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.COMMENTS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.COMMENTS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).CREATE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ATTACHMENTS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ATTACHMENTS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).SET_PAGE_PERMISSIONS,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.RESTRICTIONS,
                columnName: columnNames.ADD_DELETE,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.restrictionsTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.restrictionsTooltipIconLabel,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).EXPORT_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.SPACE,
                columnName: columnNames.EXPORT,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).ADMINISTER_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.SPACE,
                columnName: columnNames.ADMIN
            })
        }
    ];
    const updateSpacePermissions = (checkboxValues)=>{
        setSpacePermissions(Object.keys(checkboxValues).filter((val)=>checkboxValues[val]));
    };
    const checkSelectAllCheckbox = (valuesObject)=>{
        if (Object.values(valuesObject).every((v)=>{
            return v;
        })) setSelectAllCheckbox(true);
        else setSelectAllCheckbox(false);
    };
    const getAriaLabel = (checkBox)=>{
        switch(checkBox){
            case (0, $lqf9t.SpacePermissionType).VIEW_SPACE:
                return `${columnNames.VIEW} ${groupNames.ALL}`;
            case (0, $lqf9t.SpacePermissionType).REMOVE_OWN_CONTENT:
                return `${columnNames.DELETE_OWN} ${groupNames.ALL}`;
            case (0, $lqf9t.SpacePermissionType).CREATE_EDIT_PAGE:
                return `${columnNames.ADD} ${groupNames.CONTENT}`;
            case (0, $lqf9t.SpacePermissionType).ARCHIVE_PAGE:
                return `${columnNames.ARCHIVE} ${groupNames.CONTENT}`;
            case (0, $lqf9t.SpacePermissionType).REMOVE_PAGE:
                return `${columnNames.DELETE} ${groupNames.CONTENT}`;
            case (0, $lqf9t.SpacePermissionType).EDIT_BLOG:
                return `${columnNames.ADD} ${groupNames.BLOGS}`;
            case (0, $lqf9t.SpacePermissionType).REMOVE_BLOG:
                return `${columnNames.DELETE} ${groupNames.BLOGS}`;
            case (0, $lqf9t.SpacePermissionType).COMMENT:
                return `${columnNames.ADD} ${groupNames.COMMENTS}`;
            case (0, $lqf9t.SpacePermissionType).REMOVE_COMMENT:
                return `${columnNames.DELETE} ${groupNames.COMMENTS}`;
            case (0, $lqf9t.SpacePermissionType).CREATE_ATTACHMENT:
                return `${columnNames.ADD} ${groupNames.ATTACHMENTS}`;
            case (0, $lqf9t.SpacePermissionType).REMOVE_ATTACHMENT:
                return `${columnNames.DELETE} ${groupNames.ATTACHMENTS}`;
            case (0, $lqf9t.SpacePermissionType).SET_PAGE_PERMISSIONS:
                return `${columnNames.ADD_DELETE} ${groupNames.RESTRICTIONS}`;
            case (0, $lqf9t.SpacePermissionType).EXPORT_SPACE:
                return `${columnNames.EXPORT} ${groupNames.SPACE}`;
            case (0, $lqf9t.SpacePermissionType).ADMINISTER_SPACE:
                return `${columnNames.ADMIN} ${groupNames.SPACE}`;
        }
    };
    const PermissionsTableCheckBox = ({ spacePermission: spacePermission })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7a1206d786c0ab1b$var$CheckboxWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7gpC4.default), {
            testId: `bulk-space-permissions-table-checkbox-${spacePermission}`,
            "aria-label": getAriaLabel(spacePermission),
            isChecked: getCheckedValue(spacePermission),
            isDisabled: spacePermission === (0, $lqf9t.SpacePermissionType).VIEW_SPACE ? false : isDisabled(),
            onChange: ()=>{
                checkboxValues[spacePermission] = !checkboxValues[spacePermission];
                setCheckboxValues(checkboxValues);
                checkSelectAllCheckbox(checkboxValues);
                updateSpacePermissions(checkboxValues);
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        actionSubject: 'checkbox',
                        action: 'clicked',
                        actionSubjectId: spacePermission,
                        source: (0, $9TVBV.ANALYTICS_SOURCE),
                        attributes: {
                            value: checkboxValues[spacePermission]
                        }
                    }
                }).fire();
            }
        }));
    };
    const handleSelectAllChange = ()=>{
        setSelectAllCheckbox(!isSelectAllCheckbox);
        Object.keys(checkboxValues).map((val)=>{
            checkboxValues[val] = !isSelectAllCheckbox;
        });
        setCheckboxValues(checkboxValues);
        updateSpacePermissions(checkboxValues);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'checkbox',
                action: 'clicked',
                actionSubjectId: 'COLUMN_KEY_SELECT_ALL',
                source: (0, $9TVBV.ANALYTICS_SOURCE),
                attributes: {
                    value: isSelectAllCheckbox
                }
            }
        }).fire();
    };
    const isDisabled = ()=>{
        return !checkboxValues[(0, $lqf9t.SpacePermissionType).VIEW_SPACE];
    };
    const getCheckedValue = (itemId)=>{
        return checkboxValues[itemId];
    };
    const checkboxes = [
        {
            key: $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7a1206d786c0ab1b$var$CheckboxWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7gpC4.default), {
                testId: "bulk-space-permissions-table-checkbox-SELECT_ALL",
                "aria-label": groupNames.SELECT_ALL,
                isChecked: isSelectAllCheckbox,
                isDisabled: false,
                onChange: handleSelectAllChange
            }))
        },
        {
            key: (0, $lqf9t.SpacePermissionType).VIEW_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).VIEW_SPACE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_OWN_CONTENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).REMOVE_OWN_CONTENT
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).CREATE_EDIT_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).CREATE_EDIT_PAGE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).ARCHIVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).ARCHIVE_PAGE
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).REMOVE_PAGE
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).EDIT_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).EDIT_BLOG
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).REMOVE_BLOG
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).COMMENT
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).REMOVE_COMMENT
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).CREATE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).CREATE_ATTACHMENT
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).REMOVE_ATTACHMENT
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).SET_PAGE_PERMISSIONS,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).SET_PAGE_PERMISSIONS
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).EXPORT_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).EXPORT_SPACE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).ADMINISTER_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).ADMINISTER_SPACE
            })
        }
    ];
    const rowData = [
        checkboxValues
    ].map(()=>({
            key: `checkboxes`,
            cells: checkboxes
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7a1206d786c0ab1b$var$TableWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gEpEw.default), {
        head: {
            cells: permissionsTableHeaders
        },
        rows: rowData,
        testId: "bulk-space-permissions-table"
    }));
};

});
parcelRegister("eicAg", function(module, exports) {

$parcel$export(module.exports, "HeaderCell", () => $1734009c6c243aaa$export$efcbfab786023e1a);
/* HeaderCell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $4vzBZ = parcelRequire("4vzBZ");

var $3gadb = parcelRequire("3gadb");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $eEA8O = parcelRequire("eEA8O");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1734009c6c243aaa$var$HeaderWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { center: center, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4 _1bahesu3 _1p57v77o _y3gn1h6o _1ul9xy5q _4t3i1wug",
            __cmplp.center ? "_4cvr1h6o" : "_4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$GroupNameWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { setWidth: setWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c81vhk _1e0c1txw _2lx21bp4 _1bah1h6o _1reoewfl _o5721q9c _1tke1u1b _y3gn1h6o _syaz1fxt",
            __cmplp.setWidth ? "_p12fglyw" : "_p12foahv",
            __cmplp.setWidth ? "_1bsb7l9q" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$largeGroupNameStyle = (0, $ecnYn.xcss)({
    whiteSpace: 'normal',
    wordBreak: 'keep-all'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1734009c6c243aaa$var$ColumnNameWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c81o8v _1e0c1txw _o5721q9c _syaz1gjq _1wpz1h6o",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$IconWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1ssb _4t3i4cqu _s7n4nkob _jq8g4cqu _14hp4cqu _irr3avxe _oq581axd",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$export$efcbfab786023e1a = ({ groupName: groupName, columnName: columnName, showGroupName: showGroupName = false, testKey: testKey, tooltipContent: tooltipContent, tooltipIconLabel: tooltipIconLabel, centerGroupName: centerGroupName = false, setMaxWidth: setMaxWidth = false, setWidth: setWidth = false })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1734009c6c243aaa$var$HeaderWrapper, {
        center: centerGroupName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1734009c6c243aaa$var$GroupNameWrapper, {
        "data-testid": testKey ? `space-table-header-${testKey}` : undefined,
        "aria-label": `${groupName}`,
        setMaxWidth: setMaxWidth,
        setWidth: setWidth
    }, showGroupName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            setWidth ? $1734009c6c243aaa$var$largeGroupNameStyle : false
        ]
    }, groupName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        "aria-label": `${groupName}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1734009c6c243aaa$var$ColumnNameWrapper, {
        key: groupName + columnName,
        "aria-label": `${columnName}`
    }, columnName, tooltipContent && tooltipIconLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), tooltipContent)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1734009c6c243aaa$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
            ...tooltipProps,
            appearance: "subtle-link",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), {
                label: formatMessage(tooltipIconLabel),
                color: "var(--ds-icon, #44546F)",
                size: "small"
            })
        })))));
};

});



parcelRegister("eIwUX", function(module, exports) {

$parcel$export(module.exports, "RestrictedView", () => $57959768319b5632$export$b5dab984a2ed58cb);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gllul = parcelRequire("gllul");

var $j3Co0 = parcelRequire("j3Co0");

var $2VsnS = parcelRequire("2VsnS");
const $57959768319b5632$var$i18n = (0, $2nPZH.defineMessages)({
    title: {
        id: "bulk-permissions.restricted.title",
        defaultMessage: "This item is restricted"
    },
    message: {
        id: "bulk-permissions.space-settings.restricted.message",
        defaultMessage: "If you think you should have access, try asking the person who sent you here for help."
    }
});
const $57959768319b5632$export$b5dab984a2ed58cb = ()=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gllul.ErrorPageComponent), {
        errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($j3Co0))),
        errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($2VsnS))),
        errorTitle: intl.formatMessage($57959768319b5632$var$i18n.title),
        errorMessage: intl.formatMessage($57959768319b5632$var$i18n.message)
    });
};

});
parcelRegister("j3Co0", function(module, exports) {
module.exports = new URL("RestrictedContentIcon-Light.e0fef1fb.svg", import.meta.url).toString();

});

parcelRegister("2VsnS", function(module, exports) {
module.exports = new URL("RestrictedContentIcon-Dark.bc90ae31.svg", import.meta.url).toString();

});


parcelRegister("2Pnx9", function(module, exports) {

$parcel$export(module.exports, "BulkSpacePermissionsModal", () => $0e3e25b83ca7a775$export$a9b83e32db9bc573);

var $gwFzn = parcelRequire("gwFzn");

var $ekolh = parcelRequire("ekolh");
var $6xdDU = parcelRequire("6xdDU");

var $67Foi = parcelRequire("67Foi");

var $lM2MU = parcelRequire("lM2MU");

var $iPchQ = parcelRequire("iPchQ");
const $0e3e25b83ca7a775$export$a9b83e32db9bc573 = ({ principalName: principalName, isLoading: isLoading, isRemoval: isRemoval, spaceSelection: spaceSelection, onCancel: onCancel, onConfirm: onConfirm })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $67Foi.ScreenEvent), {
        name: "bulk-space-permissions-dialog",
        id: "bulk-space-permissions-dialog",
        attributes: isRemoval ? {
            action: 'remove'
        } : {
            action: 'add'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ekolh.default), {
        testId: "bulk-space-permissions-confirmation",
        onClose: // Don't allow the dialog to close while mutation is loading
        isLoading ? undefined : onCancel
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lM2MU.LoadingDialog), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iPchQ.ConfirmationDialog), {
        principalName: principalName,
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        onCancel: onCancel,
        onConfirm: onConfirm
    })));

});
parcelRegister("lM2MU", function(module, exports) {

$parcel$export(module.exports, "LoadingDialog", () => $b25698afe0cbfe9a$export$7d8626d803788e96);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $1DHa6 = parcelRequire("1DHa6");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");

var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $6UBEn = parcelRequire("6UBEn");

var $2ZJmt = parcelRequire("2ZJmt");
const $b25698afe0cbfe9a$var$i18n = (0, $2nPZH.defineMessages)({
    loadingTitle: {
        id: "bulk-permissions.space.loading-title",
        defaultMessage: "We\u2019re processing your change"
    },
    loadingDialogDescription: {
        id: "bulk-permissions.space.loading-dialog-description",
        defaultMessage: "Don\u2019t navigate away or refresh."
    }
});
const $b25698afe0cbfe9a$var$LoadingSubSectionStyle = (0, $ecnYn.xcss)({
    rowGap: 'space.300',
    paddingBottom: 'space.800'
});
const $b25698afe0cbfe9a$export$7d8626d803788e96 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ot3w.default), {
        hasCloseButton: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b25698afe0cbfe9a$var$i18n.loadingTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $b25698afe0cbfe9a$var$LoadingSubSectionStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b25698afe0cbfe9a$var$i18n.loadingDialogDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6UBEn.default), {
        isIndeterminate: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2ZJmt.NavigationLockout), null));

});

parcelRegister("iPchQ", function(module, exports) {

$parcel$export(module.exports, "ConfirmationDialog", () => $e9f437038d263d04$export$b8704437d11c7fe7);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $eEA8O = parcelRequire("eEA8O");

var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $8A6YM = parcelRequire("8A6YM");
const $e9f437038d263d04$var$i18n = (0, $2nPZH.defineMessages)({
    addConfirmationDialogTitle: {
        id: "bulk-permissions.space.add.confirmation-dialog",
        defaultMessage: "Add {principalName} to selected spaces?"
    },
    addAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> (excluding personal) on your site with the selected permissions."
    },
    addAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-all.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> on your site with the selected permissions."
    },
    addAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all personal spaces</b> on your site with the selected permissions."
    },
    confirmationDialogWarning: {
        id: "bulk-permissions.space.confirmation-dialog-warning",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    removeConfirmationDialogTitle: {
        id: "bulk-permissions.space.remove.confirmation-dialog",
        defaultMessage: "Remove {principalName} from selected spaces?"
    },
    removeAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> (excluding personal) on your site."
    },
    removeAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-all.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> on your site."
    },
    removeAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all personal spaces</b> on your site."
    },
    cancelButtonText: {
        id: "bulk-permissions.space.cancel-button-text",
        defaultMessage: "Cancel"
    },
    addButtonText: {
        id: "bulk-permissions.space.add-button-text",
        defaultMessage: "Add to all"
    },
    removeButtonText: {
        id: "bulk-permissions.space.remove-button-text",
        defaultMessage: "Remove from all"
    }
});
const $e9f437038d263d04$var$ConfirmatonSubSection = (0, $ecnYn.xcss)({
    paddingTop: 'space.300'
});
const $e9f437038d263d04$var$boldString = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks);
const $e9f437038d263d04$export$b8704437d11c7fe7 = ({ principalName: principalName, isRemoval: isRemoval, spaceSelection: spaceSelection, onConfirm: onConfirm, onCancel: onCancel })=>{
    const getConfirmationDialogDescription = ()=>{
        if (isRemoval) switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $e9f437038d263d04$var$i18n.removeAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $e9f437038d263d04$var$i18n.removeAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $e9f437038d263d04$var$i18n.removeAllPersonalConfirmationDialogDescription;
        }
        else switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $e9f437038d263d04$var$i18n.addAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $e9f437038d263d04$var$i18n.addAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $e9f437038d263d04$var$i18n.addAllPersonalConfirmationDialogDescription;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d8eRd.default), {
        appearance: isRemoval ? 'warning' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...isRemoval ? $e9f437038d263d04$var$i18n.removeConfirmationDialogTitle : $e9f437038d263d04$var$i18n.addConfirmationDialogTitle,
        values: {
            principalName: principalName
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...getConfirmationDialogDescription(),
        values: {
            b: $e9f437038d263d04$var$boldString
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $e9f437038d263d04$var$ConfirmatonSubSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$e9f437038d263d04$var$i18n.confirmationDialogWarning,
        values: {
            b: $e9f437038d263d04$var$boldString
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $e9f437038d263d04$var$i18n.cancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        testId: "confirmation-dialog-confirm-button",
        appearance: isRemoval ? 'warning' : 'primary',
        onClick: onConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), isRemoval ? $e9f437038d263d04$var$i18n.removeButtonText : $e9f437038d263d04$var$i18n.addButtonText))));
};

});


parcelRegister("kAGh9", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $1f40f2edcedc8ce5$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "BulkAccessManagementPage", () => $1f40f2edcedc8ce5$export$db2035bfb5892b74);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $laHi9 = parcelRequire("laHi9");

var $ccHMk = parcelRequire("ccHMk");
var $7p4As = parcelRequire("7p4As");

var $inPa6 = parcelRequire("inPa6");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $1BYn9 = parcelRequire("1BYn9");

var $g3p2i = parcelRequire("g3p2i");
var $hpRYU = parcelRequire("hpRYU");

var $1NBp8 = parcelRequire("1NBp8");

var $dIouf = parcelRequire("dIouf");

var $7aRa9 = parcelRequire("7aRa9");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $c6lYi = parcelRequire("c6lYi");

var $itlCX = parcelRequire("itlCX");

var $6sX6R = parcelRequire("6sX6R");

var $8A6YM = parcelRequire("8A6YM");

var $ipM1n = parcelRequire("ipM1n");

var $b8z8O = parcelRequire("b8z8O");

var $lhYST = parcelRequire("lhYST");

var $eIwUX = parcelRequire("eIwUX");

var $9TVBV = parcelRequire("9TVBV");

var $d259h = parcelRequire("d259h");

var $i0aiC = parcelRequire("i0aiC");
const $1f40f2edcedc8ce5$export$f7109619a5e9e0d6 = 'bulkAccessManagementScreen';
const $1f40f2edcedc8ce5$var$i18n = (0, $2nPZH.defineMessages)({
    bulkRoleAccessHeader: {
        id: "bulk-permissions.space.role-access-header",
        defaultMessage: "Manage space access in bulk"
    },
    bulkRoleAccessSubtext: {
        id: "bulk-permissions.space.role-access-subtext",
        defaultMessage: "Quickly add, change, or remove access for individual users or groups across all spaces on your Confluence site. This is an all or nothing action that will overwrite any existing access."
    },
    userPickerAccessHeader: {
        id: "bulk-permissions.space.user-picker-access-header",
        defaultMessage: "Who<asterisk>*</asterisk>"
    },
    userPickerPlaceholder: {
        id: "bulk-permissions.space.user-picker-placeholder",
        defaultMessage: "Add a user, group, or user class"
    }
});
const $1f40f2edcedc8ce5$var$bulkAddRolesHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $1f40f2edcedc8ce5$var$bulkRolesSubtextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    width: '75%'
});
const $1f40f2edcedc8ce5$var$principlePickerHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $1f40f2edcedc8ce5$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $1f40f2edcedc8ce5$var$principlePickerFineTextStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.050',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $1f40f2edcedc8ce5$var$contentStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.1000',
    marginRight: 'space.1000',
    paddingBottom: 'space.1000'
});
const $1f40f2edcedc8ce5$var$backAndFeedbackButtonsStyle = (0, $ecnYn.xcss)({
    width: '100%',
    marginLeft: 'space.negative.200',
    paddingTop: 'space.300',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
});
const $1f40f2edcedc8ce5$var$principlePickerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.050'
});
const $1f40f2edcedc8ce5$var$requirementTextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingTop: 'space.300',
    paddingBottom: 'space.1000',
    marginBottom: 'space.1000'
});
const $1f40f2edcedc8ce5$export$db2035bfb5892b74 = (0, $7aRa9.withFlags)((0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE
})(({ flags: flags })=>{
    const intl = (0, $dBxQj.default)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const accessClassInclusion = (0, $6sX6R.useAccessClassInclusion)();
    const [showDialog, setShowDialog] = (0, $gwFzn.useState)(false);
    const [stagedPrincipal, setStagedPrincipal] = (0, $gwFzn.useState)(undefined);
    const [spaceSelection, setSpaceSelection] = (0, $gwFzn.useState)((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
    const [actionSelection, setActionSelection] = (0, $gwFzn.useState)((0, $ipM1n.ActionSelection).AddOrChangeAccess);
    const [roleAssignment, setRoleAssignment] = (0, $gwFzn.useState)(null);
    const isRemoval = actionSelection === (0, $ipM1n.ActionSelection).RemoveAccess;
    const closeDialog = (0, $gwFzn.useCallback)(()=>{
        setShowDialog(false);
    }, [
        setShowDialog
    ]);
    const { bulkSetRoleAssignmentToSpaces: bulkSetRoleAssignmentToSpaces, bulkRemoveRoleAssignment: bulkRemoveRoleAssignment } = (0, $i0aiC.useBulkRoleSetAssignment)({
        closeDialog: closeDialog,
        flags: flags
    });
    const getSpaceTypes = (targetValue)=>{
        const spaceTypesArray = [
            (0, $b8z8O.BulkRoleAssignmentSpaceType).PERSONAL,
            (0, $b8z8O.BulkRoleAssignmentSpaceType).COLLABORATION,
            (0, $b8z8O.BulkRoleAssignmentSpaceType).GLOBAL,
            (0, $b8z8O.BulkRoleAssignmentSpaceType).KNOWLEDGE_BASE
        ];
        if (targetValue === (0, $8A6YM.SpaceSelection).AllExcludingPersonal) return spaceTypesArray.filter((type)=>type !== (0, $b8z8O.BulkRoleAssignmentSpaceType).PERSONAL);
        else if (targetValue === (0, $8A6YM.SpaceSelection).AllIncludingPersonal) return spaceTypesArray;
        else if (targetValue === (0, $8A6YM.SpaceSelection).OnlyPersonal) return [
            (0, $b8z8O.BulkRoleAssignmentSpaceType).PERSONAL
        ];
    };
    const getPrincipalType = (principalType)=>{
        if (principalType === 'group') return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
        else if (principalType === 'team') return (0, $itlCX.RoleAssignmentPrincipalType).TEAM;
        else if (principalType === 'custom') return (0, $itlCX.RoleAssignmentPrincipalType).ACCESS_CLASS;
        else return (0, $itlCX.RoleAssignmentPrincipalType).USER;
    };
    const getPrincipalId = (principal)=>{
        if (principal?.type === 'custom') return principal?.id;
        else if (principal?.type === 'group') return principal?.extra?.id;
        else {
            const idx = principal?.id.indexOf('-');
            return principal?.id.slice(idx + 1);
        }
    };
    const onDialogConfirm = (0, $gwFzn.useCallback)(async ()=>{
        closeDialog();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'bulk-access-management-confirm',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    principalType: stagedPrincipal?.type,
                    selectedRole: roleAssignment?.name,
                    spaceTypes: getSpaceTypes(spaceSelection),
                    action: isRemoval ? 'remove' : 'add'
                }
            }
        }).fire();
        isRemoval ? await bulkRemoveRoleAssignment({
            variables: {
                principalId: getPrincipalId(stagedPrincipal),
                principalType: getPrincipalType(stagedPrincipal.type),
                spaceTypes: getSpaceTypes(spaceSelection)
            }
        }) : await bulkSetRoleAssignmentToSpaces({
            variables: {
                principalId: getPrincipalId(stagedPrincipal),
                principalType: getPrincipalType(stagedPrincipal.type),
                roleId: roleAssignment.id,
                spaceTypes: getSpaceTypes(spaceSelection)
            }
        });
    }, [
        closeDialog,
        isRemoval,
        bulkRemoveRoleAssignment,
        stagedPrincipal,
        spaceSelection,
        bulkSetRoleAssignmentToSpaces,
        roleAssignment,
        createAnalyticsEvent
    ]);
    const handleBackToDefaultSpaceAccessClick = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'defaultspaceperms',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onSpaceTypeRadioChange = (0, $gwFzn.useCallback)((e)=>{
        setSpaceSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementSpace',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    spaceSelection: e.target.value,
                    isRBACEnabled: true
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onActionRadioChange = (0, $gwFzn.useCallback)((e)=>{
        setActionSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementAction',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    actionSelection: e.target.value,
                    isRBACEnabled: true
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    //Only passing roleId to the analytics event to avoid leaking UGC
    //Ticket to audit rest of analytics events: https://product-fabric.atlassian.net/browse/RBAC-1552
    const onRoleChange = (0, $gwFzn.useCallback)((role)=>{
        setRoleAssignment(role);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'role picker',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagement',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    roleAssignment: role.id
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onPrincipalChange = (0, $gwFzn.useCallback)((received)=>{
        // Only send an analytic event if a principal isn't deselected
        if (received) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'principal',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementPrincipal',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    principal: received.type,
                    isRBACEnabled: true
                }
            }
        }).fire();
        setStagedPrincipal(received);
    }, [
        createAnalyticsEvent
    ]);
    const openDialog = (0, $gwFzn.useCallback)(()=>{
        setShowDialog(true);
    }, [
        setShowDialog
    ]);
    // Don't render the page until we know if the user is a product admin
    // to avoid a flicker of the restricted view.
    if (isAdminCheckLoading) return null;
    if (!isProductAdmin || edition === (0, $euL71.ConfluenceEdition).FREE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eIwUX.RestrictedView), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$contentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$backAndFeedbackButtonsStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        onClick: handleBackToDefaultSpaceAccessClick,
        href: (0, $1NBp8.ADMIN_SITE_SPACE_PERMISSIONS).toUrl({
            tab: 'allspaces'
        }),
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                ...iconProps,
                size: "small"
            })
    }, intl.formatMessage((0, $9TVBV.i18nBulk).backToSpacePermissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c6lYi.FeedbackCollectorButton), {
        source: "Bulk Space Roles"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$bulkAddRolesHeaderStyle
    }, intl.formatMessage($1f40f2edcedc8ce5$var$i18n.bulkRoleAccessHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$bulkRolesSubtextStyle
    }, intl.formatMessage($1f40f2edcedc8ce5$var$i18n.bulkRoleAccessSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerHeaderStyle
    }, intl.formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerAccessHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $1f40f2edcedc8ce5$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
        ariaLabel: intl.formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerPlaceholder),
        "data-test-id": "user-and-group-search",
        fieldId: "bulk-permissions-user-picker",
        includeGroup: true,
        withUsers: true,
        isMulti: false,
        smart: false,
        customInclusion: accessClassInclusion,
        placeholder: intl.formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerPlaceholder),
        sitePermissionTypeFilter: (0, $g3p2i.SitePermissionTypeFilter).NONE,
        // @ts-ignore - Type 'null' is not assignable to type 'string | ((input: { inputValue: string; }) => string | null)'
        // Using `ts-ignore` and not `ts-expect-error` here as TypeScript will fail on this line without `ts-ignore` but with `ts-expect-error`
        // This error was introduced after upgrading to TypeScript 5
        noOptionsMessage: null,
        onChange: (received)=>{
            // @ts-ignore - Argument of type 'Value' is not assignable to parameter of type 'OptionData | undefined'
            // Using `ts-ignore` and not `ts-expect-error` here as TypeScript will fail on this line without `ts-ignore` but with `ts-expect-error`
            // This error was introduced after upgrading to TypeScript 5
            onPrincipalChange(received);
        },
        value: stagedPrincipal || [],
        filterSearchResults: (value)=>value?.extra?.permissionType !== (0, $g3p2i.SitePermissionType).EXTERNAL
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerFineTextStyle
    }, intl.formatMessage((0, $9TVBV.i18nBulk).userPickerSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipM1n.ActionSelectionRadioButtons), {
        actionSelection: actionSelection,
        onRadioChange: onActionRadioChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8A6YM.SpaceSelectionRadioButtons), {
        spaceSelection: spaceSelection,
        onRadioChange: onSpaceTypeRadioChange
    }), !isRemoval && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lhYST.RoleSelectionSection), {
        onRoleChange: onRoleChange,
        roleAssignment: roleAssignment,
        analyticsSource: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
        flags: flags
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: isRemoval ? 'danger' : 'primary',
        onClick: ()=>openDialog(),
        isDisabled: stagedPrincipal === undefined || !isRemoval && roleAssignment === null
    }, intl.formatMessage(isRemoval ? (0, $9TVBV.i18nBulk).applyButtonTextRemove : (0, $9TVBV.i18nBulk).applyButtonTextAdd)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        xcss: $1f40f2edcedc8ce5$var$requirementTextStyle
    }, intl.formatMessage((0, $9TVBV.i18nBulk).requirementMessage, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $1f40f2edcedc8ce5$var$asteriskStyle
            }, chunks)
    }))), showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d259h.BulkAccessModal), {
        principalName: stagedPrincipal?.name || '',
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        isLoading: false,
        onConfirm: onDialogConfirm,
        onCancel: closeDialog,
        roleName: roleAssignment?.name
    }));
}));

});
parcelRegister("6sX6R", function(module, exports) {

$parcel$export(module.exports, "useAccessClassInclusion", () => $fed355c8c6dd10eb$export$3084d470555a4d72);
/** @graphql cc **/ 
var $diswb = parcelRequire("diswb");

var $d2LG0 = parcelRequire("d2LG0");

var $7Sm4c = parcelRequire("7Sm4c");

var $5ZqQS = parcelRequire("5ZqQS");

var $dIouf = parcelRequire("dIouf");

var $bQm3c = parcelRequire("bQm3c");
const $fed355c8c6dd10eb$var$useAccessClassInclusionClassesQuery = (0, $d2LG0.gql)`query useAccessClassInclusionClassesQuery($cloudId:ID!){confluence_userClasses(cloudId:$cloudId){nodes{principalId displayName}}}`;
const $fed355c8c6dd10eb$var$toLowerWithoutSpaces = (str)=>str?.toLowerCase().replace(/ /g, '');


const $fed355c8c6dd10eb$export$3084d470555a4d72 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)($fed355c8c6dd10eb$var$useAccessClassInclusionClassesQuery, {
        variables: {
            cloudId: cloudId
        },
        onError: (e)=>{
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(e);
        }
    });
    const allConfluenceUsers = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-licensed-users');
    const allConfluenceAdmins = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-product-admins');
    if (loading || error) return [];
    return [
        {
            ...allConfluenceUsers?.principalId && allConfluenceUsers?.displayName && {
                [$fed355c8c6dd10eb$var$toLowerWithoutSpaces(allConfluenceUsers.displayName)]: {
                    id: allConfluenceUsers.principalId,
                    name: allConfluenceUsers.displayName,
                    type: 'custom',
                    avatarUrl: (parcelRequire("j43jY"))
                }
            },
            ...allConfluenceAdmins?.principalId && allConfluenceAdmins?.displayName && {
                [$fed355c8c6dd10eb$var$toLowerWithoutSpaces(allConfluenceAdmins.displayName)]: {
                    id: allConfluenceAdmins.principalId,
                    name: allConfluenceAdmins.displayName,
                    type: 'custom',
                    avatarUrl: (parcelRequire("j43jY"))
                }
            }
        }
    ];
};

});
parcelRegister("j43jY", function(module, exports) {
module.exports = new URL("atlassian-icon.1175e11b.svg", import.meta.url).toString();

});


parcelRegister("ipM1n", function(module, exports) {

$parcel$export(module.exports, "ActionSelection", () => $8799edea050578d8$export$19d9f94347fa723d);
$parcel$export(module.exports, "ActionSelectionRadioButtons", () => $8799edea050578d8$export$321778e99f9fd257);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $kZ5GD = parcelRequire("kZ5GD");
const $8799edea050578d8$var$i18n = (0, $2nPZH.defineMessages)({
    actionSelectionHeader: {
        id: "bulk-permissions.space.action-selection-header",
        defaultMessage: "Action to perform<asterisk>*</asterisk>"
    },
    actionSelectionAdd: {
        id: "bulk-permissions.space.action-selection-add",
        defaultMessage: "Add or change access"
    },
    actionSelectionRemove: {
        id: "bulk-permissions.space.action-selection-remove",
        defaultMessage: "Remove access"
    }
});
var $8799edea050578d8$export$19d9f94347fa723d = /*#__PURE__*/ function(ActionSelection) {
    ActionSelection["AddOrChangeAccess"] = "add-or-change-access";
    ActionSelection["RemoveAccess"] = "remove-access";
    return ActionSelection;
}({});
const $8799edea050578d8$var$actionSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $8799edea050578d8$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $8799edea050578d8$export$321778e99f9fd257 = ({ actionSelection: actionSelection, onRadioChange: onRadioChange })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $8799edea050578d8$var$actionSelectionHeaderStyle,
        "data-testId": "action-selection-radio-buttons"
    }, formatMessage($8799edea050578d8$var$i18n.actionSelectionHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $8799edea050578d8$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kZ5GD.default), {
        value: "add-or-change-access",
        onChange: onRadioChange,
        isChecked: actionSelection === "add-or-change-access",
        name: "action-selection",
        label: formatMessage($8799edea050578d8$var$i18n.actionSelectionAdd)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kZ5GD.default), {
        value: "remove-access",
        onChange: onRadioChange,
        isChecked: actionSelection === "remove-access",
        name: "action-selection",
        label: formatMessage($8799edea050578d8$var$i18n.actionSelectionRemove)
    })));
};

});

parcelRegister("b8z8O", function(module, exports) {

$parcel$export(module.exports, "BulkRoleAssignmentSpaceType", () => $2fd747c2df30bd9d$export$dc2a111abcc46324);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $2fd747c2df30bd9d$export$dc2a111abcc46324 = /*#__PURE__*/ function(BulkRoleAssignmentSpaceType) {
    BulkRoleAssignmentSpaceType["COLLABORATION"] = "COLLABORATION";
    BulkRoleAssignmentSpaceType["GLOBAL"] = "GLOBAL";
    BulkRoleAssignmentSpaceType["KNOWLEDGE_BASE"] = "KNOWLEDGE_BASE";
    BulkRoleAssignmentSpaceType["PERSONAL"] = "PERSONAL";
    return BulkRoleAssignmentSpaceType;
}({});
var $2fd747c2df30bd9d$export$4e2d5448f3fd8728 = /*#__PURE__*/ function(RoleAssignmentPrincipalType) {
    RoleAssignmentPrincipalType["ACCESS_CLASS"] = "ACCESS_CLASS";
    RoleAssignmentPrincipalType["GROUP"] = "GROUP";
    RoleAssignmentPrincipalType["TEAM"] = "TEAM";
    RoleAssignmentPrincipalType["USER"] = "USER";
    return RoleAssignmentPrincipalType;
}({});

});

parcelRegister("lhYST", function(module, exports) {

$parcel$export(module.exports, "RoleSelectionSection", () => $0c8581713df69b2f$export$884fc60bd42d0abd);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $d2LG0 = parcelRequire("d2LG0");

var $diswb = parcelRequire("diswb");

var $6f0Oj = parcelRequire("6f0Oj");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $bfgIy = parcelRequire("bfgIy");

var $1kHsc = parcelRequire("1kHsc");

var $ku6MO = parcelRequire("ku6MO");

var $4zvS9 = parcelRequire("4zvS9");
const $0c8581713df69b2f$var$i18n = (0, $2nPZH.defineMessages)({
    roleSelectionHeader: {
        id: "bulk-permissions.space.role-selection-header",
        defaultMessage: "With what access<asterisk>*</asterisk>"
    },
    roleSelectionSubHeader: {
        id: "bulk-permissions.space.role-selection-sub-header",
        defaultMessage: "Choose the role they should have."
    },
    roleSelectionWarning: {
        id: "bulk-permissions.space.role-selection-warning",
        defaultMessage: "This will overwrite any existing access they have. <b>This can\u2019t be undone,</b> so make sure to double check your selections."
    },
    roleSelectLabel: {
        id: "bulk-permissions.space.role-select-label",
        defaultMessage: "Role"
    },
    roleSelectPlaceholder: {
        id: "bulk-permissions.space-role.select-placeholder",
        defaultMessage: "Select a role"
    }
});
const $0c8581713df69b2f$var$roleSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 'space.100'
});
const $0c8581713df69b2f$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $0c8581713df69b2f$var$roleSelectionContainer = (0, $ecnYn.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.300'
});
const $0c8581713df69b2f$var$sectionContainer = (0, $ecnYn.xcss)({
    marginBottom: 'space.300'
});
const $0c8581713df69b2f$var$roleSelectInfoButtonStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    minWidth: '500px',
    alignItems: 'center'
});
const $0c8581713df69b2f$var$roleSelectStyle = (0, $ecnYn.xcss)({
    minWidth: '300px'
});
const $0c8581713df69b2f$var$roleSelectionSectionRolesQuery = (0, $d2LG0.default)`query RoleSelectionSectionRolesQuery{spaceRolesByCriteria{nodes{roleId roleDisplayName roleDescription roleType spacePermissionList{id priority displayName description requiredSpacePermissions}}}}`;
const $0c8581713df69b2f$export$884fc60bd42d0abd = ({ onRoleChange: onRoleChange, roleAssignment: roleAssignment, analyticsSource: analyticsSource, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [experienceStarted, setExperienceStarted] = (0, $gwFzn.useState)(false);
    //TODO: update this and add it to experience tracker once the experience is created
    const BULK_ROLES_VIEW_EXPERIENCE = 'bulk-roles-view-experience';
    const placeholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text"
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectPlaceholder));
    const { data: data, loading: loading } = (0, $diswb.useQuery)($0c8581713df69b2f$var$roleSelectionSectionRolesQuery, {
        onCompleted: ()=>{
            setExperienceStarted(false);
            experienceTracker.succeed({
                name: BULK_ROLES_VIEW_EXPERIENCE
            });
        },
        onError: (error)=>{
            experienceTracker.stopOnError({
                name: BULK_ROLES_VIEW_EXPERIENCE,
                error: error
            });
        }
    });
    const roleOptions = data?.spaceRolesByCriteria?.nodes.map((role)=>({
            id: role?.roleId || '',
            name: role?.roleDisplayName || '',
            permissions: role?.spacePermissionList.map((permission)=>permission.id) || [],
            description: role?.roleDescription || ''
        })) || [];
    (0, $gwFzn.useEffect)(()=>{
        if (loading && !experienceStarted) setExperienceStarted(true);
    }, [
        loading,
        experienceStarted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$sectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectionHeaderStyle
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $0c8581713df69b2f$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionSubHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bfgIy.Label), {
        htmlFor: "role-selector"
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectInfoButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ku6MO.RoleSelector), {
        value: roleAssignment?.id || null,
        onChange: onRoleChange,
        placeholder: placeholder,
        isLoading: loading,
        spaceRoleOptions: roleOptions,
        appearance: "default"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4zvS9.RoleSelectInfoButton), {
        currentRole: roleAssignment,
        roleLookup: roleOptions,
        analyticsSource: analyticsSource,
        flags: flags
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionWarning, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
    })));
};

});
parcelRegister("ku6MO", function(module, exports) {

$parcel$export(module.exports, "RoleSelector", () => $d5c5d64568180920$export$7b32174eb7b60a13);
/* RoleSelector.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3hOY6 = parcelRequire("3hOY6");
var $2gD2K = parcelRequire("2gD2K");

var $6f0Oj = parcelRequire("6f0Oj");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");
const $d5c5d64568180920$var$menuItemStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.050'
});
const $d5c5d64568180920$export$7b32174eb7b60a13 = ({ initialRoleId: initialRoleId, value: value, isLoading: isLoading, onChange: onChange, placeholder: placeholder, spaceRoleOptions: spaceRoleOptions, onMenuClose: onMenuClose, onMenuOpen: onMenuOpen, menuPlacement: menuPlacement = 'auto', appearance: appearance = 'subtle', noOptionsMessage: noOptionsMessage = '' })=>{
    const [internalVal, setInternalVal] = (0, $gwFzn.useState)((value === undefined ? initialRoleId : value) || null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // The component is controlled if value is not `undefined`. `initialRole` will ignored in controlled mode.
    const isControlledComponent = value !== undefined;
    const options = (0, $gwFzn.useMemo)(()=>spaceRoleOptions.map((role)=>({
                id: role?.id ?? '',
                label: role?.name ?? '',
                value: role?.id ?? '',
                description: role?.description ?? ''
            })), [
        spaceRoleOptions
    ]);
    const getOptionFromValue = (0, $gwFzn.useCallback)((val)=>{
        if (!val) return null;
        return typeof val === 'string' ? options.find((option)=>option.value === val) || null : {
            id: val.value.toString(),
            label: val.label,
            value: val.value.toString(),
            description: ''
        };
    }, [
        options
    ]);
    const CustomSingleValue = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3hOY6.components).SingleValue, props, props.data.label));
    const CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3hOY6.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $d5c5d64568180920$var$menuItemStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, props.data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest"
        }, props.data.description))));
    const handleChange = (newSelection)=>{
        const newSelectionType = spaceRoleOptions.find((role)=>role?.id === newSelection?.value)?.roleType;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'change',
                source: 'spaceRoles-roleSelector',
                attributes: {
                    newSelection: newSelection?.id,
                    newSelectionType: newSelectionType
                }
            }
        }).fire();
        setInternalVal(newSelection?.value || null);
        onChange?.(spaceRoleOptions.find((role)=>role?.id === newSelection?.value));
    };
    const handleMenuOpen = (currentRoleSelection)=>{
        onMenuOpen?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'open',
                source: 'spaceRoles-roleSelector',
                attributes: {
                    currentRoleSelection: currentRoleSelection?.id
                }
            }
        }).fire();
    };
    const SELECT_STYLE_PROPS = {
        isSearchable: false,
        styles: {
            menu: (base)=>({
                    ...base,
                    width: '320px',
                    padding: 0,
                    margin: 0
                })
        }
    };
    const selectValue = isControlledComponent ? getOptionFromValue(value) : getOptionFromValue(internalVal);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2gD2K.default), {
        "data-testid": "space-roles-table-role-selector",
        placeholder: isLoading ? '' : placeholder,
        options: options,
        appearance: appearance,
        isLoading: isLoading,
        onChange: handleChange,
        onMenuOpen: ()=>handleMenuOpen(getOptionFromValue(isControlledComponent ? value : internalVal)),
        onMenuClose: onMenuClose,
        components: {
            SingleValue: CustomSingleValue,
            Option: CustomOption
        },
        menuPosition: "fixed",
        menuPlacement: menuPlacement,
        maxMenuHeight: 320,
        scrollBehavior: "outside",
        defaultValue: getOptionFromValue(initialRoleId),
        value: selectValue,
        noOptionsMessage: ()=>noOptionsMessage,
        ...SELECT_STYLE_PROPS
    });
};

});

parcelRegister("4zvS9", function(module, exports) {

$parcel$export(module.exports, "RoleSelectInfoButton", () => $117ed3de9d2a23fd$export$5bafd35f9dc9151a);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");

var $inPa6 = parcelRequire("inPa6");

var $9rnOu = parcelRequire("9rnOu");

var $g26MG = parcelRequire("g26MG");

var $9C54a = parcelRequire("9C54a");

var $cMmEA = parcelRequire("cMmEA");

var $7swbU = parcelRequire("7swbU");
const $117ed3de9d2a23fd$export$5bafd35f9dc9151a = ({ analyticsSource: analyticsSource, currentRole: currentRole, roleLookup: roleLookup, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isPopupOpen, setIsPopupOpen] = (0, $gwFzn.useState)(false);
    const [isViewPermissionsModalOpen, setIsViewPermissionsModalOpen] = (0, $gwFzn.useState)(false);
    const { permissions: permissions, roles: roles } = (0, $9C54a.useViewPermissionsModal)({
        flags: flags
    });
    const systemRoles = roles.filter((role)=>role?.roleType === 'SYSTEM');
    const customRoles = roles.filter((role)=>role?.roleType === 'CUSTOM');
    const onInfoButtonClick = (0, $gwFzn.useCallback)(()=>{
        setIsPopupOpen(!isPopupOpen);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'role-select-info-button',
                source: analyticsSource,
                attributes: {
                    roleId: currentRole?.id
                }
            }
        }).fire();
    }, [
        isPopupOpen,
        currentRole?.id,
        analyticsSource,
        createAnalyticsEvent
    ]);
    const onPopupContentCtaClick = (0, $gwFzn.useCallback)(()=>{
        setIsPopupOpen(false);
        setIsViewPermissionsModalOpen(true);
    }, []);
    const popupRef = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(null);
    (0, $gwFzn.useEffect)(()=>{
        if (popupRef.current) {
            const handleClickOutside = (e)=>{
                if (popupRef.current && !popupRef.current.contains(e.target)) setIsPopupOpen(false);
            };
            document.addEventListener('click', handleClickOutside);
            return ()=>document.removeEventListener('click', handleClickOutside);
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, isViewPermissionsModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9rnOu.ViewRolePermissionModal), {
        systemRoles: (0, $g26MG.normalizeSpaceRoleList)(systemRoles),
        customRoles: (0, $g26MG.normalizeSpaceRoleList)(customRoles),
        allPermissions: (0, $g26MG.normalizeSpacePermissionAll)(permissions),
        initialActiveRoleId: currentRole?.id,
        analyticsSource: analyticsSource,
        onClose: ()=>setIsViewPermissionsModalOpen(false)
    }), currentRole ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        ref: popupRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cMmEA.ViewPermissionsInfoButton), {
        "data-testid": "role-selector-info-button",
        isOpen: isPopupOpen,
        onClick: onInfoButtonClick,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7swbU.InfoPopupContent), {
            onCtaClick: onPopupContentCtaClick,
            roleId: currentRole.id,
            permissions: currentRole.permissions,
            roleLookup: roleLookup
        })
    })) : null);
};

});
parcelRegister("9rnOu", function(module, exports) {

$parcel$export(module.exports, "ViewRolePermissionModal", () => $b296da749f5cb895$export$5cfd4e5ecf699324);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $ccHMk = parcelRequire("ccHMk");

var $7hXDW = parcelRequire("7hXDW");

var $aUEBE = parcelRequire("aUEBE");

var $7yDmn = parcelRequire("7yDmn");

var $56M4r = parcelRequire("56M4r");
var $7rvPL = parcelRequire("7rvPL");

var $inPa6 = parcelRequire("inPa6");

var $8TTLA = parcelRequire("8TTLA");
var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");
var $6xdDU = parcelRequire("6xdDU");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $cwkWT = parcelRequire("cwkWT");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $bWLcG = parcelRequire("bWLcG");

var $c6lYi = parcelRequire("c6lYi");

var $8Eh39 = parcelRequire("8Eh39");
const $b296da749f5cb895$var$i18n = (0, $2nPZH.defineMessages)({
    title: {
        id: "space-roles.view-role-permissions-modal.title",
        defaultMessage: "Role permissions"
    },
    predefinedRoleListTitle: {
        id: "space-roles.view-role-permissions-modal.predefined-role-list-title",
        defaultMessage: "Confluence roles"
    },
    customRoleListTitle: {
        id: "space-roles.view-role-permissions-modal.custom-role-list-title",
        defaultMessage: "Custom roles"
    },
    doneButtonText: {
        id: "space-roles.view-role-permissions-modal.done-button-text",
        defaultMessage: "Done"
    },
    permissionEnabled: {
        id: "space-roles.view-role-permissions-modal.permission-enabled",
        defaultMessage: "Enabled"
    },
    permissionDisabled: {
        id: "space-roles.view-role-permissions-modal.permission-disabled",
        defaultMessage: "Disabled"
    },
    editButtonLabel: {
        id: "space-roles.view-role-permissions-modal.edit-button-label",
        defaultMessage: "Edit role permissions"
    }
});
// -- Styles --
const $b296da749f5cb895$var$detailViewStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.600'
});
const $b296da749f5cb895$var$rolePermissionDetailContainerStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.400',
    rowGap: 'space.400',
    columnGap: 'space.1000',
    [(0, $bWLcG.media).above.sm]: {
        gridTemplateColumns: 'repeat(2, 1fr)'
    }
});
const $b296da749f5cb895$var$contentStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200'
});
const $b296da749f5cb895$var$checkboxGroupStyles = (0, $ecnYn.xcss)({
    gap: 'space.100',
    justifyContent: 'start'
});
const $b296da749f5cb895$var$navContainerStyles = (0, $ecnYn.xcss)({
    width: '202px'
});
const $b296da749f5cb895$var$modalHeaderStyle = (0, $ecnYn.xcss)({
    marginBottom: 'space.150',
    justifyContent: 'flex-end',
    width: '100%'
});
const $b296da749f5cb895$var$modalHeaderSpacing = (0, $ecnYn.xcss)({
    height: '100%',
    alignItems: 'center',
    width: '100%'
});
const $b296da749f5cb895$export$5cfd4e5ecf699324 = ({ systemRoles: systemRoles = [], customRoles: customRoles = [], allPermissions: allPermissions = [], onClose: onClose = ()=>{}, initialActiveRoleId: initialActiveRoleId, analyticsSource: analyticsSource })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [activeRoleId, setActiveRoleId] = (0, $gwFzn.useState)(initialActiveRoleId || systemRoles[0]?.id || '');
    const activeRole = [
        ...systemRoles,
        ...customRoles
    ].find((role)=>role.id === activeRoleId);
    // Left side navigation
    const [systemRoleButtonItems, customRoleButtonItems] = [
        systemRoles,
        customRoles
    ].map((list)=>list.map((role)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $56M4r.default), {
                key: role.id,
                isSelected: role.id === activeRoleId,
                onClick: ()=>setActiveRoleId(role.id)
            }, role.name)));
    // Right side detail view
    // Build a dictionary for the active role to look up if a permission is enabled or not
    const activeRolePermissionDict = (0, $8Eh39.buildPermissionDictionary)(activeRole?.permissions || []);
    // Get all permissions and group them by group name
    const sortedPermissionGroupDict = (0, $8Eh39.getNormalizedPermissionItems)(undefined, allPermissions);
    const permissionListComps = Object.values(sortedPermissionGroupDict).map((group)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
            space: "space.150",
            key: group.group.name,
            xcss: $b296da749f5cb895$var$checkboxGroupStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
            size: "xsmall"
        }, group.group.name), group.group.checkboxes.map((item)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
                space: "space.100",
                alignBlock: "start",
                key: item.id
            }, activeRolePermissionDict[item.id] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUEBE))), {
                label: formatMessage($b296da749f5cb895$var$i18n.permissionEnabled),
                color: "var(--ds-icon-success, #22A06B)",
                spacing: "none"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                label: formatMessage($b296da749f5cb895$var$i18n.permissionDisabled),
                color: "var(--ds-icon-disabled, #091E424F)",
                spacing: "none"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, item.displayName));
        }));
    });
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'viewRolePermissionsModal',
                attributes: {
                    source: analyticsSource
                }
            }
        }).fire();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ekolh.default), {
        width: 968,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $b296da749f5cb895$var$modalHeaderSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "medium"
    }, formatMessage($b296da749f5cb895$var$i18n.title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $b296da749f5cb895$var$modalHeaderStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c6lYi.FeedbackCollectorButton), {
        source: analyticsSource,
        appearance: "subtle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8TTLA.CloseButton), {
        onClick: onClose
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        xcss: $b296da749f5cb895$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $b296da749f5cb895$var$navContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7rvPL.default), {
        title: formatMessage($b296da749f5cb895$var$i18n.predefinedRoleListTitle)
    }, systemRoleButtonItems), customRoles?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7rvPL.default), {
        title: formatMessage($b296da749f5cb895$var$i18n.customRoleListTitle)
    }, customRoleButtonItems)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $b296da749f5cb895$var$detailViewStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "medium"
    }, activeRole?.name || ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, activeRole?.description || ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cwkWT.default), {
        xcss: $b296da749f5cb895$var$rolePermissionDetailContainerStyle
    }, permissionListComps)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: onClose
    }, formatMessage($b296da749f5cb895$var$i18n.doneButtonText))))));
};

});
parcelRegister("8Eh39", function(module, exports) {

$parcel$export(module.exports, "getNormalizedPermissionItems", () => $00348e3352156ed0$export$dbc5bcb243a11b25);
$parcel$export(module.exports, "buildPermissionDictionary", () => $00348e3352156ed0$export$eda4a295c95572c4);
const $00348e3352156ed0$export$dbc5bcb243a11b25 = (permissions, allSpacePermissions, assignablePermissions)=>{
    // Permission groups are sorted here, then checkboxes of permissions are sorted below
    const sortedSpacePermissions = [
        ...allSpacePermissions
    ].sort((a, b)=>a.groupPriority - b.groupPriority);
    return Object.values(sortedSpacePermissions).reduce((acc, permission)=>{
        const isChecked = Boolean(permissions?.includes(permission.key));
        const checkbox = {
            id: permission.key,
            displayName: permission.actionName,
            priority: permission.priority,
            description: permission.description || '',
            isAssignable: !!assignablePermissions ? assignablePermissions.includes(permission.key) : true,
            isChecked: isChecked,
            isDisabled: false
        };
        const group = {
            groupName: permission.groupName,
            groupPriority: permission.groupPriority
        };
        if (!acc[group.groupName]) acc[group.groupName] = {
            group: {
                name: group.groupName,
                priority: group.groupPriority,
                checkboxes: []
            }
        };
        acc[group.groupName].group.checkboxes.push(checkbox);
        acc[group.groupName].group.checkboxes.sort((a, b)=>a.priority - b.priority);
        return acc;
    }, {});
};
const $00348e3352156ed0$export$eda4a295c95572c4 = (allowedPermissions)=>{
    return allowedPermissions.reduce((acc, permission)=>{
        acc[permission] = true;
        return acc;
    }, {});
};

});


parcelRegister("g26MG", function(module, exports) {

$parcel$export(module.exports, "normalizeSpacePermissionAll", () => $bab3f5eb7fd997b5$export$4b3b0188cc9d39a8);
$parcel$export(module.exports, "normalizeSpaceRoleList", () => $bab3f5eb7fd997b5$export$429eba48f8769b83);
$parcel$export(module.exports, "getPrincipalTypeFromUserPickerType", () => $bab3f5eb7fd997b5$export$bf16ef98b7c6b580);
$parcel$export(module.exports, "normalizeAssignments", () => $bab3f5eb7fd997b5$export$1c34a8ae4dfc585c);
$parcel$export(module.exports, "mergeGroupCountWithAssignments", () => $bab3f5eb7fd997b5$export$f41b22015074a487);
$parcel$export(module.exports, "filterOutUnlicensedUsersAssignment", () => $bab3f5eb7fd997b5$export$b3299b59e278e268);

var $gwFzn = parcelRequire("gwFzn");

var $lebfc = parcelRequire("lebfc");

var $lAFHW = parcelRequire("lAFHW");

var $buthI = parcelRequire("buthI");

var $itlCX = parcelRequire("itlCX");
const $bab3f5eb7fd997b5$var$AccessClassIcon = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lAFHW.ConfluenceIcon), {
        appearance: 'brand'
    });
const $bab3f5eb7fd997b5$var$getPrincipalIcon = (principal)=>{
    switch(principal.__typename){
        case 'SpaceRoleGroupPrincipal':
            return 0, (/*@__PURE__*/$parcel$interopDefault($lebfc));
        case 'SpaceRoleAccessClassPrincipal':
            return principal.principalId === 'anonymous-users' ? (0, (/*@__PURE__*/$parcel$interopDefault($buthI))) : $bab3f5eb7fd997b5$var$AccessClassIcon;
        default:
            return null;
    }
};
const $bab3f5eb7fd997b5$export$4b3b0188cc9d39a8 = (data)=>{
    return data.map((item)=>({
            key: item.id,
            groupName: item.group.displayName,
            groupPriority: item.group.priority,
            actionName: item.displayName,
            priority: item.priority,
            description: item.description,
            requiredPermissions: item.requiredSpacePermissions
        }))// Filter out all actions without display names before the deprecation of some permissions is completed
    .filter((item)=>!!item.actionName);
};
const $bab3f5eb7fd997b5$export$429eba48f8769b83 = (rawData)=>{
    return rawData.map((item)=>({
            id: item.roleId,
            name: item.roleDisplayName,
            description: item.roleDescription,
            permissions: item.spacePermissionList.map((permission)=>permission.id),
            roleType: item.roleType,
            confluenceRoleAssignabilityCode: item.confluenceRoleAssignabilityCode
        }));
};
const $bab3f5eb7fd997b5$export$8bdeeb44c9ac0591 = (type)=>{
    switch(type){
        case 'SpaceRoleGuestPrincipal':
            // Guests are users.
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'SpaceRoleGroupPrincipal':
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
        case 'SpaceRoleUserPrincipal':
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'SpaceRoleAccessClassPrincipal':
            return (0, $itlCX.RoleAssignmentPrincipalType).ACCESS_CLASS;
        default:
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
    }
};
const $bab3f5eb7fd997b5$export$bf16ef98b7c6b580 = (type)=>{
    switch(type){
        case 'user':
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'group':
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
        case 'external_user':
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'custom':
            return (0, $itlCX.RoleAssignmentPrincipalType).ACCESS_CLASS;
        default:
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
    }
};
const $bab3f5eb7fd997b5$export$1c34a8ae4dfc585c = (rawData)=>{
    if (!rawData) return [];
    return rawData.map((item)=>({
            assignmentId: item.principal.principalId,
            principal: {
                id: item.principal.principalId,
                displayName: item.principal.displayName,
                type: $bab3f5eb7fd997b5$export$8bdeeb44c9ac0591(item.principal.__typename),
                email: 'email' in item.principal ? item.principal?.email : undefined,
                avatarUrl: 'profilePicture' in item.principal ? item.principal.profilePicture?.path : undefined,
                icon: $bab3f5eb7fd997b5$var$getPrincipalIcon(item.principal),
                isGuest: item.principal.__typename === 'SpaceRoleGuestPrincipal'
            },
            roleId: item.role?.roleId || null,
            roleLabel: item.role?.roleDisplayName || null,
            roleDescription: item.role?.roleDescription || null,
            // Principal can either be assigned granular space permissions, or permissions through a role
            permissions: item?.permissions?.map((permission)=>permission.id) || item.role?.spacePermissionList.map((permission)=>permission.id) || [],
            availableRoles: [],
            unavailableRoles: [],
            assignablePermissions: item.assignablePermissions?.map((permission)=>permission).filter(Boolean) || []
        }));
};
const $bab3f5eb7fd997b5$export$f41b22015074a487 = (groupCountRecords, assignments)=>{
    const groupCountMap = groupCountRecords.reduce((acc, { key: key, value: value })=>{
        if (key !== null) acc[key] = value;
        return acc;
    }, {});
    return assignments.map((assignment)=>({
            ...assignment,
            principal: assignment.principal.type === (0, $itlCX.RoleAssignmentPrincipalType).GROUP ? {
                ...assignment.principal,
                groupCount: groupCountMap[assignment.principal.id] ?? undefined
            } : assignment.principal
        }));
};
const $bab3f5eb7fd997b5$var$UNLICENSED_USERS_ID = 'authenticated-users';
const $bab3f5eb7fd997b5$export$b3299b59e278e268 = (assignments)=>assignments.filter((record)=>record.principal.id !== $bab3f5eb7fd997b5$var$UNLICENSED_USERS_ID);

});

parcelRegister("9C54a", function(module, exports) {

$parcel$export(module.exports, "useViewPermissionsModal", () => $838f830302a4f6f5$export$aec138b16dafcc0a);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");

var $diswb = parcelRequire("diswb");

var $gwFzn = parcelRequire("gwFzn");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

var $4Kj5T = parcelRequire("4Kj5T");
const $838f830302a4f6f5$var$useViewPermissionsModalPermissionsQuery = (0, $d2LG0.default)`query useViewPermissionsModalPermissionsQuery{spacePermissionsAll{nodes{id displayName description priority group{displayName priority}requiredSpacePermissions}}}`;
const $838f830302a4f6f5$var$useViewPermissionsModalRolesQuery = (0, $d2LG0.default)`query useViewPermissionsModalRolesQuery{spaceRolesByCriteria{nodes{roleId roleDisplayName roleDescription roleType spacePermissionList{id priority displayName description requiredSpacePermissions}}pageInfo{endCursor hasNextPage}}}`;
const $838f830302a4f6f5$export$aec138b16dafcc0a = ({ flags: flags })=>{
    const [experienceStarted, setExperienceStarted] = (0, $gwFzn.useState)(false);
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showErrorFlag: showErrorFlag } = (0, $4Kj5T.useBulkRoleFlags)({
        flags: flags
    });
    const fail = (error)=>{
        const experienceFailure = error || new Error('An error occurred');
        experienceTracker.fail({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE),
            error: experienceFailure
        });
        showErrorFlag();
    };
    const { data: permissionsData, loading: loading } = (0, $diswb.useQuery)($838f830302a4f6f5$var$useViewPermissionsModalPermissionsQuery, {
        onCompleted: ()=>{
            setExperienceStarted(false);
            experienceTracker.succeed({
                name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
            });
        },
        onError: (error)=>{
            setExperienceStarted(false);
            fail(error);
        }
    });
    const { data: rolesData, loading: rolesLoading } = (0, $diswb.useQuery)($838f830302a4f6f5$var$useViewPermissionsModalRolesQuery, {
        onCompleted: ()=>{
            setExperienceStarted(false);
            experienceTracker.succeed({
                name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
            });
        },
        onError: (error)=>{
            setExperienceStarted(false);
            fail(error);
        }
    });
    (0, $gwFzn.useEffect)(()=>{
        if (loading || rolesLoading && !experienceStarted) experienceTracker.start({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
        });
    }, [
        loading,
        rolesLoading,
        experienceStarted,
        experienceTracker
    ]);
    return {
        loading: loading,
        permissions: permissionsData?.spacePermissionsAll?.nodes || [],
        roles: rolesData?.spaceRolesByCriteria?.nodes || []
    };
};

});
parcelRegister("4Kj5T", function(module, exports) {

$parcel$export(module.exports, "useBulkRoleFlags", () => $5b8a2a030512dd5e$export$4b081a83cd5f1b6f);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $9hlns = parcelRequire("9hlns");
const $5b8a2a030512dd5e$var$i18n = (0, $2nPZH.defineMessages)({
    errorIconLabel: {
        id: "bulk-permissions.flag-message.error-icon-label",
        defaultMessage: "Error"
    },
    processingFlagTitle: {
        id: "bulk-permissions.flag-message.processing",
        defaultMessage: "Bulk permissions change processing"
    },
    processingFlagContent: {
        id: "bulk-permissions.flag-message.processing-content",
        defaultMessage: "These changes can take a while. We\u2019ll notify you when it\u2019s finished."
    },
    errorFlagTitle: {
        id: "bulk-permissions.flag-message.error",
        defaultMessage: "Bulk access change failed"
    },
    errorFlagContent: {
        id: "bulk-permissions.flag-message.error-content",
        defaultMessage: "We ran into a problem completing your bulk access change. Try again."
    }
});
const $5b8a2a030512dd5e$export$4b081a83cd5f1b6f = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const showErrorFlag = ()=>flags.showErrorFlag({
            id: `error-${Date.now()}`,
            title: formatMessage($5b8a2a030512dd5e$var$i18n.errorFlagTitle),
            description: formatMessage($5b8a2a030512dd5e$var$i18n.errorFlagContent),
            isAutoDismiss: true
        });
    const showProcessingFlag = ()=>flags.showCustomFlag({
            id: `processing-${Date.now()}`,
            title: formatMessage($5b8a2a030512dd5e$var$i18n.processingFlagTitle),
            description: formatMessage($5b8a2a030512dd5e$var$i18n.processingFlagContent),
            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
                testId: "spinner",
                size: "small",
                label: "spinner"
            })
        });
    return {
        showErrorFlag: showErrorFlag,
        showProcessingFlag: showProcessingFlag
    };
};

});


parcelRegister("cMmEA", function(module, exports) {

$parcel$export(module.exports, "ViewPermissionsInfoButton", () => $710ea738a38b5734$export$1a3c335d7dca645d);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $lGgRw = parcelRequire("lGgRw");

var $4vzBZ = parcelRequire("4vzBZ");

var $ccHMk = parcelRequire("ccHMk");

var $9wGTI = parcelRequire("9wGTI");
const $710ea738a38b5734$export$1a3c335d7dca645d = ({ content: content, isOpen: isOpen, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        content: ()=>content,
        placement: "bottom",
        trigger: (triggerProps)=>// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                ...triggerProps,
                onClick: onClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
                appearance: "subtle",
                "aria-haspopup": true,
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))),
                onClick: onClick,
                "aria-label": formatMessage({
                    id: "bulk-access.role-select.info-popup",
                    defaultMessage: "View info"
                })
            }, null)),
        shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-truepermissions')
    }));
};

});

parcelRegister("7swbU", function(module, exports) {

$parcel$export(module.exports, "InfoPopupContent", () => $5e889a2aa3054314$export$90dae7b611e581b7);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $7hXDW = parcelRequire("7hXDW");

var $ccHMk = parcelRequire("ccHMk");
const $5e889a2aa3054314$var$i18n = (0, $2nPZH.defineMessages)({
    viewRolePermissionsLabel: {
        id: "bulk-permissions.info-popup.view-role-permissions-label",
        defaultMessage: "View role permissions"
    }
});
const $5e889a2aa3054314$var$contentStyle = (0, $ecnYn.xcss)({
    width: '315px',
    padding: 'space.300'
});
const $5e889a2aa3054314$var$headerStyle = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
const $5e889a2aa3054314$var$buttonStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.150',
    display: 'flex',
    alignItems: 'center'
});
const $5e889a2aa3054314$var$usePermissionsSummary = ({ roleId: roleId, roleLookup: roleLookup })=>{
    const role = roleLookup.find((lookup)=>lookup.id === roleId);
    // Role access
    return {
        heading: role?.name,
        description: role?.description
    };
};
const $5e889a2aa3054314$export$90dae7b611e581b7 = ({ onCtaClick: onCtaClick, roleId: roleId, roleLookup: roleLookup })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { heading: heading, description: description } = $5e889a2aa3054314$var$usePermissionsSummary({
        roleId: roleId,
        roleLookup: roleLookup
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $5e889a2aa3054314$var$contentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $5e889a2aa3054314$var$headerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "xsmall"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        xcss: $5e889a2aa3054314$var$buttonStyle
    }, Boolean(roleId) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        onClick: onCtaClick
    }, formatMessage($5e889a2aa3054314$var$i18n.viewRolePermissionsLabel)) : null)));
};

});



parcelRegister("d259h", function(module, exports) {

$parcel$export(module.exports, "BulkAccessModal", () => $1d76093de32754c2$export$9297639d67b5de69);

var $gwFzn = parcelRequire("gwFzn");

var $ekolh = parcelRequire("ekolh");
var $6xdDU = parcelRequire("6xdDU");

var $lM2MU = parcelRequire("lM2MU");

var $etDcs = parcelRequire("etDcs");
const $1d76093de32754c2$export$9297639d67b5de69 = ({ principalName: principalName, roleName: roleName, isLoading: isLoading, isRemoval: isRemoval, spaceSelection: spaceSelection, onCancel: onCancel, onConfirm: onConfirm })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ekolh.default), {
        testId: "bulk-access-confirmation",
        onClose: // Don't allow the dialog to close while mutation is loading
        isLoading ? undefined : onCancel
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lM2MU.LoadingDialog), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $etDcs.ChangeConfirmationDialog), {
        principalName: principalName,
        roleName: roleName,
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        onCancel: onCancel,
        onConfirm: onConfirm
    })));

});
parcelRegister("etDcs", function(module, exports) {

$parcel$export(module.exports, "ChangeConfirmationDialog", () => $d771d120872e42c7$export$6daa4510cb54b507);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $eEA8O = parcelRequire("eEA8O");

var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $67Foi = parcelRequire("67Foi");

var $8A6YM = parcelRequire("8A6YM");
const $d771d120872e42c7$var$i18n = (0, $2nPZH.defineMessages)({
    addConfirmationDialogTitle: {
        id: "bulk-permissions.space.add.confirmation-dialog",
        defaultMessage: "Add {principalName} to all spaces?"
    },
    addAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces (excluding personal)</b> on your site as <b>{roleName}</b>."
    },
    addAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-all.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> on your site as <b>{roleName}</b>."
    },
    addAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all personal spaces</b> on your site as <b>{roleName}</b>."
    },
    confirmationDialogWarning: {
        id: "bulk-permissions.space.confirmation-dialog-warning",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    removeConfirmationDialogTitle: {
        id: "bulk-permissions.space.remove.confirmation-dialog",
        defaultMessage: "Remove {principalName} from all spaces?"
    },
    removeAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> (excluding personal) on your site."
    },
    removeAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-all.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> on your site."
    },
    removeAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all personal spaces</b> on your site."
    },
    cancelButtonText: {
        id: "bulk-permissions.space.cancel-button-text",
        defaultMessage: "Cancel"
    },
    addButtonText: {
        id: "bulk-permissions.space.add-button-text",
        defaultMessage: "Add to all"
    },
    removeButtonText: {
        id: "bulk-permissions.space.remove-button-text",
        defaultMessage: "Remove access"
    }
});
const $d771d120872e42c7$var$ConfirmatonSubSection = (0, $ecnYn.xcss)({
    paddingTop: 'space.300'
});
const $d771d120872e42c7$var$boldString = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks);
const $d771d120872e42c7$export$6daa4510cb54b507 = ({ principalName: principalName, isRemoval: isRemoval, spaceSelection: spaceSelection, roleName: roleName, onConfirm: onConfirm, onCancel: onCancel })=>{
    const getConfirmationDialogDescription = ()=>{
        if (isRemoval) switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $d771d120872e42c7$var$i18n.removeAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $d771d120872e42c7$var$i18n.removeAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $d771d120872e42c7$var$i18n.removeAllPersonalConfirmationDialogDescription;
        }
        else switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $d771d120872e42c7$var$i18n.addAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $d771d120872e42c7$var$i18n.addAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $d771d120872e42c7$var$i18n.addAllPersonalConfirmationDialogDescription;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $67Foi.ScreenEvent), {
        name: "bulk-access-dialog",
        id: "bulk-access-dialog",
        attributes: {
            action: isRemoval ? 'remove' : 'add',
            spaceType: spaceSelection
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d8eRd.default), {
        appearance: isRemoval ? 'warning' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...isRemoval ? $d771d120872e42c7$var$i18n.removeConfirmationDialogTitle : $d771d120872e42c7$var$i18n.addConfirmationDialogTitle,
        values: {
            principalName: principalName
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...getConfirmationDialogDescription(),
        values: {
            b: $d771d120872e42c7$var$boldString,
            roleName: roleName
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $d771d120872e42c7$var$ConfirmatonSubSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$d771d120872e42c7$var$i18n.confirmationDialogWarning,
        values: {
            b: $d771d120872e42c7$var$boldString
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $d771d120872e42c7$var$i18n.cancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        testId: "confirmation-dialog-confirm-button",
        appearance: isRemoval ? 'warning' : 'primary',
        onClick: onConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), isRemoval ? $d771d120872e42c7$var$i18n.removeButtonText : $d771d120872e42c7$var$i18n.addButtonText))));
};

});


parcelRegister("i0aiC", function(module, exports) {

$parcel$export(module.exports, "useBulkRoleSetAssignment", () => $754fc52bc3b4de65$export$667fffd9e35f2dcd);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $4Kj5T = parcelRequire("4Kj5T");
const $754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation = (0, $d2LG0.default)`mutation useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation($principalId:ID!$principalType:RoleAssignmentPrincipalType!$roleId:ID!$spaceTypes:[BulkRoleAssignmentSpaceType]!){bulkSetRoleAssignmentToSpaces(input:{roleAssignment:{principal:{principalId:$principalId principalType:$principalType}roleId:$roleId}spaceTypes:$spaceTypes}){taskId success errors{message}}}`;
const $754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation = (0, $d2LG0.default)`mutation useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation($principalId:ID!$principalType:RoleAssignmentPrincipalType!$spaceTypes:[BulkRoleAssignmentSpaceType]!){bulkRemoveRoleAssignmentFromSpaces(input:{principal:{principalId:$principalId principalType:$principalType}spaceTypes:$spaceTypes}){taskId success errors{message}}}`;
const $754fc52bc3b4de65$export$667fffd9e35f2dcd = ({ closeDialog: closeDialog, flags: flags })=>{
    const { showErrorFlag: showErrorFlag, showProcessingFlag: showProcessingFlag } = (0, $4Kj5T.useBulkRoleFlags)({
        flags: flags
    });
    const onMutationErrored = (0, $gwFzn.useCallback)(()=>{
        closeDialog();
        showErrorFlag();
    }, [
        closeDialog,
        showErrorFlag
    ]);
    const onAsyncMutationSubmitted = (0, $gwFzn.useCallback)((data)=>{
        closeDialog();
        /**
     * The backend is counting the mutation as a success for some exceptions
     * but returning an error in the mutation response.  We need to check for
     * these here.
     */ if (data?.bulkSetRoleAssignmentToSpaces?.errors?.length > 0 || data?.bulkRemoveRoleAssignmentFromSpaces?.errors?.length > 0) onMutationErrored();
        else if (data.bulkSetRoleAssignmentToSpaces?.taskId || data.bulkRemoveRoleAssignmentFromSpaces?.taskId) // show the progress flag
        showProcessingFlag();
    }, [
        closeDialog,
        showProcessingFlag,
        onMutationErrored
    ]);
    const [bulkSetRoleAssignmentToSpaces, { data: bulkAssignmentData }] = (0, $diswb.useMutation)($754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: ()=>{
            closeDialog();
            onMutationErrored();
        }
    });
    const [bulkRemoveRoleAssignment, { data: bulkRemoveAssignmentData }] = (0, $diswb.useMutation)($754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: ()=>{
            closeDialog();
            onMutationErrored();
        }
    });
    return {
        bulkSetRoleAssignmentToSpaces: bulkSetRoleAssignmentToSpaces,
        bulkRemoveRoleAssignment: bulkRemoveRoleAssignment,
        bulkAssignmentData: bulkAssignmentData,
        bulkRemoveAssignmentData: bulkRemoveAssignmentData
    };
};

});



parcelRegister("dCXIs", function(module, exports) {

let $9ebd255b6bfc080f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9ebd255b6bfc080f$var$load("bg14Y"),
    $9ebd255b6bfc080f$var$load("fXI14")
]).then(()=>parcelRequire('6TPcn'));

});

parcelRegister("bDjCi", function(module, exports) {

$parcel$export(module.exports, "LazyHomepageCard", () => $0fe83f4fb6168025$export$9bc5a864d70a9980);
$parcel$export(module.exports, "LazyTeamCalendarSiteSettingsPage", () => $0fe83f4fb6168025$export$85a8d72151ca049b);
$parcel$export(module.exports, "ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE", () => (parcelRequire("e8WZK")).ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE);

var $jmjWc = parcelRequire("jmjWc");

var $e8WZK = parcelRequire("e8WZK");

const $0fe83f4fb6168025$export$9bc5a864d70a9980 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "DHsKy",
    name: "LazyHomepageCard",
    loader: async ()=>(await (parcelRequire("fPFju"))).HomepageCard
});

const $0fe83f4fb6168025$export$85a8d72151ca049b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sxt9o",
    name: "LazyTeamCalendarSiteSettingsPage",
    loader: async ()=>(await (parcelRequire("eiZKG"))).TeamCalendarSiteSettingsPage
});

});
parcelRegister("e8WZK", function(module, exports) {

$parcel$export(module.exports, "ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE", () => $5e4945ce4960200f$export$c0e43f82fc27fe04);
const $5e4945ce4960200f$export$c0e43f82fc27fe04 = 'adminTeamCalendars';

});

parcelRegister("fPFju", function(module, exports) {

let $b86baa6b77a82a8f$var$load = (parcelRequire("lhnSv"))(5);



module.exports = Promise.all([
    $b86baa6b77a82a8f$var$load("8rsL2"),
    $b86baa6b77a82a8f$var$load("iAaum"),
    $b86baa6b77a82a8f$var$load("1ISAt"),
    $b86baa6b77a82a8f$var$load("mKoWX"),
    $b86baa6b77a82a8f$var$load("1m9tW"),
    $b86baa6b77a82a8f$var$load("7J7Dl"),
    $b86baa6b77a82a8f$var$load("9gJO7"),
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("3g2Oe"), 5)),
    $b86baa6b77a82a8f$var$load("5oU5X"),
    $b86baa6b77a82a8f$var$load("aDdwA"),
    $b86baa6b77a82a8f$var$load("jRzT2"),
    $b86baa6b77a82a8f$var$load("ifr0h"),
    $b86baa6b77a82a8f$var$load("gLxW3"),
    $b86baa6b77a82a8f$var$load("2tDVK"),
    $b86baa6b77a82a8f$var$load("kjZZD"),
    $b86baa6b77a82a8f$var$load("ffEVr"),
    $b86baa6b77a82a8f$var$load("3orE4")
]).then(()=>parcelRequire('IdTEh'));

});

parcelRegister("eiZKG", function(module, exports) {

let $a6a2a5cb8d979912$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a6a2a5cb8d979912$var$load("8rsL2"),
    $a6a2a5cb8d979912$var$load("iAaum"),
    $a6a2a5cb8d979912$var$load("5oU5X"),
    $a6a2a5cb8d979912$var$load("9MRDB"),
    $a6a2a5cb8d979912$var$load("jRzT2"),
    $a6a2a5cb8d979912$var$load("9g1FS")
]).then(()=>parcelRequire('4GncZ'));

});


parcelRegister("lFEIy", function(module, exports) {

let $fc6d02fe66bc5877$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $fc6d02fe66bc5877$var$load("9MRDB"),
    $fc6d02fe66bc5877$var$load("iQ0Jm"),
    $fc6d02fe66bc5877$var$load("ffEVr"),
    $fc6d02fe66bc5877$var$load("krOJz")
]).then(()=>parcelRequire('lMhQj'));

});

parcelRegister("i6ccO", function(module, exports) {

$parcel$export(module.exports, "ADMIN_SPACE_REPORT_SCREEN", () => $5030b4f7b6082c77$export$40d649ebb84b67da);
const $5030b4f7b6082c77$export$40d649ebb84b67da = 'spaceReportsSiteSettings';

});

parcelRegister("j3YCh", function(module, exports) {

let $de0d514acf5cf8ef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $de0d514acf5cf8ef$var$load("8rsL2"),
    $de0d514acf5cf8ef$var$load("iAaum"),
    $de0d514acf5cf8ef$var$load("3xuDK"),
    $de0d514acf5cf8ef$var$load("joJy8"),
    $de0d514acf5cf8ef$var$load("aHE9G"),
    $de0d514acf5cf8ef$var$load("lCdlK")
]).then(()=>parcelRequire('d2onE'));

});

parcelRegister("3Zt4d", function(module, exports) {

let $2e7d9dad702b85de$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2e7d9dad702b85de$var$load("8rsL2"),
    $2e7d9dad702b85de$var$load("iAaum"),
    $2e7d9dad702b85de$var$load("1m9tW"),
    $2e7d9dad702b85de$var$load("7J7Dl"),
    $2e7d9dad702b85de$var$load("9gJO7"),
    $2e7d9dad702b85de$var$load("8Ttlq"),
    $2e7d9dad702b85de$var$load("b52u5"),
    $2e7d9dad702b85de$var$load("9gXki"),
    $2e7d9dad702b85de$var$load("ffEVr"),
    $2e7d9dad702b85de$var$load("jRzT2"),
    $2e7d9dad702b85de$var$load("fKpYd"),
    $2e7d9dad702b85de$var$load("aO7Ry"),
    $2e7d9dad702b85de$var$load("joJy8"),
    $2e7d9dad702b85de$var$load("aHE9G"),
    $2e7d9dad702b85de$var$load("2YlyO")
]).then(()=>parcelRequire('753aK'));

});

parcelRegister("3ka5g", function(module, exports) {

let $26bb0fcbe20ff86e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $26bb0fcbe20ff86e$var$load("cxsa4"),
    $26bb0fcbe20ff86e$var$load("5k4m3"),
    $26bb0fcbe20ff86e$var$load("ll4CQ"),
    $26bb0fcbe20ff86e$var$load("1kY5y"),
    $26bb0fcbe20ff86e$var$load("8rsL2"),
    $26bb0fcbe20ff86e$var$load("iAaum"),
    $26bb0fcbe20ff86e$var$load("aZinD"),
    $26bb0fcbe20ff86e$var$load("YlVRj"),
    $26bb0fcbe20ff86e$var$load("e1z0Z"),
    $26bb0fcbe20ff86e$var$load("aO7Ry"),
    $26bb0fcbe20ff86e$var$load("1ISAt"),
    $26bb0fcbe20ff86e$var$load("mKoWX"),
    $26bb0fcbe20ff86e$var$load("7sZmN"),
    $26bb0fcbe20ff86e$var$load("l4Ek9"),
    $26bb0fcbe20ff86e$var$load("6vzdH"),
    $26bb0fcbe20ff86e$var$load("kPQBd"),
    $26bb0fcbe20ff86e$var$load("joJy8"),
    $26bb0fcbe20ff86e$var$load("aHE9G"),
    $26bb0fcbe20ff86e$var$load("bU3dV"),
    $26bb0fcbe20ff86e$var$load("6XHqm"),
    $26bb0fcbe20ff86e$var$load("96X3r")
]).then(()=>parcelRequire('9FcLT'));

});

parcelRegister("334xJ", function(module, exports) {

let $23852d0b2a3ffbb6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $23852d0b2a3ffbb6$var$load("8rsL2"),
    $23852d0b2a3ffbb6$var$load("iAaum"),
    $23852d0b2a3ffbb6$var$load("1ISAt"),
    $23852d0b2a3ffbb6$var$load("mKoWX"),
    $23852d0b2a3ffbb6$var$load("1m9tW"),
    $23852d0b2a3ffbb6$var$load("7J7Dl"),
    $23852d0b2a3ffbb6$var$load("5k4m3"),
    $23852d0b2a3ffbb6$var$load("bg14Y"),
    $23852d0b2a3ffbb6$var$load("5cXIN"),
    $23852d0b2a3ffbb6$var$load("cxsa4"),
    $23852d0b2a3ffbb6$var$load("aO7Ry"),
    $23852d0b2a3ffbb6$var$load("7sZmN"),
    $23852d0b2a3ffbb6$var$load("6XHqm"),
    $23852d0b2a3ffbb6$var$load("6gpUD")
]).then(()=>parcelRequire('dTw2J'));

});

parcelRegister("d73E7", function(module, exports) {

$parcel$export(module.exports, "WhiteboardRouteComponentLoader", () => $61e340fdd81a37ab$export$eb67fd6afe5bdfc8);

var $jmjWc = parcelRequire("jmjWc");

const $61e340fdd81a37ab$export$eb67fd6afe5bdfc8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "X7rQv",
    name: "WhiteboardRouteComponentLoader",
    loader: ()=>(parcelRequire("3DA2Z"))
});

});
parcelRegister("3DA2Z", function(module, exports) {

let $2a60f9d2ae23b336$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2a60f9d2ae23b336$var$load("7HNNc"),
    $2a60f9d2ae23b336$var$load("eFpF6"),
    $2a60f9d2ae23b336$var$load("1ISAt"),
    $2a60f9d2ae23b336$var$load("mKoWX"),
    $2a60f9d2ae23b336$var$load("1m9tW"),
    $2a60f9d2ae23b336$var$load("7J7Dl"),
    $2a60f9d2ae23b336$var$load("jRzT2"),
    $2a60f9d2ae23b336$var$load("931GG"),
    $2a60f9d2ae23b336$var$load("kG4eT"),
    $2a60f9d2ae23b336$var$load("2XL47"),
    $2a60f9d2ae23b336$var$load("jmjAW"),
    $2a60f9d2ae23b336$var$load("1Zo7q"),
    $2a60f9d2ae23b336$var$load("32ARE"),
    $2a60f9d2ae23b336$var$load("cFYwo"),
    $2a60f9d2ae23b336$var$load("4tTUt"),
    $2a60f9d2ae23b336$var$load("3QAHI"),
    $2a60f9d2ae23b336$var$load("4e15z"),
    $2a60f9d2ae23b336$var$load("1jZDC"),
    $2a60f9d2ae23b336$var$load("1wN7j"),
    $2a60f9d2ae23b336$var$load("dTVzs"),
    $2a60f9d2ae23b336$var$load("3S9pV"),
    $2a60f9d2ae23b336$var$load("i3TSs"),
    $2a60f9d2ae23b336$var$load("kCTMZ"),
    $2a60f9d2ae23b336$var$load("jPS1u"),
    $2a60f9d2ae23b336$var$load("8rsL2"),
    $2a60f9d2ae23b336$var$load("iAaum"),
    $2a60f9d2ae23b336$var$load("58UdM"),
    $2a60f9d2ae23b336$var$load("aLgYQ"),
    $2a60f9d2ae23b336$var$load("4Qstt"),
    $2a60f9d2ae23b336$var$load("kVNpE"),
    $2a60f9d2ae23b336$var$load("5odbj"),
    $2a60f9d2ae23b336$var$load("i5Fj1"),
    $2a60f9d2ae23b336$var$load("ckJgn"),
    $2a60f9d2ae23b336$var$load("2u53D"),
    $2a60f9d2ae23b336$var$load("dLkMK"),
    $2a60f9d2ae23b336$var$load("eRWKD"),
    $2a60f9d2ae23b336$var$load("7a4au"),
    $2a60f9d2ae23b336$var$load("iB9CC"),
    $2a60f9d2ae23b336$var$load("6OVfM"),
    $2a60f9d2ae23b336$var$load("fiwvK"),
    $2a60f9d2ae23b336$var$load("1ZAFx"),
    $2a60f9d2ae23b336$var$load("ifr0h"),
    $2a60f9d2ae23b336$var$load("cdEjw"),
    $2a60f9d2ae23b336$var$load("2F69B"),
    $2a60f9d2ae23b336$var$load("gkMTK"),
    $2a60f9d2ae23b336$var$load("bGaMz"),
    $2a60f9d2ae23b336$var$load("8yyrA"),
    $2a60f9d2ae23b336$var$load("lHceO"),
    $2a60f9d2ae23b336$var$load("8Sd4b"),
    $2a60f9d2ae23b336$var$load("joJy8"),
    $2a60f9d2ae23b336$var$load("aHE9G"),
    $2a60f9d2ae23b336$var$load("7jSfd"),
    $2a60f9d2ae23b336$var$load("6ACCg"),
    $2a60f9d2ae23b336$var$load("4HZlX"),
    $2a60f9d2ae23b336$var$load("fe4be"),
    $2a60f9d2ae23b336$var$load("kDqHr"),
    $2a60f9d2ae23b336$var$load("kjZZD"),
    $2a60f9d2ae23b336$var$load("j87NQ"),
    $2a60f9d2ae23b336$var$load("bZxqd"),
    $2a60f9d2ae23b336$var$load("9gJO7"),
    $2a60f9d2ae23b336$var$load("5rp59"),
    $2a60f9d2ae23b336$var$load("ffEVr"),
    $2a60f9d2ae23b336$var$load("6Z8WE"),
    $2a60f9d2ae23b336$var$load("jZkQK")
]).then(()=>parcelRequire('ib0d9'));

});


parcelRegister("6b7s3", function(module, exports) {

let $47f98cd88f2c57de$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $47f98cd88f2c57de$var$load("8rsL2"),
    $47f98cd88f2c57de$var$load("iAaum"),
    $47f98cd88f2c57de$var$load("cdEjw"),
    $47f98cd88f2c57de$var$load("8yRnn"),
    $47f98cd88f2c57de$var$load("gLWJk")
]).then(()=>parcelRequire('5Idyr'));

});

parcelRegister("lX2jh", function(module, exports) {

let $ffb0e66388411c30$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ffb0e66388411c30$var$load("8rsL2"),
    $ffb0e66388411c30$var$load("iAaum"),
    $ffb0e66388411c30$var$load("8yRnn"),
    $ffb0e66388411c30$var$load("cdEjw"),
    $ffb0e66388411c30$var$load("iOr1f")
]).then(()=>parcelRequire('58rkb'));

});

parcelRegister("k9rXZ", function(module, exports) {

let $eaba577bbded3ec0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $eaba577bbded3ec0$var$load("1ISAt"),
    $eaba577bbded3ec0$var$load("mKoWX"),
    $eaba577bbded3ec0$var$load("jRzT2"),
    $eaba577bbded3ec0$var$load("6OVfM"),
    $eaba577bbded3ec0$var$load("j87NQ"),
    $eaba577bbded3ec0$var$load("32ARE"),
    $eaba577bbded3ec0$var$load("cFYwo"),
    $eaba577bbded3ec0$var$load("84ZqO"),
    $eaba577bbded3ec0$var$load("2HlAY"),
    $eaba577bbded3ec0$var$load("jCu7l"),
    $eaba577bbded3ec0$var$load("1ZAFx"),
    $eaba577bbded3ec0$var$load("cdEjw"),
    $eaba577bbded3ec0$var$load("2F69B"),
    $eaba577bbded3ec0$var$load("8rsL2"),
    $eaba577bbded3ec0$var$load("iAaum"),
    $eaba577bbded3ec0$var$load("6vzdH"),
    $eaba577bbded3ec0$var$load("cgwQl"),
    $eaba577bbded3ec0$var$load("5YJ6r"),
    $eaba577bbded3ec0$var$load("hIYCb"),
    $eaba577bbded3ec0$var$load("fNL1b"),
    $eaba577bbded3ec0$var$load("avCUM"),
    $eaba577bbded3ec0$var$load("cixpG"),
    $eaba577bbded3ec0$var$load("7lGj4"),
    $eaba577bbded3ec0$var$load("aZinD"),
    $eaba577bbded3ec0$var$load("c6MKV"),
    $eaba577bbded3ec0$var$load("c0JsV"),
    $eaba577bbded3ec0$var$load("joJy8"),
    $eaba577bbded3ec0$var$load("aHE9G"),
    $eaba577bbded3ec0$var$load("kjZZD"),
    $eaba577bbded3ec0$var$load("ffEVr"),
    $eaba577bbded3ec0$var$load("bZxqd"),
    $eaba577bbded3ec0$var$load("9gJO7"),
    $eaba577bbded3ec0$var$load("6Z8WE"),
    $eaba577bbded3ec0$var$load("kZzff")
]).then(()=>parcelRequire('2rALa'));

});

parcelRegister("fZ1oS", function(module, exports) {

let $ba2da39801c9c2d0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ba2da39801c9c2d0$var$load("7HNNc"),
    $ba2da39801c9c2d0$var$load("eFpF6"),
    $ba2da39801c9c2d0$var$load("1ISAt"),
    $ba2da39801c9c2d0$var$load("mKoWX"),
    $ba2da39801c9c2d0$var$load("1m9tW"),
    $ba2da39801c9c2d0$var$load("7J7Dl"),
    $ba2da39801c9c2d0$var$load("jRzT2"),
    $ba2da39801c9c2d0$var$load("j87NQ"),
    $ba2da39801c9c2d0$var$load("931GG"),
    $ba2da39801c9c2d0$var$load("2XL47"),
    $ba2da39801c9c2d0$var$load("1Zo7q"),
    $ba2da39801c9c2d0$var$load("32ARE"),
    $ba2da39801c9c2d0$var$load("cFYwo"),
    $ba2da39801c9c2d0$var$load("4tTUt"),
    $ba2da39801c9c2d0$var$load("i3TSs"),
    $ba2da39801c9c2d0$var$load("jPS1u"),
    $ba2da39801c9c2d0$var$load("8rsL2"),
    $ba2da39801c9c2d0$var$load("iAaum"),
    $ba2da39801c9c2d0$var$load("58UdM"),
    $ba2da39801c9c2d0$var$load("aLgYQ"),
    $ba2da39801c9c2d0$var$load("4Qstt"),
    $ba2da39801c9c2d0$var$load("kVNpE"),
    $ba2da39801c9c2d0$var$load("5odbj"),
    $ba2da39801c9c2d0$var$load("i5Fj1"),
    $ba2da39801c9c2d0$var$load("ifr0h"),
    $ba2da39801c9c2d0$var$load("cdEjw"),
    $ba2da39801c9c2d0$var$load("2F69B"),
    $ba2da39801c9c2d0$var$load("8yyrA"),
    $ba2da39801c9c2d0$var$load("joJy8"),
    $ba2da39801c9c2d0$var$load("aHE9G"),
    $ba2da39801c9c2d0$var$load("kjZZD"),
    $ba2da39801c9c2d0$var$load("ffEVr"),
    $ba2da39801c9c2d0$var$load("bZxqd"),
    $ba2da39801c9c2d0$var$load("bT0I9")
]).then(()=>parcelRequire('1hCZf'));

});

parcelRegister("bwC5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $864039964f3f4398$export$2e2bcd8739ae039);

var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");

var $4b4iP = parcelRequire("4b4iP");
const $864039964f3f4398$var$SpaceRestriction = ({ spaceKey: spaceKey, children: children })=>{
    if (!spaceKey) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey
    }, children);
};
$864039964f3f4398$var$SpaceRestriction.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).node.isRequired
};
var $864039964f3f4398$export$2e2bcd8739ae039 = $864039964f3f4398$var$SpaceRestriction;

});

parcelRegister("eDPHu", function(module, exports) {

let $aa8ccfdb2e21401e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $aa8ccfdb2e21401e$var$load("hmUGS").then(()=>parcelRequire('1azj7'));

});

parcelRegister("iufgB", function(module, exports) {

$parcel$export(module.exports, "CreateContentRouteComponentLoader", () => $ef29e49aacc3ecbc$export$80e55c7cff6cb8a);

var $jmjWc = parcelRequire("jmjWc");

const $ef29e49aacc3ecbc$export$80e55c7cff6cb8a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "IPyzb",
    name: "CreateContentRouteComponentLoader",
    loader: async ()=>(await (parcelRequire("5rx2o"))).CreateContentRouteComponentWrapper
});

});
parcelRegister("5rx2o", function(module, exports) {

let $3f6919f20bd6f6fe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3f6919f20bd6f6fe$var$load("8rsL2"),
    $3f6919f20bd6f6fe$var$load("iAaum"),
    $3f6919f20bd6f6fe$var$load("1ISAt"),
    $3f6919f20bd6f6fe$var$load("mKoWX"),
    $3f6919f20bd6f6fe$var$load("cFYwo"),
    $3f6919f20bd6f6fe$var$load("4NgYy"),
    $3f6919f20bd6f6fe$var$load("16ht2"),
    $3f6919f20bd6f6fe$var$load("lk8h1"),
    $3f6919f20bd6f6fe$var$load("bZxqd"),
    $3f6919f20bd6f6fe$var$load("9gJO7"),
    $3f6919f20bd6f6fe$var$load("lrKPf")
]).then(()=>parcelRequire('79aVL'));

});


parcelRegister("ePWfS", function(module, exports) {

let $acd3045dea50b5a1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $acd3045dea50b5a1$var$load("8rsL2"),
    $acd3045dea50b5a1$var$load("iAaum"),
    $acd3045dea50b5a1$var$load("9gJO7"),
    $acd3045dea50b5a1$var$load("iCuQy")
]).then(()=>parcelRequire('4Shbp'));

});

parcelRegister("9RZdh", function(module, exports) {

let $72f88bf6f31facc1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $72f88bf6f31facc1$var$load("ckx79").then(()=>parcelRequire('eGJ8h'));

});

parcelRegister("5yf3x", function(module, exports) {

let $40abce921cbeb38e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $40abce921cbeb38e$var$load("kbzD1").then(()=>parcelRequire('aFOyu'));

});

parcelRegister("vFVYi", function(module, exports) {

let $05f36c96db6e60f8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $05f36c96db6e60f8$var$load("8rsL2"),
    $05f36c96db6e60f8$var$load("iAaum"),
    $05f36c96db6e60f8$var$load("fc0Qy"),
    $05f36c96db6e60f8$var$load("6Y8Qe"),
    $05f36c96db6e60f8$var$load("oNs1E"),
    $05f36c96db6e60f8$var$load("6ltm2"),
    $05f36c96db6e60f8$var$load("tzKH7"),
    $05f36c96db6e60f8$var$load("7a4au"),
    $05f36c96db6e60f8$var$load("iB9CC"),
    $05f36c96db6e60f8$var$load("6OVfM"),
    $05f36c96db6e60f8$var$load("1ZAFx"),
    $05f36c96db6e60f8$var$load("iPz8n"),
    $05f36c96db6e60f8$var$load("8Sd4b"),
    $05f36c96db6e60f8$var$load("joJy8"),
    $05f36c96db6e60f8$var$load("aHE9G"),
    $05f36c96db6e60f8$var$load("7jSfd"),
    $05f36c96db6e60f8$var$load("6ACCg"),
    $05f36c96db6e60f8$var$load("4HZlX"),
    $05f36c96db6e60f8$var$load("fe4be"),
    $05f36c96db6e60f8$var$load("kDqHr"),
    $05f36c96db6e60f8$var$load("kjZZD"),
    $05f36c96db6e60f8$var$load("j87NQ"),
    $05f36c96db6e60f8$var$load("bZxqd"),
    $05f36c96db6e60f8$var$load("9gJO7"),
    $05f36c96db6e60f8$var$load("5rp59"),
    $05f36c96db6e60f8$var$load("ffEVr"),
    $05f36c96db6e60f8$var$load("6Z8WE"),
    $05f36c96db6e60f8$var$load("6NuFa")
]).then(()=>parcelRequire('ftgYc'));

});

parcelRegister("6iTV5", function(module, exports) {

let $496fccfeb9e3dc94$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $496fccfeb9e3dc94$var$load("7sZmN"),
    $496fccfeb9e3dc94$var$load("iyhyY"),
    $496fccfeb9e3dc94$var$load("9ZY0L"),
    $496fccfeb9e3dc94$var$load("joJy8"),
    $496fccfeb9e3dc94$var$load("aHE9G"),
    $496fccfeb9e3dc94$var$load("7niKq")
]).then(()=>parcelRequire('2O6Yo'));

});

parcelRegister("1oZpX", function(module, exports) {

let $1057ac97217283a5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1057ac97217283a5$var$load("7HNNc"),
    $1057ac97217283a5$var$load("8rsL2"),
    $1057ac97217283a5$var$load("iAaum"),
    $1057ac97217283a5$var$load("lADvr"),
    $1057ac97217283a5$var$load("tzKH7"),
    $1057ac97217283a5$var$load("iB9CC"),
    $1057ac97217283a5$var$load("oNs1E"),
    $1057ac97217283a5$var$load("gGjKt"),
    $1057ac97217283a5$var$load("g6X6x"),
    $1057ac97217283a5$var$load("2UsgQ"),
    $1057ac97217283a5$var$load("2YTyP"),
    $1057ac97217283a5$var$load("jVHJJ"),
    $1057ac97217283a5$var$load("deXSb"),
    $1057ac97217283a5$var$load("fc0Qy"),
    $1057ac97217283a5$var$load("7a4au"),
    $1057ac97217283a5$var$load("6OVfM"),
    $1057ac97217283a5$var$load("1ZAFx"),
    $1057ac97217283a5$var$load("6Y8Qe"),
    $1057ac97217283a5$var$load("19KJH"),
    $1057ac97217283a5$var$load("iPz8n"),
    $1057ac97217283a5$var$load("8Sd4b"),
    $1057ac97217283a5$var$load("joJy8"),
    $1057ac97217283a5$var$load("aHE9G"),
    $1057ac97217283a5$var$load("7jSfd"),
    $1057ac97217283a5$var$load("6ACCg"),
    $1057ac97217283a5$var$load("4HZlX"),
    $1057ac97217283a5$var$load("fe4be"),
    $1057ac97217283a5$var$load("kDqHr"),
    $1057ac97217283a5$var$load("kjZZD"),
    $1057ac97217283a5$var$load("4PppF"),
    $1057ac97217283a5$var$load("j87NQ"),
    $1057ac97217283a5$var$load("bZxqd"),
    $1057ac97217283a5$var$load("9gJO7"),
    $1057ac97217283a5$var$load("5rp59"),
    $1057ac97217283a5$var$load("ffEVr"),
    $1057ac97217283a5$var$load("6Z8WE"),
    $1057ac97217283a5$var$load("buFAk")
]).then(()=>parcelRequire('dNbOB'));

});

parcelRegister("14MBR", function(module, exports) {

let $0c8bdf0ab626fb8e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0c8bdf0ab626fb8e$var$load("du6ec"),
    $0c8bdf0ab626fb8e$var$load("k1w8t"),
    $0c8bdf0ab626fb8e$var$load("35VQy"),
    $0c8bdf0ab626fb8e$var$load("exvU8")
]).then(()=>parcelRequire('9ZXTU'));

});

parcelRegister("e77A8", function(module, exports) {

let $a46799bebb0bcc70$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a46799bebb0bcc70$var$load("8rsL2"),
    $a46799bebb0bcc70$var$load("iAaum"),
    $a46799bebb0bcc70$var$load("ftJgg"),
    $a46799bebb0bcc70$var$load("3KV1Y"),
    $a46799bebb0bcc70$var$load("ffEVr"),
    $a46799bebb0bcc70$var$load("2MuhG")
]).then(()=>parcelRequire('gelCt'));

});

parcelRegister("3Flev", function(module, exports) {

let $2ab5abdc62e71471$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2ab5abdc62e71471$var$load("kkqQ6"),
    $2ab5abdc62e71471$var$load("luyQ6"),
    $2ab5abdc62e71471$var$load("aDFb6")
]).then(()=>parcelRequire('2zBDm'));

});

parcelRegister("1B9Op", function(module, exports) {

let $12a0db9f039ae181$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $12a0db9f039ae181$var$load("hGSL3").then(()=>parcelRequire('jOGWx'));

});

parcelRegister("gq6QA", function(module, exports) {

let $bf4462bd33a93f5c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bf4462bd33a93f5c$var$load("d3Mqz").then(()=>parcelRequire('ezyVI'));

});

parcelRegister("8vGbU", function(module, exports) {

let $6321f23deb8b99b5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6321f23deb8b99b5$var$load("1ISAt"),
    $6321f23deb8b99b5$var$load("mKoWX"),
    $6321f23deb8b99b5$var$load("9EI97")
]).then(()=>parcelRequire('ivpO0'));

});

parcelRegister("3A8WH", function(module, exports) {

let $29bbac5632d7888c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $29bbac5632d7888c$var$load("8rsL2"),
    $29bbac5632d7888c$var$load("iAaum"),
    $29bbac5632d7888c$var$load("jczTu")
]).then(()=>parcelRequire('bnpc5'));

});


var $gwFzn = parcelRequire("gwFzn");

var $4FhhO = parcelRequire("4FhhO");

var $dkxAr = parcelRequire("dkxAr");

var $9i0Rp = parcelRequire("9i0Rp");

var $ja596 = parcelRequire("ja596");

var $7eXBl = parcelRequire("7eXBl");

var $hnvzE = parcelRequire("hnvzE");

var $5QpZa = parcelRequire("5QpZa");

var $2DIgf = parcelRequire("2DIgf");

var $5nRL1 = parcelRequire("5nRL1");

var $1iSzD = parcelRequire("1iSzD");

var $9wGTI = parcelRequire("9wGTI");

var $3ay3Q = parcelRequire("3ay3Q");

var $hPcrh = parcelRequire("hPcrh");

var $9wGTI = parcelRequire("9wGTI");

var $04e9M = parcelRequire("04e9M");

var $9eE57 = parcelRequire("9eE57");

var $4VJDS = parcelRequire("4VJDS");
var $49cc78e79e334ef6$export$a4def92db6fc8e17 = /*#__PURE__*/ function(PerformanceObserverEntryTypes) {
    PerformanceObserverEntryTypes["LayoutShift"] = "layout-shift";
    PerformanceObserverEntryTypes["LongTask"] = "longtask";
    PerformanceObserverEntryTypes["Event"] = "event";
    return PerformanceObserverEntryTypes;
}({});


class $4313abb7a0000648$export$2c6e86519c9e8188 {
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
    // Default maxLength is an arbitrary number but it is long enough to capture tasks within the full experience
    // 1000 x 50ms = 50s which should be long enough for every healthy experience
    constructor(maxLength = 1000){
        this.buffer = [];
        this.maxLength = void 0;
        this.full = false;
        this.maxLength = maxLength;
    }
}
const $4313abb7a0000648$export$f7dc16cbd16f7bbe = {
    [(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LongTask]: new $4313abb7a0000648$export$2c6e86519c9e8188(),
    [(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LayoutShift]: new $4313abb7a0000648$export$2c6e86519c9e8188(),
    [(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).Event]: new $4313abb7a0000648$export$2c6e86519c9e8188()
};
// This function is exposed to the window object to be used in the integration tests
// to fail the test if there is a layout shift in the page
const $4313abb7a0000648$var$hadLayoutShift = (predicate)=>{
    const buffer = $4313abb7a0000648$export$f7dc16cbd16f7bbe[(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LayoutShift].buffer;
    return predicate(buffer);
};
window.__hadLayoutShift = $4313abb7a0000648$var$hadLayoutShift;



function $dc2c9e680a6dd356$var$findFiberNode(domNode) {
    if (!domNode) return undefined;
    const key = Object.keys(domNode).find((k)=>k.startsWith('__reactFiber$'));
    return key ? domNode[key] : undefined;
}
function $dc2c9e680a6dd356$var$attributionByClosestFiberNode(fiberNode) {
    let current = fiberNode;
    while(current){
        if (current.memoizedProps?.__boundaryMarker) return current.memoizedProps?.attribution ?? 'unknown';
        current = current.return;
    }
    return 'not-attributed';
}
function $dc2c9e680a6dd356$var$toQuerySelector(node) {
    const path = [];
    if (node instanceof HTMLElement) {
        if (node.tagName) path.push(node.tagName.toLowerCase());
        if (node.id) path.push(`#${node.id}`);
        if (node.className) path.push(`.${node.className.split(' ').join('.')}`);
        if (node.dataset) Object.entries(node.dataset).forEach(([key, value])=>{
            path.push(`[data-${key}=${value}]`);
        });
    }
    return path.join('');
}
const $dc2c9e680a6dd356$export$36b44777ebe5656d = (experienceName, clsAttributionConfig)=>{
    const layoutShiftMap = new Map();
    const shifts = (0, $4313abb7a0000648$export$f7dc16cbd16f7bbe)[(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LayoutShift].buffer;
    const includeEntries = clsAttributionConfig.includeEntries?.[experienceName] ?? false;
    shifts.forEach((shift)=>{
        shift.sources.forEach((source)=>{
            let hasInsideShift = false;
            let hasOutsideShift = false;
            if (source.previousRect.x !== source.currentRect.x || source.previousRect.y !== source.currentRect.y) hasOutsideShift = true;
            if (source.previousRect.width !== source.currentRect.width || source.previousRect.height !== source.currentRect.height) hasInsideShift = true;
            const getDebugEntry = ()=>({
                    shift: shift.value,
                    hasInsideShift: hasInsideShift,
                    hasOutsideShift: hasOutsideShift,
                    element: source.node ? $dc2c9e680a6dd356$var$toQuerySelector(source.node) : 'undefined'
                });
            const fiberNode = $dc2c9e680a6dd356$var$findFiberNode(source.node);
            const attribution = fiberNode ? $dc2c9e680a6dd356$var$attributionByClosestFiberNode(fiberNode) : 'nonReact';
            if (layoutShiftMap.has(attribution)) {
                const stats = layoutShiftMap.get(attribution);
                stats.totalShift += shift.value;
                if (includeEntries) stats.entries.push(getDebugEntry());
            } else layoutShiftMap.set(attribution, {
                totalShift: shift.value,
                entries: includeEntries ? [
                    getDebugEntry()
                ] : []
            });
        });
    });
    return Object.fromEntries(layoutShiftMap);
};



var $6VdZc = parcelRequire("6VdZc");

var $8Lf0D = parcelRequire("8Lf0D");
var $jy3Cx = parcelRequire("jy3Cx");

var $5leFG = parcelRequire("5leFG");
const $2ba6133bff070823$export$8c5248f0cec8446d = new (0, $5leFG.EventBus)();


var $80c67148001d6fe8$var$_JSCacheRate;
class $80c67148001d6fe8$export$aca60c726e4e7838 {
    /**
   * Clear Cache
   *
   * Clears all existing cache entries
   */ static clearCache() {
        this.IDs.reset();
        this.Cache.clear();
    }
    /**
   * Compute Cache Rate
   *
   * Iterates the cache looking for the LRU cache compute
   * and creates a new compute based upon the results of
   * it (if it exists). If not, it'll compute cache rate
   * using a bottom-up iteration of loaded assets
   */ static computeCacheRate(time) {
        let lastKey = '';
        const entries = this.Cache.keys;
        const maxIndex = entries.length - 1;
        for(let i = maxIndex; i > -1; i--){
            const key = entries[i];
            const { time: stopTime } = this.Cache.get(key);
            if (time > stopTime) {
                lastKey = key;
                break;
            }
        }
        let newEntry;
        if (lastKey) newEntry = this.mergeFromLastKey(lastKey, time);
        else newEntry = this.iterateResources(time);
        const ID = $80c67148001d6fe8$export$aca60c726e4e7838.IDs.ID();
        $80c67148001d6fe8$export$aca60c726e4e7838.Cache.set(ID, {
            time: time,
            ...newEntry
        });
        return $80c67148001d6fe8$export$aca60c726e4e7838.Cache.get(ID);
    }
    /**
   * Merge From Last Key
   *
   * Combines the LRU cache rate with a cache rate being computed
   */ static mergeFromLastKey(key, time) {
        const { lastIndex: lastIndex, criticalPath: criticalPath } = $80c67148001d6fe8$export$aca60c726e4e7838.Cache.get(key);
        const { lastIndex: newIndex, criticalPath: newCriticalPath } = this.iterateResources(time, lastIndex + 1);
        return {
            lastIndex: newIndex,
            criticalPath: this.merge(criticalPath, newCriticalPath)
        };
    }
    /**
   * Iterate Resources
   *
   * Iterates performance resource timings given a time and from (index)
   * filter. While iterating, this method will accumulate the scripts
   * that have loaded prior to the input time and capture the last index
   * of the final script loaded within that scope
   */ static iterateResources(time, from = 0) {
        const criticalPath = this.criticalPath;
        const resources = window.performance.getEntriesByType('resource');
        const { length: length } = resources;
        let lastIndex = from;
        for(let i = lastIndex; i < length; i++){
            const entry = resources[i];
            if (entry.initiatorType !== 'script' || entry.responseEnd > time) continue;
            lastIndex = i;
            if (entry.transferSize) criticalPath.nonCachedSize += entry.encodedBodySize;
            else {
                criticalPath.cachedCount += 1;
                criticalPath.cachedSize += entry.encodedBodySize;
            }
            criticalPath.totalSize += entry.encodedBodySize;
            criticalPath.scripts.push({
                name: entry.name.split('/').pop() || '',
                start: entry.startTime,
                end: entry.responseEnd,
                size: entry.encodedBodySize
            });
        }
        return {
            criticalPath: criticalPath,
            lastIndex: lastIndex
        };
    }
    /**
   * Critical Path
   *
   * Returns an initialized `CriticalPath` object
   */ static get criticalPath() {
        return {
            scripts: [],
            totalSize: 0,
            cachedCount: 0,
            cachedSize: 0,
            nonCachedSize: 0
        };
    }
    /**
   * Merge
   *
   * Merges the properties of two critical path objects
   */ static merge(cachedCP, newCP) {
        return {
            scripts: cachedCP.scripts.concat(newCP.scripts),
            totalSize: cachedCP.totalSize + newCP.totalSize,
            cachedCount: cachedCP.cachedCount + newCP.cachedCount,
            cachedSize: cachedCP.cachedSize + newCP.cachedSize,
            nonCachedSize: cachedCP.nonCachedSize + newCP.nonCachedSize
        };
    }
}
$80c67148001d6fe8$var$_JSCacheRate = $80c67148001d6fe8$export$aca60c726e4e7838;
$80c67148001d6fe8$export$aca60c726e4e7838.IDs = new (0, $8Lf0D.AutoIncrementingID)();
$80c67148001d6fe8$export$aca60c726e4e7838.Cache = new (0, $jy3Cx.Cache)();
$80c67148001d6fe8$export$aca60c726e4e7838.Listener = (0, $2ba6133bff070823$export$8c5248f0cec8446d).on('page-transition', $80c67148001d6fe8$var$_JSCacheRate.clearCache.bind($80c67148001d6fe8$var$_JSCacheRate));


const $798e13e8b010d13b$export$2ae1dd61fa7d6fb4 = (stop)=>{
    const { criticalPath: { scripts: scripts, totalSize: totalSize, cachedCount: cachedCount, cachedSize: cachedSize, nonCachedSize: nonCachedSize } } = (0, $80c67148001d6fe8$export$aca60c726e4e7838).computeCacheRate(stop);
    return {
        cachedRate: cachedCount / scripts.length * 100,
        count: scripts.length,
        size: totalSize,
        cachedSize: cachedSize,
        nonCachedSize: nonCachedSize,
        sizeBasedCachedRate: cachedSize / (cachedSize + nonCachedSize)
    };
};


const $1f8015dad40e09ac$export$4a5a528f9e4c1e63 = ()=>window.jQuery?.fn?.jquery;


const $8476ac2738811490$export$30c543c9fd9ad97 = ({ stop: stop })=>{
    const customAttributes = {
        initial: (0, $6VdZc.isInitial)(),
        criticalAssets: (0, $798e13e8b010d13b$export$2ae1dd61fa7d6fb4)(stop),
        jqVer: (0, $1f8015dad40e09ac$export$4a5a528f9e4c1e63)()
    };
    return customAttributes;
};


var $e9zUf = parcelRequire("e9zUf");
const $4c29a57cb1cefaed$var$isAssets = (x)=>{
    if (typeof x !== 'object' || !x) return false;
    for (const value of Object.values(x)){
        if (typeof value !== 'string') return false;
    }
    return true;
};
const $4c29a57cb1cefaed$var$scriptInitiator = {
    script: true,
    other: true,
    link: true
};
const $4c29a57cb1cefaed$var$CACHED_ASSETS_KEY = 'confluence.cachedAssets';
const $4c29a57cb1cefaed$var$criticalChunkPrefixes = {
    'query-preloader': true,
    'translations.en-US': true,
    runtime: true,
    atlaskit: true,
    afp: true,
    static: true,
    vendors: true,
    app: true
};
const $4c29a57cb1cefaed$var$getCachedAssets = ()=>{
    try {
        const assets = JSON.parse((0, $e9zUf.confluenceLocalStorageInstance).getItem($4c29a57cb1cefaed$var$CACHED_ASSETS_KEY)) || {};
        if (!$4c29a57cb1cefaed$var$isAssets(assets)) return {};
        return assets;
    } catch (ex) {
        return {};
    }
};
const $4c29a57cb1cefaed$var$updateCachedAssets = (assets)=>{
    try {
        (0, $e9zUf.confluenceLocalStorageInstance).setItem($4c29a57cb1cefaed$var$CACHED_ASSETS_KEY, JSON.stringify(assets));
    } catch (ex) {
    // NOOP
    }
};
const $4c29a57cb1cefaed$export$445ccb86da5ca9ca = (endTime)=>{
    const cachedChunks = $4c29a57cb1cefaed$var$getCachedAssets();
    const loadedChunks = {};
    const criticalChunks = {};
    let totalChunkCount = 0;
    performance.getEntriesByType('resource').forEach((entry)=>{
        const { initiatorType: initiatorType, responseEnd: responseEnd, duration: duration, name: name } = entry;
        // Discard non-scripts and scripts that were loaded after the end time
        if (!$4c29a57cb1cefaed$var$scriptInitiator[initiatorType] || responseEnd > endTime) return;
        const chunkName = name.split('/').pop();
        if (!chunkName) return;
        const chunkPrefix = chunkName.split('~').shift();
        if (!chunkPrefix) return;
        // Match loaded chunk name with cached chunk name for all critical chunks
        if ($4c29a57cb1cefaed$var$criticalChunkPrefixes[chunkPrefix]) {
            loadedChunks[chunkPrefix] = chunkName;
            criticalChunks[chunkPrefix] = {
                cached: cachedChunks[chunkPrefix] === chunkName,
                duration: duration
            };
        }
        totalChunkCount++;
    });
    $4c29a57cb1cefaed$var$updateCachedAssets(loadedChunks);
    return {
        criticalChunks: criticalChunks,
        totalChunkCount: totalChunkCount
    };
};



var $gpK3n = parcelRequire("gpK3n");

var $6VdZc = parcelRequire("6VdZc");const $ac2afaf945b706af$export$2980a1865b8e55dd = (hydrationErrors)=>{
    return hydrationErrors.reduce((accumulator, error)=>{
        if (!error.type || !error.msg) return accumulator;
        if (!accumulator[error.type]) accumulator[error.type] = '';
        accumulator[error.type] += (accumulator[error.type] ? ' ; ' : '') + error.msg;
        return accumulator;
    }, {});
};

const $feab3ea7dc0c8aa0$export$b471d97e795847e1 = (resourceTimings)=>{
    for (const entry of resourceTimings){
        if (entry.initiatorType !== 'script') continue;
        // As of Feb 2021, `nextHopProtocol` is only supported by 73% of browsers
        // https://caniuse.com/mdn-api_performanceresourcetiming_nexthopprotocol
        if (entry?.nextHopProtocol) return entry.nextHopProtocol;
    }
    return 'unknown';
};

const $8e41f03039b3a7c1$export$338c8cd28585b375 = (ssrSmartLinks)=>{
    let total = 0;
    let jira = 0;
    let confluence = 0;
    if (ssrSmartLinks) for(const key in ssrSmartLinks){
        const link = ssrSmartLinks[key];
        if (link.status === 'resolved') {
            total++;
            const product = link.details?.meta?.product;
            if (product === 'jira') jira++;
            else if (product === 'confluence') confluence++;
        }
    }
    return {
        total: total,
        jira: jira,
        confluence: confluence
    };
};

const $8b39c089fbdae2d5$export$96934690d8345a62 = (obj)=>{
    if (typeof obj !== 'object' || !obj) return {};
    const recursivelyBuildCustomValues = (obj)=>{
        const customValues = {};
        Object.entries(obj).forEach(([key, value])=>{
            if (Array.isArray(value)) customValues[key] = value.map((e)=>JSON.stringify(e)).join(',');
            else if (typeof value === 'object' && value) {
                const nestedValues = recursivelyBuildCustomValues(value);
                Object.entries(nestedValues).forEach(([nestedKey, nestedValue])=>{
                    customValues[`${key}:${nestedKey}`] = nestedValue;
                });
            } else {
                if (typeof value === 'number') customValues[key] = Math.round(value);
                else if (typeof value === 'boolean') customValues[key] = value;
                else customValues[key] = String(value);
            }
        });
        return customValues;
    };
    return recursivelyBuildCustomValues(obj);
};



function $31b0fb0fb1951a4c$export$d433f54c1fc2edb7(obj, filter, map) {
    if (!obj) return {};
    return Object.keys(obj).filter((key)=>filter(obj[key])).reduce((res, key)=>{
        res[key] = map(obj[key]);
        return res;
    }, {});
}
const $31b0fb0fb1951a4c$export$7908ff149a3cbadd = ({ stop: stop })=>{
    const customAttributes = {
        transitionId: (0, $6VdZc.browserMetricsState).transitionId,
        // HTTP protocol used to fetch resources
        // Use multiple domains for http/1.1 users
        // Set in packages/confluence-frontend-server/templates/generator.js
        domainSharding: Boolean(window.__GET_CC_ASSET_URL),
        // HTTP protocol used to fetch resources
        httpProtocol: (0, $feab3ea7dc0c8aa0$export$b471d97e795847e1)(performance.getEntriesByType('resource')),
        // Add the critical path JS assets size stats
        criticalAssets: (0, $798e13e8b010d13b$export$2ae1dd61fa7d6fb4)(stop)
    };
    Object.entries((0, $gpK3n.collectDurationFromPerfMarkers)('CFP-63.')).forEach(([fieldName, value])=>{
        customAttributes[`cfp63Durations:${fieldName}`] = value;
    });
    if ((0, $6VdZc.browserMetricsState).transitionId === 0) {
        const navigationTimings = window.performance.getEntriesByType('navigation');
        if (navigationTimings.length) {
            // TypeScript isn't returning the proper type for this, so some
            // casting here
            const firstTiming = navigationTimings[0];
            if (firstTiming.transferSize != null) customAttributes.pageLoadedFromCache = firstTiming.transferSize === 0;
        }
        // Record the current version of jQuery
        customAttributes.jqVer = window.jQuery?.fn?.jquery;
        // Record if page is rendered by React SSR service
        customAttributes.ssr = Boolean(window.__SSR_RENDERED__);
        customAttributes.ssrTraceId = window.__SSR_TRACE_ID__ ?? '';
        // only send ssr macro metrics if there is at least one macro on the SSRd page
        if (window?.__SSR_MACROS_INFO__) customAttributes.ssrMacrosInfo = window.__SSR_MACROS_INFO__;
        // Record user clicks and intent to click on SSR placeholder elements
        customAttributes.ssrInteractions = window?.__SSR_INTERACTIONS__ || {};
        // @ts-ignore `__SSR_INTERACTIONS_DURATIONS__` maintains an array of numbers, but browser-metrics doesn't really accept arrays. Might make sense to comma-join the values
        customAttributes.ssrInteractionsDurations = window?.__SSR_INTERACTIONS_DURATIONS__ || {};
        customAttributes.ssrQueryTimeouts = window?.__SSR_QUERY_TIMEOUTS__ || {};
        customAttributes.ssrPartialSuccess = window?.__SSR_PARTIAL_SUCCESS__ || {};
        if (window?.__SSR_STREAM_END__) customAttributes.ssrStreamEnd = window.__SSR_STREAM_END__;
        // Record loadable ids that timed out
        customAttributes.loadableTimeouts = Array.from(new Set(window?.__LOADABLE_TIMEOUTS__ || [])).join(',');
        // Records the number of SmartLinks on the page (even ones that are not successfully rendered)
        customAttributes.ssrNumberOfSmartLinks = window?.__SSR_NUMBER_OF_SMARTLINKS__ || 0;
        customAttributes.ssrNumberOfConfluenceSmartLinks = window?.__SSR_NUMBER_OF_CONFLUENCE_SMARTLINKS__ || 0;
        customAttributes.ssrNumberOfJiraSmartLinks = window?.__SSR_NUMBER_OF_JIRA_SMARTLINKS__ || 0;
        // Records the number of successfully ssrd smartlinks
        if (window?.__SSR_SMARTLINKS__) {
            const resolvedSmartLinks = (0, $8e41f03039b3a7c1$export$338c8cd28585b375)(window.__SSR_SMARTLINKS__);
            customAttributes.ssrResolvedSmartLinksCount = resolvedSmartLinks.total;
            customAttributes.ssrResolvedConfluenceSmartLinksCount = resolvedSmartLinks.confluence;
            customAttributes.ssrResolvedJiraSmartLinksCount = resolvedSmartLinks.jira;
        }
        if (window?.__HYDRATION_ERRORS__) customAttributes.hydrationErrors = (0, $ac2afaf945b706af$export$2980a1865b8e55dd)(window.__HYDRATION_ERRORS__);
        customAttributes.hydrationFailed = window?.__HYDRATION_FAILED__ || false;
        customAttributes.hydrationDisabled = window?.__SSR_DISABLE_HYDRATION__ || false;
        // Record the number of SSRed elements
        customAttributes.totalSSRedElements = window?.__TOTAL_SSR_ELEMENTS__ || 0;
        // Calculates which query is the long pole, as well as its duration
        customAttributes.longPoleQuery = window?.__SSR_LONG_POLE_QUERY__ || {};
        // Send stats on expensive queries and unnecessary watches
        customAttributes.apolloBroadcastStats = $31b0fb0fb1951a4c$export$d433f54c1fc2edb7(window?.__APOLLO_STATS__?.broadcast, (value)=>value.duration >= 10, (value)=>({
                count: value.count,
                duration: Math.round(value.duration)
            }));
        // Node counts from AK renderer, available in fabric only
        customAttributes.rendererNodesCount = window?.__RENDERER_NODES_COUNT__ || {};
        // Add the caching status of each asset
        const cacheStatus = (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
            cacheStatus: (0, $4c29a57cb1cefaed$export$445ccb86da5ca9ca)(stop)
        });
        for (const [key, value] of Object.entries(cacheStatus))customAttributes[key] = value;
    }
    return customAttributes;
};

const $47229cc534a9628f$export$79c58f8fef22ebf2 = ()=>{
    const customAttributes = {
        ssrRegion: window.__SSR_REGION__ ?? ''
    };
    return customAttributes;
};



var $eSuZj = parcelRequire("eSuZj");
const $18160efac3c2d8a9$export$8f5840779a8ebb97 = (interaction, otherMetadataFromSessionData)=>{
    const buildInfoData = (0, $eSuZj.getBuildInfo)();
    const buildInfo = {};
    if (buildInfoData) Object.keys(buildInfoData).forEach((item)=>{
        const newKey = `buildInfo:${item}`;
        buildInfo[newKey] = buildInfoData[item];
    });
    const data = {
        ...(0, $31b0fb0fb1951a4c$export$7908ff149a3cbadd)({
            stop: interaction.end,
            start: interaction.start,
            key: interaction.ufoName
        }),
        ...(0, $8476ac2738811490$export$30c543c9fd9ad97)({
            stop: interaction.end,
            start: interaction.start,
            key: interaction.ufoName
        }),
        ...(0, $47229cc534a9628f$export$79c58f8fef22ebf2)(),
        ...buildInfo,
        ...otherMetadataFromSessionData
    };
    return {
        confluence: data
    };
};


const $65f6d9e9d3e9996f$export$3def7672244bab0c = ()=>{
    const ssrTTRMark = performance?.getEntriesByName('CFP-63.ssr-ttr');
    if (!ssrTTRMark || !ssrTTRMark[0]) return undefined;
    // rounded to the nearest integer as the VC component log only uses integers as keys
    return Math.round(ssrTTRMark[0].startTime);
};
const $65f6d9e9d3e9996f$export$bf7408e83532dcd0 = ()=>{
    if (!window.__SSR_MEASURES__) return [];
    const ssrTimings = Object.keys(window.__SSR_MEASURES__).map((key)=>{
        return {
            label: key,
            data: window.__SSR_MEASURES__[key]
        };
    });
    return ssrTimings || [];
};



var $lMdlY = parcelRequire("lMdlY");
function $9d8d828ea9fa0be5$export$29dd34cf1269f6da(traceId) {
    return !!traceId && /^[a-z0-9]+$/i.test(traceId) && traceId.length >= 16;
}
function $9d8d828ea9fa0be5$export$47cd5ebc723ead8d() {
    const traceId = window.__SSR_TRACE_ID__;
    const traceSampled = window.__SSR_TRACE_SAMPLED__;
    // Only enable trace propagation if the trace is sampled.
    // Keep per-request unique traceIds for prod traffic until we have the x-request-id solution.
    // See: https://hello.atlassian.net/wiki/spaces/~71202065d425fcbfb345c9a5639940cc3845bb/pages/4187050054/Trace+Propagation+Across+an+Experience
    if (!traceSampled) return;
    const validTraceId = $9d8d828ea9fa0be5$export$29dd34cf1269f6da(traceId) ? traceId : undefined;
    const validSpanId = validTraceId ? validTraceId.substring(validTraceId.length - 16) : undefined;
    // If the traceId is invalid, we ignore it and don't set the trace context.
    // This would fallback to default behavior where trace context is not propagated.
    if (validTraceId && validSpanId) (0, $lMdlY.setActiveTrace)(validTraceId, validSpanId, '' /* trace type param is unused */ );
}


// If you use any FF during UFO initialization,
// please pass the feature flag to __SSR_INIT_UFO_DATA__ in the confluence/next/packages/ssr-app/src/index.tsx
// and update initUFOWithSsrData as well
const $57685508af60afdd$var$getConfig = (configName)=>{
    try {
        return JSON.parse((0, $4VJDS.default).getString(configName, ''));
    } catch (error) {
        return {};
    }
};
const $57685508af60afdd$var$getUfoConfig = ()=>$57685508af60afdd$var$getConfig('confluence_ufo_config');
const $57685508af60afdd$var$getClsAttributionConfig = ()=>$57685508af60afdd$var$getConfig('confluence_cls_attribution_config');
function $57685508af60afdd$var$runConfigureSsrTiming() {
    (0, $hPcrh.configure)({
        getDoneMark: ()=>(0, $9eE57.getMark)('CFP-63.ssr-ttr') ?? null,
        // from confluence/next/packages/browser-metrics/src/initializeBrowserMetrics.ts
        // TODO: add correct functions to `getTimings` and `getFeatureFlags`
        getTimings: ()=>null,
        getFeatureFlags: ()=>null
    });
}
function $57685508af60afdd$var$initializeUFO(initData) {
    if (!initData) return;
    const { shard: shard, cloudId: cloudId, config: config, flags: { devToolsEnabled: devToolsEnabled, stopVCAtInteractionFinish: stopVCAtInteractionFinish, enableTracePropagation: enableTracePropagation, postInteractionLogEnabled: postInteractionLogEnabled, enableSegmentHighlighting: enableSegmentHighlighting, enableAdditionalPerformanceMarks: enableAdditionalPerformanceMarks, enableExperimentalHolds: enableExperimentalHolds, shouldCalculateLighthouseMetricsFromTTAI: shouldCalculateLighthouseMetricsFromTTAI, manuallyTrackReactProfilerMounts: manuallyTrackReactProfilerMounts } } = initData;
    $57685508af60afdd$var$runConfigureSsrTiming();
    if (enableTracePropagation) (0, $9d8d828ea9fa0be5$export$47cd5ebc723ead8d)();
    const perfPushFY25ExperienceRates = {
        'view-page': 1,
        'edit-page': 1,
        'space-overview': 1,
        'confluence-home': 1,
        'advanced-search': 1,
        'ufo-live-edit': 1
    };
    (0, $3ay3Q.init)((0, $04e9M.getAnalyticsWebClient)(), {
        postInteractionLog: {
            enabled: postInteractionLogEnabled,
            rates: perfPushFY25ExperienceRates
        },
        experimentalInteractionMetrics: {
            enabled: enableExperimentalHolds,
            rates: perfPushFY25ExperienceRates
        },
        enableSegmentHighlighting: enableSegmentHighlighting,
        enableAdditionalPerformanceMarks: enableAdditionalPerformanceMarks,
        shouldCalculateLighthouseMetricsFromTTAI: shouldCalculateLighthouseMetricsFromTTAI,
        manuallyTrackReactProfilerMounts: manuallyTrackReactProfilerMounts,
        product: 'confluence',
        region: shard || 'unknown',
        vc: {
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            selectorConfig: {
                id: false,
                role: false,
                className: true,
                testId: true
            },
            devToolsEnabled: devToolsEnabled,
            stopVCAtInteractionFinish: stopVCAtInteractionFinish,
            enabledVCRevisions: {
                all: [
                    'fy25.02',
                    'fy25.03'
                ]
            }
        },
        ...config,
        ssr: {
            getSSRDoneTime: $65f6d9e9d3e9996f$export$3def7672244bab0c,
            getSSRTimings: $65f6d9e9d3e9996f$export$bf7408e83532dcd0
        },
        additionalPayloadData: (interaction)=>(0, $18160efac3c2d8a9$export$8f5840779a8ebb97)(interaction, {
                cloudId: cloudId,
                isShardPreProd: shard ? shard.startsWith('conf-prod-us-preprod') : false,
                layoutShiftWithAttribution: (0, $9wGTI.fg)('confluence_enable_ls_attribution') ? (0, $dc2c9e680a6dd356$export$36b44777ebe5656d)(interaction.ufoName, $57685508af60afdd$var$getClsAttributionConfig()) : {}
            })
    });
}
function $57685508af60afdd$export$7c8267660020a63e(initData) {
    if (!initData?.config?.enabled) return false;
    $57685508af60afdd$var$initializeUFO(initData);
    return true;
}
function $57685508af60afdd$export$af995ee1d7017fea(sessionData) {
    const config = $57685508af60afdd$var$getUfoConfig();
    if (!config?.enabled) return;
    $57685508af60afdd$var$initializeUFO({
        shard: sessionData.shard,
        cloudId: sessionData.cloudId,
        config: config,
        flags: {
            manuallyTrackReactProfilerMounts: true,
            devToolsEnabled: (0, $4VJDS.default).isKillSwitchOn('confluence_enable_ttvc_devtool'),
            stopVCAtInteractionFinish: (0, $9wGTI.fg)('stop_vc_at_interaction_finish'),
            enableTracePropagation: (0, $9wGTI.fg)('confluence_fe_enable_trace_propagation'),
            postInteractionLogEnabled: true,
            enableSegmentHighlighting: false,
            enableAdditionalPerformanceMarks: false,
            enableExperimentalHolds: (0, $9wGTI.fg)('ufo-enable-experimental-holds-confluence'),
            shouldCalculateLighthouseMetricsFromTTAI: true
        }
    });
}



var $gwFzn = parcelRequire("gwFzn");

var $3kTfj = parcelRequire("3kTfj");

var $1iSzD = parcelRequire("1iSzD");

var $04e9M = parcelRequire("04e9M");

var $eSuZj = parcelRequire("eSuZj");

var $9eE57 = parcelRequire("9eE57");

var $9wGTI = parcelRequire("9wGTI");

var $6vg9V = parcelRequire("6vg9V");

var $45prt = parcelRequire("45prt");

var $7W8i8 = parcelRequire("7W8i8");

var $hpjl4 = parcelRequire("hpjl4");
const $b48399af2cf0b1aa$export$1a2bb347935fc536 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $hpjl4.JS_LOAD_START))) return {
            name: mark.substring(0, mark.indexOf((0, $hpjl4.JS_LOAD_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $hpjl4.JS_LOAD_END))) return {
            name: mark.substring(0, mark.indexOf((0, $hpjl4.JS_LOAD_END))),
            type: 'end'
        };
        return null;
    }
};



var $j4jXg = parcelRequire("j4jXg");

var $eSuZj = parcelRequire("eSuZj");

var $2oDRW = parcelRequire("2oDRW");

var $78QFu = parcelRequire("78QFu");
const $105e628ab69b7692$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const clsData = {
        score: 0,
        nodeCounts: {}
    };
    const allLayoutShifts = buffer.getAll();
    const layoutShifts = allLayoutShifts.filter(// Filter for layoutShifts within start and stop time and if entry had no recent user input (which can cause CLS)
    (entry)=>entry.startTime >= start && entry.startTime <= stop && !entry.hadRecentInput);
    const sessionWindows = [];
    let currentWindow = null;
    // Record CLS offenderes by node type
    layoutShifts.forEach((layoutShift)=>{
        layoutShift.sources.forEach((source)=>{
            const { node: node } = source;
            const nodeKey = `${node?.localName || '-'}(:)${node?.className || '-'}`;
            const count = clsData.nodeCounts[nodeKey];
            if (count > 0) clsData.nodeCounts[nodeKey] += 1;
            else clsData.nodeCounts[nodeKey] = 1;
        });
    });
    // Group layout shifts into session windows and calculate score
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric rounded to 4 decimal places
    clsData.score = Math.round(maxScore * 10000) / 10000;
    return clsData;
};


const $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $f69af1ee3d00be57$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter(// filter entries that are long tasks (greater than MAX_ACCEPTABLE_TASK_DURATION)
    // and overlap with the start and stop window in any way
    (entry)=>entry.startTime <= stop && entry.duration > $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // accumulate observed tbt even when the entry's duration is outside the stop window
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION;
        // accumulate total tbt within start and stop window
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });


const $35573fd923792093$export$f878c419d6dfad3e = 10;
const $35573fd923792093$var$getEstimatedP98LongestInteraction = (interactionEvents)=>{
    const sortedInteractions = [
        ...interactionEvents
    ].sort((a, b)=>b.duration - a.duration);
    sortedInteractions.splice($35573fd923792093$export$f878c419d6dfad3e);
    // If we have an usually high number of interactions,
    // ignore the longest interaction and take the next one.
    // https://web.dev/articles/inp#what-is-inp -> "Details on how INP is calculated"
    const p98Index = Math.min(sortedInteractions.length - 1, Math.floor(interactionEvents.length / 50));
    return {
        p98: sortedInteractions[p98Index],
        interactionCount: sortedInteractions.length
    };
};
const $35573fd923792093$export$6693a9916ea977ef = (start, stop, buffer)=>{
    const inpData = {
        score: 0,
        interactionCounts: {}
    };
    const allEvents = buffer.getAll();
    const interactionEvents = allEvents.filter((entry)=>entry.startTime >= start && entry.startTime <= stop && entry.entryType !== 'first-input' && //@ts-ignore for some reason our Typecheck says this property doesn't exist but its in the reference https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEventTiming
        entry.interactionId);
    if (interactionEvents.length) {
        const { p98: p98, interactionCount: interactionCount } = $35573fd923792093$var$getEstimatedP98LongestInteraction(interactionEvents);
        inpData.score = p98.duration;
        inpData.interactionCounts = interactionCount;
    }
    return inpData;
};







const $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $6947188617eea69c$export$b7f047fd73089148 = (start, stop, buffer)=>buffer.getAll().filter(// filter entries that are long tasks (greater than MAX_ACCEPTABLE_TASK_DURATION)
    (entry)=>entry.duration > $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((longTaskTiming, entry)=>{
        longTaskTiming += entry.duration - $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION;
        return longTaskTiming;
    }, 0);





let $7ca3f558dc62e54e$var$pe = null;
const $7ca3f558dc62e54e$var$getObserver = ()=>{
    if ($7ca3f558dc62e54e$var$pe !== null) return $7ca3f558dc62e54e$var$pe;
    $7ca3f558dc62e54e$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LayoutShift) (0, $4313abb7a0000648$export$f7dc16cbd16f7bbe)[(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LayoutShift].push(entry);
            if (entry.entryType === (0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LongTask) (0, $4313abb7a0000648$export$f7dc16cbd16f7bbe)[(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LongTask].push(entry);
            if (entry.entryType === (0, $49cc78e79e334ef6$export$a4def92db6fc8e17).Event) (0, $4313abb7a0000648$export$f7dc16cbd16f7bbe)[(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).Event].push(entry);
        });
    });
    return $7ca3f558dc62e54e$var$pe;
};
const $7ca3f558dc62e54e$export$231c167ad8c908df = ()=>{
    if ($7ca3f558dc62e54e$var$pe) {
        // Disconnect the observer if it's already set up
        $7ca3f558dc62e54e$var$pe.disconnect();
        $7ca3f558dc62e54e$var$pe = null;
    }
    for (const type of Object.values((0, $49cc78e79e334ef6$export$a4def92db6fc8e17)))$7ca3f558dc62e54e$var$getObserver().observe({
        type: type,
        buffered: true
    });
};


const $21a76cadeda71c1e$export$1391212d75b2ee65 = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $21a76cadeda71c1e$export$b46cecdf698e4bb5 = async ({ start: start, stop: stop })=>{
    // PerformanceObserver is not deterministic in reporting entries, so a 500ms delay is needed
    // 500ms was tested in Jira and it captured enough data without causing a volume drop in reported events
    await $21a76cadeda71c1e$export$1391212d75b2ee65(500);
    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(start, stop, (0, $4313abb7a0000648$export$f7dc16cbd16f7bbe)[(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $105e628ab69b7692$export$fc6227831ee7c7)(start, stop, (0, $4313abb7a0000648$export$f7dc16cbd16f7bbe)[(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LayoutShift]);
    const longTaskTiming = (0, $6947188617eea69c$export$b7f047fd73089148)(start, stop, (0, $4313abb7a0000648$export$f7dc16cbd16f7bbe)[(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LongTask]);
    const metrics = {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls.score,
        'metric:clsNodeCounts': cls.nodeCounts,
        'metric:longTaskTiming': Math.round(longTaskTiming)
    };
    return metrics;
};


const $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS = 8000;
const $834cc9c1e99eabd0$export$d4724968c3d7ea5 = async ({ start: start, stop: stop })=>{
    const webVitalsAttributes = {
        uuid: (0, $78QFu.getUniquePageLoadId)().uuid ?? ''
    };
    // wait for 8 seconds to calculate CLS to account for macros causing page layout shifts
    await (0, $21a76cadeda71c1e$export$1391212d75b2ee65)($834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS);
    const cls = (0, $105e628ab69b7692$export$fc6227831ee7c7)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $4313abb7a0000648$export$f7dc16cbd16f7bbe)[(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LayoutShift]);
    // for slow pages, TTI is marked too early which causes TBT numbers to be inaccurate so we extend the stop time
    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $4313abb7a0000648$export$f7dc16cbd16f7bbe)[(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LongTask]);
    const inp = (0, $35573fd923792093$export$6693a9916ea977ef)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $4313abb7a0000648$export$f7dc16cbd16f7bbe)[(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).Event]);
    webVitalsAttributes['metric:inpForInitialLoad'] = inp.score;
    webVitalsAttributes['metric:clsForInitialLoad'] = cls.score;
    webVitalsAttributes['metric:clsOffendersForInitialLoad'] = cls.nodeCounts;
    webVitalsAttributes['metric:tbtForInitialLoad'] = Math.round(tbt.total); // sum of blocking time for long tasks within the 'start' and 'stop' time
    return webVitalsAttributes;
};





const $eaeb1ca3a97f458a$export$e3f9d1444e2c5f5d = (sessionData)=>{
    const { cloudId: cloudId, environment: environment, shard: shard } = sessionData;
    const plugins = [];
    plugins.push((0, $21a76cadeda71c1e$export$b46cecdf698e4bb5));
    /**
	 * https://product-fabric.atlassian.net/browse/CCP-1320
	 * Remove unused attributes in page-segment-load event
	 */ const buildInfo = (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
        buildInfo: (0, $eSuZj.getBuildInfo)()
    });
    /**
	 * Data to be added to all events.
	 */ const allEventConfig = {
        custom: (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
            cloudId: cloudId,
            environment: environment,
            shard: shard,
            ssr: Boolean(window.__SSR_RENDERED__)
        }),
        featureFlags: (0, $2oDRW.ALLOWLIST_FFS_CUSTOM_EVENTS),
        sfxEvents: {
            activeTab: (0, $j4jXg.PageVisibleFields).pageVisibleState
        },
        plugins: plugins
    };
    /**
	 * Data to be added to only page-load events.
	 */ const pageLoadEventConfig = {
        custom: buildInfo,
        plugins: [
            (0, $31b0fb0fb1951a4c$export$7908ff149a3cbadd),
            (0, $47229cc534a9628f$export$79c58f8fef22ebf2)
        ],
        histogram: {
            initial: {
                fmp: '1000_2000_2500_3000_4000_5000',
                tti: '2000_2500_3000_3500_4000_5000_6000'
            },
            transition: {
                fmp: '500_1000_1500_2000_2500_3000',
                tti: '1000_1500_2000_2500_3000_4000'
            }
        },
        // page-load type event will include allEventConfig.featureFlags + the following list.
        featureFlags: (0, $2oDRW.FF_ALLOWLIST_FOR_PERF_METRICS)
    };
    /**
	 * Data to be added to only custom events.
	 */ const pageSegmentLoadEventConfig = {
        plugins: [
            (0, $8476ac2738811490$export$30c543c9fd9ad97),
            (0, $47229cc534a9628f$export$79c58f8fef22ebf2)
        ],
        histogram: {
            initial: {
                fmp: '1000_2000_2500_3000_4000_5000',
                tti: '2000_2500_3000_3500_4000_5000_6000'
            },
            transition: {
                fmp: '500_1000_1500_2000_2500_3000',
                tti: '1000_1500_2000_2500_3000_4000'
            }
        },
        // page-segment-load type event will include allEventConfig.featureFlags + the following list.
        featureFlags: (0, $2oDRW.FF_ALLOWLIST_FOR_PERF_METRICS),
        enableBundleEvalTimings: false
    };
    const customEventConfig = {
        custom: buildInfo,
        plugins: [
            (0, $8476ac2738811490$export$30c543c9fd9ad97)
        ]
    };
    const webVitalsConfig = {
        custom: buildInfo,
        enabled: true,
        plugins: [
            (0, $834cc9c1e99eabd0$export$d4724968c3d7ea5)
        ],
        // Undefined timeout defaults to 30000ms, increasing timeout here on Cypress tests to prevent flakiness.
        timeout: window?.Cypress ? undefined : 10000,
        ttciEnabled: false,
        featureFlags: (0, $2oDRW.FF_ALLOWLIST_FOR_PERF_METRICS)
    };
    return {
        all: allEventConfig,
        [(0, $j4jXg.BMEventsType).PAGE_LOAD]: pageLoadEventConfig,
        [(0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD]: pageSegmentLoadEventConfig,
        [(0, $j4jXg.BMEventsType).CUSTOM]: customEventConfig,
        [(0, $j4jXg.BMEventsType).WEB_VITALS]: webVitalsConfig
    };
};



let $ae045ed661bc53ec$var$isBrowserMetricsInitialized = false;
const $ae045ed661bc53ec$var$logger = (0, $7W8i8.getLogger)('initializeBrowserMetrics');
const $ae045ed661bc53ec$var$criticalAssetsList = [
    'app',
    'atl',
    'runtime',
    'vendors',
    'ssr-scripts',
    'stable_vendors',
    'query-preloader',
    'browser-not-supported'
];
function $ae045ed661bc53ec$var$mapResources(url) {
    return $ae045ed661bc53ec$var$criticalAssetsList.find((asset)=>url.includes(`/${asset}.`)) || 'ignored';
}

const $ae045ed661bc53ec$export$efcab8bd082cbc1f = (sessionData)=>{
    if (!$ae045ed661bc53ec$var$isBrowserMetricsInitialized) {
        const { featureFlags: featureFlags, shard: shard } = sessionData;
        const getAnalyticsWebClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const product = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? 'embeddedConfluence' : 'confluence';
        (parcelRequire("9tNjS")).then((ufo)=>ufo.setup(sessionData, getAnalyticsWebClientPromise)).catch((error)=>{
            $ae045ed661bc53ec$var$logger.error`Fail to import UFO client: ${error}`;
        });
        (0, $7ca3f558dc62e54e$export$231c167ad8c908df)();
        (0, $3kTfj.browserMetrics).init({
            info: {
                app: {
                    framework: {
                        name: 'react',
                        version: (0, $gwFzn.version)
                    },
                    version: {
                        web: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
                        ssr: window.__SSR_BUILD__
                    }
                },
                hostname: window.location.hostname,
                product: product,
                region: shard
            },
            plugins: {
                featureFlags: {
                    client: Promise.resolve({
                        getValue: (featureFlagKey)=>{
                            const ldValue = featureFlags[featureFlagKey] ?? (0, $45prt.getSSRFeatureFlag)(featureFlagKey);
                            // eslint-disable-next-line confluence-feature-gating/static-feature-gates
                            return ldValue ?? (0, $9wGTI.fg)(featureFlagKey);
                        }
                    })
                },
                resourceTimings: {
                    mapResources: $ae045ed661bc53ec$var$mapResources,
                    // Not interested in fetch requests as we have already marked wf/
                    sanitiseEndpoints: ()=>'ignored'
                },
                bundleEvalTimings: $b48399af2cf0b1aa$export$1a2bb347935fc536
            },
            endpoints: {
                eventPipelineClient: getAnalyticsWebClientPromise,
                metalClient: (0, $6vg9V.getMetalClient)()
            },
            events: (0, $eaeb1ca3a97f458a$export$e3f9d1444e2c5f5d)(sessionData),
            ssr: {
                getDoneMark: ()=>(0, $9eE57.getMark)('CFP-63.ssr-ttr') ?? null,
                getTimings: ()=>window.__SSR_MEASURES__ || {}
            },
            enableReactUFOTracker: true
        });
        $ae045ed661bc53ec$var$isBrowserMetricsInitialized = true;
    }
};



var $KcDWk = parcelRequire("KcDWk");

var $iC5L0 = parcelRequire("iC5L0");
var $ge2sX = parcelRequire("ge2sX");

var $gKr8t = parcelRequire("gKr8t");
var $hp2SH = parcelRequire("hp2SH");

var $bLJr5 = parcelRequire("bLJr5");

var $ezH4I = parcelRequire("ezH4I");
var $3GQl6 = parcelRequire("3GQl6");

var $hZpML = parcelRequire("hZpML");

var $04e9M = parcelRequire("04e9M");

var $cMvQV = parcelRequire("cMvQV");

var $9j59h = parcelRequire("9j59h");

var $jmjWc = parcelRequire("jmjWc");

const $94ecb5e99e218b76$export$b602c35a55c29946 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "-DYr1",
    name: "ErrorAppLoader",
    loader: async ()=>(await (parcelRequire("jD74V"))).ErrorApp
});





var $gwFzn = parcelRequire("gwFzn");

var $hZpML = parcelRequire("hZpML");
/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $gwFzn = parcelRequire("gwFzn");
const $db1172108b431747$export$bc237d627614fc48 = `!function(e,t){const n=t.__SSR_INTERACTIONS__={},i=t.__SSR_INTERACTIONS_DURATIONS__={},o=t.__SSR_EVENT_LISTENERS__=[];Array.from(e.getElementsByClassName("ssrMouseEvent")).forEach((t=>{t.previousSibling&&((t,s)=>{if(!t||!s)return;const r=e=>{if(!e)return!1;if(e.disabled)return!0;let t=!1;for(let n=0;n<e.childNodes.length;n++)if(r(e.childNodes[n])){t=!0;break}return t};if(r(t)){var c;const n=e.createElement("div");n.style.cssText="display: inline-block; position: relative;",n.setAttribute("data-testid","".concat(s,"_CLICK_CONTAINER"));const i=e.createElement("div");i.style.cssText="content: ''; position: absolute; top: 0; left: 0; bottom: 0; right: 0;",i.setAttribute("data-testid","".concat(s,"_CLICK_AREA")),null===(c=t.parentElement)||void 0===c||c.replaceChild(n,t),n.append(t),n.append(i),t=i}const a=e=>{n[e]=!0,i[e]=[...i[e]||[],performance.now()]};let l,d=!1;const u=()=>{a("".concat(s,"_CLICK"))},_=()=>{d=!0,l=setTimeout((function(){d&&(a("".concat(s,"_HOVER")),d=!1)}),100)},E=()=>{l&&clearTimeout(l),d=!1};t.addEventListener("click",u,!0),t.addEventListener("mouseenter",_),t.addEventListener("mouseleave",E),o.push([t,"click",u,!0]),o.push([t,"mouseenter",_,void 0]),o.push([t,"mouseleave",E,void 0])})(t.previousSibling,t.value)}))}(document,window);`;


const $c07037197fae7cb7$export$a6f691eaa46471c3 = ()=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        dangerouslySetInnerHTML: {
            __html: `if(window["__SSR_RENDERED__"]){${(0, $db1172108b431747$export$bc237d627614fc48)}}`
        }
    });
};



var $36IZS = parcelRequire("36IZS");

var $gwFzn = parcelRequire("gwFzn");

var $hZpML = parcelRequire("hZpML");
function $a6e2c333ce8dee1c$export$d2cb5cf8969d339e() {
    const script = `window.performance.mark("${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_FORCE_LAYOUT}.start");` + // Accessing clientHeight causes the browser to perform a synchronous layout recalculation.
    // While this doesn't directly trigger a "paint" operation, it increases the likelihood of one
    // occurring shortly afterward. This means it is less likely that users will see a partially
    // painted screen while the browser processes imported JavaScript modules.
    `window.document.documentElement.clientHeight;` + `window.performance.mark("${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_FORCE_LAYOUT}.end")`;
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: script
        }
    });
}


const $8714b2bec379cfae$export$bd148a921cde8da1 = ()=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a6e2c333ce8dee1c$export$d2cb5cf8969d339e), null), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SSR_SCRIPTS}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c07037197fae7cb7$export$a6f691eaa46471c3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $36IZS.SSRInlineScriptsInit), null), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SSR_SCRIPTS}.end`), !window.__SSR_REACT_STREAMING__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            // Suppress error when performance API failed.
            // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
            // That's why wrap with try catch statement.
            __html: 'if(window["__SSR_RENDERED__"]){try{window.performance.mark("CFP-63.ssr-ttr");window.performance.measure("browser-metric:fmp",undefined,"CFP-63.ssr-ttr")}catch(e){}}'
        }
    }));
};


var $gwFzn = parcelRequire("gwFzn");

var $hZpML = parcelRequire("hZpML");
/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $gwFzn = parcelRequire("gwFzn");

var $PrCoC = parcelRequire("PrCoC");

var $bj5fB = parcelRequire("bj5fB");
const $ef8ede6c338f8be6$export$6838ff380832204f = ({ uri: uri })=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)(uri);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        dangerouslySetInnerHTML: {
            __html: `if(window["__SSR_RENDERED__"]){${(0, $PrCoC.themeSSRManager).getThemeHtmlAttrsScript({
                forceAuto: isMobileApp
            })}}`
        }
    });
};


const $d847caf3274d14b7$export$f3385cdc6645f7e3 = ({ uri: uri })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_THEME_INIT}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ef8ede6c338f8be6$export$6838ff380832204f), {
        uri: uri
    }), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_THEME_INIT}.end`));


var $gwFzn = parcelRequire("gwFzn");

var $hZpML = parcelRequire("hZpML");
const $799291abed68198f$export$640957ec8f6fdf34 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_REACT_ROOT}.start`), children, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_REACT_ROOT}.end`));
};



var $jLfE2 = parcelRequire("jLfE2");
var $irVI7 = parcelRequire("irVI7");

var $dYU3e = parcelRequire("dYU3e");

var $7NOdL = parcelRequire("7NOdL");
function $c63485f681d81d31$export$693b572d94b96722() {
    return (0, $dYU3e.query)({
        query: (0, $7NOdL.ThemeQuery)
    });
}



var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $4vyfK = parcelRequire("4vyfK");

var $djivE = parcelRequire("djivE");
function $c3ef336b2b86bed6$export$2d0f6d5aa0911699() {
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $djivE.AppNavigationUnifiedQuery)
        }),
        (0, $4vyfK.preloadWebItemLocation)({
            location: 'system.header/left'
        })
    ]);
}



var $jLfE2 = parcelRequire("jLfE2");
var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $9wGTI = parcelRequire("9wGTI");

var $3RlfX = parcelRequire("3RlfX");

var $dYU3e = parcelRequire("dYU3e");

var $gKr8t = parcelRequire("gKr8t");

var $d2LG0 = parcelRequire("d2LG0");
const $d199bbef1016a157$export$5e3fffcd629ba9ef = (0, $d2LG0.default)`query PreloadUnseenNotificationCountQuery{notifications{unseenNotificationCount}}`;


const $b7ee762a3100e127$export$18585825cd8ca022 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $d199bbef1016a157$export$5e3fffcd629ba9ef),
        client: (0, $gKr8t.getAGGClient)()
    });
};


async function $a6a4fe9083f3db22$export$d46e9819bcc1eb51() {
    const { userId: userId } = await (0, $jLfE2.getPreloaderFnContext)();
    const topNavigationPromises = [
        (0, $dYU3e.query)({
            query: (0, $3RlfX.TopNavigationQuery),
            variables: {
                includeNav4AdminOptIn: (0, $9wGTI.fg)('confluence_nav4_ga_phase_1')
            }
        })
    ];
    if (userId && (0, $9wGTI.fg)('confluence_frontend_preload_notifications')) //skip for anon
    topNavigationPromises.push((0, $b7ee762a3100e127$export$18585825cd8ca022)());
    return (0, $lyWac.waitForAllReturnWhenError)(topNavigationPromises);
}



var $dYU3e = parcelRequire("dYU3e");

var $e1GUi = parcelRequire("e1GUi");
function $553b9603687aba42$export$dfb7e28de13124a4() {
    // @ts-ignore
    if (window['__ENABLE_SITE_INFORMATION_QUERY__']) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $e1GUi.SPAViewContextQuery)
    });
}



var $jLfE2 = parcelRequire("jLfE2");
var $dYU3e = parcelRequire("dYU3e");

var $a1A9A = parcelRequire("a1A9A");
async function $969a3e14c27be3bd$export$9930aa21f1e6a4e3() {
    const { userId: userId } = await (0, $jLfE2.getPreloaderFnContext)();
    if (!userId) return;
    return (0, $dYU3e.query)({
        query: (0, $a1A9A.OperationsQuery)
    });
}



var $5ZqQS = parcelRequire("5ZqQS");

var $9WAeG = parcelRequire("9WAeG");

var $f7B1p = parcelRequire("f7B1p");

var $60cDW = parcelRequire("60cDW");
const $55fac8bf1a108c66$export$509bd252264314bd = 'backbone';
const $55fac8bf1a108c66$export$ece352750a2c4ea1 = async ()=>{
    if (window.__COOKIE_CONSENT_CATEGORIES__) return window.__COOKIE_CONSENT_CATEGORIES__;
    const { perimeter: perimeter } = (0, $60cDW.getSSRRenderInputs)();
    // if we are in FedRAMP, don't preload the consent categories
    if (perimeter === 'fedramp-moderate') return window.__COOKIE_CONSENT_CATEGORIES__ = null;
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:CookieCategories', async ()=>{
        try {
            const res = await (0, $f7B1p.cfetch)(`https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json`, {
                method: 'GET',
                credentials: 'omit',
                headers: {
                    Accept: 'application/json'
                }
            });
            if (!res.ok) throw new Error(`Cannot load Cookie Consent Categories: ${res.statusText}`);
            const result = await res.json();
            return window.__COOKIE_CONSENT_CATEGORIES__ = result;
        } catch (e) {
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: $55fac8bf1a108c66$export$509bd252264314bd
            });
            return window.__COOKIE_CONSENT_CATEGORIES__ = null;
        }
    });
};



var $7MEbC = parcelRequire("7MEbC");

var $5ZqQS = parcelRequire("5ZqQS");

var $9WAeG = parcelRequire("9WAeG");

var $60cDW = parcelRequire("60cDW");
const $c841b55372d4071a$export$509bd252264314bd = 'backbone';
const $c841b55372d4071a$export$96f49c018063fe60 = async ()=>{
    if (window.__PRELOADED_COOKIE_PREFERENCES__) return window.__PRELOADED_COOKIE_PREFERENCES__;
    const { perimeter: perimeter } = (0, $60cDW.getSSRRenderInputs)();
    // if we are in FedRAMP, don't preload the consent categories
    if (perimeter === 'fedramp-moderate') return window.__PRELOADED_COOKIE_PREFERENCES__ = null;
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:Preferences', async ()=>{
        try {
            const result = await (0, $7MEbC.getPreferences)();
            return window.__PRELOADED_COOKIE_PREFERENCES__ = result || null;
        } catch (e) {
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: $c841b55372d4071a$export$509bd252264314bd
            });
            return window.__PRELOADED_COOKIE_PREFERENCES__ = null;
        }
    });
};



var $eiCiP = parcelRequire("eiCiP");

var $9fLxI = parcelRequire("9fLxI");

var $dYU3e = parcelRequire("dYU3e");

var $9p5st = parcelRequire("9p5st");
function $88b2ba3b9422ec6a$export$3837c35a0d92ab93() {
    const macroParams = window['__LEGACY_MACRO_PARAMS__'] || [];
    window['__LEGACY_MACRO_PARAMS__'] = [];
    // eslint-disable-next-line check-preloaders/no-promise-all
    return Promise.all(macroParams.map(({ isMacroContentAndBody: isMacroContentAndBody, ...rest })=>{
        const preloadMacroQuery = isMacroContentAndBody ? (0, $9p5st.MacroBodyRendererQueryWithTags) : (0, $9p5st.MacroContentRendererQueryWithTags);
        return (0, $dYU3e.query)({
            query: preloadMacroQuery,
            variables: rest,
            context: {
                single: true
            }
        });
    }));
}



var $dYU3e = parcelRequire("dYU3e");

var $PrCoC = parcelRequire("PrCoC");

var $l6Xaz = parcelRequire("l6Xaz");

var $9wGTI = parcelRequire("9wGTI");

var $bUqLQ = parcelRequire("bUqLQ");

var $8SfNq = parcelRequire("8SfNq");
async function $821e100427ee88aa$export$ce64f7b5556cdb62({ preloadSuperBatchForSSR: preloadSuperBatchForSSR = false } = {}) {
    if (preloadSuperBatchForSSR) {
        const superbatchData = await (0, $dYU3e.query)({
            query: (0, $bUqLQ.FrontendResourceRenderQuery)
        });
        const resourceList = superbatchData?.data?.internalFrontendResource?.resourceList || [];
        const { js: js, css: css } = resourceList.reduce((acc, resource)=>{
            const html = (0, $l6Xaz.convertSuperBatchResourceToScriptTags)(resource);
            acc[resource.type].push(html);
            return acc;
        }, {
            js: [],
            css: []
        });
        const jsResources = (0, $l6Xaz.removeJquery)(js.join('\n'));
        const cssResources = css.join('\n');
        (0, $PrCoC.superbatchJSRecorder).add(jsResources);
        (0, $PrCoC.superbatchCSSRecorder).add(cssResources);
        (0, $PrCoC.superbatchJSRecorder).includeSuperBatchResources();
        (0, $PrCoC.superbatchCSSRecorder).includeSuperBatchResources();
        if ((0, $9wGTI.fg)('confluence_always_preload_superbatch')) window['__PRELOADED_SUPERBATCH_DATA__'] = {
            js: jsResources,
            css: cssResources,
            superbatchDataForSPA: (0, $8SfNq.parseSuperBatchDataForSPA)(superbatchData?.data)
        };
    } else if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    !window.__SUPERBATCH_REQUESTED__ && !Boolean(window.__PRELOADED_SUPERBATCH_DATA__)) return (0, $dYU3e.query)({
        query: (0, $bUqLQ.FrontendResourceRenderQuery)
    });
    return Promise.resolve();
}



var $hvqgK = parcelRequire("hvqgK");

var $dIouf = parcelRequire("dIouf");

var $5ZqQS = parcelRequire("5ZqQS");

var $9WAeG = parcelRequire("9WAeG");

var $f7B1p = parcelRequire("f7B1p");

var $60cDW = parcelRequire("60cDW");

var $cgNzK = parcelRequire("cgNzK");

var $jLfE2 = parcelRequire("jLfE2");

var $9wGTI = parcelRequire("9wGTI");
const $29df517881fdeca7$export$c2d188ccf9271ffd = 'CookiePreferencesQuery';
const $29df517881fdeca7$export$990c5eb6cb59ce1c = async ()=>{
    if (window.__COOKIE_CONSENT_PREFERENCES__) return window.__COOKIE_CONSENT_PREFERENCES__;
    let hostEnv = 'prod';
    const { environment: environment } = await (0, $jLfE2.getPreloaderFnContext)();
    if (environment !== 'PRODUCTION') hostEnv = 'staging';
    const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken, userId: userId, perimeter: perimeter } = (0, $60cDW.getSSRRenderInputs)();
    // If the consent token cookie exist (user has already set their preferences), there is no need to
    // fetch the preferences from ConsentHub
    if (cookiesConsentToken) return window.__COOKIE_CONSENT_PREFERENCES__ = {
        consentToken: cookiesConsentToken,
        fallbackConsentToken: cookiesFallbackToken
    };
    if (!userId && (0, $9wGTI.fg)('confluence_frontend_fix_inconsistent_cookie_banner')) return window.__COOKIE_CONSENT_PREFERENCES__ = {
        consentToken: (0, $hvqgK.serializeConsents)({})
    };
    // If we have no userId, or we are in FedRAMP, don't preload the consent preferences
    if (!userId || perimeter === 'fedramp-moderate') return window.__COOKIE_CONSENT_PREFERENCES__ = null;
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:CookieConsentPreferences', async ()=>{
        let result = null;
        try {
            const res = await (0, $f7B1p.cfetch)(`https://atl-preferences-center-elb.${hostEnv}.atl-paas.net/rest/user/${userId}/consents/cookies`, (0, $cgNzK.constructCompatibleRequestInit)({
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }));
            if (!res.ok) throw new Error(`Cannot load Cookie Consent Preferences: ${res.statusText}`);
            result = await res.json();
        } catch (e) {
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $dIouf.Attribution).BACKBONE
            });
        }
        if (result && Object.keys(result).length) return window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign({}, result, {
            fallbackConsentToken: cookiesFallbackToken
        });
        else return window.__COOKIE_CONSENT_PREFERENCES__ = null;
    });
};



var $60cDW = parcelRequire("60cDW");
var $PrCoC = parcelRequire("PrCoC");

var $5SzHz = parcelRequire("5SzHz");

var $eS4vC = parcelRequire("eS4vC");
var $jLfE2 = parcelRequire("jLfE2");
var $lyWac = parcelRequire("lyWac");

var $6bQlH = parcelRequire("6bQlH");

var $jLfE2 = parcelRequire("jLfE2");
var $dYU3e = parcelRequire("dYU3e");

var $PrCoC = parcelRequire("PrCoC");

var $lesra = parcelRequire("lesra");

var $d2LG0 = parcelRequire("d2LG0");
const $e86bb77932783694$export$ef738b2af6d7e87a = (0, $d2LG0.default)`query UserSettingsQuery($isNotLicensed:Boolean!){userPreferences@skip(if:$isNotLicensed){shouldShowCardOnPageTreeHover feedRecommendedUserSettingsDismissTimestamp userSpacesNotifiedOfExternalCollab favouriteTemplateEntityIds homePagesDisplayView feedType feedTab recentFilter missionControlOverview missionControlMetricSuggestions{suggestion value dismissalDateTime}confluenceEditorSettings{toolbarDockingInitialPosition}missionControlFeatureDiscoverySuggestions{suggestion dismissalDateTime}globalPageCardAppearancePreference homeWidgets{id state __typename}recentFilter isHomeOnboardingDismissed theme watchMyOwnContent nav4OptOut __typename}featureDiscovery{pluginKey featureKey userKey date}}`;


const $96ee7afaced2313e$export$758dd268a3743917 = 'default';
const $96ee7afaced2313e$export$e0e94d96f49a1aa = async ({ themeState: themeState })=>{
    const { isLicensed: isLicensed, isLoggedIn: isLoggedIn } = await (0, $jLfE2.getPreloaderFnContext)();
    if (!isLoggedIn) return;
    if (themeState) (0, $PrCoC.themeSSRManager).setThemeStateBasedOnSavedThemeState((0, $lesra.getEffectiveThemeState)(decodeURIComponent(themeState)));
    const response = await (0, $dYU3e.query)({
        query: (0, $e86bb77932783694$export$ef738b2af6d7e87a),
        variables: {
            isNotLicensed: !isLicensed
        }
    });
    const theme = response?.data?.userPreferences?.theme;
    // Setting colorMode for user theme
    if (theme) (0, $PrCoC.themeSSRManager).setThemeStateBasedOnSavedThemeState((0, $lesra.getEffectiveThemeState)(theme));
    return response;
};



var $d2LG0 = parcelRequire("d2LG0");

var $034wI = parcelRequire("034wI");
var $bnGHl = parcelRequire("bnGHl");

var $jLfE2 = parcelRequire("jLfE2");
var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $gKr8t = parcelRequire("gKr8t");

var $4vyfK = parcelRequire("4vyfK");

var $8CHHT = parcelRequire("8CHHT");

var $jLfE2 = parcelRequire("jLfE2");
var $lyWac = parcelRequire("lyWac");

var $9wGTI = parcelRequire("9wGTI");

var $8dUjs = parcelRequire("8dUjs");
const $0253e305bf4bf030$export$8b5d8927d613430e = async ()=>{
    const { edition: edition, accessStatus: accessStatus } = await (0, $jLfE2.getPreloaderFnContext)();
    const { webItemParams: webItemParams, forgeExtensionParams: forgeExtensionParams } = (0, $8dUjs.getGlobalAppsParams)({
        edition: edition,
        accessStatus: accessStatus
    });
    const promises = [
        (0, $4vyfK.preloadWebItemLocation)(webItemParams)
    ];
    if ((0, $9wGTI.fg)('confluence_nav_4_global_forge_extensions_preload')) promises.push((0, $8CHHT.preloadUseExtensionList)(forgeExtensionParams));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};


const $34aa8f5c495a6ba2$export$3efc211209d16247 = async ()=>{
    const { cloudId: cloudId, userId: userId, activationId: activationId } = await (0, $jLfE2.getPreloaderFnContext)();
    const promises = [
        (0, $0253e305bf4bf030$export$8b5d8927d613430e)()
    ];
    if (userId) promises.push((0, $dYU3e.query)({
        query: $34aa8f5c495a6ba2$var$preloadGlobalNavigationComponentQuery,
        context: {
            headers: {
                'Atl-Client-Name': 'confluence-frontend'
            }
        },
        variables: {
            entityAri: (0, $034wI.ConfluenceWorkspaceAri).create({
                siteId: cloudId,
                activationId: activationId
            }).toString(),
            ownerAri: (0, $bnGHl.IdentityUserAri).create({
                userId: userId
            }).toString()
        },
        client: (0, $gKr8t.getAGGClient)()
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};
const $34aa8f5c495a6ba2$var$preloadGlobalNavigationComponentQuery = (0, $d2LG0.default)`query preloadGlobalNavigationComponentQuery($entityAri:ID!$ownerAri:ID!){settings_navigationCustomisation(entityAri:$entityAri ownerAri:$ownerAri){sidebar{nodes{menuId visible}}}}`;



var $9wGTI = parcelRequire("9wGTI");

var $6mKj3 = parcelRequire("6mKj3");

var $9sGCn = parcelRequire("9sGCn");

var $jLfE2 = parcelRequire("jLfE2");
var $dYU3e = parcelRequire("dYU3e");

var $d9tcB = parcelRequire("d9tcB");

var $aT8im = parcelRequire("aT8im");
async function $1f8e7f4831866dd9$export$f92adbce3a1ce419() {
    const { isLoggedIn: isLoggedIn, accessStatus: accessStatus } = await (0, $jLfE2.getPreloaderFnContext)();
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return;
    return (0, $dYU3e.query)({
        query: (0, $aT8im.useConfluenceStandardToPremiumExperimentQuery),
        variables: {
            key: (0, $aT8im.EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED)
        }
    });
}



var $dYU3e = parcelRequire("dYU3e");

var $iaqHp = parcelRequire("iaqHp");
const $da1fd1e44d7582fe$export$b4f1825d0b62630d = ()=>(0, $dYU3e.query)({
        query: (0, $iaqHp.EditorPreferencesQuery)
    });



var $iUV81 = parcelRequire("iUV81");

var $hXDOc = parcelRequire("hXDOc");

var $kM8fE = parcelRequire("kM8fE");

var $eS4vC = parcelRequire("eS4vC");
var $jLfE2 = parcelRequire("jLfE2");
var $kkLBe = parcelRequire("kkLBe");
var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $iq03p = parcelRequire("iq03p");

var $furnK = parcelRequire("furnK");

var $lcQ5b = parcelRequire("lcQ5b");

var $2WwwU = parcelRequire("2WwwU");

var $3e0r1 = parcelRequire("3e0r1");

var $fyUox = parcelRequire("fyUox");

var $gKMkU = parcelRequire("gKMkU");

var $iV8Fk = parcelRequire("iV8Fk");

var $g9fWM = parcelRequire("g9fWM");

var $9wGTI = parcelRequire("9wGTI");

var $f7B1p = parcelRequire("f7B1p");

var $60cDW = parcelRequire("60cDW");
var $i2tcl = parcelRequire("i2tcl");
var $PrCoC = parcelRequire("PrCoC");
function $64996f4302e0f23b$var$convertResourceToScriptTags(resource) {
    const nonce = window.__SSR_NONCE_VALUE__;
    if (resource.resourceType === 'CSS') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}" data-key="${resource.key}" data-batch-type="${resource.batchType}"${resource.ieOnly ? ' data-ie-only="true"' : ''} />`;
    else if (resource.resourceType === 'JAVASCRIPT') return `<script nonce="${nonce}" src="${resource.url}" data-key="${resource.key}" data-batch-type="${resource.batchType}"${resource.ieOnly ? ' data-ie-only="true"' : ''}></script>`;
    return '';
}
// Create cookie with cloud session token
const $64996f4302e0f23b$var$createCookie = (userContext)=>{
    const cookieTarget = 'cloud.session.token';
    return `${cookieTarget}=${userContext}`;
};
const $64996f4302e0f23b$export$51bf8f21dab6d404 = async ()=>{
    if (!(0, $9wGTI.fg)('content_early_connect_iframe_initialization')) return;
    const { userContext: userContext, host: host, cloudId: cloudId } = (0, $60cDW.getSSRRenderInputs)();
    try {
        const headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Cookie: $64996f4302e0f23b$var$createCookie(userContext || ''),
            CloudId: cloudId || '',
            'X-Product': 'CONFLUENCE',
            Origin: host?.startsWith('http') ? host : `https://${host}`
        };
        const response = await (0, $f7B1p.cfetch)('/wiki/rest/webResources/1.0/resources', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                r: [
                    'confluence.web.resources:querystring',
                    'confluence.web.resources:navigator-context',
                    'com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
                ],
                c: [],
                xc: [
                    '_super'
                ],
                xr: [
                    'com.atlassian.plugins.jquery:jquery',
                    'com.atlassian.plugins.jquery:jquery-migrate'
                ]
            })
        });
        if (!response.ok) throw new Error(`Failed to preload web resources: ${response.status}`);
        const data = await response.json();
        // unparsedData in the response will later be claimed by window.WRM.data.claim()
        // This need to be fore all the JS scripts because they might claim the data while executing.
        if (data?.unparsedData) {
            const entries = [];
            for (const [key, value] of Object.entries(data.unparsedData))// value is a stringified JSON object.
            entries.push(`d["${key}"]="${(0, $i2tcl.sanitizeDataForSSR)(value)}"`);
            (0, $PrCoC.superbatchJSRecorder).addConnectResource(`<script>(function(d){if(d){${entries.join(';')}}})(window?.WRM?._unparsedData)</script>`);
        }
        (0, $PrCoC.superbatchJSRecorder).addConnectResource(data?.resources?.filter((resource)=>resource.resourceType === 'JAVASCRIPT')?.map((resource)=>$64996f4302e0f23b$var$convertResourceToScriptTags(resource)).join('\n'));
        (0, $PrCoC.superbatchCSSRecorder).addConnectResource(data?.resources?.filter((resource)=>resource.resourceType === 'CSS')?.map((resource)=>$64996f4302e0f23b$var$convertResourceToScriptTags(resource)).join('\n'));
    } catch (error) {
        (0, $PrCoC.ssrPrepareErrorsClient).submitError(new Error(`Unable to preload connect web resources: ${error.message}`));
    }
};



var $1i2qc = parcelRequire("1i2qc");

var $dYU3e = parcelRequire("dYU3e");

var $fOjen = parcelRequire("fOjen");

var $25RVt = parcelRequire("25RVt");
const $151aa4f2ef9a59b5$export$dc87c93837fe9dba = async (contentId, spaceKey)=>{
    const response = await (0, $dYU3e.query)({
        query: (0, $25RVt.DSPIsActionEnabledForContentQuery),
        variables: {
            action: (0, $fOjen.DataSecurityPolicyAction).PAGE_EXPORT,
            contentId: contentId,
            contentStatus: 'CURRENT',
            contentVersion: 1,
            spaceKey: spaceKey
        }
    });
    return response;
};



var $kZZXz = parcelRequire("kZZXz");

var $93jhx = parcelRequire("93jhx");

var $28DDG = parcelRequire("28DDG");

var $1NBp8 = parcelRequire("1NBp8");

var $dYU3e = parcelRequire("dYU3e");

var $6mKj3 = parcelRequire("6mKj3");

var $4XcQZ = parcelRequire("4XcQZ");
function $3b0bcd4ef0479f8b$export$ae057a53ebe0d3cd({ contentId: contentId, spaceKey: spaceKey, contentType: contentType }) {
    return (0, $dYU3e.query)({
        query: (0, $4XcQZ.EndOfPageRecommendationQuery),
        variables: {
            type: contentType,
            id: contentId,
            exp: (0, $6mKj3.expVal)('cc_ai_discovery_linked_pages_on_related_pages', 'experience', 'end_of_page_v5'),
            key: spaceKey,
            keyString: spaceKey
        },
        // Must be preloaded with network only to get fresh data
        fetchPolicy: 'network-only'
    });
}



var $7tT2b = parcelRequire("7tT2b");

var $dYU3e = parcelRequire("dYU3e");

var $d2LG0 = parcelRequire("d2LG0");
const $2c43f8284c39f713$export$e687ae7a39790072 = (0, $d2LG0.default)`query PresenceSettingsQuery($cloudId:ID!$spaceKey:String!){confluence_teamPresenceContentSetting(cloudId:$cloudId spaceKey:$spaceKey){isEnabledOnContentView}}`;


function $853f14d41fe05930$export$fb43949e55e0c9d2({ cloudId: cloudId, spaceKey: spaceKey }) {
    return (0, $dYU3e.query)({
        query: (0, $2c43f8284c39f713$export$e687ae7a39790072),
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey
        }
    });
}



var $d9tcB = parcelRequire("d9tcB");

var $9ycGg = parcelRequire("9ycGg");

var $5SzHz = parcelRequire("5SzHz");

var $gBI6h = parcelRequire("gBI6h");

var $lt4mJ = parcelRequire("lt4mJ");

var $eSLr0 = parcelRequire("eSLr0");

var $5Rwa0 = parcelRequire("5Rwa0");

var $d2LG0 = parcelRequire("d2LG0");

var $dYU3e = parcelRequire("dYU3e");

var $dBcar = parcelRequire("dBcar");
const { IS_CONTENT_WRAPPER_LABELS_TOUR_DISMISSED: $36563fb90811f781$var$IS_CONTENT_WRAPPER_LABELS_TOUR_DISMISSED } = (0, $dBcar.ONBOARDING_EXPERIENCES);
const $36563fb90811f781$export$c2a50242f4317108 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $d2LG0.default)`query preloadLabelsMovedChangeboardingQuery($key:String!){onboardingState(key:[$key]){key value}}`,
        variables: {
            key: $36563fb90811f781$var$IS_CONTENT_WRAPPER_LABELS_TOUR_DISMISSED
        }
    });
};



var $9wGTI = parcelRequire("9wGTI");

var $6mKj3 = parcelRequire("6mKj3");

var $7Ndnw = parcelRequire("7Ndnw");

var $8CHHT = parcelRequire("8CHHT");

var $gDMf3 = parcelRequire("gDMf3");

var $fNrAc = parcelRequire("fNrAc");


var $dYU3e = parcelRequire("dYU3e");

var $cg3Zk = parcelRequire("cg3Zk");
function $c44bc7c35ccb995d$export$b39ebabf96e926c8(id) {
    return (0, $dYU3e.query)({
        query: (0, $cg3Zk.RequestViewQuery),
        variables: {
            id: id
        }
    });
}



var $ePnB5 = parcelRequire("ePnB5");

var $dYU3e = parcelRequire("dYU3e");

var $eDV4X = parcelRequire("eDV4X");

var $7vJu5 = parcelRequire("7vJu5");
function $177bcfd6fc5d7374$export$1c5f808d33dd5bee({ contentId: contentId }) {
    if (!contentId) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $7vJu5.LabelsQuery),
        variables: {
            contentId: contentId,
            status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES),
            refetchQuery: false
        },
        fetchPolicy: 'network-only'
    });
}



var $dYU3e = parcelRequire("dYU3e");

var $66UJS = parcelRequire("66UJS");
const $ae623fc05873186d$export$8770175d3079e1c0 = [
    'quickstart-state:isPanelOpen',
    'quickstart-state:isDismissed',
    'quickstart-state:openTaskId',
    'quickstart-state:openComponentId',
    'quickstart-state:jswConfIntroCompleted',
    'quickstart-state:helpCompleted',
    'quickstart-state:spaceModalCompleted',
    'quickstart-state:spaceTourCompleted',
    'quickstart-state:collaborateCompleted',
    'quickstart-state:homeModalCompleted',
    'quickstart-state:homeTourCompleted',
    'quickstart-state:mobileCompleted',
    'quickstart-state:hasSeenDismissedFlag',
    'quickstart-state:isMigratedUserV2',
    'quickstart-state:jswXflowSwitcherTourCompleted',
    'onboarding-origin-state:attributes',
    'quickstart-state:jswXFlowModalCompleted',
    'quickstart-state:editorTutorialTaskCompleted',
    'quickstart-state:qsv2ReadConfluenceGuideCompleted',
    'quickstart-state:qsv2InviteTeammateCompleted',
    'quickstart-state:qsv2IntegrationCompleted',
    'quickstart-state:qsv2SiteVideoTourCompleted',
    'quickstart-state:qsv2SpotlightCompleted',
    'quickstart-state:migrationsWelcomeCompleted',
    'quickstart-state:migrationsNewPageCompleted',
    'quickstart-state:migrationsCollaborateCompleted',
    'quickstart-state:migrationsFindAndOrganizePagesCompleted',
    'quickstart-state:migrationsEditAndCustomizeContentCompleted',
    'quickstart-state:simplifyAdminRenameSiteCompleted',
    'quickstart-state:nqsv2HelpCompleted',
    'quickstart-state:nqsv2CreateCompleted',
    'quickstart-state:nqsv2CollaborateCompleted',
    'quickstart-state:nqsv2Confluence101Completed',
    'onboarding-state:isFoundingAdmin',
    'onboarding-live-doc-changeboarding:hasDismissedIntroSpotlight',
    'onboarding-live-doc-changeboarding:hasDismissedLiveDocTour',
    'onboarding-live-doc-changeboarding:hasDismissedLiveDocModal',
    'onboarding-live-doc-changeboarding:hasDismissedContentWrapperTour',
    'onboarding-live-doc-changeboarding:hasDismissedAiButtonTour',
    'onboarding-live-doc-changeboarding:hasDismissedConvertToPageSpotlight',
    'onboarding-state:isRedactionsTourVisible',
    'onboarding-state:isContentWrapperLabelsTourDismissed',
    'onboarding-state:isMoreActionsTourVisible',
    'onboarding-state:isMoreActionsHintVisible',
    'random:ShareAndRestrictDialog:spotlightSeen',
    'home-onboarding-takeover-v2:hasSeenHomeNudge',
    'home-onboarding-takeover-v2:takeoverSeenAt',
    'home-onboarding-takeover-v2:onboardingActionStates',
    'home-onboarding-takeover-v2:isCollapsed',
    'home-onboarding-takeover-v2:hasSeenConfetti',
    'home-onboarding-takeover-v2:hasDismissedTakeover',
    'editor-state:editorOnboardingEligiblity',
    'editor-state:editorVisited',
    'editor-state:wasDraftBannerSeen',
    'editor-state:isDraftBannerVisible',
    'editor-state:isLandInEditorBannerVisible',
    'editor-state:hasUserPublished',
    'editor-state:successFlagCompleted',
    'editor-state:recentSpotlightOpen',
    'editor-state:recentSpotlightCompleted',
    'editor-state:editorTutorialSuccessFlagCompleted',
    'editor-state:wasEditorConversionModalSeen',
    'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    'onboarding-intent-experiences:onboardingIntentExperienceLandClosed',
    'page:pagePresenceAvatarGroupSpotlightSeen',
    'page:pageTelepointerAvatarGroupSpotlightSeen',
    'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt',
    'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceIpmModal',
    'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceBanner',
    'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    'trial-components:trialGracePeriodBannerDismissed',
    'trial-components:dismissedTrialnullDayFlag',
    'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag',
    'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen',
    'land-in-sample-space:hasDismissedBanner',
    'live-page-nudge:wasLivePageNudgeSeen',
    'nav4:isNav4GlobalSpotlightDismissed',
    'nav4:isNav4SpaceTourDismissed',
    'personalized-templates-v2:onboardingActionStates',
    'personalized-templates-v2:hasDismissedOnboardingActions',
    'personalized-templates-v2:takeoverSeenAt',
    'personalized-templates-v2:isTemplateListDismissed',
    'personalized-templates-v2:templateUsageValues',
    'templates-collection:isTaggedForTemplatesCollectionExperiment',
    'templates-collection:isTemplatesSectionDismissed',
    'onboarding-state:introWorkflow',
    'onboarding-state:legacy',
    'onboarding-state:isSampleContentV2SpotlightVisible',
    'onboarding-state:landOnPath',
    'onboarding-state:teamSpaceCreated',
    'onboarding-state:improvedGetStartedPath',
    'onboarding-state:improvedGetStartedWhiteboardPath',
    'enhance-orientation-tour:tourSeenAt',
    'enhance-orientation-tour:hasDismissedTour',
    'enhance-orientation-tour:hasCompletedTour',
    'enhance-orientation-tour:hasSeenFinishNudge',
    'nav4:isNav4CollapseReminderSpotlightDismissed',
    'storage-enforcement-state:flagsDismissedFreeThreshold'
];
const $ae623fc05873186d$export$c279cfd6dfc47585 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: $ae623fc05873186d$export$8770175d3079e1c0
        }
    });
};



var $4vyfK = parcelRequire("4vyfK");


var $1swiX = parcelRequire("1swiX");

var $kM8fE = parcelRequire("kM8fE");

var $dpyxe = parcelRequire("dpyxe");

var $d2LG0 = parcelRequire("d2LG0");
const $4158c1d6b24615da$export$7a6b4ce398eb3192 = (0, $d2LG0.default)`query UnifiedSpaceQuery($spaceKey:String){space(key:$spaceKey){id key name type status alias dataClassificationTags didContainUserContent homepageId containsExternalCollaborators operations{operation targetType}currentUser{isAdmin isFavourited isWatched isAnonymouslyAuthorized}externalCollaboratorCount homepage{id operations{operation}properties(keys:["emoji-title-published"]){nodes{id key value}}}icon{path}links{webui}history{createdDate}theme{name themeKey}lookAndFeel{headings{key value}content{header{background backgroundAttachment backgroundBlendMode backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPosition backgroundRepeat backgroundSize borderRadius padding}screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}settings{customHeaderAndFooter{header{html js css spaUnfriendlyMacros{name}}footer{html js css spaUnfriendlyMacros{name}}}}spaceTypeSettings{enabledContentTypes{isBlogsEnabled isDatabasesEnabled isEmbedsEnabled isLivePagesEnabled isWhiteboardsEnabled isFoldersEnabled}}}}`;



var $d2LG0 = parcelRequire("d2LG0");
const $1d72fef168a20b6f$export$be884ca5181c66aa = (0, $d2LG0.default)`query UnifiedSidebarLinksQuery($spaceKey:String){spaceSidebarLinks(spaceKey:$spaceKey){main(includeHidden:true){id webItemKey webItemCompleteKey title url position styleClass icon{path width height isDefault}iconClass hidden canHide tooltip linkIdentifier type}quick{id url position title styleClass}}}`;


/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $b4749e5dd7184d60$export$32430b45163821f2 = (0, $d2LG0.default)`query UnifiedUserQuery{isSiteAdmin hasUserAccessAdminRole userCanCreateContent isNewUser currentConfluenceUser{isAnonymous}user:confluence_atlassianUser(current:true){id displayName photos{value isPrimary}emails{value isPrimary}confluence{permissionType space{id}operations{operation targetType}}}}`;



var $9sGCn = parcelRequire("9sGCn");
const $445d6fd463fd83fa$export$9503d022471fff24 = async (match, url, isTransition = false, previousMatch = null)=>{
    const { featureFlags: featureFlags, isLicensed: isLicensed, userId: userId, edition: edition, cloudId: cloudId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, environment: environment, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled, activationId: activationId } = await (0, $jLfE2.getPreloaderFnContext)();
    const tasks = [];
    // following functions will be triggered after we load data
    const postLoadingTasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    const username = (0, $1swiX.getUsername)(match);
    const isEmbeddedConfluence = (0, $1swiX.getIsEmbeddedConfluence)(match);
    const isBlog = Boolean((0, $kM8fE.matchBlogPage)(url));
    const isInitialLoad = !isTransition;
    const shouldPreloadNavigation = !isEmbeddedConfluence && (isInitialLoad || (0, $1swiX.shouldPreloadNavigationForTransition)(previousMatch));
    // Get isArchived from cached page data
    const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId);
    // Don't preload queries that will be updated by editor if previous route is edit_page
    const isPrevEditRoute = previousMatch?.name === (0, $1NBp8.EDIT_PAGE_V2).name || previousMatch?.name === (0, $1NBp8.EDIT_BLOG_V2).name || previousMatch?.name === (0, $1NBp8.COMPANY_HUB_EDIT).name;
    if (isPrevEditRoute && isTransition) // Preload for edit -> view transition
    return (0, $furnK.preloadContentHeader)({
        spaceKey: spaceKey,
        contentId: contentId,
        isLicensed: isLicensed,
        userId: userId,
        username: username,
        edition: edition,
        isPrevEditRoute: isPrevEditRoute,
        useNewContentTopper: true,
        isBlog: isBlog
    });
    // 0. consolidated preloaders
    if ((0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) {
        tasks.push((0, $dYU3e.query)({
            query: (0, $4158c1d6b24615da$export$7a6b4ce398eb3192),
            variables: {
                spaceKey: spaceKey
            }
        }));
        tasks.push((0, $dYU3e.query)({
            query: (0, $1d72fef168a20b6f$export$be884ca5181c66aa),
            variables: {
                spaceKey: spaceKey
            }
        }));
        tasks.push((0, $dYU3e.query)({
            query: (0, $b4749e5dd7184d60$export$32430b45163821f2)
        }));
    }
    // 1. Preload superbatch for connect iframes
    if ((0, $9wGTI.fg)('content_early_connect_iframe_initialization')) tasks.push((0, $kkLBe.prepareGuardExceptionTask)('Superbatch', ()=>(0, $821e100427ee88aa$export$ce64f7b5556cdb62)({
            preloadSuperBatchForSSR: true
        })));
    // 2. Content types header (object header) + Unified Share and Restrict Button
    const contentTypesHeaderPreloadTasks = [];
    if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) contentTypesHeaderPreloadTasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    if ((0, $9wGTI.fg)('confluence_frontend_object_header')) {
        contentTypesHeaderPreloadTasks.push((0, $3e0r1.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_object_header')));
        // preload data for whether "unpublished changes" label should show in view page object header
        contentTypesHeaderPreloadTasks.push((0, $4vyfK.preloadWebItemLocation)({
            location: 'page.metadata.banner',
            contentId: contentId
        }));
    }
    // (No need to call preloadPageRestrictionsQuery() here; it will be called by
    //  preloadContentHeader() )
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-types-header', contentTypesHeaderPreloadTasks));
    // 3. Page title
    const pageTitlePreloadTasks = [
        ...contentTypesHeaderPreloadTasks,
        (0, $fyUox.preloadPageTitleContentProperties)({
            contentId: contentId,
            spaceKey: spaceKey
        })
    ];
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('page-title', pageTitlePreloadTasks));
    // 4. Content + Byline
    let contentNodesPromiseResolve = undefined;
    const contentNodesPromise = new Promise((resolve)=>{
        contentNodesPromiseResolve = resolve;
    });
    const contentPreloadTasks = [
        ...pageTitlePreloadTasks,
        (0, $kkLBe.prepareGuardExceptionTask)('Connect Web Resources', ()=>(0, $64996f4302e0f23b$export$51bf8f21dab6d404)()),
        (0, $kkLBe.prepareGuardExceptionTask)('Macros', ()=>(0, $g9fWM.preloadMacrosSSR)({
                contentId: contentId,
                useMultipleMacrosQuery: true,
                contentNodes: contentNodesPromise
            })),
        (0, $kkLBe.prepareGuardExceptionTask)('Content', ()=>(0, $iq03p.preloadContent)({
                contentId: contentId,
                isBlog: isBlog,
                spaceKey: spaceKey,
                featureFlags: featureFlags
            }).then(({ result: result, hasErrors: hasErrors })=>{
                if ((0, $9wGTI.fg)('cc_macro_preload_early_exit')) contentNodesPromiseResolve?.(result?.data?.content?.nodes);
                // In case of errors on preloading content the content data may not make it to the
                // Apollo cache. To ensure we can try handling errors or missing content data cases
                // on SSR we preload content prerequisites here.
                // We don't want to preload content dependencies as in case of errors and/or missing
                // content this may result in unnecessary queries.
                if (hasErrors) return (0, $lyWac.waitForAllReturnWhenError)([
                    (0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey),
                    (0, $9wGTI.fg)('confluence_ssr_permissions_error_handler') && (0, $c44bc7c35ccb995d$export$b39ebabf96e926c8)(contentId)
                ]);
            })),
        (0, $gBI6h.preloadPageStatusQuery)(contentId),
        (0, $lt4mJ.preloadLegacyBridge)({
            contentId: contentId,
            isBlog: isBlog
        })
    ];
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-header', (0, $furnK.preloadContentHeader)({
        spaceKey: spaceKey,
        contentId: contentId,
        isLicensed: isLicensed,
        userId: userId,
        username: username,
        edition: edition,
        isPrevEditRoute: isPrevEditRoute,
        useNewContentTopper: true,
        isBlog: isBlog
    })), (0, $eS4vC.createDataFetcherForSuspense)('content-main', contentPreloadTasks));
    // 5. Space details
    if (!(0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    // 6. Content Smart Links
    tasks.push((0, $2WwwU.preloadContentSmartLinks)(contentId));
    // 7. Navigation & 7. Page tree + blog tree for blog post
    if (shouldPreloadNavigation) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('side-navigation', (0, $dpyxe.preloadNavigationTasks)(spaceKey, contentId, isLicensed, isBlog)));
    // 8. Inline Comments
    if (match?.query.focusedCommentId) tasks.push((0, $kZZXz.preloadFocusedInlineComment)(match?.query.focusedCommentId, contentId));
    if (!isEmbeddedConfluence || (0, $1swiX.hasEmbeddedAllowedFeatures)('inline-comments', match)) // when rendering an embedded confluence page, we do not want to preload inline comments if they are not requested via the allowlist features
    {
        if (!(0, $9wGTI.fg)('confluence_frontend_rm_preload_comment_highlights')) tasks.push((0, $93jhx.preloadInlineHighlights)(contentId));
    }
    // 9. Reactions
    if (!isEmbeddedConfluence || (0, $1swiX.hasEmbeddedAllowedFeatures)('page-reactions', match)) {
        // Preload whether the server has enabled reactions at all to show placeholder
        tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        }));
        // Preload reactions asynchronously so SSR won't wait for it
        // it's best effort preloading so if it preloads then we have the data, otherwise SPA can load it
        if ((0, $9wGTI.fg)('confluence_ssr_reactions_preload') || (0, $9wGTI.fg)('confluence_frontend_ssr_view_page_byline_reactions')) tasks.push((0, $9ycGg.preloadPageReactions)(contentId));
    }
    // 10. Recommendations
    if ((0, $9wGTI.fg)('ssr_end_of_page_recommendation')) tasks.push((0, $3b0bcd4ef0479f8b$export$ae057a53ebe0d3cd)({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: isBlog ? 'blogpost' : 'page'
    }));
    // 11. Stuff only needed for initial load
    if (isInitialLoad) {
        tasks.push(// We only refresh token when it is about to expire.
        (0, $1i2qc.preloadMediaToken)(contentId));
        if (!(0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) tasks.push((0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey));
        if ((0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) tasks.push((0, $151aa4f2ef9a59b5$export$dc87c93837fe9dba)(contentId, spaceKey));
    }
    // 12. Labels
    if ((0, $9wGTI.fg)('confluence_frontend_remove_labels')) tasks.push((0, $36563fb90811f781$export$c2a50242f4317108)());
    // please remove this when clean up confluence_frontend_remove_labels
    if (isTransition && !(0, $9wGTI.fg)('confluence_frontend_remove_labels') && (0, $9wGTI.fg)('confluence_frontend_preload_labels_in_transition')) tasks.push((0, $177bcfd6fc5d7374$export$1c5f808d33dd5bee)({
        contentId: contentId
    }));
    // 13. Preload web panel atl_general
    tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    }));
    // 14. Object Sidebar Control + AI Button
    if (isAdminHubAIEnabled) tasks.push((0, $28DDG.preloadAIFloatingContextMenu)(contentId, isBlog));
    // 15. Preload forge extension manifest
    if ((0, $9wGTI.fg)('confluence_preload_forge_viewport_heights')) {
        const extensionListLoader = ()=>(0, $8CHHT.preloadUseExtensionList)({
                contentId: contentId,
                spaceKey: spaceKey,
                moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
            });
        if ((0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) postLoadingTasks.push(extensionListLoader);
        else tasks.push(extensionListLoader());
    }
    // 16. Preload Loom button in Action Bar
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && isLoggedIn) tasks.push((0, $7tT2b.preloadRecordLoomButton)({
        cloudId: cloudId,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn,
        userId: userId,
        environment: environment
    }));
    // 17. Presence Avatar Visibility
    tasks.push((0, $853f14d41fe05930$export$fb43949e55e0c9d2)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }));
    // 18. Preload content-based AI enablement check
    if ((0, $9wGTI.fg)('confluence_ai_access_policy')) {
        const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabled;
        if (isAdminHubAIEnabled || shouldShowRovo) tasks.push((0, $fNrAc.preloadUseIsAIEnabledForContentQuery)(contentId));
    }
    // 20. Preload definition autohighlights
    if ((0, $9wGTI.fg)('confluence_frontend_ssr_autohighlights')) tasks.push((0, $gKMkU.preloadAutohighlights)({
        contentId: contentId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: isBlog ? 'blogpost' : 'page'
    }));
    // 21. Preload footer comments for the redesigned footer comment experience
    // SSRing live pages necessitates non-server (i.e. transition) preloading, so enable here too for consistency in the footer component
    if ((0, $9wGTI.fg)('confluence_frontend_ssr_empty_live_footer_comments') && (0, $9wGTI.fg)('confluence_frontend_ssr_empty_footer_comments')) // this query is needed for the new redesigned footer comment experience
    {
        if ((0, $9wGTI.fg)('confluence-frontend-redesigned-footer-comment')) tasks.push((0, $ePnB5.preloadFooterComments)(contentId, isArchived));
    }
    // 21. Preload onboarding state for view page
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS) && (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false)) tasks.push((0, $ae623fc05873186d$export$c279cfd6dfc47585)());
    if ((0, $9wGTI.fg)('query_preloader_no_promise_all')) {
        const errors = await (0, $lyWac.waitForAllReturnWhenError)(tasks);
        const postLoadingErrors = await (0, $lyWac.waitForAllReturnWhenError)(postLoadingTasks.map((task)=>task()));
        if (errors || postLoadingErrors) return [
            ...errors || [],
            ...postLoadingErrors || []
        ];
    } else // eslint-disable-next-line check-preloaders/no-promise-all
    return Promise.all(tasks).then(()=>{
        return (0, $lyWac.waitForAllReturnWhenError)(tasks).then(()=>{
            // eslint-disable-next-line check-preloaders/no-promise-all
            return Promise.all(postLoadingTasks.map((task)=>task()));
        });
    });
};



var $1NBp8 = parcelRequire("1NBp8");

var $aBowN = parcelRequire("aBowN");

var $3e0r1 = parcelRequire("3e0r1");


var $3bcaN = parcelRequire("3bcaN");

var $1i2qc = parcelRequire("1i2qc");

var $fyUox = parcelRequire("fyUox");

var $gKMkU = parcelRequire("gKMkU");




var $5SzHz = parcelRequire("5SzHz");

var $dYU3e = parcelRequire("dYU3e");

var $2z79p = parcelRequire("2z79p");
function $3c8474b5b6cc7016$export$986e86a20e675444({ accountId: accountId }) {
    return (0, $dYU3e.query)({
        query: (0, $2z79p.AudienceSegmentationContextProviderQuery),
        variables: {
            accountId: accountId
        }
    });
}



var $3Tnjq = parcelRequire("3Tnjq");

var $jLfE2 = parcelRequire("jLfE2");
var $kkLBe = parcelRequire("kkLBe");
var $lyWac = parcelRequire("lyWac");

var $jLfE2 = parcelRequire("jLfE2");
const $de1bf574523c3b16$export$7237b12e4aa9c6c = async ()=>{
    const { activationId: activationId, cloudId: cloudId } = await (0, $jLfE2.getPreloaderFnContext)();
    if (activationId && cloudId) return `~HUB-${cloudId}-${activationId}~`;
};



var $gDMf3 = parcelRequire("gDMf3");


var $c3Qwv = parcelRequire("c3Qwv");


var $9wGTI = parcelRequire("9wGTI");

var $eSLr0 = parcelRequire("eSLr0");

var $5Rwa0 = parcelRequire("5Rwa0");

const $fe22b38e04163065$var$homepageIdPromiseMap = new Map();
const $fe22b38e04163065$var$homepageIdMap = new Map();
const $fe22b38e04163065$var$loadHomepageId = async (spaceKey)=>{
    const { result: result, hasErrors: hasErrors } = await (0, $aBowN.preloadSpaceOverviewId)(spaceKey);
    return !hasErrors && result?.data?.space?.homepageId || null;
};
const $fe22b38e04163065$export$75a73f2fbf5e96e8 = async (match)=>{
    const { spaceKey: spaceKey } = match.params;
    const homepageId = match.query ? (0, $c3Qwv.getSingleParam)(match.query, (0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY) : undefined;
    if (homepageId) return;
    const homepageIdPromise = $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey) ?? $fe22b38e04163065$var$loadHomepageId(spaceKey);
    // Keep both maps in sync - promises and actual values for synchronous access
    $fe22b38e04163065$var$homepageIdPromiseMap.set(spaceKey, homepageIdPromise);
    return homepageIdPromise.then((homepageId)=>{
        $fe22b38e04163065$var$homepageIdMap.set(spaceKey, homepageId);
    });
};
const $fe22b38e04163065$export$75071d943b36f58f = async (match, previousMatch, _url)=>{
    const { cloudId: cloudId, isLicensed: isLicensed, userId: userId, activationId: activationId } = await (0, $jLfE2.getPreloaderFnContext)();
    const { spaceKey: spaceKey } = match.params;
    const initialHomepageId = match.query ? (0, $c3Qwv.getSingleParam)(match.query, (0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY) : undefined;
    const tasks = [];
    spaceKey;
    const isCompanyHub = match.name === (0, $1NBp8.COMPANY_HUB).name;
    const companyHubSpaceKey = isCompanyHub ? await (0, $de1bf574523c3b16$export$7237b12e4aa9c6c)() : undefined;
    const versionOverride = companyHubSpaceKey && match.query ? (0, $c3Qwv.getSingleParamInt)(match.query, 'versionOverride') : null;
    const homepageId = initialHomepageId || $fe22b38e04163065$var$homepageIdMap.get(spaceKey ?? companyHubSpaceKey);
    tasks.push((0, $3bcaN.preloadSpaceOverview)({
        spaceKey: spaceKey ?? companyHubSpaceKey,
        homepageId: homepageId,
        homepageIdPromise: $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey ?? companyHubSpaceKey),
        previousMatch: previousMatch,
        versionOverride: versionOverride
    }));
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: homepageId || '',
        contentIdPromise: $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey ?? companyHubSpaceKey),
        spaceKey: spaceKey ?? companyHubSpaceKey
    }));
    if ((0, $9wGTI.fg)('content_early_connect_iframe_initialization')) {
        // Preload superbatch
        tasks.push((0, $kkLBe.prepareGuardExceptionTask)('Superbatch', ()=>(0, $821e100427ee88aa$export$ce64f7b5556cdb62)({
                preloadSuperBatchForSSR: true
            })));
        // Preload Connect web resources
        tasks.push((0, $kkLBe.prepareGuardExceptionTask)('Connect Web Resources', ()=>(0, $64996f4302e0f23b$export$51bf8f21dab6d404)()));
    }
    tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    if (isCompanyHub && userId) tasks.push((0, $3c8474b5b6cc7016$export$986e86a20e675444)({
        accountId: userId
    }));
    // Presence Avatar Visibility
    tasks.push((0, $853f14d41fe05930$export$fb43949e55e0c9d2)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }));
    // Space Overview's homepageId is needed for the content types header, but may not be in the URL
    // depending on which route was used.  skip preloading if it's not in the url because sequential calls block SSR
    if (!isCompanyHub && homepageId && (0, $9wGTI.fg)('confluence_frontend_object_header')) {
        tasks.push((0, $3e0r1.preloadContentTypesHeader)(homepageId, (0, $9wGTI.fg)('confluence_frontend_object_header')));
        // Standalone Restrictions button needs to have its data preloaded)
        tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(homepageId, false));
    }
    // Unified Share and Restrict Button
    if (!isCompanyHub && homepageId && (0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(homepageId));
    // Preload definition autohighlights
    if (homepageId && (0, $9wGTI.fg)('confluence_frontend_ssr_autohighlights')) tasks.push((0, $gKMkU.preloadAutohighlights)({
        contentId: homepageId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: 'page'
    }));
    // Preload media token for cover image
    if (homepageId && (0, $9wGTI.fg)('confluence_frontend_cover_image_ssr')) tasks.push((0, $1i2qc.preloadMediaToken)(homepageId));
    if (homepageId) tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: homepageId,
        location: (0, $eSLr0.ATL_GENERAL)
    }));
    //moved chained queries to the bottom to unblock other queries needed to preload & to combine the contentId query
    if (!isCompanyHub && !homepageId && ((0, $9wGTI.fg)('confluence_frontend_usd_ssr') || (0, $9wGTI.fg)('confluence_frontend_object_header'))) {
        const homepageIdPromise = $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey) || $fe22b38e04163065$var$loadHomepageId(spaceKey);
        await homepageIdPromise.then((contentId)=>{
            if ((0, $9wGTI.fg)('confluence_frontend_object_header')) {
                tasks.push((0, $3e0r1.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_object_header')));
                tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId ?? '', false));
            }
            if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId ?? ''));
            if (contentId) {
                // Preload web panel atl_general
                tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
                    contentId: contentId,
                    location: (0, $eSLr0.ATL_GENERAL)
                }));
                // Preload media token for cover image
                if ((0, $9wGTI.fg)('confluence_frontend_cover_image_ssr')) tasks.push((0, $1i2qc.preloadMediaToken)(contentId));
            }
        });
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
const $fe22b38e04163065$export$d1ef19b00f2c3147 = ()=>{
    $fe22b38e04163065$var$homepageIdMap.clear();
    $fe22b38e04163065$var$homepageIdPromiseMap.clear();
};



var $7A94k = parcelRequire("7A94k");




var $3e0r1 = parcelRequire("3e0r1");

var $3Tnjq = parcelRequire("3Tnjq");

var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");



var $9wGTI = parcelRequire("9wGTI");

var $c3dSY = parcelRequire("c3dSY");

var $aVmIf = parcelRequire("aVmIf");

var $d2LG0 = parcelRequire("d2LG0");
const $4706763577468788$export$b7b653968af0ab1f = (0, $d2LG0.default)`query ContentIdByReferenceIdQueryWhiteboards($id:String!){contentIdByReferenceId(referenceId:$id)}`;


async function $7ba44aaf109d7b00$export$69c63edd0aeaee0b({ spaceKey: spaceKey, contentId: contentId }) {
    const preloadPromises = [
        $7ba44aaf109d7b00$var$preloadContentData(contentId, spaceKey),
        $7ba44aaf109d7b00$var$preloadSpace(spaceKey)
    ];
    return (0, $lyWac.waitForAllReturnWhenError)(preloadPromises);
}
async function $7ba44aaf109d7b00$var$preloadContentData(contentId, spaceKey) {
    const UUIDRegex = /[-]/;
    const isUuidBasedId = UUIDRegex.test(contentId);
    if (isUuidBasedId) await (0, $dYU3e.query)({
        query: (0, $4706763577468788$export$b7b653968af0ab1f),
        variables: {
            id: contentId
        }
    });
    else await (0, $dYU3e.query)({
        query: (0, $c3dSY.WhiteboardUnifiedQuery),
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            // The DSP query doesn't currently user the content version value, so using a fixed value
            contentVersion: 1,
            enableBulkImportProperties: (0, $9wGTI.fg)('cc_importer_axp_enable_fe_bulk_import_properties'),
            enableLastModifiedDate: (0, $9wGTI.fg)('cc_importer_enable_last_modified_whiteboards')
        }
    });
}
async function $7ba44aaf109d7b00$var$preloadSpace(spaceKey) {
    await (0, $dYU3e.query)({
        query: (0, $aVmIf.SpaceQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
}



var $gDMf3 = parcelRequire("gDMf3");

var $jLfE2 = parcelRequire("jLfE2");
var $lyWac = parcelRequire("lyWac");

var $9wGTI = parcelRequire("9wGTI");
const $d639d659544153c3$export$a107836a8bcfc0c9 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = await (0, $jLfE2.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    // Content types header (object header)
    if ((0, $9wGTI.fg)('confluence_frontend_object_header')) {
        tasks.push((0, $3e0r1.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_object_header')));
        // Standalone Restrictions button needs to have its data preloaded)
        tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
    }
    // Unified Share and Restrict Button
    if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    tasks.push((0, $7ba44aaf109d7b00$export$69c63edd0aeaee0b)({
        spaceKey: spaceKey,
        contentId: contentId
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};



var $3e0r1 = parcelRequire("3e0r1");

var $7A94k = parcelRequire("7A94k");




var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");



var $2iJnA = parcelRequire("2iJnA");
async function $6ac7363a4b3b3fec$export$de0a909710c86263(spaceKey, contentId) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        $6ac7363a4b3b3fec$var$preloadContentData(contentId, spaceKey),
        $6ac7363a4b3b3fec$var$preloadContentTree(contentId, spaceKey)
    ]);
}
async function $6ac7363a4b3b3fec$var$preloadContentData(contentId, spaceKey) {
    await (0, $dYU3e.query)({
        query: (0, $2iJnA.DatabaseUnifiedQuery),
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            // The DSP query doesn't currently user the content version value, so using a fixed value
            contentVersion: 1
        }
    });
}
async function $6ac7363a4b3b3fec$var$preloadContentTree(contentId, spaceKey) {}



var $jLfE2 = parcelRequire("jLfE2");
var $lyWac = parcelRequire("lyWac");

var $9wGTI = parcelRequire("9wGTI");

var $gDMf3 = parcelRequire("gDMf3");
const $f7a595baa9e6d446$export$f9f9f93ef86bfae1 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = await (0, $jLfE2.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    if ((0, $9wGTI.fg)('confluence_frontend_object_header')) tasks.push((0, $3e0r1.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_object_header')));
    // Unified Share and Restrict Button
    if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    tasks.push((0, $6ac7363a4b3b3fec$export$de0a909710c86263)(spaceKey, contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};



var $7A94k = parcelRequire("7A94k");

var $3e0r1 = parcelRequire("3e0r1");




var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");



var $ahDyi = parcelRequire("ahDyi");
async function $457aeee54b862c4a$export$b1c9c77d4871a337(spaceKey, contentId) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        $457aeee54b862c4a$var$preloadContentData(contentId, spaceKey),
        $457aeee54b862c4a$var$preloadContentTree(contentId, spaceKey)
    ]);
}
async function $457aeee54b862c4a$var$preloadContentData(contentId, spaceKey) {
    await (0, $dYU3e.query)({
        query: (0, $ahDyi.EmbedUnifiedQuery),
        variables: {
            contentId: contentId,
            spaceKey: spaceKey
        }
    });
}
async function $457aeee54b862c4a$var$preloadContentTree(contentId, spaceKey) {}





var $gDMf3 = parcelRequire("gDMf3");

var $jLfE2 = parcelRequire("jLfE2");
var $lyWac = parcelRequire("lyWac");

var $9wGTI = parcelRequire("9wGTI");
const $a17ca091e4cf9f3d$export$18e29f32c47bffc9 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = await (0, $jLfE2.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    // Content types header (object header)
    if ((0, $9wGTI.fg)('confluence_frontend_object_header')) tasks.push((0, $3e0r1.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_object_header')));
    // Unified Share and Restrict Button
    if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    tasks.push((0, $457aeee54b862c4a$export$b1c9c77d4871a337)(spaceKey, contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};



var $cvj7x = parcelRequire("cvj7x");

var $fywGr = parcelRequire("fywGr");

var $5SzHz = parcelRequire("5SzHz");

var $jLfE2 = parcelRequire("jLfE2");
var $lyWac = parcelRequire("lyWac");

var $8R0gj = parcelRequire("8R0gj");

var $gvxhu = parcelRequire("gvxhu");

var $5oHEP = parcelRequire("5oHEP");
var $2GGOW = parcelRequire("2GGOW");
var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $9wGTI = parcelRequire("9wGTI");


var $9ycGg = parcelRequire("9ycGg");



var $72lVk = parcelRequire("72lVk");

var $80xNa = parcelRequire("80xNa");
function $7f1954fc7a2cd99f$export$c628356b573f8241({ isUnpublishedDraft: isUnpublishedDraft, spaceKey: spaceKey, contentId: contentId }) {
    const queries = [];
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline') && (0, $9wGTI.fg)('cc_ssr_preload_header_data_for_edit_page')) {
        const handleExpectedErrors = (result)=>{
            const errorProcessor = window.__GRAPHQL_ERROR_PROCESSOR__;
            result?.errors?.forEach((error)=>{
                if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $5oHEP.isNotFoundError)(error)) errorProcessor?.markErrorAsHandled(error);
            });
            return result;
        };
        queries.push((0, $dYU3e.query)({
            query: (0, $72lVk.ContentHeaderUnifiedQuery),
            variables: {
                contentId: contentId,
                spaceKey: spaceKey,
                versionOverride: null,
                embeddedContentRender: null,
                limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                ...isUnpublishedDraft && {
                    status: [
                        'draft'
                    ]
                }
            }
        }).then(handleExpectedErrors));
        if ((0, $9wGTI.fg)('confluence_ssr_reactions_preload')) queries.push((0, $9ycGg.preloadPageReactions)(contentId));
    }
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}





var $3e0r1 = parcelRequire("3e0r1");



var $cm3dv = parcelRequire("cm3dv");

var $3Tnjq = parcelRequire("3Tnjq");


var $gDMf3 = parcelRequire("gDMf3");

var $9wGTI = parcelRequire("9wGTI");

var $eSLr0 = parcelRequire("eSLr0");

var $5Rwa0 = parcelRequire("5Rwa0");

var $7tT2b = parcelRequire("7tT2b");

var $2WwwU = parcelRequire("2WwwU");

var $d9tcB = parcelRequire("d9tcB");

var $7Ndnw = parcelRequire("7Ndnw");

var $8CHHT = parcelRequire("8CHHT");

var $1swiX = parcelRequire("1swiX");

var $kM8fE = parcelRequire("kM8fE");

const $32e736695aa13b8b$export$8abf4a07f4444858 = async (match, _url, isTransition = false)=>{
    const { userId: userId, isLicensed: isLicensed, cloudId: cloudId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, environment: environment } = await (0, $jLfE2.getPreloaderFnContext)();
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    const isBlog = Boolean((0, $kM8fE.matchEditBlog)(_url));
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const shouldPreloadMentionsProvider = Boolean(undefined);
    const isEmbeddedConfluence = (0, $1swiX.getIsEmbeddedConfluence)(match);
    const shouldPreloadNavigation = !isEmbeddedConfluence;
    tasks.push((0, $gvxhu.preloadBreadcrumbs)(spaceKey, contentId, false), (0, $cvj7x.preloadEditorData)({
        spaceKey: spaceKey,
        userId: userId,
        contentId: contentId,
        cloudId: cloudId,
        shouldPreloadMentionsProvider: shouldPreloadMentionsProvider,
        useCache: false,
        isBlog: isBlog
    }));
    // we dont know if a page is unpublished until we get data back. guess based on the draftShareId being in the url
    const guessIsUnpublishedDraft = Boolean(match?.query?.draftShareId);
    tasks.push((0, $7f1954fc7a2cd99f$export$c628356b573f8241)({
        isUnpublishedDraft: guessIsUnpublishedDraft,
        spaceKey: spaceKey,
        contentId: contentId
    }));
    if ((0, $9wGTI.fg)('platform_ssr_smartlinks_editor')) {
        const contentIdWithAri = `ari:cloud:confluence:${cloudId}:page/${contentId}`;
        tasks.push((0, $2WwwU.preloadContentSmartLinks)(contentIdWithAri, true));
    }
    if ((0, $9wGTI.fg)('confluence_frontend_object_header')) {
        tasks.push((0, $3e0r1.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_object_header')));
        // Standalone Restrictions button needs to have its data preloaded
        tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
    }
    // Unified Share and Restrict Button
    if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    if (spaceKey && (0, $9wGTI.fg)('confluence_preload_blank_page_quick_actions')) tasks.push((0, $cm3dv.preloadSuggestedTemplateQuery)({
        spaceKey: spaceKey
    }));
    if (isLicensed) tasks.push((0, $fywGr.preloadEditorOnboardingState)());
    if (isTransition) return (0, $lyWac.waitForAllReturnWhenError)(tasks);
    tasks.push((0, $8R0gj.preloadDraft)(contentId));
    tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    }));
    tasks.push((0, $c44bc7c35ccb995d$export$b39ebabf96e926c8)(contentId));
    // Preload Loom button in Action Bar
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && isLoggedIn) tasks.push((0, $7tT2b.preloadRecordLoomButton)({
        cloudId: cloudId,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn,
        userId: userId,
        environment: environment
    }));
    // Preload forge extension manifest
    if ((0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor')) tasks.push((0, $8CHHT.preloadUseExtensionList)({
        contentId: contentId,
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};



var $8R0gj = parcelRequire("8R0gj");
async function $73df6e46d3afaa7c$export$9c3872cc60e7dbce(match, _url) {
    const { contentId: contentId, draftShareId: draftShareId } = match.params;
    await (0, $8R0gj.preloadDraft)(contentId, draftShareId);
}



var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $c3Qwv = parcelRequire("c3Qwv");

var $dPxOK = parcelRequire("dPxOK");

var $f3nZa = parcelRequire("f3nZa");

var $86moY = parcelRequire("86moY");

var $7AO3u = parcelRequire("7AO3u");
const $61c2bc00711f31ff$export$e56b81ae74d866fc = ({ spaceKey: spaceKey, queryParams: queryParams, userId: userId, isLicensed: isLicensed, isLoggedIn: isLoggedIn, spaceId: spaceId = '', isWhiteboardEnabled: isWhiteboardEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false })=>{
    const pagesFilter = (0, $c3Qwv.getSingleParam)(queryParams, 'pagesFilter');
    const searchText = (0, $c3Qwv.getSingleParam)(queryParams, 'text') || '';
    const variables = {
        first: 24,
        maxNumberOfResults: 12,
        searchText: searchText,
        filters: {
            spaces: {
                spaceKeys: [
                    spaceKey
                ]
            },
            titleMatchOnly: {
                titleMatchOnly: true
            },
            ...pagesFilter === 'worked-on' && userId && isLicensed && {
                contributors: {
                    accountIds: [
                        userId
                    ]
                }
            },
            ...pagesFilter === 'starred' && isLicensed && {
                labels: [
                    {
                        namespace: 'MY',
                        name: 'favourite'
                    }
                ]
            },
            statuses: {
                statuses: [
                    (0, $7AO3u.ConfluenceSearchContentStatus).CURRENT,
                    (0, $7AO3u.ConfluenceSearchContentStatus).DRAFT
                ]
            }
        },
        sortBy: [
            {
                field: (0, $7AO3u.ConfluenceContentSortingParameter).LAST_MODIFIED_DATE,
                order: (0, $7AO3u.SortOrder).DESC
            }
        ],
        isLicensed: Boolean(isLicensed),
        includeRecommended: false,
        spaceId: spaceId,
        scopes: [
            (0, $7AO3u.ConfluenceContentSearchScope).PAGE,
            ...isWhiteboardEnabled ? [
                (0, $7AO3u.ConfluenceContentSearchScope).WHITEBOARD
            ] : [],
            ...isDatabaseEnabled ? [
                (0, $7AO3u.ConfluenceContentSearchScope).DATABASE
            ] : [],
            (0, $7AO3u.ConfluenceContentSearchScope).EMBED,
            (0, $7AO3u.ConfluenceContentSearchScope).FOLDER
        ]
    };
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $dPxOK.SpacePagesQuery),
            variables: variables
        }),
        ...!spaceId ? [
            (0, $dYU3e.query)({
                query: (0, $f3nZa.PagesSpaceIdQuery),
                variables: {
                    spaceKey: spaceKey
                }
            })
        ] : [],
        ...isLoggedIn ? [
            (0, $dYU3e.query)({
                query: (0, $86moY.SpacePagesPersistenceQuery),
                variables: {
                    spaceKey: spaceKey
                }
            })
        ] : []
    ]);
};



var $jLfE2 = parcelRequire("jLfE2");

var $yuLaV = parcelRequire("yuLaV");

var $d9tcB = parcelRequire("d9tcB");
const $106eac55bed5d4af$export$206b1c2d74bc11a2 = async (match)=>{
    const { userId: userId, isLoggedIn: isLoggedIn, accessStatus: accessStatus } = await (0, $jLfE2.getPreloaderFnContext)();
    const { spaceKey: spaceKey } = match.params;
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    return (0, $61c2bc00711f31ff$export$e56b81ae74d866fc)({
        spaceKey: spaceKey,
        queryParams: match.query,
        userId: userId,
        isLicensed: isLicensed,
        isLoggedIn: isLoggedIn,
        spaceId: '',
        isWhiteboardEnabled: isWhiteboardsEnabled,
        isDatabaseEnabled: isDatabasesEnabled
    });
};



var $lcQ5b = parcelRequire("lcQ5b");

var $3e0r1 = parcelRequire("3e0r1");

var $9wGTI = parcelRequire("9wGTI");

var $3Tnjq = parcelRequire("3Tnjq");

var $jLfE2 = parcelRequire("jLfE2");
var $lyWac = parcelRequire("lyWac");

const $0ef4e79dd69588ad$export$9f53340e87bacbbd = async (match)=>{
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    const preloadedSessionContext = await (0, $jLfE2.getPreloaderFnContext)();
    const { cloudId: cloudId } = preloadedSessionContext;
    // Since this query is not called in ContentPrerequisites when contentId is
    // missing, we should follow the same reasoning and skip preload when content is
    // missing.
    if (contentId) tasks.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey));
    if ((0, $9wGTI.fg)('confluence_frontend_object_header')) {
        tasks.push((0, $3e0r1.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_object_header')));
        // Standalone Restrictions button needs to have its data preloaded
        tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
    }
    // Presence Avatar Visibility
    tasks.push((0, $853f14d41fe05930$export$fb43949e55e0c9d2)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};



var $dYU3e = parcelRequire("dYU3e");
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $d60ad13a535d2a0b$export$62545e32f1a399cb = (0, $d2LG0.default)`query PersonalSpaceDetailQuery{user:confluence_atlassianUser(current:true){id confluence{space{id key dataClassificationTags}}}}`;


const $51133d1487ddd8f7$export$88da34a67bdae7e0 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $d60ad13a535d2a0b$export$62545e32f1a399cb)
    });
};



var $dYU3e = parcelRequire("dYU3e");

var $dBcar = parcelRequire("dBcar");

var $66UJS = parcelRequire("66UJS");
const $fedd9a86a97c3653$export$520ec834118606cc = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: Object.values({
                ...(0, $dBcar.ONBOARDING_INTENT_EXPERIENCES),
                ...(0, $dBcar.ONBOARDING_EXPERIENCES)
            })
        }
    });
};



var $dYU3e = parcelRequire("dYU3e");

var $8tdeJ = parcelRequire("8tdeJ");
const $94117ca0130c8194$export$1cf448b10191509a = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8tdeJ.GetLicensedProductsQuery)
    });
};



var $lyWac = parcelRequire("lyWac");
const $b8044be2d73de97b$export$67bd345805db186 = 'IntentBasedOnboardingQuery';
const $b8044be2d73de97b$export$609c06e14413a6a4 = ()=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $fedd9a86a97c3653$export$520ec834118606cc)(),
        (0, $94117ca0130c8194$export$1cf448b10191509a)()
    ]);
};



var $dYU3e = parcelRequire("dYU3e");

var $dBcar = parcelRequire("dBcar");

var $66UJS = parcelRequire("66UJS");
const $4a65d2e0fc1b9479$export$c74d8144128874bf = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: [
                ...Object.values((0, $dBcar.WHATS_NEW_IN_CONFLUENCE)),
                ...Object.values((0, $dBcar.MODERNIZE_CONFLUENCE_IPM_MODAL))
            ]
        }
    });
};



var $eS4vC = parcelRequire("eS4vC");
var $lyWac = parcelRequire("lyWac");

var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $5WLjq = parcelRequire("5WLjq");
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $f949b26e1eea859f$export$6567b01beefeacf2 = (0, $d2LG0.default)`query HomeLeftPanelAdministrationQuery{user:confluence_atlassianUser(current:true){id confluence{operations{operation targetType}}}isSiteAdmin}`;


const $91746eda3fd3599a$export$9671d08731c11b3b = ({ isLoggedIn: isLoggedIn, isLicensed: isLicensed })=>{
    // Spaces list and Administration section shown in the left navigation
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $5WLjq.preloadSpacesList)({
            isLicensed: isLicensed
        }),
        $91746eda3fd3599a$var$preloadLeftPanelAdministrationQuery({
            isLoggedIn: isLoggedIn
        })
    ]);
};
const $91746eda3fd3599a$var$preloadLeftPanelAdministrationQuery = ({ isLoggedIn: isLoggedIn })=>{
    const queryOptions = {
        query: (0, $f949b26e1eea859f$export$6567b01beefeacf2),
        skip: !isLoggedIn
    };
    return (0, $dYU3e.query)(queryOptions);
};



var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $6mKj3 = parcelRequire("6mKj3");

var $9wGTI = parcelRequire("9wGTI");

var $l6Wn6 = parcelRequire("l6Wn6");

var $iMMzj = parcelRequire("iMMzj");

var $gdJfm = parcelRequire("gdJfm");
const $f413d4da5ba15b92$export$77a2c40a93849218 = ({ isLoggedIn: isLoggedIn })=>{
    // If the user is not logged in we show the following feed by default
    // so only preload that feed. If the user is logged in preload both
    // feeds and the feed preference
    const tasks = [
        (0, $dYU3e.query)({
            query: (0, $l6Wn6.FeedContentQuery),
            variables: {
                first: (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'following_ssr', 5)
            }
        })
    ];
    if (isLoggedIn) tasks.push((0, $dYU3e.query)({
        query: (0, $gdJfm.FeedPopularFeedQuery),
        variables: {
            first: (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? 5 : (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'popular_ssr', 5)
        }
    }), (0, $dYU3e.query)({
        query: (0, $iMMzj.FeedTypeSelectorRefreshQuery)
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};



var $6mKj3 = parcelRequire("6mKj3");

var $dYU3e = parcelRequire("dYU3e");

var $7OD0G = parcelRequire("7OD0G");
function $d85b408e33b913ac$export$d97df32fa415897c({ isLicensed: isLicensed }) {
    if (!isLicensed) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $7OD0G.HomeWidgetsQuery)
    });
}


const $ef1b2e92c64fee29$export$3e66106e6cf0fa15 = ({ isLicensed: isLicensed })=>{
    return (0, $d85b408e33b913ac$export$d97df32fa415897c)({
        isLicensed: isLicensed
    });
};



var $7qrXq = parcelRequire("7qrXq");

var $1Qleo = parcelRequire("1Qleo");
const $e7135ce78dee924f$var$preloadRecentWork = (args)=>{
    const queryOptions = (0, $7qrXq.getRecentWorkQueryOptions)(args);
    if (queryOptions.skip) return Promise.resolve({});
    return (0, $dYU3e.query)(queryOptions);
};
const $e7135ce78dee924f$export$109541cc66c7e041 = ({ userId: userId, cloudId: cloudId, isLicensed: isLicensed, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false })=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        $e7135ce78dee924f$var$preloadRecentWork({
            cloudId: cloudId,
            isLoggedIn: !!userId,
            isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
            isDatabaseEnabled: isDatabaseEnabled,
            first: (0, $1Qleo.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH),
            isActivityV3MigrationEnabled: (0, $6mKj3.expVal)('confluence_activity_v3_collaborated_on_experiment', 'isEnabled', false)
        }),
        (0, $f413d4da5ba15b92$export$77a2c40a93849218)({
            isLoggedIn: !!userId
        }),
        (0, $ef1b2e92c64fee29$export$3e66106e6cf0fa15)({
            isLicensed: isLicensed
        })
    ]);
};



var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $dYU3e = parcelRequire("dYU3e");

var $iNq0h = parcelRequire("iNq0h");
const $e4b2bfbed97961bc$export$a8fc7c44e5aafa61 = ({ isLoggedIn: isLoggedIn })=>{
    if (!isLoggedIn) return Promise.resolve({});
    return (0, $dYU3e.query)({
        query: (0, $iNq0h.HomeViewsUserPreferencesQuery)
    });
};



var $k2RxH = parcelRequire("k2RxH");

var $dTFEh = parcelRequire("dTFEh");
const $914eb87cd194adde$export$daee90b6ccc653e0 = ({ cloudId: cloudId, isLoggedIn: isLoggedIn, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled, isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled })=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)((0, $k2RxH.getRecentQueryOptions)({
            pill: 'all',
            cloudId: cloudId,
            endCursor: '',
            isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
            isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled
        })),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        }),
        ...isLoggedIn ? [
            (0, $dYU3e.query)({
                query: (0, $dTFEh.HomeRecentUserPreferencesQuery)
            })
        ] : []
    ]);
};



var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");


var $h6oqk = parcelRequire("h6oqk");
const $82a332f3eb0b7b32$export$9151a9689f071b49 = ({ isLoggedIn: isLoggedIn })=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)((0, $h6oqk.getStarredQueryOptions)({})),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        })
    ]);
};



var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");


var $kgC8N = parcelRequire("kgC8N");
const $db48a3960bd53439$export$ef22b7398f0c0746 = ({ isLoggedIn: isLoggedIn })=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)((0, $kgC8N.getDraftsQueryOptions)({})),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        })
    ]);
};



var $01STT = parcelRequire("01STT");
const $f65ab46c8acdebd2$var$getSelectedView = (matchParams)=>{
    const view = matchParams?.view;
    return Object.values((0, $01STT.View)).includes(view) ? view : (0, $01STT.View).OVERVIEW;
};
const $f65ab46c8acdebd2$var$preloadSelectedView = ({ cloudId: cloudId, isLicensed: isLicensed, userId: userId, matchParams: matchParams, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false })=>{
    if (!cloudId) return Promise.resolve({});
    const isLoggedIn = Boolean(userId);
    const selectedView = $f65ab46c8acdebd2$var$getSelectedView(matchParams);
    switch(selectedView){
        case (0, $01STT.View).RECENT:
            return (0, $914eb87cd194adde$export$daee90b6ccc653e0)({
                cloudId: cloudId,
                isLoggedIn: isLoggedIn,
                isWhiteboardViewedEnabled: isWhiteboardViewedEnabled
            });
        case (0, $01STT.View).STARRED:
            return (0, $82a332f3eb0b7b32$export$9151a9689f071b49)({
                isLoggedIn: isLoggedIn
            });
        case (0, $01STT.View).DRAFTS:
            return (0, $db48a3960bd53439$export$ef22b7398f0c0746)({
                isLoggedIn: isLoggedIn
            });
        case (0, $01STT.View).OVERVIEW:
        default:
            return (0, $e7135ce78dee924f$export$109541cc66c7e041)({
                userId: userId,
                cloudId: cloudId,
                isLicensed: isLicensed,
                isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
                isDatabaseEnabled: isDatabaseEnabled
            });
    }
};
const $f65ab46c8acdebd2$export$ae91664215c56ac5 = (options)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $eS4vC.createDataFetcherForSuspense)('side-navigation', (0, $91746eda3fd3599a$export$9671d08731c11b3b)({
            isLoggedIn: Boolean(options.userId),
            isLicensed: options.isLicensed
        })),
        $f65ab46c8acdebd2$var$preloadSelectedView(options)
    ]);
};



var $dYU3e = parcelRequire("dYU3e");

var $d2LG0 = parcelRequire("d2LG0");

var $dBcar = parcelRequire("dBcar");
const $2530d274e9450bea$var$queryString = `
		query TemplatesCollectionEligibleQuery {
		onboardingState(
			key: ${JSON.stringify(Object.values({
    ...(0, $dBcar.TEMPLATES_COLLECTION),
    ...(0, $dBcar.ONBOARDING_EXPERIENCES)
}))}
		) {
			key
			value
		}
		confluence_tenantContext {
			licensedProducts {
				licenseStatus
				productKey
			}
		}
		user {
			id
			team
			confluence {
				hasPersonalSpace
				space {
					id
					key
				}
			}
		}
	}
`;
const $2530d274e9450bea$export$22168b2e6752c7f = (0, $d2LG0.default)($2530d274e9450bea$var$queryString);


const $d6c1da4e7cea115f$export$61d1d0b9775c631b = ()=>(0, $dYU3e.query)({
        query: (0, $2530d274e9450bea$export$22168b2e6752c7f)
    });



var $jLfE2 = parcelRequire("jLfE2");
var $lyWac = parcelRequire("lyWac");

var $MyxIQ = parcelRequire("MyxIQ");
const $3050fc659ed4bb43$export$4be2eb0104d640dc = async (preloadedSessionContext)=>{
    return (0, $MyxIQ.preloadPostOfficePlacementWithSessionContext)('confluence-home-banner', preloadedSessionContext);
};





var $bFNdd = parcelRequire("bFNdd");

var $d9tcB = parcelRequire("d9tcB");

var $yuLaV = parcelRequire("yuLaV");

var $6mKj3 = parcelRequire("6mKj3");

var $9wGTI = parcelRequire("9wGTI");

var $9WAeG = parcelRequire("9WAeG");
const $179951d621935e1e$export$cefc517f3ae2aa98 = async (match)=>{
    const preloadedSessionContext = await (0, $jLfE2.getPreloaderFnContext)();
    const { userId: userId, cloudId: cloudId, accessStatus: accessStatus } = preloadedSessionContext;
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const tasks = [];
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const canAccessHome = accessStatus !== 'ANONYMOUS_ACCESS' && accessStatus !== 'UNLICENSED_AUTHENTICATED_ACCESS';
    if (isLicensed && canAccessHome) tasks.push((0, $f65ab46c8acdebd2$export$ae91664215c56ac5)({
        cloudId: cloudId,
        isLicensed: isLicensed,
        userId: userId,
        matchParams: match.params,
        isWhiteboardViewedEnabled: isWhiteboardsEnabled,
        isDatabaseEnabled: isDatabasesEnabled
    }));
    tasks.push((0, $51133d1487ddd8f7$export$88da34a67bdae7e0)());
    if (userId) tasks.push((0, $b8044be2d73de97b$export$609c06e14413a6a4)(), (0, $d6c1da4e7cea115f$export$61d1d0b9775c631b)(), (0, $4a65d2e0fc1b9479$export$c74d8144128874bf)());
    const isLocaleEligible = (0, $9wGTI.fg)('post-office_confluence-home-banner-v2-locale-check') ? preloadedSessionContext.locale.toLowerCase().startsWith('en') : true;
    if (userId && // Manually check locale in code, instead of using Statsig, because CCFE does not have locale populated with value during FG initialization yet.
    isLocaleEligible && // suppress exposure because if feed is empty, users do not see the banner even if they are initially assigned to be in Variation
    (0, $6mKj3.expValEqualsNoExposure)('post_office_confluence_home_banner_experiment_-_v2', 'cohort', 'variation')) {
        // Confluence Home Banner in SSR
        const preloadPostOfficeHomeBanner = async ()=>{
            return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/postOffice:ConfluenceHomeBanner', async ()=>{
                return (0, $3050fc659ed4bb43$export$4be2eb0104d640dc)(preloadedSessionContext);
            });
        };
        tasks.push(preloadPostOfficeHomeBanner());
    }
    if ((0, $9wGTI.fg)('po-connie-side-nav-ssr-shadow')) tasks.push((0, $bFNdd.preloadPostOfficeConfluenceSideNav)(preloadedSessionContext));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};



var $jLfE2 = parcelRequire("jLfE2");

var $dYU3e = parcelRequire("dYU3e");

var $h7lOC = parcelRequire("h7lOC");
const $dfe1021c2b61fce7$export$446ff95ac31f413e = 'AdminAnnouncementBannerQuery';
const $dfe1021c2b61fce7$export$eec5c6a2cd111615 = ()=>(0, $dYU3e.query)({
        query: (0, $h7lOC.AdminAnnouncementBannerQuery)
    });



var $dYU3e = parcelRequire("dYU3e");
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $9da8bf16e8e9b3d1$export$7612bace2450507d = (0, $d2LG0.default)`query GetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed isStorageEnforcementGracePeriodComplete gracePeriodEndDate}}`;


const $b5b554d7930e19fd$export$91ccde13a31d1982 = ()=>(0, $dYU3e.query)({
        query: (0, $9da8bf16e8e9b3d1$export$7612bace2450507d)
    });


const $5368439faec350a5$export$6c7e4784651f052f = async ()=>{
    const { edition: edition } = await (0, $jLfE2.getPreloaderFnContext)();
    const upperCaseEdition = edition?.toUpperCase() || '';
    if (upperCaseEdition === 'PREMIUM' || upperCaseEdition === 'STANDARD') return (0, $dfe1021c2b61fce7$export$eec5c6a2cd111615)();
    else if (upperCaseEdition === 'FREE') return (0, $b5b554d7930e19fd$export$91ccde13a31d1982)();
};



var $gwFzn = parcelRequire("gwFzn");

var $9QvUi = parcelRequire("9QvUi");

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $c6GJD = parcelRequire("c6GJD");

var $gwFzn = parcelRequire("gwFzn");

var $5SWCd = parcelRequire("5SWCd");

var $PAiZW = parcelRequire("PAiZW");

var $6yHRM = parcelRequire("6yHRM");
const $f1742253be8873a8$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};


const $1f89a5665998c680$export$daf66a67c26dc848 = (config)=>{
    const scopeNames = $1f89a5665998c680$var$scopesNamesAsString(config.scopes);
    const matchScopes = (0, $gwFzn.useCallback)((input)=>$1f89a5665998c680$export$ec890b48cae4cc1c(config)(input), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        scopeNames
    ]);
    const [state, setState] = (0, $gwFzn.useState)($1f89a5665998c680$var$initialState);
    const route = (0, $6yHRM.usePostOfficeRoute)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const next = matchScopes({
        route: route,
        context: context
    });
    $1f89a5665998c680$var$usePostOfficeScopeSpy(state, config);
    (0, $gwFzn.useEffect)(()=>{
        if ($1f89a5665998c680$export$fcc046cb16c47539({
            next: next,
            state: state
        })) setState(({ current: current })=>({
                updateKey: Math.random().toString(36).substring(2),
                current: next,
                previous: current
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $1f89a5665998c680$var$scopesNamesAsString(next)
    ]);
    return state;
};
const $1f89a5665998c680$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
const $1f89a5665998c680$var$initialState = {
    updateKey: undefined,
    current: [],
    previous: []
};
const $1f89a5665998c680$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
        const contextMatch = route ? 'pathname' in route ? {
            route: route,
            context: context
        } : route.current ? {
            route: $1f89a5665998c680$var$extractRelevantUrlFields(route.current),
            context: context
        } : {
            route: undefined,
            context: context
        } : {
            route: undefined,
            context: context
        };
        const inputMatch = input.when;
        return $1f89a5665998c680$export$5c1cef6f5f213829({
            contextMatch: contextMatch,
            inputMatch: inputMatch
        });
    };
const $1f89a5665998c680$var$extractRelevantUrlFields = (route)=>{
    const { hostname: hostname, pathname: pathname } = new URL(route);
    return {
        hostname: hostname,
        pathname: pathname
    };
};
const $1f89a5665998c680$export$5c1cef6f5f213829 = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, (/*@__PURE__*/$parcel$interopDefault($5SWCd)))(contextMatch, inputMatch, (contextValue, inputValue)=>$1f89a5665998c680$var$isValueMatchDeep({
            contextValue: contextValue,
            inputValue: inputValue
        }));
const $1f89a5665998c680$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
    if (!contextValue || !inputValue) return false;
    if (typeof inputValue === 'string') return contextValue === inputValue;
    if (inputValue?.equals) return contextValue === inputValue.equals;
    if (!inputValue?.matches) return false;
    if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
    return new RegExp(inputValue.matches).test(contextValue);
};
const $1f89a5665998c680$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $1f89a5665998c680$export$5c1cef6f5f213829({
        contextMatch: contextValue,
        inputMatch: inputValue
    }) : $1f89a5665998c680$var$isValueMatch({
        contextValue: contextValue,
        inputValue: inputValue
    });
const $1f89a5665998c680$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($1f89a5665998c680$var$createMatchScope(input)).map((scope)=>({
                name: scope.name
            }));
const $1f89a5665998c680$export$fcc046cb16c47539 = ({ next: next, state: state })=>{
    const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
    const nextSet = Array.from(new Set(next.map((e)=>e.name)));
    if (nextSet.length !== currentSet.length) return true;
    return !nextSet.every((e)=>currentSet.includes(e));
};
// Scope Spy
const $1f89a5665998c680$var$usePostOfficeScopeSpy = (state, config)=>{
    if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
        const [listen, update] = (0, $f1742253be8873a8$export$92469b55607f005b)();
        window.postOffice = {
            ...window.postOffice,
            scopes: {
                [config?.consoleSpy.name]: {
                    listen: listen,
                    update: update,
                    list: config.scopes
                }
            }
        };
    }
    (0, $gwFzn.useEffect)(()=>{
        if (!config?.consoleSpy) return;
        if (!window.postOffice?.scopes) return;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $1f89a5665998c680$var$scopesNamesAsString(state.current)
    ]);
};


var $cpPWT = parcelRequire("cpPWT");

var $7XIdu = parcelRequire("7XIdu");

var $2mPpz = parcelRequire("2mPpz");
var $cyz5M = parcelRequire("cyz5M");
var $6Ht9d = parcelRequire("6Ht9d");

var $j0Fou = parcelRequire("j0Fou");
const $6dedf2638d31103b$export$54a06e3f4a159ad8 = [
    {
        name: 'all',
        when: {
            route: {
                pathname: {
                    matches: '.*'
                }
            }
        }
    },
    {
        name: 'admin/all',
        when: {
            context: {
                product: 'admin'
            }
        }
    },
    {
        name: 'admin/products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'products'
                }
            }
        }
    },
    {
        name: 'admin/discovered-products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'discovered-products'
                }
            }
        }
    },
    {
        name: 'admin/domains',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'domains'
                }
            }
        }
    },
    {
        name: 'admin/user-access-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-access-settings'
                }
            }
        }
    },
    {
        name: 'admin/authentication-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'authentication-policies'
                }
            }
        }
    },
    {
        name: 'admin/users',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'users'
                }
            }
        }
    },
    {
        name: 'admin/audit-log',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'audit-log'
                }
            }
        }
    },
    {
        name: 'admin/billing-preview',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'billing-preview'
                }
            }
        }
    },
    {
        name: 'admin/data-security-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'data-security-policies'
                }
            }
        }
    },
    {
        name: 'jira/all',
        when: {
            context: {
                product: 'jira'
            }
        }
    },
    {
        name: 'jira/kanban',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'board'
                }
            }
        }
    },
    {
        name: 'confluence/all',
        when: {
            context: {
                product: 'confluence'
            }
        }
    },
    {
        name: 'confluence/wiki-home',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/home'
                }
            }
        }
    },
    {
        name: 'confluence/pages-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/pages/(?!edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'confluence/blogs-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/blog/(?!edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'pop3/all',
        when: {
            context: {
                product: 'pop3'
            }
        }
    },
    {
        name: 'pop3/send-it',
        when: {
            context: {
                product: 'pop3'
            },
            route: {
                pathname: {
                    matches: 'send-it'
                }
            }
        }
    },
    {
        name: 'trello/all',
        when: {
            context: {
                product: 'trello'
            }
        }
    },
    {
        name: 'jira/queue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'queue'
                }
            }
        }
    },
    {
        name: 'jira/browse',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse'
                }
            }
        }
    },
    {
        name: 'jira/issues',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'issues'
                }
            }
        }
    },
    {
        name: 'jira/software',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software'
                }
            }
        }
    },
    {
        name: 'jira/polaris',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/polaris'
                }
            }
        }
    },
    {
        name: 'jira/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'backlog'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk'
                }
            }
        }
    },
    {
        name: 'jira/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*(?=.*project)(?=.*setting).*'
                }
            }
        }
    },
    {
        name: 'jira/your-work',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'your-work'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/business/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/board'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/business/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list'
                }
            }
        }
    },
    {
        // Handles both CMP Software and Business
        name: 'jira/cmp/project-settings/people',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/people'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/access'
                }
            }
        }
    }
];


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $cyz5M = parcelRequire("cyz5M");
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");

var $0774be60745e96fa$export$2e2bcd8739ae039 = {
    'confluence-lovability-survey': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("LSv6P")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");





var $ca937ed6076f1963$export$2e2bcd8739ae039 = {
    'confluence-commented-on-page-nudge': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("4LIeq"))),
    'confluence-continue-reading-nudge': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3X6Hs"))),
    'confluence-inline-reactions-nudge': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hPi92"))),
    'confluence-mentioned-in-comment-nudge': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ibLA3"))),
    'confluence-mentioned-on-page-nudge': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("389Ps")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");

var $f1defad88f3ededc$export$2e2bcd8739ae039 = {
    'jira-access-page-contact-sales-nudge': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hh1xX")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");



var $cf53bc18bbf356e9$export$2e2bcd8739ae039 = {
    'jira-forms-conditional-fields-changeboarding': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1woFf"))),
    'jira-forms-public-forms-changeboarding': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("ldwIv"))),
    'jira-forms-public-forms-changeboarding-flag': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("d3ihR")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");

var $53fd973e0d2f480f$export$2e2bcd8739ae039 = {
    'marketing-screen-space-flag-contentful-usecase': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7IRes")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");

var $fda6a8631e4ef6c6$export$2e2bcd8739ae039 = {
    'mercury-edit-hierarchy-spotlight': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hxeLl")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");

var $39ad37f7bb22409d$export$2e2bcd8739ae039 = {
    'end-of-trial-extension': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bUpIE")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");

var $284371f7cedb00b6$export$2e2bcd8739ae039 = {
    'jira-messaging-research-recruitment': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("1rd6h")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");

var $d18ed3e4124c4bae$export$2e2bcd8739ae039 = {
    'message-template-template': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("juVX6")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");



var $4789487cd8e09fd4$export$2e2bcd8739ae039 = {
    'test-message-inapp': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("8rflh"))),
    'test-message-inapp-implicit-pendo': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dh19o"))),
    'test-message-tap-ingestion-trigger-subscription': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("cv9ia")))
};


const $90021a5e9b56864d$export$e30378e28ad3e6ab = {
    ...(0, $0774be60745e96fa$export$2e2bcd8739ae039),
    ...(0, $ca937ed6076f1963$export$2e2bcd8739ae039),
    ...(0, $f1defad88f3ededc$export$2e2bcd8739ae039),
    ...(0, $cf53bc18bbf356e9$export$2e2bcd8739ae039),
    ...(0, $53fd973e0d2f480f$export$2e2bcd8739ae039),
    ...(0, $fda6a8631e4ef6c6$export$2e2bcd8739ae039),
    ...(0, $39ad37f7bb22409d$export$2e2bcd8739ae039),
    ...(0, $284371f7cedb00b6$export$2e2bcd8739ae039),
    ...(0, $d18ed3e4124c4bae$export$2e2bcd8739ae039),
    ...(0, $4789487cd8e09fd4$export$2e2bcd8739ae039)
};
const { initializeMessageRenderer: $90021a5e9b56864d$export$bce4e5106d86e473, MessageRenderer: $90021a5e9b56864d$export$2df1250b8f917a59 } = (0, $cyz5M.asMessageRenderer)($90021a5e9b56864d$export$e30378e28ad3e6ab);


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $23990983e3348fe0$export$a5cfae247d8360ef = 'screen-space-flags';


/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $jQRRW = parcelRequire("jQRRW");
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $3DZgu = parcelRequire("3DZgu");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $223bc95bfcc0f29f$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $223bc95bfcc0f29f$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("6y7aV")));
        case 'da':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("iuRsy")));
        case 'de':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("ilGcp")));
        case 'en-GB':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("aytiN")));
        case 'en-US':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("iDf56")));
        case 'en-XA':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("dX7bz")));
        case 'en-XB':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("a4jvV")));
        case 'en-ZZ':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("4AUtH")));
        case 'en':
            return $223bc95bfcc0f29f$var$importHelper(await Promise.resolve((parcelRequire("3DZgu"))));
        case 'es':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("QfAjK")));
        case 'et':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("2TSO1")));
        case 'fi':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("5X1yU")));
        case 'fr':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("b4a4o")));
        case 'hu':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("bdFY5")));
        case 'it':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("koqHb")));
        case 'ja':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("9cFEs")));
        case 'ko':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("66Uoo")));
        case 'nb':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("8SgN2")));
        case 'nl':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("hVolH")));
        case 'pl':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("j8YNs")));
        case 'pt-BR':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("ismoR")));
        case 'ro':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("eXsNg")));
        case 'ru':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("kEGya")));
        case 'sv':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("knmab")));
        case 'th':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("7VXGD")));
        case 'tr':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("fkdvI")));
        case 'uk':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("ekIdk")));
        case 'vi':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("jXV6x")));
        case 'zh-CN':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("kYtBN")));
        case 'zh-TW':
            return $223bc95bfcc0f29f$var$importHelper(await (parcelRequire("csosQ")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($3DZgu));
    }
};



var $8SCD0 = parcelRequire("8SCD0");
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8eaIp = parcelRequire("8eaIp");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e7828c42cee8f105$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $e7828c42cee8f105$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("9nrLF")));
        case 'da':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("072qY")));
        case 'de':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("f8DOr")));
        case 'en-GB':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("4JINB")));
        case 'en-US':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("hP2es")));
        case 'en-XA':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("b9d2B")));
        case 'en-XB':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("lPPqW")));
        case 'en-ZZ':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("2Jy3v")));
        case 'en':
            return $e7828c42cee8f105$var$importHelper(await Promise.resolve((parcelRequire("8eaIp"))));
        case 'es':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("3GNuy")));
        case 'et':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("iFq2c")));
        case 'fi':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("eqrdf")));
        case 'fr':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("4Z2v5")));
        case 'hu':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("5OCmX")));
        case 'it':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("30V0g")));
        case 'ja':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("6QQ5t")));
        case 'ko':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("l24m6")));
        case 'nb':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("D4XYM")));
        case 'nl':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("lJ8yA")));
        case 'pl':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("fMF98")));
        case 'pt-BR':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("9froW")));
        case 'ro':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("baIoP")));
        case 'ru':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("deOSs")));
        case 'sv':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("eN7sM")));
        case 'th':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("kClRv")));
        case 'tr':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("kvyHO")));
        case 'uk':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("kOupr")));
        case 'vi':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("9Bx7u")));
        case 'zh-CN':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("2ysIi")));
        case 'zh-TW':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("9hBAJ")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8eaIp));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8tEET = parcelRequire("8tEET");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $97f5f84bf86ebe81$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $97f5f84bf86ebe81$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("9takY")));
        case 'da':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("7T2Ab")));
        case 'de':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("gx3gE")));
        case 'en-GB':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("3A5UP")));
        case 'en-US':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("5OZh8")));
        case 'en-XA':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("6o3f7")));
        case 'en-XB':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("020UP")));
        case 'en-ZZ':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("igBdr")));
        case 'en':
            return $97f5f84bf86ebe81$var$importHelper(await Promise.resolve((parcelRequire("8tEET"))));
        case 'es':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("4vr7a")));
        case 'et':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("jpJlx")));
        case 'fi':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("4wfWo")));
        case 'fr':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("lEfnE")));
        case 'hu':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("cD0rk")));
        case 'it':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("Ieb9P")));
        case 'ja':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("fGwXg")));
        case 'ko':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("99YE3")));
        case 'nb':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("1dxyE")));
        case 'nl':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("avyvI")));
        case 'pl':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("c82Ts")));
        case 'pt-BR':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("aVBSY")));
        case 'ro':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("k6kUh")));
        case 'ru':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("9qv27")));
        case 'sv':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("16MXq")));
        case 'th':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("juoyx")));
        case 'tr':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("dtGrc")));
        case 'uk':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("9nD6W")));
        case 'vi':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("jY3FI")));
        case 'zh-CN':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("i4sMa")));
        case 'zh-TW':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("04jS0")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8tEET));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8nApX = parcelRequire("8nApX");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb8ac3a3a164780d$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $bb8ac3a3a164780d$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("1twF8")));
        case 'da':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("h4zXj")));
        case 'de':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("BA2fD")));
        case 'en-GB':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("bCcp4")));
        case 'en-US':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("1nSTE")));
        case 'en-XA':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("Rymcn")));
        case 'en-XB':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("8CPhn")));
        case 'en-ZZ':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("k9OBz")));
        case 'en':
            return $bb8ac3a3a164780d$var$importHelper(await Promise.resolve((parcelRequire("8nApX"))));
        case 'es':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("lLPqK")));
        case 'et':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("6naQl")));
        case 'fi':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("hPwRb")));
        case 'fr':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("ftDmR")));
        case 'hu':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("5hkBs")));
        case 'it':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("jKwev")));
        case 'ja':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("hEy5s")));
        case 'ko':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("5gaXr")));
        case 'nb':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("38gmN")));
        case 'nl':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("6idDu")));
        case 'pl':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("lnfmB")));
        case 'pt-BR':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("4CcQP")));
        case 'ro':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("hf4xR")));
        case 'ru':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("4S5lb")));
        case 'sv':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("1sJnj")));
        case 'th':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("14RMm")));
        case 'tr':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("hlEdv")));
        case 'uk':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("2P62U")));
        case 'vi':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("cBK9i")));
        case 'zh-CN':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("8BN7t")));
        case 'zh-TW':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("66oq1")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8nApX));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kHXyL = parcelRequire("kHXyL");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9580f92347c74f32$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $9580f92347c74f32$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("cZyB2")));
        case 'da':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("1ltui")));
        case 'de':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("l8ET7")));
        case 'en-GB':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("jICO9")));
        case 'en-US':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("6C4fP")));
        case 'en-XA':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("l8ufW")));
        case 'en-XB':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("kQMWC")));
        case 'en-ZZ':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("iOZ24")));
        case 'en':
            return $9580f92347c74f32$var$importHelper(await Promise.resolve((parcelRequire("kHXyL"))));
        case 'es':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("f71EB")));
        case 'et':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("d02qk")));
        case 'fi':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("7bAQx")));
        case 'fr':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("g7Hoq")));
        case 'hu':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("50xXm")));
        case 'it':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("4VEmY")));
        case 'ja':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("agzpj")));
        case 'ko':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("bgCiS")));
        case 'nb':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("a5lac")));
        case 'nl':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("gRJCD")));
        case 'pl':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("kbZao")));
        case 'pt-BR':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("giBKD")));
        case 'ro':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("kUbBO")));
        case 'ru':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("k0YJR")));
        case 'sv':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("cbXCv")));
        case 'th':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("hu14P")));
        case 'tr':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("2QkKc")));
        case 'uk':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("duNYv")));
        case 'vi':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("27bNl")));
        case 'zh-CN':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("jtwm0")));
        case 'zh-TW':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("5PGrx")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kHXyL));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jeVa2 = parcelRequire("jeVa2");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1cfeadb092a11e96$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $1cfeadb092a11e96$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("f2p2B")));
        case 'da':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("ht46J")));
        case 'de':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("69h1H")));
        case 'en-GB':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("kuzQN")));
        case 'en-US':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("cVInB")));
        case 'en-XA':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("gUWuQ")));
        case 'en-XB':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("lcJMw")));
        case 'en-ZZ':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("dzgQz")));
        case 'en':
            return $1cfeadb092a11e96$var$importHelper(await Promise.resolve((parcelRequire("jeVa2"))));
        case 'es':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("jYtJC")));
        case 'et':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("4UFaq")));
        case 'fi':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("h9L2A")));
        case 'fr':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("6TMXE")));
        case 'hu':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("aPvxU")));
        case 'it':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("dh1Oe")));
        case 'ja':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("ebbqp")));
        case 'ko':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("5rgEX")));
        case 'nb':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("3aChI")));
        case 'nl':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("9Xt6M")));
        case 'pl':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("GLe4m")));
        case 'pt-BR':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("lD1OE")));
        case 'ro':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("a3k8w")));
        case 'ru':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("fg2Qv")));
        case 'sv':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("5xGAj")));
        case 'th':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("h8OJ6")));
        case 'tr':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("2VF7p")));
        case 'uk':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("8NZtL")));
        case 'vi':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("brGsg")));
        case 'zh-CN':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("9zB1f")));
        case 'zh-TW':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("5mCru")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jeVa2));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kMgxO = parcelRequire("kMgxO");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $193ea6a661b759dc$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $193ea6a661b759dc$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("7WTpk")));
        case 'da':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("9dooa")));
        case 'de':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("ij9bL")));
        case 'en-GB':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("jcTLd")));
        case 'en-US':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("obvEU")));
        case 'en-XA':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("8tL0f")));
        case 'en-XB':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("3BUd1")));
        case 'en-ZZ':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("flNwZ")));
        case 'en':
            return $193ea6a661b759dc$var$importHelper(await Promise.resolve((parcelRequire("kMgxO"))));
        case 'es':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("1l4zu")));
        case 'et':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("hlZ1E")));
        case 'fi':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("2IBih")));
        case 'fr':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("iLrRt")));
        case 'hu':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("268pL")));
        case 'it':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("lKhlb")));
        case 'ja':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("cSKrP")));
        case 'ko':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("djV8I")));
        case 'nb':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("adlpo")));
        case 'nl':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("5MMtL")));
        case 'pl':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("do7sW")));
        case 'pt-BR':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("iJkP1")));
        case 'ro':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("EwpC0")));
        case 'ru':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("1wmKm")));
        case 'sv':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("apoy6")));
        case 'th':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("124bV")));
        case 'tr':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("5h1r2")));
        case 'uk':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("h67tt")));
        case 'vi':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("lj2SK")));
        case 'zh-CN':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("7Fmf9")));
        case 'zh-TW':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("ilu75")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kMgxO));
    }
};



var $3nDO6 = parcelRequire("3nDO6");

var $kdvUL = parcelRequire("kdvUL");
const $15113d446a8ed41e$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $223bc95bfcc0f29f$export$720676d8cac8fbb)(locale),
        (0, $8SCD0.messagesLoader)(locale),
        (0, $e7828c42cee8f105$export$720676d8cac8fbb)(locale),
        (0, $97f5f84bf86ebe81$export$720676d8cac8fbb)(locale),
        (0, $bb8ac3a3a164780d$export$720676d8cac8fbb)(locale),
        (0, $9580f92347c74f32$export$720676d8cac8fbb)(locale),
        (0, $1cfeadb092a11e96$export$720676d8cac8fbb)(locale),
        (0, $193ea6a661b759dc$export$720676d8cac8fbb)(locale),
        (0, $3nDO6.messagesLoader)(locale),
        (0, $kdvUL.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $15113d446a8ed41e$export$b0eee5de066b2bf5 = (Component)=>{
    return (0, $jQRRW.withIntlProvider)({
        messagesLoader: $15113d446a8ed41e$export$d5a462ce7bd04520
    }, Component);
};


const $0381e4ebc4c9b908$export$c32237a999261c49 = (input)=>(0, $1f89a5665998c680$export$ec890b48cae4cc1c)({
        scopes: $6dedf2638d31103b$export$54a06e3f4a159ad8
    })(input);
const $0381e4ebc4c9b908$export$c60b43809441c5b0 = (0, $15113d446a8ed41e$export$b0eee5de066b2bf5)((0, $2mPpz.createPlacementComponent)((0, $23990983e3348fe0$export$a5cfae247d8360ef), /*#__PURE__*/ (0, $gwFzn.memo)(({ initialData: initialData, preloadedInitialData: preloadedInitialData, setPreloadedInitialData: setPreloadedInitialData, jiraFlagsService: jiraFlagsService, reportExpectedError: reportExpectedError, reportUnexpectedError: reportUnexpectedError })=>{
    const [localMessageState, setLocalMessageState] = (0, $gwFzn.useState)(()=>{
        if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? preloadedInitialData?.messages : undefined;
        return undefined;
    });
    (0, $6Ht9d.useInitialData)(initialData);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $cpPWT.useMessagePlacementHooks)();
    const handleDismiss = (0, $gwFzn.useCallback)(({ messageInstanceId: messageInstanceId })=>{
        setLocalMessageState((current)=>{
            if (current) {
                const newState = current.filter((e)=>e.messageInstanceId !== messageInstanceId);
                if (typeof setPreloadedInitialData === 'function') setPreloadedInitialData({
                    messages: newState
                });
                return newState;
            }
            return undefined;
        });
    }, [
        setPreloadedInitialData
    ]);
    const onDismissed = (0, $gwFzn.useCallback)(()=>{
        setLocalMessageState([]);
        if (typeof setPreloadedInitialData === 'function') setPreloadedInitialData({
            messages: []
        });
    }, [
        setPreloadedInitialData
    ]);
    (0, $gwFzn.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss
    ]);
    (0, $gwFzn.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked
    ]);
    (0, $gwFzn.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze
    ]);
    const activeScopes = (0, $1f89a5665998c680$export$daf66a67c26dc848)({
        scopes: $6dedf2638d31103b$export$54a06e3f4a159ad8
    });
    const messagesState = (0, $j0Fou.usePlacementApi)('/update-messages', {
        queryParams: {
            updateKey: activeScopes.updateKey ?? ''
        },
        requestOptions: {
            method: 'POST',
            body: JSON.stringify(activeScopes)
        },
        throttleTime: 100,
        autoRefetch: {
            isEnabled: !!activeScopes.updateKey && typeof localMessageState === 'undefined',
            updateKey: activeScopes.updateKey ?? ''
        }
    });
    (0, $gwFzn.useEffect)(()=>{
        if (messagesState?.data?.messages?.length) setLocalMessageState(messagesState.data.messages);
    }, [
        messagesState.data
    ]);
    return (0, $c6GJD.default).checkGate('post-office-screen-space-flags-shadow') ? /*#__PURE__*/ (0, $7UHDa.jsx)($0381e4ebc4c9b908$var$SuppressIfModalIsPresent, {
        children: localMessageState?.slice(0, 1).map(({ messageInstanceId: messageInstanceId, ...props })=>// Adding @ts-ingore to suppress the error in confluence typecheck and below error is not thrown in post-office typecheck
            // This error exists because confluence is using react 16 and post-office is using react 18
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - 'ReactNode | ReactElement<any, any>' is not a valid JSX element.
            /*#__PURE__*/ (0, $gwFzn.createElement)((0, $90021a5e9b56864d$export$2df1250b8f917a59), {
                ...props,
                key: messageInstanceId,
                id: messageInstanceId,
                messageInstanceId: messageInstanceId,
                onDismissed: onDismissed,
                SuspenseBoundary: (0, $cyz5M.MaybeSuspenseBoundary),
                jiraFlagsService: jiraFlagsService,
                onError: reportUnexpectedError,
                reportExpectedError: reportExpectedError
            }))
    }) : null;
}), {
    choreographer: {
        isDefaultEnabled: true
    }
}));
var $0381e4ebc4c9b908$export$2e2bcd8739ae039 = $0381e4ebc4c9b908$export$c60b43809441c5b0;
const $0381e4ebc4c9b908$var$SuppressIfModalIsPresent = ({ children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $gwFzn.useState)(true);
    const handleVisibilityChange = (0, $gwFzn.useCallback)((modalOnScreen)=>{
        const shouldShow = !modalOnScreen;
        if (!shouldShow) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'suppressed',
            actionSubject: 'screenSpaceFlags'
        });
        setIsVisible(shouldShow);
    }, [
        fireAnalyticsEvent
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const modalOnScreen = !!globalThis.document.querySelector('.atlaskit-portal-container .atlaskit-portal [role=dialog]');
        handleVisibilityChange(modalOnScreen);
    }, [
        handleVisibilityChange
    ]);
    return (0, $c6GJD.default).checkGate('post-office-screen-space-flags-modal-detector') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: isVisible && children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};



var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $9wGTI = parcelRequire("9wGTI");

var $bQm3c = parcelRequire("bQm3c");

var $7UHDa = parcelRequire("7UHDa");

var $6yHRM = parcelRequire("6yHRM");

var $7UHDa = parcelRequire("7UHDa");

var $kO3gu = parcelRequire("kO3gu");

var $gwFzn = parcelRequire("gwFzn");
const $29f905239c235f73$export$e5ffd38dcf6e5c53 = `/gateway/api/post-office/api/v1/placements/`;
const $29f905239c235f73$export$85c4756977e87c75 = `/gateway/api/post-office/api/v1/placement-preview/`;
const $29f905239c235f73$export$52e362b70e115c68 = ({ returnOverride: returnOverride, eligibleMessages: eligibleMessages, children: children })=>{
    const fetch = (0, $gwFzn.useMemo)(()=>{
        if (returnOverride) return $29f905239c235f73$export$fb5156757134712c({
            returnOverride: returnOverride
        });
        return $29f905239c235f73$export$c05392ff95b4319d({
            eligibleMessages: eligibleMessages
        });
    }, [
        eligibleMessages,
        returnOverride
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kO3gu.PlacementFetchingProvider), {
        fetch: fetch,
        children: children
    });
};
const $29f905239c235f73$export$fb5156757134712c = ({ returnOverride: returnOverride })=>async ()=>{
        return new Response(JSON.stringify(returnOverride), {
            status: 200,
            statusText: 'ok'
        });
    };
const $29f905239c235f73$export$c05392ff95b4319d = ({ eligibleMessages: eligibleMessages })=>(url, options)=>{
        const finalUrl = url.replace($29f905239c235f73$export$e5ffd38dcf6e5c53, $29f905239c235f73$export$85c4756977e87c75);
        const payload = {
            originalMethod: options?.method || 'GET',
            originalBody: $29f905239c235f73$var$parseBody(options?.body),
            eligibleMessages: eligibleMessages
        };
        return globalThis.fetch(finalUrl, {
            ...options,
            method: 'POST',
            headers: {
                ...options?.headers || {}
            },
            body: $29f905239c235f73$var$stringifyPayload(payload)
        });
    };
const $29f905239c235f73$var$objectHasKeys = (input)=>!!Object.keys(input).length;
const $29f905239c235f73$var$parseBody = (body)=>{
    if (typeof body === 'undefined' || body === null) return undefined;
    try {
        const parsedBody = JSON.parse(body);
        if ($29f905239c235f73$var$objectHasKeys(parsedBody)) return parsedBody;
        throw new Error();
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};
const $29f905239c235f73$var$stringifyPayload = (payload)=>{
    try {
        return JSON.stringify(payload);
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};




var $gwFzn = parcelRequire("gwFzn");
'use client';
const $1443d28958eafd79$export$b16d9fb1a22de840 = (0, $gwFzn.createContext)(null);
const $1443d28958eafd79$var$initialState = {
    didCatch: false,
    error: null
};
class $1443d28958eafd79$export$e926676385687eaf extends (0, $gwFzn.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($1443d28958eafd79$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $1443d28958eafd79$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($1443d28958eafd79$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $gwFzn.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $gwFzn.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $gwFzn.createElement)($1443d28958eafd79$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $1443d28958eafd79$var$initialState;
    }
}
function $1443d28958eafd79$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $1443d28958eafd79$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $1443d28958eafd79$export$c052f6604b7d51fe() {
    const context = (0, $gwFzn.useContext)($1443d28958eafd79$export$b16d9fb1a22de840);
    $1443d28958eafd79$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $gwFzn.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $gwFzn.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $1443d28958eafd79$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $gwFzn.forwardRef)((props, ref)=>(0, $gwFzn.createElement)($1443d28958eafd79$export$e926676385687eaf, errorBoundaryProps, (0, $gwFzn.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}



var $9QvUi = parcelRequire("9QvUi");
const $95ecb474353a02ba$export$16e97e6603eadea = ({ PlacementComponent: PlacementComponent, placementId: placementId, eligibleMessages: eligibleMessages, errorFallback: errorFallback = null, onError: onError, returnOverride: returnOverride, disableInitialData: disableInitialData })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $1443d28958eafd79$export$e926676385687eaf), {
        fallback: errorFallback,
        onError: onError,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $29f905239c235f73$export$52e362b70e115c68), {
            eligibleMessages: eligibleMessages,
            returnOverride: returnOverride,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9QvUi.default), {
                PlacementComponent: PlacementComponent,
                placementId: placementId,
                disableInitialData: disableInitialData
            })
        })
    });
const $95ecb474353a02ba$export$46db7cd62b063064 = ({ isEnabled: isEnabled, children: children })=>{
    const { searchParams: searchParams } = (0, $6yHRM.usePostOfficeRoute)();
    const previewId = searchParams?.get('contentfulPreviewId');
    const hasPreviewType = Boolean(searchParams?.get('contentfulPreviewId'));
    const eligibleMessage = [
        {
            messageInstanceId: 'messageInstanceId',
            messageTemplateId: 'marketing-screen-space-flag-contentful-usecase',
            messageCategory: 'Engagement',
            context: {
                id: previewId
            },
            createdAt: new Date().toString(),
            eventTime: new Date().toString(),
            triggerId: 'triggerId',
            messageCreationType: 'explicit'
        }
    ];
    if (isEnabled && hasPreviewType) return /*#__PURE__*/ (0, $7UHDa.jsx)($95ecb474353a02ba$export$16e97e6603eadea, {
        placementId: "screen-space-flags",
        PlacementComponent: (0, $0381e4ebc4c9b908$export$c60b43809441c5b0),
        eligibleMessages: eligibleMessage
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};



var $9oJIg = parcelRequire("9oJIg");
var $MyxIQ = parcelRequire("MyxIQ");

var $MyxIQ = parcelRequire("MyxIQ");

var $0VKZa = parcelRequire("0VKZa");
const $ccd0dc06d2167081$export$f6564e60882bdf90 = /*#__PURE__*/ (0, $gwFzn.memo)(()=>{
    const [messageErrorToReport, setMessageErrorToReport] = (0, $gwFzn.useState)();
    const [preloadedInitialData, setPreloadedInitialData] = (0, $MyxIQ.usePlacementPreloadedData)('screen-space-flags/update-messages');
    const memoizedPlacementProps = (0, $gwFzn.useMemo)(()=>({
            reportExpectedError: (0, $7Sm4c.markErrorAsHandled),
            reportUnexpectedError: setMessageErrorToReport,
            preloadedInitialData: preloadedInitialData,
            setPreloadedInitialData: setPreloadedInitialData
        }), [
        preloadedInitialData,
        setPreloadedInitialData
    ]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    if ((0, $9wGTI.fg)('confluence-screen-space-overlay-no-anonymous-users')) {
        if (!userId) return null;
    }
    return (0, $9wGTI.fg)('post-office-screen-space-overlay-confluence') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $95ecb474353a02ba$export$46db7cd62b063064), {
        isEnabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9oJIg.PlacementFetchProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9QvUi.default), {
        placementId: "screen-space-flags",
        // @ts-ignore - Type 'ComponentType<ErrorBoundariedProps<Placement>>' is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $0381e4ebc4c9b908$export$c60b43809441c5b0),
        placementProps: memoizedPlacementProps,
        disableInitialData: true
    }), messageErrorToReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: messageErrorToReport
    }))) : null;
});
const $ccd0dc06d2167081$export$1966d6abb8c3b6 = async (preloadedSessionContext, match)=>{
    const activeScopes = (0, $0381e4ebc4c9b908$export$c32237a999261c49)({
        route: {
            hostname: '',
            pathname: match?.pathname ?? ''
        },
        context: (0, $0VKZa.sessionToPostOfficeContext)(preloadedSessionContext)
    });
    const updateMessagesBody = {
        current: activeScopes,
        previous: []
    };
    return (0, $MyxIQ.preloadPostOfficePlacementWithSessionContext)('screen-space-flags', preloadedSessionContext, {
        resource: '/update-messages',
        requestInit: {
            method: 'POST',
            body: JSON.stringify(updateMessagesBody)
        }
    });
};



var $9WAeG = parcelRequire("9WAeG");

var $jLfE2 = parcelRequire("jLfE2");
async function $f217a7781374a3c1$export$5ab53e93f975c926(match) {
    const preloadedSessionContext = await (0, $jLfE2.getPreloaderFnContext)();
    const { userId: userId } = preloadedSessionContext;
    if (!userId || !match) return;
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/postOffice:ScreenSpaceFlags', async ()=>{
        return (0, $ccd0dc06d2167081$export$1966d6abb8c3b6)(preloadedSessionContext, match);
    });
}


async function $e80763d537fd4542$export$6aefe8c2dfd7fe98(url) {
    const match = $e80763d537fd4542$var$matchRoute(url);
    if (match?.experience === (0, $irVI7.VIEW_PAGE_EXPERIENCE) || match?.experience === (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE) || match?.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE) || match?.experience === (0, $irVI7.LIVE_PAGE_VIEW_EXPERIENCE)) return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $9fLxI.getExtensionManifest)({
            spaceKey: match.params.spaceKey
        }),
        (0, $5SzHz.preloadSpaceDetail)(match.params.spaceKey),
        (0, $821e100427ee88aa$export$ce64f7b5556cdb62)(),
        (0, $88b2ba3b9422ec6a$export$3837c35a0d92ab93)()
    ]);
}
async function $e80763d537fd4542$export$57d895781a697848(url, isTransition = false, previousMatch = null, preloadOptions) {
    const commonTasks = [];
    const match = $e80763d537fd4542$var$matchRoute(url);
    if (match?.experience) (0, $6bQlH.setFallbackAtlExperience)(match.experience);
    /**
	 * There are synchronous operations in preparing session data.
	 * All queries that independent to session data should be fired first.
	 */ if (!isTransition) {
        commonTasks.push((0, $29df517881fdeca7$export$990c5eb6cb59ce1c)());
        if ((0, $9wGTI.fg)('confluence_browser_storage_controls')) commonTasks.push((0, $55fac8bf1a108c66$export$ece352750a2c4ea1)(), (0, $c841b55372d4071a$export$96f49c018063fe60)());
        if (match?.experience === (0, $irVI7.PDF_EXPORT_PAGE_EXPERIENCE)) // The PDF export route only renders a specific Confluence page's title and content.
        // So, we don't need to fetch data for certain common Confluence features and preferences such as navigation and user settings.
        // Note 1: PDF export is not a SSR capability and also need not support SPA transitions, as it is only accessible via direct URL.
        commonTasks.push(// SPA view context
        (0, $553b9603687aba42$export$dfb7e28de13124a4)(), // Remote local storage
        (0, $eiCiP.preloadLocalStorage)(), // Forge UI user profile
        (0, $969a3e14c27be3bd$export$9930aa21f1e6a4e3)());
        else if (match?.experience !== (0, $irVI7.EXTERNAL_SHARE_EXPERIENCE)) {
            // external share doesn't have navigation, preloadSPAViewContext returns only errors
            commonTasks.push((0, $553b9603687aba42$export$dfb7e28de13124a4)(), (0, $eiCiP.preloadLocalStorage)(), (0, $5368439faec350a5$export$6c7e4784651f052f)());
            if (//this will preload nav4 queries even when users are opted out. This is because
            //we do not have access to site settings, user Preferences, or local storage at this point in the preloading
            (0, $9wGTI.fg)('confluence_nav_4') || (0, $9wGTI.fg)('confluence_nav4_ga_phase_1') || (0, $9wGTI.fg)('confluence_nav4_ga_phase_2') || (0, $6mKj3.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false) || (0, $6mKj3.expVal)('confluence_nav_4_free', 'isEnabled', false)) {
                commonTasks.push((0, $c3ef336b2b86bed6$export$2d0f6d5aa0911699)());
                //new for nav4 queries
                commonTasks.push((0, $c63485f681d81d31$export$693b572d94b96722)());
                commonTasks.push((0, $a6a4fe9083f3db22$export$d46e9819bcc1eb51)());
                commonTasks.push((0, $34aa8f5c495a6ba2$export$3efc211209d16247)());
            } else commonTasks.push((0, $c3ef336b2b86bed6$export$2d0f6d5aa0911699)());
            if ((0, $6mKj3.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) {
                if ((0, $6mKj3.expValEqualsNoExposure)('platform_editor_controls_performance_fixes', 'isEnabled', true)) commonTasks.push((0, $da1fd1e44d7582fe$export$b4f1825d0b62630d)());
            }
            // https://switcheroo.atlassian.com/ui/gates/0d974cd3-c266-43ed-9312-0980df443012/key/post-office_screen-space-flags-confluence-ssr
            if ((0, $9wGTI.fg)('post-office_screen-space-flags-confluence-ssr')) commonTasks.push((0, $f217a7781374a3c1$export$5ab53e93f975c926)(match));
            commonTasks.push((0, $969a3e14c27be3bd$export$9930aa21f1e6a4e3)());
            const experience = match?.experience;
            commonTasks.push((0, $96ee7afaced2313e$export$e0e94d96f49a1aa)({
                themeState: [
                    (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE),
                    (0, $irVI7.VIEW_PAGE_EXPERIENCE)
                ].includes(experience) ? match?.query?.themeState : undefined
            }));
            if ((0, $9wGTI.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) commonTasks.push((0, $1f8e7f4831866dd9$export$f92adbce3a1ce419)());
        }
    }
    if (!match) // Following code are specific to each route.
    // If we don't get a match here then there is nothing interesting
    return Promise.resolve();
    let routeTasks = null;
    if (match.experience === (0, $irVI7.VIEW_PAGE_EXPERIENCE)) {
        const { isLivePage: isLivePageSSR } = (0, $60cDW.getSSRRenderInputs)();
        // On transition, validate whether we're a live doc. If so, only preload live doc routes, not all view page routes. Prevents unnecessary GQL calls, e.g. ContentUnifiedQuery.
        let isLivePageTransition = false;
        const contentId = match?.params?.contentId;
        if (contentId && !isLivePageSSR) {
            const { subType: subType, isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId);
            isLivePageTransition = isTransition && subType === 'live' && isArchived === false;
        }
        routeTasks = isLivePageSSR || isLivePageTransition ? (0, $iUV81.preloadLivePageRoute)(match, url) : (0, $445d6fd463fd83fa$export$9503d022471fff24)(match, url, isTransition, previousMatch);
    } else if (match.experience === (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE) || match.experience === (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE)) {
        if (preloadOptions?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJSAndCriticalData) routeTasks = (0, $fe22b38e04163065$export$75a73f2fbf5e96e8)(match);
        else routeTasks = (0, $fe22b38e04163065$export$75071d943b36f58f)(match, previousMatch, url);
    } else if (match.experience === (0, $irVI7.WHITEBOARD_EXPERIENCE)) routeTasks = (0, $d639d659544153c3$export$a107836a8bcfc0c9)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.DATABASE_EXPERIENCE)) routeTasks = (0, $f7a595baa9e6d446$export$f9f9f93ef86bfae1)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.EMBED_EXPERIENCE)) routeTasks = (0, $a17ca091e4cf9f3d$export$18e29f32c47bffc9)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE)) routeTasks = (0, $32e736695aa13b8b$export$8abf4a07f4444858)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.HOME_EXPERIENCE)) routeTasks = (0, $179951d621935e1e$export$cefc517f3ae2aa98)(match);
    else if (match.experience === (0, $irVI7.SPACE_PAGES_EXPERIENCE)) routeTasks = (0, $106eac55bed5d4af$export$206b1c2d74bc11a2)(match);
    else if (match.experience === (0, $irVI7.CONTENT_HISTORY_EXPERIENCE)) routeTasks = (0, $0ef4e79dd69588ad$export$9f53340e87bacbbd)(match);
    if ((0, $9wGTI.fg)('query_preloader_no_promise_all')) return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $eS4vC.createDataFetcherForSuspense)('main-content', routeTasks),
        ...commonTasks
    ]).then((errors)=>{
        if (errors) for (const e of errors)(0, $PrCoC.ssrPrepareErrorsClient).submitError(e);
    });
    else return Promise.all([
        (0, $eS4vC.createDataFetcherForSuspense)('main-content', routeTasks),
        ...commonTasks
    ]).catch((e)=>{
        (0, $PrCoC.ssrPrepareErrorsClient).submitError(e);
    });
}
async function $e80763d537fd4542$export$faa68b5324f40037(pageUrl) {
    const match = $e80763d537fd4542$var$matchRoute(pageUrl);
    if (!match) return;
    if (match.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE)) return (0, $73df6e46d3afaa7c$export$9c3872cc60e7dbce)(match, pageUrl);
}
function $e80763d537fd4542$var$matchRoute(url) {
    let match;
    let experience;
    if (match = (0, $kM8fE.matchViewPage)(url)) experience = (0, $irVI7.VIEW_PAGE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchWhiteboardPage)(url)) experience = (0, $irVI7.WHITEBOARD_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSpaceOverview)(url)) experience = (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE);
    else if (match = (0, $kM8fE.matchCompanyHub)(url)) experience = (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE);
    else if (match = (0, $kM8fE.matchHome)(url)) experience = (0, $irVI7.HOME_EXPERIENCE);
    else if (match = (0, $kM8fE.matchFabricEditor)(url)) experience = (0, $irVI7.EDIT_PAGE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchExternalShare)(url)) experience = (0, $irVI7.EXTERNAL_SHARE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSpacePages)(url)) experience = (0, $irVI7.SPACE_PAGES_EXPERIENCE);
    else if (match = (0, $kM8fE.matchContentHistory)(url)) experience = (0, $irVI7.CONTENT_HISTORY_EXPERIENCE);
    else if (match = (0, $kM8fE.matchEmbeddedEditor)(url)) experience = (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE);
    else if (match = (0, $kM8fE.matchDatabasePage)(url)) experience = (0, $irVI7.DATABASE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchEmbedPage)(url)) experience = (0, $irVI7.EMBED_EXPERIENCE);
    else if ((0, $kM8fE.matchPdfExport)(url) && (0, $9wGTI.fg)('confluence_pdf_export_query_preloader_reduction')) {
        match = (0, $kM8fE.matchPdfExport)(url);
        experience = (0, $irVI7.PDF_EXPORT_PAGE_EXPERIENCE);
    }
    return match && {
        ...match,
        experience: experience
    };
}
async function $e80763d537fd4542$export$bd8e570400e2d126() {
    const pageUrl = window.location.toString();
    // Extensions Manifest and extensions data (when preloading is requested for them)
    // are heavy and should not be loaded on server side and embedded into HTML.
    $e80763d537fd4542$export$6aefe8c2dfd7fe98(pageUrl);
    if (window.__SSR_RENDERED__) $e80763d537fd4542$export$faa68b5324f40037(pageUrl);
    else $e80763d537fd4542$export$57d895781a697848(pageUrl);
}



var $4VJDS = parcelRequire("4VJDS");

var $dtDUi = parcelRequire("dtDUi");

var $2DVQX = parcelRequire("2DVQX");

var $id4ij = parcelRequire("id4ij");
const $2bffd0a48908e22c$export$daa1e83127b2f677 = async ()=>{
    const imageElements = Array.prototype.slice.call(document.getElementById('content') ? document.getElementById('content').querySelectorAll('img') : []);
    window._contentMediaSources = imageElements.filter((element)=>(0, $id4ij.isPartOfElementStillInViewPort)(element)).map((element)=>element.src);
};



var $3Tw8v = parcelRequire("3Tw8v");

var $9F7Qb = parcelRequire("9F7Qb");

var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $cKyDI = parcelRequire("cKyDI");

var $ipPpS = parcelRequire("ipPpS");

var $3pfAb = parcelRequire("3pfAb");

var $gwFzn = parcelRequire("gwFzn");

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $PAiZW = parcelRequire("PAiZW");

var $c3xd8 = parcelRequire("c3xd8");

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");


var $6yHRM = parcelRequire("6yHRM");
const $89c4065b6c91d839$var$noop = ()=>{};
const $89c4065b6c91d839$var$RouteListenerContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    update: $89c4065b6c91d839$var$noop
});
const $89c4065b6c91d839$export$7a2084f4baac29a7 = ()=>(0, $f1742253be8873a8$export$92469b55607f005b)();
const $89c4065b6c91d839$export$72fd8977abf03d60 = ()=>(0, $gwFzn.useContext)($89c4065b6c91d839$var$RouteListenerContext);
const $89c4065b6c91d839$export$755edb1665399d41 = ()=>{
    const ref = (0, $gwFzn.useRef)();
    if (!ref.current) ref.current = $89c4065b6c91d839$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $gwFzn.useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $gwFzn.useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $89c4065b6c91d839$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $89c4065b6c91d839$export$72fd8977abf03d60();
    (0, $gwFzn.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $89c4065b6c91d839$export$31986273b686f5ea = ({ children: children })=>{
    const [route, routeUpdater] = $89c4065b6c91d839$export$755edb1665399d41();
    return /*#__PURE__*/ (0, $7UHDa.jsx)($89c4065b6c91d839$var$RouteListenerContext.Provider, {
        value: routeUpdater,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6yHRM.PostOfficeRouteProvider), {
            ...route,
            children: children
        })
    });
};



var $3Bn1T = parcelRequire("3Bn1T");

var $aXjWU = parcelRequire("aXjWU");

var $4H1Ql = parcelRequire("4H1Ql");

var $cpPWT = parcelRequire("cpPWT");
const $3e0678b32258dc83$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
    const { env: env, overrides: overrides } = environmentWithOverrides;
    return {
        currentEnv: env,
        envConfigs: {
            ...defaultEnvironmentValues.envConfigs,
            [env]: {
                remoteModule: {
                    origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                    pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                    searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                },
                api: {
                    origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                    pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                    searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                }
            }
        }
    };
};


const $7282dd84f12498d5$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children })=>{
    const stableEnvironment = (0, $4H1Ql.useStableObject)((0, $3e0678b32258dc83$export$ae3dab16eb1fc2cc)((0, $c3xd8.defaultEnvironmentValues), envWithOverrides));
    const stableContext = (0, $4H1Ql.useStableObject)($7282dd84f12498d5$var$composeConfig((0, $PAiZW.defaultPostOfficeContextValue), context.current));
    const memoizedMessagePlacementValues = (0, $gwFzn.useMemo)(()=>(0, $cpPWT.createMessagePlacementValues)(), []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c3xd8.PostOfficeEnvironmentProvider), {
        value: stableEnvironment,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $PAiZW.InternalPostOfficeContextProvider), {
            value: stableContext,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Bn1T.PostOfficeScreenContextProvider), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cpPWT.MessagePlacementProvider), {
                    value: memoizedMessagePlacementValues,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $89c4065b6c91d839$export$31986273b686f5ea), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aXjWU.TriggerContextProvider), {
                            children: children
                        })
                    })
                })
            })
        })
    });
};
const $7282dd84f12498d5$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
        // Bring logic inline with lodash merge
        // Iterator (right) properties that resolve to undefined are skipped if an Accumulator (left) value already exists
        for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
        return {
            ...acc,
            ...v
        };
    }, {
        ...base
    });



var $bQm3c = parcelRequire("bQm3c");

var $7zgzO = parcelRequire("7zgzO");
var $dPJCf = parcelRequire("dPJCf");

var $9wGTI = parcelRequire("9wGTI");

var $0VKZa = parcelRequire("0VKZa");

var $gwFzn = parcelRequire("gwFzn");

var $djMdn = parcelRequire("djMdn");

var $ibzAc = parcelRequire("ibzAc");

var $bQm3c = parcelRequire("bQm3c");

var $32x2E = parcelRequire("32x2E");
const $b765bc6fd36943f2$export$e2036a91fb26c8cf = (url)=>{
    /* Extracting Confluence page data from URL because we don't have access to the page context
	 * from the Screen Space Flags placement.
	 *
	 * Sample page URL: wiki/spaces/{spaceKey}/pages/{contentId}/This+is+the+title+of+a+page
	 * Sample blog URL: wiki/spaces/{spaceKey}/blog/2025/04/11/{contentId}/This+is+the+title+of+a+blog+post
	 */ const [, spaceKey, rawContentType, contentId] = url.match(/\/wiki\/spaces\/([^/]+)\/(pages|blog)(?:\/\d{4}\/\d{2}\/\d{2})?\/([^/]+)/) || [];
    const contentType = rawContentType === 'pages' ? 'page' : rawContentType === 'blog' ? 'blogpost' : rawContentType;
    return {
        spaceKey: spaceKey,
        contentType: contentType,
        contentId: contentId
    };
};



var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $6mKj3 = parcelRequire("6mKj3");

var $8P0Bd = parcelRequire("8P0Bd");

var $d2LG0 = parcelRequire("d2LG0");
const $073649295a5d6e54$export$1f83ea450ebdfcae = (0, $d2LG0.default)`query AISnippetQuery($contentId:ID!$contentType:ConfluenceContentType!$objectType:KnowledgeGraphObjectType!){latestKnowledgeGraphObject(contentId:$contentId contentType:$contentType objectType:$objectType){contentId contentType objectData createdAt}}`;



var $7opsJ = parcelRequire("7opsJ");

var $d2LG0 = parcelRequire("d2LG0");
const $bd7e8efd102a89c2$export$40ae2927f44e642d = (0, $d2LG0.default)`query SpaceHoverPageCardQuery($id:ID!){singleContent(id:$id){id title type subType status links{webui editui}editorVersion:properties(key:"editor"){nodes{id key value}}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}excerpt(length:372)metadata{currentuser{favourited{isFavourite}}comments{commentsCount}lastModifiedDate}history{createdBy{profilePicture{path}displayName ...on KnownUser{accountId}...on User{accountId}}ownedBy{profilePicture{path}displayName ...on KnownUser{accountId}...on User{accountId}}}space{id key alias name}likes{count}version{by{profilePicture{path}displayName ...on KnownUser{accountId}...on User{accountId}}}}}`;



const $19a192258e8db8bc$export$1d93f080b8c40251 = (skip = false)=>{
    const { contentId: contentId, spaceKey: spaceKey } = (0, $b765bc6fd36943f2$export$e2036a91fb26c8cf)(globalThis.location.href);
    // Get recommendation data
    const { data: recPageData, loading: recPageLoading, error: recPageError } = (0, $diswb.useQuery)((0, $8P0Bd.EndOfPageRecommendationQuery), {
        variables: {
            type: 'page',
            id: contentId ?? '',
            exp: 'end_of_page_v5',
            key: spaceKey ?? '',
            keyString: spaceKey ?? ''
        },
        skip: !contentId || !spaceKey || skip
    });
    // Transform/sort data and grab first rec
    const recommendedPage = (0, $gwFzn.useMemo)(()=>{
        const rankedPages = $19a192258e8db8bc$var$transformAndOrderRecs(recPageData?.getRecommendedPages?.recommendedPages);
        return rankedPages?.[0];
    }, [
        recPageData
    ]);
    // Get avatar and name of the page owner
    const { data: hoverPageData, loading: hoverPageLoading, error: hoverPageError } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $bd7e8efd102a89c2$export$40ae2927f44e642d), {
        variables: {
            id: recommendedPage ? recommendedPage.id : ''
        },
        skip: !recommendedPage || skip
    });
    // Get AI Snippet for page. This data is optional to display the message so we won't stop message rednering if it fails.
    const objectType = (0, $7opsJ.KnowledgeGraphObjectType)[(0, $6mKj3.expVal)('consumption_ai_page_tree_snippets_2', 'type', 'snippet_v1')] || (0, $7opsJ.KnowledgeGraphObjectType).snippet_v1;
    const { data: AISnippetData } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $073649295a5d6e54$export$1f83ea450ebdfcae), {
        variables: {
            contentId: recommendedPage?.id,
            contentType: recommendedPage?.type === 'page' ? (0, $7opsJ.ConfluenceContentType).PAGE : (0, $7opsJ.ConfluenceContentType).BLOG_POST,
            objectType: objectType
        },
        skip: !recommendedPage || skip
    });
    let pageRecommendationData = {
        data: undefined,
        loading: hoverPageLoading || recPageLoading,
        hoverPageError: hoverPageError,
        recPageError: recPageError
    };
    if (hoverPageData?.singleContent?.history?.ownedBy?.displayName && hoverPageData?.singleContent?.history?.ownedBy?.profilePicture?.path && recommendedPage?.links?.webui && recommendedPage?.title.text) pageRecommendationData.data = {
        pageOwner: {
            name: hoverPageData.singleContent.history.ownedBy.displayName,
            avatarUrl: hoverPageData.singleContent.history.ownedBy.profilePicture.path
        },
        page: {
            title: recommendedPage.title.text,
            url: `/wiki${recommendedPage.links.webui}`
        },
        aiSnippet: AISnippetData?.latestKnowledgeGraphObject?.objectData
    };
    return pageRecommendationData;
};
/**
 * The ordering of recs array is determined by the "ranking" in the backend.
 * Each rec will have a corresponding "strategies" array that can have one or multiple strategies.
 * We want to ensure that we are choosing strategies from each rec in a way that avoids monotony on the UI.
 * To accomplish this, we must first sort the recs array depending on the number of strategies each rec has, in
 * ascending order. We then pass each rec to transformEndOfPageRecContent which helps to choose the strategy, and
 * finally we return the transformed array back to the intial ranking order determind by the backend
 */ const $19a192258e8db8bc$var$transformAndOrderRecs = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>(0, $8P0Bd.transformEndOfPageRecContent)(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const el = transformedRecs.find((card)=>card.id === rec.content.id);
        pageCards.push(el);
    });
    return pageCards;
};


/* eslint-disable graphql-relay-compat/no-import-graphql-operations */ /* eslint-disable no-restricted-imports */ 
var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");


var $3V1KT = parcelRequire("3V1KT");

var $hp2SH = parcelRequire("hp2SH");

var $2OQgp = parcelRequire("2OQgp");

var $bQm3c = parcelRequire("bQm3c");

const $f95c9b8c12af7d64$var$INITIAL_REACTED_USER_QUERY_RESULT = {
    data: undefined,
    loading: false,
    error: undefined
};
// Helper function to fetch the specific names of users who reacted to a specific emoji
const $f95c9b8c12af7d64$var$getReactedUsersForEmoji = async (contentId, contentType, emojiId)=>{
    const { data: data } = await (0, $hp2SH.getApolloClient)().query({
        query: (0, $2OQgp.ReactedUsersQuery),
        variables: {
            contentId: contentId,
            contentType: contentType.toUpperCase(),
            containerId: contentId,
            containerType: contentType.toUpperCase(),
            emojiId: emojiId
        }
    });
    return data;
};
// Helper function to get unique users who reacted to any emoji
const $f95c9b8c12af7d64$var$getUniqueReactedUsers = async (contentId, contentType, emojiIds)=>{
    const uniqueUsers = {};
    // Process all emojis in parallel to get all unique users
    await Promise.allSettled(emojiIds.filter(Boolean).map(async (emojiId)=>{
        const data = await $f95c9b8c12af7d64$var$getReactedUsersForEmoji(contentId, contentType, emojiId);
        // Add all users to the unique users map
        for (const user of data.reactedUsers.users)if (user?.displayName && user.accountId) uniqueUsers[user.accountId] = user.displayName;
    }));
    return uniqueUsers;
};
const $f95c9b8c12af7d64$export$a35f2f61e0cb4308 = (numberOfReactedUsers, skip = false)=>{
    // Needed for Confluence-required analytic events
    const { userId: userId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { contentId: contentId, contentType: contentType } = (0, $b765bc6fd36943f2$export$e2036a91fb26c8cf)(window.location.href);
    const [reactedUsers, setReactedUsers] = (0, $gwFzn.useState)($f95c9b8c12af7d64$var$INITIAL_REACTED_USER_QUERY_RESULT);
    const [uniqueUsersCount, setUniqueUsersCount] = (0, $gwFzn.useState)(0);
    // Fetch page author and author's avatar URL
    const { data: spaceHoverPageCardResult, loading: spaceHoverPageCardLoading, error: spaceHoverPageCardError } = (0, $diswb.useQuery)((0, $bd7e8efd102a89c2$export$40ae2927f44e642d), {
        variables: {
            id: contentId
        },
        skip: !contentId || skip
    });
    // Fetch total reactions count and emoji ID summary
    const { data: reactionsContentData, loading: reactionsLoading, error: reactionsError } = (0, $diswb.useQuery)((0, $3V1KT.ReactionsContentQuery), {
        variables: {
            contentId: contentId
        },
        skip: !contentId || skip
    });
    // Use the emoji ID summary from reactionsContentData to fetch the specific names of users who reacted
    (0, $gwFzn.useEffect)(()=>{
        const emojiIds = reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji?.flatMap((reaction)=>reaction?.emojiId ?? []);
        // Need to put this in a function and then call it because we can't use async/await in useEffect
        const getReactedUsers = async ()=>{
            if (!contentId || !contentType || !emojiIds || reactedUsers.data || reactedUsers.loading) return;
            setReactedUsers({
                loading: true
            });
            try {
                // Get all unique users in parallel
                const uniqueUsers = await $f95c9b8c12af7d64$var$getUniqueReactedUsers(contentId, contentType, emojiIds);
                // Take only the first numberOfReactedUsers users for the reactedUsers state
                const limitedUsers = Object.values(uniqueUsers).slice(0, numberOfReactedUsers);
                // Update state
                setUniqueUsersCount(Object.keys(uniqueUsers).length);
                setReactedUsers({
                    data: limitedUsers,
                    loading: false
                });
            } catch (error) {
                setReactedUsers({
                    loading: false,
                    error: error
                });
            }
        };
        getReactedUsers();
    }, [
        contentId,
        contentType,
        reactionsContentData,
        reactedUsers,
        numberOfReactedUsers
    ]);
    // Transform this so that it matches Post Office's expected shape (for use with the ReactionWrapper component)
    const transformedReactionsSummary = (0, $gwFzn.useMemo)(()=>({
            reactionsSummary: {
                ari: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.ari,
                containerAri: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.containerAri,
                reactionsSummaryForEmoji: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji.map((emoji)=>({
                        count: emoji?.count,
                        emojiId: emoji?.emojiId,
                        reacted: emoji?.reacted
                    }))
            }
        }), [
        reactionsContentData
    ]);
    return {
        data: {
            authorName: spaceHoverPageCardResult?.singleContent?.history?.ownedBy?.displayName ?? undefined,
            authorAvatar: spaceHoverPageCardResult?.singleContent?.history?.ownedBy?.profilePicture?.path,
            reactionsCount: uniqueUsersCount,
            reactionsSummary: transformedReactionsSummary,
            reactedUsers: reactedUsers.data,
            userId: userId,
            activationId: activationId
        },
        loading: spaceHoverPageCardLoading || reactionsLoading || reactedUsers.loading,
        error: spaceHoverPageCardError || reactionsError || reactedUsers.error
    };
};


const $a730e736ff2c0fdb$export$50c48a5a1548e4da = ({ children: children })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const experimentsContextValue = (0, $gwFzn.useMemo)(()=>{
        return {
            usePageRecommendationData: $19a192258e8db8bc$export$1d93f080b8c40251,
            useInlineReactionsData: $f95c9b8c12af7d64$export$a35f2f61e0cb4308,
            getPageDataFromUrl: $b765bc6fd36943f2$export$e2036a91fb26c8cf,
            emojiProvider: (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
                userId: userId,
                cloudId: cloudId
            })
        };
    }, [
        userId,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $djMdn.ConfluenceExperimentsContext).Provider, {
        value: experimentsContextValue
    }, children);
};



var $gwFzn = parcelRequire("gwFzn");

var $kDuN4 = parcelRequire("kDuN4");

var $aXjWU = parcelRequire("aXjWU");
const $f6be7463febe9936$var$GASV3_DWELL_TRIGGER_TIME = 40000; // ms
const $f6be7463febe9936$var$PO_DWELL_TRIGGER_TIME = 60000; // ms
const $f6be7463febe9936$export$2855524b2284c48 = ({ children: children })=>{
    const { fireTrigger: fireTrigger } = (0, $aXjWU.useFirePostOfficeTrigger)({
        triggerId: 'confluence-page-dwelled'
    });
    const onEvent = (0, $gwFzn.useCallback)((event)=>{
        if (event.payload?.data?.action === 'dwelled' && event.payload?.data?.actionSubject === 'page') {
            const dwellTime = event.payload.data.attributes?.dwellTime;
            // Dwell events are triggered at 5, 10, 20, 40, 80s, but we want 60s
            if (event.payload.data.attributes?.finalDwellEvent) fireTrigger({
                isActive: false
            });
            else if (dwellTime && dwellTime >= $f6be7463febe9936$var$GASV3_DWELL_TRIGGER_TIME && dwellTime <= $f6be7463febe9936$var$PO_DWELL_TRIGGER_TIME) fireTrigger({
                isActive: true
            });
        }
    }, [
        fireTrigger
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kDuN4.default), {
        onEvent: onEvent,
        channel: "*"
    }, children);
};


const $074500c4d6f25c0d$var$ConfluencePostOfficeProvider = ({ children: children })=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, environment: environment, locale: locale, orgId: orgId, edition: edition } = (0, $bQm3c.useSessionData)();
    const context = (0, $gwFzn.useMemo)(()=>({
            current: (0, $0VKZa.sessionToPostOfficeContext)({
                accessStatus: accessStatus,
                activationId: activationId,
                cloudId: cloudId,
                locale: locale,
                orgId: orgId,
                edition: edition
            })
        }), [
        activationId,
        cloudId,
        accessStatus,
        locale,
        orgId,
        edition
    ]);
    const env = (0, $gwFzn.useMemo)(()=>({
            env: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(environment)
        }), [
        environment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7282dd84f12498d5$export$fb465b6e855c1e85), {
        context: context,
        environment: env
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f6be7463febe9936$export$2855524b2284c48), null, children));
};
const $074500c4d6f25c0d$export$fb465b6e855c1e85 = ({ children: children })=>{
    return (0, $9wGTI.fg)('post-office-screen-space-overlay-confluence') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($074500c4d6f25c0d$var$ConfluencePostOfficeProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a730e736ff2c0fdb$export$50c48a5a1548e4da), null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
};
const $074500c4d6f25c0d$var$ReactRouterListener = ({ children: children })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    (0, $89c4065b6c91d839$export$bb606326acdd1a64)([
        routeDataRef?.current?.href ?? '',
        routeDataRef.current?.routeName ?? ''
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
};
const $074500c4d6f25c0d$var$ConfluenceRouterListener = ({ children: children })=>{
    const routeContext = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    (0, $89c4065b6c91d839$export$bb606326acdd1a64)([
        routeContext.getHref() ?? '',
        routeContext.match?.name ?? ''
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
};
const $074500c4d6f25c0d$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
    return (0, $9wGTI.fg)('post-office-screen-space-overlay-confluence') ? (0, $9wGTI.fg)('post-office-new-confluence-router-listener') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($074500c4d6f25c0d$var$ConfluenceRouterListener, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($074500c4d6f25c0d$var$ReactRouterListener, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
};




var $04e9M = parcelRequire("04e9M");

var $dEBDF = parcelRequire("dEBDF");

var $1kHsc = parcelRequire("1kHsc");
var $fGzMp = parcelRequire("fGzMp");

var $f7i8j = parcelRequire("f7i8j");

var $bLJr5 = parcelRequire("bLJr5");

var $gwFzn = parcelRequire("gwFzn");

var $04e9M = parcelRequire("04e9M");

var $bQm3c = parcelRequire("bQm3c");

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2YerA = parcelRequire("2YerA");

var $8z9j5 = parcelRequire("8z9j5");

var $7TH2w = parcelRequire("7TH2w");
const $f63d596471d12742$export$91b4dd3bfc301325 = (analyticsClient)=>{
    return (event)=>{
        return Promise.resolve(analyticsClient).then((client)=>{
            switch(event.eventType){
                case 0, $7TH2w.UI_EVENT_TYPE:
                    client.sendUIEvent(event);
                    break;
                case 0, $7TH2w.TRACK_EVENT_TYPE:
                    client.sendTrackEvent(event);
                    break;
                case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $7TH2w.SCREEN_EVENT_TYPE:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};


// Copied from xflow-ui. We post raw analytics events (context and payload only) from xflow-ui to consumer (CFE), transform on consumer and post to gasv3.

var $7TH2w = parcelRequire("7TH2w");
const $7ddb7856a75b7fbe$var$GROWTH_TAG = 'growth';
const $7ddb7856a75b7fbe$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $7ddb7856a75b7fbe$var$getSources = (context)=>$7ddb7856a75b7fbe$var$extractFromEventContext([
        'source'
    ], context);
const $7ddb7856a75b7fbe$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
        const newAttributes = {
            ...ans,
            ...contextProps
        };
        return attributes ? {
            ...newAttributes,
            ...attributes
        } : newAttributes;
    }, {});
const $7ddb7856a75b7fbe$var$getPackageInfo = (context)=>context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $7ddb7856a75b7fbe$var$last = (values)=>values[values.length - 1];
const $7ddb7856a75b7fbe$export$3f40e8c44448be30 = (event)=>{
    const { context: context, payload: payload } = event;
    if (!payload) return null;
    const sources = $7ddb7856a75b7fbe$var$getSources(context);
    const source = $7ddb7856a75b7fbe$var$last(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = $7ddb7856a75b7fbe$var$getExtraAttributes(context);
    const { packageName: packageName, packageVersion: packageVersion } = $7ddb7856a75b7fbe$var$last($7ddb7856a75b7fbe$var$getPackageInfo(context)) || {};
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
    const attributes = {
        packageName: packageName,
        packageVersion: packageVersion,
        ...extraAttributes,
        ...payloadAttributes
    };
    const tags = payload.tags || [];
    tags.push($7ddb7856a75b7fbe$var$GROWTH_TAG);
    switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};



var $49sr4 = parcelRequire("49sr4");
const $82f75673d6758a24$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $82f75673d6758a24$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $82f75673d6758a24$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $82f75673d6758a24$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $82f75673d6758a24$export$2a45a00073911255 = '/software';


var $1d705bbdb490746b$export$fc604aa353a97e10 = /*#__PURE__*/ function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    return UtmCampaign;
}({});


const $38a222a070b75a8d$var$utmCampaignMap = {
    'atlassian-switcher': (0, $1d705bbdb490746b$export$fc604aa353a97e10)['atlassian-switcher']
};
const $38a222a070b75a8d$var$isBundledProduct = (productKey)=>{
    return [
        (0, $49sr4.Targets).JIRA_SOFTWARE,
        (0, $49sr4.Targets).JIRA_SERVICE_DESK,
        (0, $49sr4.Targets).JIRA_CORE,
        (0, $49sr4.Targets).CONFLUENCE
    ].includes(productKey);
};
const $38a222a070b75a8d$var$getBundleSignUpParams = (productKey)=>{
    const bundles = {
        [(0, $49sr4.Targets).JIRA_SOFTWARE]: 'jira-software',
        [(0, $49sr4.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
        [(0, $49sr4.Targets).JIRA_CORE]: 'jira-core',
        [(0, $49sr4.Targets).CONFLUENCE]: 'confluence'
    };
    // Bundles default to free
    return `bundle=${bundles[productKey]}&edition=free`;
};
const $38a222a070b75a8d$var$isProductWithCustomSignUpPath = (productKey)=>{
    return [
        (0, $49sr4.Targets).OPSGENIE
    ].includes(productKey);
};
const $38a222a070b75a8d$var$getProductCustomSignUpPath = (productKey)=>{
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    const links = {
        [(0, $49sr4.Targets).OPSGENIE]: (0, $82f75673d6758a24$export$fb1e43fdafe12e9b)
    };
    return links[productKey];
};
const $38a222a070b75a8d$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
    return Boolean($38a222a070b75a8d$var$utmCampaignMap[sourceComponent]);
};
const $38a222a070b75a8d$var$getUtmParams = (sourceComponent, sourceContext)=>{
    let utmParams = '';
    if (sourceComponent && $38a222a070b75a8d$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + `utm_campaign=${$38a222a070b75a8d$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
        if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
    }
    return utmParams;
};
const $38a222a070b75a8d$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
    const wacUrl = env === 'staging' ? (0, $82f75673d6758a24$export$c37558e5c67d2b01) : (0, $82f75673d6758a24$export$f199baf8dfc7621e);
    const utmParams = $38a222a070b75a8d$var$getUtmParams(sourceComponent, sourceContext);
    let queryParams = '';
    let bundleParams = '';
    let path = (0, $82f75673d6758a24$export$2a45a00073911255);
    if ($38a222a070b75a8d$var$isBundledProduct(productKey)) {
        path = (0, $82f75673d6758a24$export$e6c04a1dd86d1c14);
        bundleParams = $38a222a070b75a8d$var$getBundleSignUpParams(productKey);
    } else if ($38a222a070b75a8d$var$isProductWithCustomSignUpPath(productKey)) path = $38a222a070b75a8d$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
const $38a222a070b75a8d$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
    const url = $38a222a070b75a8d$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};



var $gwFzn = parcelRequire("gwFzn");

var $7TH2w = parcelRequire("7TH2w");
const $ab8bd02760c6d61c$export$b4d5da5f34fb77ad = 'crossFlowProvider';
const $ab8bd02760c6d61c$export$9d8252a268f4fa72 = 'errorCaught';
const $ab8bd02760c6d61c$export$1045419caf49b395 = 'errorBoundary';
const $ab8bd02760c6d61c$export$d54c183f56e39aa5 = 'crossFlowSupport';
const $ab8bd02760c6d61c$export$e5c2c058fa8068a6 = 'uiInitialized';
const $ab8bd02760c6d61c$export$e67cdcb8867a3bd0 = 'openInvoked';


var $7TH2w = parcelRequire("7TH2w");
const $fbfb52c7bf4616fb$var$name = "platform-pkg";
const $fbfb52c7bf4616fb$var$version = "0.0.0-use.local";
const $fbfb52c7bf4616fb$var$payload = {
    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
    action: (0, $ab8bd02760c6d61c$export$9d8252a268f4fa72),
    actionSubject: (0, $ab8bd02760c6d61c$export$1045419caf49b395)
};
const $fbfb52c7bf4616fb$var$context = [
    {
        source: $ab8bd02760c6d61c$export$b4d5da5f34fb77ad
    },
    {
        packageName: $fbfb52c7bf4616fb$var$name,
        packageVersion: $fbfb52c7bf4616fb$var$version
    }
];
class $fbfb52c7bf4616fb$export$e926676385687eaf extends (0, $gwFzn.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        this.props.onAnalyticsEvent({
            payload: $fbfb52c7bf4616fb$var$payload,
            context: $fbfb52c7bf4616fb$var$context
        });
        if (this.props.onError) this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}


const $2990596a720578f3$var$version = "0.0.0-use.local";
const $2990596a720578f3$export$84f9cf7ef89d4c26 = {
    version: $2990596a720578f3$var$version
};
const $2990596a720578f3$export$59518efab336a8b5 = (event)=>{
    const attributes = {
        ...event.attributes || {},
        crossFlowSupport: $2990596a720578f3$export$84f9cf7ef89d4c26
    };
    return {
        ...event,
        attributes: attributes
    };
};


const $c3f4a60925dc07c0$export$a5a156dc5df42f0 = (event, requestOptions)=>{
    if (!requestOptions) return event;
    const attributes = {
        // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
        ...requestOptions.extraAnalyticsAttributes || {},
        ...event.attributes || {},
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    };
    return {
        ...event,
        attributes: attributes
    };
};



var $7TH2w = parcelRequire("7TH2w");

const $2e3c136e31b0a37a$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("9Fonl")));
const $2e3c136e31b0a37a$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
        const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
        const onCloseResolver = (0, $gwFzn.useRef)();
        const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $gwFzn.useState)(false);
        const fireEvent = (0, $gwFzn.useMemo)(()=>(0, $f63d596471d12742$export$91b4dd3bfc301325)(analyticsClient), [
            analyticsClient
        ]);
        const [requestOptions, setRequestOptions] = (0, $gwFzn.useState)();
        const onAnalyticsEvent = (0, $gwFzn.useCallback)((payload)=>{
            const gasV3Event = (0, $7ddb7856a75b7fbe$export$3f40e8c44448be30)(payload);
            if (gasV3Event) {
                const enrichedEvent = (0, $c3f4a60925dc07c0$export$a5a156dc5df42f0)((0, $2990596a720578f3$export$59518efab336a8b5)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        const onHandShake = (0, $gwFzn.useCallback)((appName)=>{
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                        action: (0, $ab8bd02760c6d61c$export$e5c2c058fa8068a6),
                        actionSubject: (0, $ab8bd02760c6d61c$export$d54c183f56e39aa5),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: $ab8bd02760c6d61c$export$b4d5da5f34fb77ad
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        const onOpen = (0, $gwFzn.useCallback)((options)=>{
            /**
     * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
     * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
     */ setFirstHandshakeReceived(false);
            const analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $c3f4a60925dc07c0$export$a5a156dc5df42f0)({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    action: (0, $ab8bd02760c6d61c$export$e67cdcb8867a3bd0),
                    actionSubject: (0, $ab8bd02760c6d61c$export$d54c183f56e39aa5)
                }, options),
                context: [
                    {
                        source: $ab8bd02760c6d61c$export$b4d5da5f34fb77ad
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $2YerA.Journeys).GET_STARTED && redirectToWac) {
                (0, $38a222a070b75a8d$export$2827e2473cb9a346)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                const completionStatus = {};
                return Promise.resolve(completionStatus);
            }
            const updatedExperimentalOptions = {
                ...globalExperimentalOptions || {},
                // "globalExperimentalOptions" will be injected to EVERY crossFlow invoke
                ...options.experimentalOptions || {} // "options.experimentalOptions" takes care of passing experimentalOptions to ONE specific crossFlow invoke
            };
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise((resolve)=>{
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        const onClose = (0, $gwFzn.useCallback)((completionStatus)=>{
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        const { colorMode: colorMode } = (0, $8z9j5.default)();
        return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2YerA.BaseCrossFlowApiProvider), {
            onOpen: onOpen,
            children: [
                children,
                requestOptions && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fbfb52c7bf4616fb$export$e926676385687eaf), {
                    onAnalyticsEvent: onAnalyticsEvent,
                    onError: onError,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                        fallback: null,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)(IntegrationView, {
                            ...baseProviderProps,
                            ...requestOptions,
                            onAnalyticsEvent: onAnalyticsEvent,
                            originProduct: originProduct,
                            theme: colorMode,
                            onClose: onClose,
                            onHandShake: onHandShake,
                            plugins: plugins,
                            env: env,
                            redirectToWac: redirectToWac,
                            zIndex: requestOptions.zIndex ?? 1000
                        })
                    })
                })
            ]
        });
    };
const $2e3c136e31b0a37a$export$d900e4062895cd7c = $2e3c136e31b0a37a$export$79d79d8dd8574306($2e3c136e31b0a37a$var$IntegrationView);



const $3ca71cfad0801800$var$ConfluenceProvider = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2e3c136e31b0a37a$export$d900e4062895cd7c), {
        ...props,
        originProduct: "confluence"
    });
};
var $3ca71cfad0801800$export$2e2bcd8739ae039 = $3ca71cfad0801800$var$ConfluenceProvider;


// Data Plugin definition and utility types
const $355a7b1aa3f573ec$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
const $355a7b1aa3f573ec$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
const $355a7b1aa3f573ec$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
const $355a7b1aa3f573ec$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};


const $fe198622d822a4a2$export$76378b0f825c024c = (fetch)=>{
    return [
        (0, $355a7b1aa3f573ec$export$a235a73f7b906dce).GetContainers,
        fetch
    ];
};
const $fe198622d822a4a2$export$8feb7eae83cf8cd5 = (fetch)=>{
    return [
        (0, $355a7b1aa3f573ec$export$a235a73f7b906dce).GetUsers,
        fetch
    ];
};
const $fe198622d822a4a2$export$21d120847be2aff4 = (fetch)=>{
    return [
        (0, $355a7b1aa3f573ec$export$a235a73f7b906dce).GetSuggestedSiteNames,
        fetch
    ];
};
const $fe198622d822a4a2$export$d7c1699c6a2ca18a = (fetch)=>{
    return [
        (0, $355a7b1aa3f573ec$export$a235a73f7b906dce).GetAvailableSites,
        fetch
    ];
};



var $hp2SH = parcelRequire("hp2SH");

var $gFHOP = parcelRequire("gFHOP");

var $e1GUi = parcelRequire("e1GUi");
function $3dc98590eeed1246$var$hasSiteSettings(data) {
    return data && typeof data === 'object' && data['siteSettings'] && data['tenant'];
}
const $3dc98590eeed1246$var$getCloudId = async ()=>{
    const isSiteInformationQueryEnabled = window['__ENABLE_SITE_INFORMATION_QUERY__'];
    const { data: data } = await (0, $hp2SH.getApolloClient)().query({
        // eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
        query: isSiteInformationQueryEnabled ? (0, $gFHOP.SiteInformationQuery) : (0, $e1GUi.SPAViewContextQuery)
    });
    const containers = [];
    if ($3dc98590eeed1246$var$hasSiteSettings(data)) {
        const { siteTitle: siteTitle } = data.siteSettings;
        const tenantId = data.tenant.cloudId;
        containers.push({
            id: tenantId,
            displayName: siteTitle,
            type: (0, $355a7b1aa3f573ec$export$6e383182a26455ff).ATLASSIAN_CLOUD_ID
        });
    }
    return {
        type: (0, $355a7b1aa3f573ec$export$6e383182a26455ff).ATLASSIAN_CLOUD_ID,
        containers: containers
    };
};
const $3dc98590eeed1246$export$81d1d40061d190bc = (0, $fe198622d822a4a2$export$76378b0f825c024c)($3dc98590eeed1246$var$getCloudId);



var $f7B1p = parcelRequire("f7B1p");
const $c394a569c7bfdabb$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await (0, $f7B1p.cfetch)(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    idType: (0, $355a7b1aa3f573ec$export$e391bab95adb8396).ATLASSIAN_ACCOUNT_ID,
                    id: value.id,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $c394a569c7bfdabb$export$7c44908d2777db01 = (0, $fe198622d822a4a2$export$8feb7eae83cf8cd5)($c394a569c7bfdabb$var$getUsers);


const $70d683a301b7be27$export$d900e4062895cd7c = ({ children: children })=>{
    const { cloudId: cloudId, locale: locale } = (0, $bQm3c.useSessionData)();
    const analyticWebClient = (0, $gwFzn.useMemo)(()=>(0, $04e9M.getAnalyticsWebClient)(), []);
    const isMarketingOptOut = document.querySelector("meta[name='ajs-marketing-opt-out']")?.getAttribute('content') === 'true';
    if (isMarketingOptOut) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3ca71cfad0801800$export$2e2bcd8739ae039), {
        cloudId: cloudId,
        analyticsClient: analyticWebClient,
        locale: locale,
        plugins: [
            (0, $c394a569c7bfdabb$export$7c44908d2777db01),
            (0, $3dc98590eeed1246$export$81d1d40061d190bc)
        ]
    }, children);
};



var $fcF01 = parcelRequire("fcF01");

var $d5ap9 = parcelRequire("d5ap9");

var $1ytiN = parcelRequire("1ytiN");

var $gwFzn = parcelRequire("gwFzn");

var $lsxnT = parcelRequire("lsxnT");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $hSHWm = parcelRequire("hSHWm");

var $jmjWc = parcelRequire("jmjWc");

const $639a6e255dabf06b$export$96cfefeef4383728 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "mA5-d",
    name: "CoreInvitesLoadable",
    loader: async ()=>(await (parcelRequire("e9go2"))).CoreInvites
});



var $koZ31 = parcelRequire("koZ31");
const $685338b3d2a4b0a3$var$noop = ()=>{
    return undefined;
};
function $685338b3d2a4b0a3$export$2e865a7ec399eb55({ children: children }) {
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const [initialInvitees, setInitialInvitees] = (0, $gwFzn.useState)([]);
    const [source, setSource] = (0, $gwFzn.useState)((0, $koZ31.CoreInvitesSource).UNKNOWN);
    const [showSpotlight, setShowSpotlight] = (0, $gwFzn.useState)(false);
    const stablePropsRef = (0, $gwFzn.useRef)({
        onInviteCompleted: $685338b3d2a4b0a3$var$noop,
        onModalClose: $685338b3d2a4b0a3$var$noop
    });
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const contextualInviteNudgeChoreographer = useChoreographer('cc-contextual-invite-nudge', {
        start: ()=>setShowSpotlight(true),
        stop: ()=>setShowSpotlight(false)
    });
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const handleModalOpen = (0, $gwFzn.useCallback)((touchPoint, { onModalClosed: onModalClosed = $685338b3d2a4b0a3$var$noop, onInviteCompleted: onInviteCompleted = $685338b3d2a4b0a3$var$noop, getContextualInviteNudgeProps: getContextualInviteNudgeProps } = {}, initialInvitees = [])=>{
        setInitialInvitees(initialInvitees);
        setSource(touchPoint || (0, $koZ31.CoreInvitesSource).UNKNOWN);
        stablePropsRef.current.onModalClose = onModalClosed;
        stablePropsRef.current.onInviteCompleted = onInviteCompleted;
        setIsOpen(true);
        const shouldShow = getContextualInviteNudgeProps?.()?.showSpotlight;
        if (shouldShow) contextualInviteNudgeChoreographer.startMessage();
    }, [
        contextualInviteNudgeChoreographer,
        setInitialInvitees,
        setSource,
        setIsOpen
    ]);
    const handleModalClose = (0, $gwFzn.useCallback)(()=>{
        setSource((0, $koZ31.CoreInvitesSource).UNKNOWN);
        // remember the current value for later invocation, since we're about to override it
        const onClosed = stablePropsRef.current.onModalClose;
        stablePropsRef.current.onModalClose = $685338b3d2a4b0a3$var$noop;
        stablePropsRef.current.onInviteCompleted = $685338b3d2a4b0a3$var$noop;
        setIsOpen(false);
        onClosed();
        contextualInviteNudgeChoreographer.stopMessage();
    }, [
        contextualInviteNudgeChoreographer,
        setSource,
        setIsOpen
    ]);
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const failExperienceOnError = (0, $gwFzn.useCallback)((error)=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.CORE_INVITES_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    const coreInviteContext = (0, $gwFzn.useMemo)(()=>({
            openCoreInvites: handleModalOpen
        }), [
        handleModalOpen
    ]);
    const coreInvitesDriveMultiProductInvites = source != (0, $koZ31.CoreInvitesSource).MENTION;
    const displayInfiSpotlight = true;
    const experimentalFeatures = (0, $gwFzn.useMemo)(()=>{
        return {
            inviteThirdPartyTeams: 'variation',
            coreInvitesDriveMultiProductInvites: coreInvitesDriveMultiProductInvites,
            confluenceXflowOnboarding: source === (0, $koZ31.CoreInvitesSource).CROSS_JOIN && (0, $9wGTI.fg)('cc_virality_cross_join_invite_email_gate')
        };
    }, [
        coreInvitesDriveMultiProductInvites,
        source
    ]);
    const inviteCompletedHandler = (0, $gwFzn.useCallback)((result)=>{
        stablePropsRef.current.onInviteCompleted(result);
    }, [
        stablePropsRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hSHWm.CoreInvitesContext).Provider, {
        value: coreInviteContext
    }, children, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.TransparentErrorBoundary), {
        attribution: (0, $dIouf.Attribution).GROWTH,
        onError: failExperienceOnError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $639a6e255dabf06b$export$96cfefeef4383728), {
        initialInvitees: initialInvitees,
        onSendHandler: handleModalClose,
        onCancelHandler: handleModalClose,
        onInviteCompletedHandler: inviteCompletedHandler,
        source: source,
        orgId: orgId,
        experimentalFeatures: experimentalFeatures,
        displayInfiSpotlight: displayInfiSpotlight,
        showSpotlight: showSpotlight
    })));
}



var $3PXtn = parcelRequire("3PXtn");

var $5zuN8 = parcelRequire("5zuN8");

var $ktUCG = parcelRequire("ktUCG");

var $brNvA = parcelRequire("brNvA");

var $cryCi = parcelRequire("cryCi");

var $fN9wG = parcelRequire("fN9wG");

var $9wGTI = parcelRequire("9wGTI");

var $97W74 = parcelRequire("97W74");

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $lwdd5 = parcelRequire("lwdd5");

var $cKyDI = parcelRequire("cKyDI");

var $dBmJE = parcelRequire("dBmJE");

var $eXODy = parcelRequire("eXODy");

var $iV00x = parcelRequire("iV00x");

var $kCeSx = parcelRequire("kCeSx");

var $cbc8g = parcelRequire("cbc8g");


var $1iSzD = parcelRequire("1iSzD");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $dIouf = parcelRequire("dIouf");

var $7aRa9 = parcelRequire("7aRa9");

var $gLUd5 = parcelRequire("gLUd5");

var $bQm3c = parcelRequire("bQm3c");

var $4VJDS = parcelRequire("4VJDS");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $2Nwuj = parcelRequire("2Nwuj");
const $b59268334a98f13b$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    genericSSRErrorFlagReason: {
        id: "ssr-render-failure-notification.flag.generic.message",
        defaultMessage: "Reason: {reason}."
    },
    branchDeployErrorFlagReason: {
        id: "ssr-render-failure-notification.flag.branch.deploy.message",
        defaultMessage: "Possible outdated branch deploy detected. Your PR changes might not be tested against SSR accurately."
    },
    runbookLink: {
        id: "ssr-render-failure-notification.runbook.link",
        defaultMessage: "See <runbookLink>this page</runbookLink> for information on how to debug this failure."
    }
});
const $b59268334a98f13b$var$BRANCH_DEPLOY_RUNBOOK_LINK = `https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4898451942/Branch+Deploys`;
const $b59268334a98f13b$var$GENERIC_SSR_FAILURE_RUNBOOK_LINK = `https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4911008649/SSR+Render+Failures`;
const $b59268334a98f13b$export$487f09dcd3f678bf = ({ ssrErrors: ssrErrors, isBranchDeployFailure: isBranchDeployFailure })=>{
    const runbookLink = isBranchDeployFailure ? $b59268334a98f13b$var$BRANCH_DEPLOY_RUNBOOK_LINK : $b59268334a98f13b$var$GENERIC_SSR_FAILURE_RUNBOOK_LINK;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        "data-testid": "flagErrorMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, isBranchDeployFailure ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b59268334a98f13b$export$a7357cdd1f0b0168.branchDeployErrorFlagReason) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$b59268334a98f13b$export$a7357cdd1f0b0168.genericSSRErrorFlagReason,
        values: {
            reason: ssrErrors[0]
        }
    })), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$b59268334a98f13b$export$a7357cdd1f0b0168.runbookLink,
        values: {
            runbookLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: runbookLink
                }, chunks)
        }
    }));
};



var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $2Nwuj = parcelRequire("2Nwuj");
const $5e5853def1ddf657$var$i18n = (0, $2nPZH.defineMessages)({
    hydrationErrorMessage: {
        id: "ssr-render-failure-notification.hydration.flag.message",
        defaultMessage: "To view the hydration mismatches, refer to window.__HYDRATION_ERRORS__ in the browser console."
    },
    runbookLink: {
        id: "ssr-render-failure-notification.hydration.runbook.link",
        defaultMessage: "See <runbookLink>this page</runbookLink> for information on how to debug the mismatches."
    }
});
const $5e5853def1ddf657$export$7922b21049d03e3b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        "data-testid": "flagErrorMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $5e5853def1ddf657$var$i18n.hydrationErrorMessage)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$5e5853def1ddf657$var$i18n.runbookLink,
        values: {
            runbookLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: "https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches"
                }, chunks)
        }
    }));
};


const $008c5cd8cb4c3a95$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    ssrRenderErrorFlagTitle: {
        id: "ssr-render-failure-notification.flag",
        defaultMessage: "This page was NOT SSR RENDERED!"
    },
    hydrationErrorFlagTitle: {
        id: "ssr-render-failure-notification.hydration.flag",
        defaultMessage: "This page was NOT HYDRATED PROPERLY!"
    }
});
const $008c5cd8cb4c3a95$export$475a1abe7cf690a3 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const [hasShownErrorFlag, setHasShownErrorFlag] = (0, $gwFzn.useState)(false);
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    // we want to exclude testing environments and pollinator tenants from showing the error flag
    const isTestEnvironment = (0, $4VJDS.default).isKillSwitchOn('confluence_frontend_ssr_failure_notification');
    // We only want to show the error flag in the dev/staging environment
    // however, branch deploys on production will default to process.env.CLOUD_ENV = 'branch'
    const isStagingEnvironment = [
        'dev',
        'branch',
        'staging',
        'stg-fedm'
    ].includes("canary") && environment !== 'PRODUCTION';
    (0, $gwFzn.useEffect)(()=>{
        if (!isStagingEnvironment || isTestEnvironment) return;
        // sometimes errors exist but the page is still SSRd succesfully - we don't want to show the SSR render error flag in this case
        if (window.__SSR_RENDERED__) {
            // if the page is SSRd successfully we check if the page was hydrated successfully, and show a hydration error flag if not
            if (!hasShownErrorFlag && window.__HYDRATION_FAILED__) {
                flags.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $008c5cd8cb4c3a95$export$a7357cdd1f0b0168.hydrationErrorFlagTitle),
                    isAutoDismiss: false,
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5e5853def1ddf657$export$7922b21049d03e3b), null)
                });
                setHasShownErrorFlag(true);
            }
            return;
        }
        // COMPILED dev warnings show up on every SSRd page even if the page is SSRd successfully,
        // so we need to filter them out to distinguish from actual errors being reported for local dev ssr
        const ssrErrors = window.__SSR_ERROR__?.filter((err)=>!err.includes('DEV WARNING')) ?? [];
        // on old branch deploys, ssr errors can still be empty but the page might not be SSRd successfully
        const isBranchDeployFailure = (0, $gLUd5.isBranchDeployFn)() && !window.__SSR_RENDERED__ && !ssrErrors?.length;
        if (!hasShownErrorFlag && (isBranchDeployFailure || ssrErrors.length)) {
            flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $008c5cd8cb4c3a95$export$a7357cdd1f0b0168.ssrRenderErrorFlagTitle),
                isAutoDismiss: false,
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b59268334a98f13b$export$487f09dcd3f678bf), {
                    ssrErrors: ssrErrors,
                    isBranchDeployFailure: isBranchDeployFailure
                })
            });
            setHasShownErrorFlag(true);
        }
    }, [
        isStagingEnvironment,
        flags,
        hasShownErrorFlag,
        isTestEnvironment
    ]);
    return null;
});
const $008c5cd8cb4c3a95$export$4e5ff544be3ec09b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.TransparentErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($008c5cd8cb4c3a95$export$475a1abe7cf690a3, null));
};



var $iJELi = parcelRequire("iJELi");

var $8n9tL = parcelRequire("8n9tL");

var $4o1RV = parcelRequire("4o1RV");

var $aFbGo = parcelRequire("aFbGo");

var $gEtAQ = parcelRequire("gEtAQ");
var $64KID = parcelRequire("64KID");

var $dIouf = parcelRequire("dIouf");

var $5q601 = parcelRequire("5q601");
var $1NBp8 = parcelRequire("1NBp8");

var $iFjdQ = parcelRequire("iFjdQ");

var $5q601 = parcelRequire("5q601");
function $192302f00fa5cc0a$export$8c3a984654991d73(routeName) {
    if (!routeName) return;
    switch(routeName){
        // edit route names taken from @confluence/browser-metrics/src/metricKeys.ts
        case (0, $1NBp8.EDIT_PAGE_EMBED).name:
        case (0, $1NBp8.EDIT_PAGE_V2).name:
        case (0, $1NBp8.EDIT_BLOG_V2).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.EDIT_BLOG).name:
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_ROUTE_CHANGE_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_TO_FMP_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_TO_TTI_ACTION));
            return;
        default:
            return;
    }
}


var $jfrcs = parcelRequire("jfrcs");
var $gwFzn = parcelRequire("gwFzn");

var $7zgzO = parcelRequire("7zgzO");

var $ezH4I = parcelRequire("ezH4I");
const $e7cb2c525109c7cf$var$MIN_LONG_TASK_DURATION = 50;
const $e7cb2c525109c7cf$export$de3c307012927947 = (start, stop, idleThreshold, buffer)=>{
    const entires = buffer.getAll().filter((entry)=>entry.duration >= $e7cb2c525109c7cf$var$MIN_LONG_TASK_DURATION).map((entry)=>({
            start: entry.startTime,
            stop: entry.startTime + entry.duration
        })).filter((entry)=>entry.stop > start && entry.start < stop).concat([
        // Add a fake entry to simplify the logic below
        {
            start: stop,
            stop: stop
        }
    ]).sort((a, b)=>a.start - b.start);
    let lastStop = start;
    for (const entry of entires){
        if (lastStop + idleThreshold < entry.start) return lastStop;
        lastStop = entry.stop;
    }
    return null;
};





var $lSOAM = parcelRequire("lSOAM");

var $fd6g2 = parcelRequire("fd6g2");
const $682a207fed74bf66$export$e49353726941624a = (0, $lSOAM.createConcurrentCustomMetric)({
    key: (0, $fd6g2.TIME_TO_APP_IDLE_KEY)
});



const $f6158bccfa436061$var$IDLE_THRESHOLD = 3000;
const $f6158bccfa436061$var$RETRY_INTERVAL = $f6158bccfa436061$var$IDLE_THRESHOLD * 2;
const $f6158bccfa436061$var$TIMEOUT_INTERVAL = 300000; // 5 minutes
const $f6158bccfa436061$var$PERFORMANCE_OBSERVER_LATENCY_ADJUSTMENT = 1000;
const $f6158bccfa436061$var$performance = window.performance;
const $f6158bccfa436061$var$delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $f6158bccfa436061$var$wainNextIdle = ()=>{
    const onIdleCallback = window.requestIdleCallback || window.requestAnimationFrame;
    const cancelCallback = (id)=>{
        if (onIdleCallback === window.requestIdleCallback) window.cancelIdleCallback(id);
        else window.cancelAnimationFrame(id);
    };
    return new Promise((resolve)=>{
        const callbackId = onIdleCallback(()=>{
            cancelCallback(callbackId);
            resolve();
        });
    });
};
const $f6158bccfa436061$export$560b992b8a813cfb = /*#__PURE__*/ (0, $gwFzn.memo)(({})=>{
    const routes = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const routeName = routes.match?.name || '';
    const contentId = routes.match?.params?.contentId || '';
    const transitionId = routes.transitionId || 0;
    (0, $gwFzn.useEffect)(()=>{
        const htmlTime = $f6158bccfa436061$var$performance?.getEntriesByName?.('CFP-63.html').pop()?.startTime || 0;
        const isInitialLoad = transitionId === 0;
        const metric = (0, $682a207fed74bf66$export$e49353726941624a)(`${transitionId}-${routeName}-${contentId}`);
        // we have two different 'startTime' variables in this context:
        // 'metricStartTime' - This is used for reporting to the metric and for calculating duration.
        // 'startTime' - This is used as a boundary for idle time calculation. There may be instances where the HTML is ready,
        // but the component is not yet rendered. In such cases, we use the component's first render time as the start boundary.
        const startTime = $f6158bccfa436061$var$performance?.now();
        const metricStartTime = isInitialLoad ? htmlTime : startTime;
        let abortedTime = 0;
        metric.start({
            startTime: metricStartTime
        });
        async function measureTimeToAppIdle() {
            while(true){
                await $f6158bccfa436061$var$delay($f6158bccfa436061$var$RETRY_INTERVAL);
                // wait for current long task to complete
                await $f6158bccfa436061$var$wainNextIdle();
                const endTime = $f6158bccfa436061$var$performance?.now();
                // wait to allow performance observer to collect recent entries
                // note that `endTime` somewhat behind after this line, but it's ok
                await $f6158bccfa436061$var$delay($f6158bccfa436061$var$PERFORMANCE_OBSERVER_LATENCY_ADJUSTMENT);
                const idleTime = (0, $e7cb2c525109c7cf$export$de3c307012927947)(startTime, endTime, $f6158bccfa436061$var$IDLE_THRESHOLD, (0, $4313abb7a0000648$export$f7dc16cbd16f7bbe)[(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LongTask]);
                const aborted = abortedTime && (!idleTime || abortedTime < idleTime) ? 'transition' : false;
                const timedOut = endTime - metricStartTime > $f6158bccfa436061$var$TIMEOUT_INTERVAL;
                if (idleTime || timedOut || aborted) {
                    const stopTime = idleTime || endTime;
                    const duration = stopTime - metricStartTime;
                    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(startTime, stopTime, (0, $4313abb7a0000648$export$f7dc16cbd16f7bbe)[(0, $49cc78e79e334ef6$export$a4def92db6fc8e17).LongTask]);
                    const customData = {
                        duration: duration,
                        startTime: metricStartTime,
                        stopTime: stopTime,
                        aborted: aborted,
                        transitionId: transitionId,
                        routeName: routeName,
                        contentId: contentId,
                        timedOut: timedOut,
                        idleThreshold: $f6158bccfa436061$var$IDLE_THRESHOLD,
                        tbtObserved: Math.round(tbt.observed),
                        tbtTotal: Math.round(tbt.total),
                        totalElementsToHydrate: (0, $ezH4I.getTotalHydratedElements)()
                    };
                    metric.stop({
                        stopTime: stopTime,
                        customData: customData
                    });
                    return;
                }
            }
        }
        measureTimeToAppIdle();
        return ()=>{
            abortedTime = $f6158bccfa436061$var$performance?.now();
        };
    }, [
        transitionId,
        routeName,
        contentId
    ]);
    return null;
});



var $78QFu = parcelRequire("78QFu");

var $le1Dp = parcelRequire("le1Dp");

var $25MM7 = parcelRequire("25MM7");

var $NAPtM = parcelRequire("NAPtM");

var $bbp3G = parcelRequire("bbp3G");

var $diswb = parcelRequire("diswb");

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");

var $jmjWc = parcelRequire("jmjWc");

var $4MlWS = parcelRequire("4MlWS");

var $d2LG0 = parcelRequire("d2LG0");
const $1e9c3a5949b84c99$export$f358e6beaa924843 = (0, $d2LG0.default)`query NetworkStatusListenerQuery{network{status}}`;



const $8bd37d13e213b9df$var$NetworkStatusFlagLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_Umim",
    name: "NetworkStatusFlagLoader",
    loader: ()=>(parcelRequire("gb3Lk"))
});
const $8bd37d13e213b9df$export$529640d4682c2 = ()=>{
    const { data: data } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $1e9c3a5949b84c99$export$f358e6beaa924843), {
        fetchPolicy: 'cache-only'
    });
    const status = data?.network?.status;
    // 1. experience-tracker
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let reason;
    switch(status){
        case (0, $4MlWS.ClientNetworkStatus).IP_BLOCKED:
            reason = 'IP blocked';
            break;
        case (0, $4MlWS.ClientNetworkStatus).OFFLINE:
            reason = 'Network unavailable';
            break;
    }
    if (reason) experienceTracker.abort({
        reason: reason,
        checkForTimeout: false
    });
    // 2. flags
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8bd37d13e213b9df$var$NetworkStatusFlagLoader, {
        status: status
    });
};



var $bEdUx = parcelRequire("bEdUx");

var $itS9i = parcelRequire("itS9i");

var $hmRc4 = parcelRequire("hmRc4");

var $8Ss4E = parcelRequire("8Ss4E");

var $5ZqQS = parcelRequire("5ZqQS");

var $KcDWk = parcelRequire("KcDWk");

var $gwFzn = parcelRequire("gwFzn");

var $1NBp8 = parcelRequire("1NBp8");

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $hBkCm = parcelRequire("hBkCm");
var $f7B1p = parcelRequire("f7B1p");

var $k3pHv = parcelRequire("k3pHv");
const $b7aff31f4e633d8f$var$checkDomainApproval = async (cloudId, userId, onError)=>{
    let OrgMemberCapabilityType = /*#__PURE__*/ function(OrgMemberCapabilityType) {
        OrgMemberCapabilityType["DIRECT_ACCESS"] = "DIRECT_ACCESS";
        OrgMemberCapabilityType["REQUEST_ACCESS"] = "REQUEST_ACCESS";
        OrgMemberCapabilityType["PENDING_REQUEST_EXISTS"] = "PENDING_REQUEST_EXISTS";
        return OrgMemberCapabilityType;
    }({});
    const params = new URLSearchParams({
        resource: `ari:cloud:confluence::site/${cloudId}`
    });
    let hasCapabilities = false;
    try {
        const response = await (0, $f7B1p.cfetch)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                resource: `ari:cloud:confluence::site/${cloudId}`,
                ACCEPT: 'application/json',
                'Account-Id': userId
            }
        });
        const data = await response.json();
        if (Object.values(data.results)[0] in OrgMemberCapabilityType) hasCapabilities = true;
    } catch (e) {
        const response = (0, $hBkCm.BadStatusError).isBadStatusError(e) ? e.response : undefined;
        const error = new Error(`Error in getting approved domains, status = ${response?.status}, message = "${response?.statusText}"`);
        onError(error);
    }
    return hasCapabilities;
};
const $b7aff31f4e633d8f$export$435bbe3b3c44f9d8 = (isExternalShareRequest = false)=>{
    const { isLicensed: isLicensed, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [isApprovedOrgMember, setIsApprovedOrgMember] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        const validateDomain = async ()=>{
            if (userId && !isLicensed && isExternalShareRequest) {
                const isApproved = await $b7aff31f4e633d8f$var$checkDomainApproval(cloudId, userId, (error)=>{
                    experienceTracker.fail({
                        name: (0, $irVI7.VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE),
                        error: error
                    });
                });
                isApproved && setIsApprovedOrgMember(isApproved);
            }
        };
        validateDomain();
    }, [
        userId,
        isLicensed,
        cloudId,
        experienceTracker,
        isExternalShareRequest
    ]);
    if (!userId) return {
        userType: (0, $k3pHv.UserTypes).ANONYMOUS
    };
    if (isLicensed) return {
        userType: (0, $k3pHv.UserTypes).CONFLUENCE_USER
    };
    return {
        userType: isApprovedOrgMember ? (0, $k3pHv.UserTypes).ORG_MEMBER : (0, $k3pHv.UserTypes).ATLASSIAN_USER
    };
};



var $gXrHX = parcelRequire("gXrHX");
const $a5952995c9c756c1$export$355d4724e049b0df = ({ children: children, path: path })=>{
    const isExternalShareRequest = !!(0, $1NBp8.EXTERNAL_SHARE).match(path);
    const { userType: userType } = (0, $b7aff31f4e633d8f$export$435bbe3b3c44f9d8)(isExternalShareRequest);
    const externalShareContextValue = (0, $gwFzn.useMemo)(()=>({
            isExternalShareRequest: isExternalShareRequest,
            userType: userType
        }), [
        isExternalShareRequest,
        userType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gXrHX.ExternalShareContext).Provider, {
        value: externalShareContextValue
    }, children);
};



var $jmjWc = parcelRequire("jmjWc");

const $af5e1b3a6aa255af$export$38f39b921d5551c1 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "Bc3Ba",
    name: "Heartbeat",
    loader: async ()=>(await (parcelRequire("bkwfe"))).Heartbeat
});



var $jHo7b = parcelRequire("jHo7b");

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $gqqjz = parcelRequire("gqqjz");
const $e4d79357fba42d43$var$i18n = (0, $2nPZH.defineMessages)({
    localStorageQuotaExceededTitle: {
        id: "local-storage-quota-subscriber.flag.quota-exceeded.title",
        defaultMessage: "We ran into a problem"
    },
    localStorageQuotaExceededDescription: {
        id: "local-storage-quota-subscriber.flag.quota-exceeded.description",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We\u2019ve noticed an issue that may affect your experience on Confluence. Select \"Refresh\" below to fix it."
    },
    refreshLocalStorage: {
        id: "local-storage-quota-subscriber.flag.refresh.title",
        defaultMessage: "Refresh"
    }
});
const $e4d79357fba42d43$export$b2c5189af5b5e948 = ()=>{
    const [isOverflown, setIsOverflown] = (0, $gwFzn.useState)(false);
    const [wasShown, setWasShown] = (0, $gwFzn.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        const onQuotaExceeded = ()=>setIsOverflown(true);
        window.addEventListener('local-storage.quota.exceeded', onQuotaExceeded);
        return ()=>{
            setIsOverflown(false);
            window.removeEventListener('local-storage.quota.exceeded', onQuotaExceeded);
        };
    }, [
        setIsOverflown
    ]);
    const clearLocalStorage = ()=>{
        window.localStorage.clear();
        window.location.reload();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'LocalStorageQuotaSubscriber',
                action: 'clicked',
                actionSubject: 'LocalStorageQuotaExceededFlag',
                actionSubjectId: 'localStorageQuotaCleared'
            }
        }).fire();
    };
    const showFlag = (flags)=>{
        if (wasShown) return;
        flags.showWarningFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $e4d79357fba42d43$var$i18n.localStorageQuotaExceededTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $e4d79357fba42d43$var$i18n.localStorageQuotaExceededDescription),
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $e4d79357fba42d43$var$i18n.refreshLocalStorage),
                    href: '',
                    onClick: ()=>clearLocalStorage()
                }
            ]
        });
        setWasShown(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>{
        if (isOverflown) showFlag(flags);
        return null;
    });
};



var $gwFzn = parcelRequire("gwFzn");

var $7J5Uc = parcelRequire("7J5Uc");
const $0f25e4f8facf0d0e$export$913cb5ed19d2180b = (initialTheme)=>{
    const { initializeTheme: initializeTheme } = (0, $7J5Uc.useThemingActions)();
    (0, $gwFzn.useEffect)(()=>{
        initializeTheme(initialTheme);
    // Only execute upon initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};



var $cBuRD = parcelRequire("cBuRD");

var $iFjdQ = parcelRequire("iFjdQ");

var $eHj6r = parcelRequire("eHj6r");


var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");
const $852a6819cc9585c3$export$5f8d39834fd61797 = ({ children: children })=>{
    // allow developers to disable strict mode for local development
    const isStrictModeDisabled = false;
    if (isStrictModeDisabled) return children;
    // React.StrictMode usage is enabled via feature flag or environment variable
    if ((0, $9wGTI.fg)('confluence_strict_mode') || false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).StrictMode, null, children);
    else return children;
};



var $2JYae = parcelRequire("2JYae");

var $9wGTI = parcelRequire("9wGTI");

var $3WLLD = parcelRequire("3WLLD");
var $bj5fB = parcelRequire("bj5fB");

var $hXDOc = parcelRequire("hXDOc");
/* eslint-disable no-restricted-syntax */ 
var $gwFzn = parcelRequire("gwFzn");

var $64KID = parcelRequire("64KID");

var $kE2cJ = parcelRequire("kE2cJ");

var $jmjWc = parcelRequire("jmjWc");

const $e9270d50e13c4524$export$58ad04e57ec143c3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "DOtt7",
    name: "RedirectLegacyCopyPageLoader",
    loader: async ()=>(await (parcelRequire("crKFl"))).RedirectLegacyCopyPage
});
$e9270d50e13c4524$export$58ad04e57ec143c3.NAVIGATION_PARAMS = ()=>false;



var $jmjWc = parcelRequire("jmjWc");

const $1547fdfac1788133$export$70a5a4ee184a1106 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "hF4WF",
    name: "RedirectLegacyViewPageLoader",
    loader: async ()=>(await (parcelRequire("i5Glc"))).RedirectLegacyViewPage
});
$1547fdfac1788133$export$70a5a4ee184a1106.NAVIGATION_PARAMS = ()=>false;


// These are routes shared between SSR and SPA

var $gwFzn = parcelRequire("gwFzn");

var $iJ8K8 = parcelRequire("iJ8K8");

var $5gmpn = parcelRequire("5gmpn");

var $8dwdz = parcelRequire("8dwdz");

var $3PXtn = parcelRequire("3PXtn");

var $gz8ZY = parcelRequire("gz8ZY");
const $6a421125f8ad1b8e$var$routeWithNavigationMapping = new Map();
function $6a421125f8ad1b8e$export$658b4fa209be6b36(match) {
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    // We need to ensure all the entries calling processNavigationParams are returning the same RouteWithNavigation instance
    // So that they won't get re-mounted when switching between routes
    const RouteWithNavParams = $6a421125f8ad1b8e$var$routeWithNavigationMapping.get(match.name);
    if (!RouteWithNavParams) return null;
    const { NAVIGATION_PARAMS: NAVIGATION_PARAMS } = RouteWithNavParams;
    if (typeof NAVIGATION_PARAMS !== 'function') return null;
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const spaceNavParams = NAVIGATION_PARAMS(match, isNav4Enabled);
    const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(RouteWithNavParams, match);
    if (spaceNavParams === false) return element;
    const { Screen: screen, MainLayout: mainLayout, BannerContext: bannerContext } = spaceNavParams;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iJ8K8.Screen), screen, mainLayout === false ? element : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5gmpn.MainLayout), {
        enableNavigation: !isMobile,
        ...mainLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3PXtn.BannerContextProvider), {
        includeTopNav: bannerContext?.includeTopNav
    }, element)));
}
function $6a421125f8ad1b8e$export$5ce5fb2a75a2a873(routes) {
    for(const name in routes){
        const RouteWithNavParams = routes[name];
        if (typeof RouteWithNavParams.NAVIGATION_PARAMS !== 'function') throw new Error(`Route must define a static NAVIGATION_PARAMS function. ${name} is missing the NAVIGATION_PARAMS function. Please read patterns/routing.md`);
        $6a421125f8ad1b8e$var$routeWithNavigationMapping.set(name, RouteWithNavParams);
        routes[name] = $6a421125f8ad1b8e$export$658b4fa209be6b36;
    }
    return routes;
}



var $gwFzn = parcelRequire("gwFzn");

var $cEgMD = parcelRequire("cEgMD");

var $kE2cJ = parcelRequire("kE2cJ");

var $iJ8K8 = parcelRequire("iJ8K8");

var $4NvKO = parcelRequire("4NvKO");

var $4l6Wo = parcelRequire("4l6Wo");

var $1NBp8 = parcelRequire("1NBp8");

var $dEBDF = parcelRequire("dEBDF");

var $iqPBi = parcelRequire("iqPBi");

var $9wGTI = parcelRequire("9wGTI");
function $3dad7419d64a8662$export$3731f94d374dc29b(Component) {
    const SpaceOverviewRoute = (match)=>{
        const { params: { spaceKey: spaceKey = '', contentId: contentId = '' }, query: query } = match;
        if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.COMPANY_HUB).name
        });
        if ((0, $9wGTI.fg)('confluence_frontend_ssr_space_base')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqPBi.SpaceBase), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
            spaceKey: spaceKey,
            contentId: contentId,
            query: query
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
            spaceKey: spaceKey,
            contentId: contentId,
            query: query
        });
    };
    SpaceOverviewRoute.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey = '' }, query: { mode: mode = '' } })=>({
            Screen: {
                screenEvent: {
                    name: 'spaceOverviewScreen',
                    id: spaceKey,
                    attributes: {
                        isGlobalMode: mode === 'global',
                        navdexPointType: (0, $dEBDF.START_TOUCH)
                    }
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                    routeName: (0, $1NBp8.SPACE_OVERVIEW).name,
                    contentType: 'page'
                }
            },
            MainLayout: {
                navView: (0, $4l6Wo.CONTAINER_HOME_ID),
                spaceKey: spaceKey,
                isViewPage: true
            }
        });
    return SpaceOverviewRoute;
}
const $3dad7419d64a8662$export$2df060b942be85a7 = $3dad7419d64a8662$export$3731f94d374dc29b((0, $4NvKO.SpaceOverviewLoader));



var $gwFzn = parcelRequire("gwFzn");

var $gwFzn = parcelRequire("gwFzn");

var $kDuN4 = parcelRequire("kDuN4");
var $inPa6 = parcelRequire("inPa6");

var $1NBp8 = parcelRequire("1NBp8");

var $dPJCf = parcelRequire("dPJCf");

var $bQm3c = parcelRequire("bQm3c");

var $7QM6o = parcelRequire("7QM6o");
const $0d72b6e269966c48$var$isOnCompanyHubRouteArgs = {
    selector: (routeName)=>(0, $1NBp8.COMPANY_HUB).name === routeName
};

const $0d72b6e269966c48$export$83316d703678f96f = ({ children: children })=>{
    const isOnCompanyHubRoute = (0, $dPJCf.useRouteName)($0d72b6e269966c48$var$isOnCompanyHubRouteArgs);
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleAnalyticCaught = (0, $gwFzn.useCallback)(async (event, channel)=>{
        if (event?.payload?.action === 'clicked' || event?.payload?.actionSubject === 'smartLink' && event?.payload?.action === 'renderSuccess') await (parcelRequire("7jLzw")).then(async ({ handleEventCaught: handleEventCaught })=>{
            await handleEventCaught(activationId, cloudId, createAnalyticsEvent, event, !!isOnCompanyHubRoute, channel, spaceId);
        });
    }, [
        activationId,
        cloudId,
        createAnalyticsEvent,
        isOnCompanyHubRoute,
        spaceId
    ]);
    if (!isOnCompanyHubRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kDuN4.default), {
        channel: "*",
        onEvent: handleAnalyticCaught
    }, children);
};



var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $d561062df6e47d30$export$4047609c83584c4b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nCrwB",
    name: "CompanyHomeBuilderUpsellPage",
    loader: async ()=>(await (parcelRequire("fnTWu"))).CompanyHomeBuilderUpsellPage
});



var $8NC5Z = parcelRequire("8NC5Z");

var $7CeAz = parcelRequire("7CeAz");

var $1NBp8 = parcelRequire("1NBp8");

var $dEBDF = parcelRequire("dEBDF");

var $cEgMD = parcelRequire("cEgMD");

var $kE2cJ = parcelRequire("kE2cJ");

var $iJ8K8 = parcelRequire("iJ8K8");

var $1ytiN = parcelRequire("1ytiN");

var $4NvKO = parcelRequire("4NvKO");

var $eqNP8 = parcelRequire("eqNP8");

var $dPJCf = parcelRequire("dPJCf");

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $dIouf = parcelRequire("dIouf");

var $cEgMD = parcelRequire("cEgMD");

var $1ytiN = parcelRequire("1ytiN");

var $9wGTI = parcelRequire("9wGTI");

var $irVI7 = parcelRequire("irVI7");
var $aJPUt = parcelRequire("aJPUt");
var $1kHsc = parcelRequire("1kHsc");

var $8NC5Z = parcelRequire("8NC5Z");

var $gi8UL = parcelRequire("gi8UL");
function $6d8995f9c98e457c$export$567b73f497a151cb({ onSuccess: onSuccess, onExists: onExists, route: route }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isCreatingHub, setIsCreatingHub] = (0, $gwFzn.useState)(false);
    const [creationError, setCreationError] = (0, $gwFzn.useState)(null);
    const { isSiteAdmin: isSiteAdmin, frontCoverState: frontCoverState } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)({
        skip: !(0, $9wGTI.fg)('company-hub-pseudo-app')
    });
    const isCompanyHubUnset = frontCoverState === (0, $cEgMD.FrontCoverStateEnum).UNSET;
    const hasCreatedHub = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (!hasCreatedHub.current && (0, $9wGTI.fg)('company-hub-pseudo-app')) {
            const shouldCreateHub = isCompanyHubUnset && isSiteAdmin && !shouldShowPremiumUpsell && !isCreatingHub;
            if (shouldCreateHub) {
                let wasHubCreated = false;
                setIsCreatingHub(true);
                hasCreatedHub.current = true;
                experienceTracker.start({
                    name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
                });
                (0, $gi8UL.createCompanyHubSpace)().then(({ didCreateSpace: didCreateSpace, homepageId: homepageId })=>{
                    if (didCreateSpace) {
                        experienceTracker.succeed({
                            name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE)
                        });
                        wasHubCreated = true;
                        onSuccess?.(homepageId);
                    } else {
                        experienceTracker.abort({
                            name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                            reason: 'Hub space already exists. Handled by redirecting user to Hub editor without first time experience'
                        });
                        onExists?.(homepageId);
                    }
                }).catch((error)=>{
                    if ((0, $9wGTI.fg)('company-hub-pseudo-app')) setCreationError(error);
                    if ((0, $gi8UL.hasStalePermissionsErrorMessage)(error)) experienceTracker.abort({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        reason: 'User has stale admin permissions'
                    });
                    else if ((0, $dIouf.isUnauthorizedError)(error)) experienceTracker.abort({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        reason: 'User is not authenticated'
                    });
                    else experienceTracker.fail({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        error: error
                    });
                }).finally(()=>{
                    setIsCreatingHub(false);
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            source: 'companyHub',
                            action: 'created',
                            actionSubject: 'onRouteStart',
                            actionSubjectId: 'companyHubOnRouteCreation',
                            attributes: {
                                created: wasHubCreated,
                                route: route
                            }
                        }
                    }).fire();
                });
            }
        }
    }, [
        isCompanyHubUnset,
        isSiteAdmin,
        createAnalyticsEvent,
        shouldShowPremiumUpsell,
        isCreatingHub,
        experienceTracker,
        onSuccess,
        onExists,
        route
    ]);
    return {
        isCreatingHub: isCreatingHub,
        creationError: creationError
    };
}



var $e4o8D = parcelRequire("e4o8D");

var $9wGTI = parcelRequire("9wGTI");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $abC4X = parcelRequire("abC4X");

var $7p4As = parcelRequire("7p4As");

var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $2Nwuj = parcelRequire("2Nwuj");

var $1NBp8 = parcelRequire("1NBp8");

var $dIouf = parcelRequire("dIouf");

var $gi8UL = parcelRequire("gi8UL");
var $24154a8506d1b517$exports = {};
$24154a8506d1b517$exports = new URL("GenericError.cd21964e.svg", import.meta.url).toString();


var $aa8478fa9c3e4fb2$exports = {};
$aa8478fa9c3e4fb2$exports = new URL("RestrictedError.e0fef1fb.svg", import.meta.url).toString();


const $3f49c0dd8d66c83c$var$containerStyles = (0, $ecnYn.xcss)({
    height: '90vh',
    paddingInline: 'space.200'
});
const $3f49c0dd8d66c83c$export$c09c08db0e42b276 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const errorConfig = (0, $gwFzn.useMemo)(()=>{
        if ((0, $gi8UL.hasStalePermissionsErrorMessage)(error)) return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($aa8478fa9c3e4fb2$exports))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceStalePermissionsErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceStalePermissionsErrorFlagDescription, {
                a: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                        href: "https://support.atlassian.com/confluence-cloud/docs/create-and-customize-a-company-hub",
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, chunks)
            })
        };
        if ((0, $dIouf.isUnauthorizedError)(error)) return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($aa8478fa9c3e4fb2$exports))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagDescription, {
                b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
            }),
            buttonLabel: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagButton),
            buttonLink: (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).toUrl()
        };
        return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($24154a8506d1b517$exports))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceErrorFlagDescription)
        };
    }, [
        error,
        formatMessage
    ]);
    const { imageUrl: imageUrl, title: title, description: description, buttonLabel: buttonLabel, buttonLink: buttonLink } = errorConfig;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $3f49c0dd8d66c83c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $abC4X.default), {
        header: title,
        description: description,
        primaryAction: buttonLabel && buttonLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7p4As.default), {
            appearance: "primary",
            href: buttonLink
        }, buttonLabel) : undefined,
        imageUrl: imageUrl
    }));
};



var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $jmjWc = parcelRequire("jmjWc");

const $44a1291d5f4bf190$export$bbf3d8e57337c75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xoU6a",
    _reactTreeRootForServerPlaceholderId: true,
    name: 'CompanyHubMainLayout',
    loader: async ()=>(await (parcelRequire("l7cWL"))).CompanyHubMainLayout
});


function $13aed4a881b0bcc1$export$f5fe5ef796a4c528(Wrapped, routeMatchPredicate = ()=>true) {
    const CompanyHubPseudoAppRoute = (props)=>{
        const wrapped = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Wrapped, props);
        if (routeMatchPredicate(props) && (0, $9wGTI.fg)('company-hub-pseudo-app')) // The Company Hub app-like experience uses its own, doesn't use Confluence's `MainLayout`:
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $44a1291d5f4bf190$export$bbf3d8e57337c75), null, wrapped);
        return wrapped;
    };
    CompanyHubPseudoAppRoute.NAVIGATION_PARAMS = (...args)=>{
        const wrappedNavParams = Wrapped.NAVIGATION_PARAMS(...args);
        if (routeMatchPredicate(args[0]) && (0, $9wGTI.fg)('company-hub-pseudo-app')) // The Company Hub app-like experience uses its own, doesn't use Confluence's `MainLayout`:
        return typeof wrappedNavParams === 'object' ? {
            ...wrappedNavParams,
            MainLayout: false
        } : false;
        return wrappedNavParams;
    };
    return CompanyHubPseudoAppRoute;
}


function $8d67d674949172ba$export$d135e6fd61f0ae86(Component) {
    const CompanyHubRoute = ()=>{
        const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled, isCompanyHubPublished: isCompanyHubPublished } = (0, $7CeAz.useIsCompanyHubEnabled)();
        const { isSiteAdmin: isSiteAdmin, loading: loading } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
        const { push: push } = (0, $dPJCf.useRouteActions)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $6d8995f9c98e457c$export$567b73f497a151cb)({
            onSuccess: (homepageId)=>{
                push((0, $1NBp8.COMPANY_HUB_EDIT).toUrl({}, {
                    query: {
                        redirect: 'first-time',
                        contentId: homepageId
                    }
                }));
            },
            route: (0, $1NBp8.COMPANY_HUB).pattern
        });
        if (isCreatingHub || loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        screenEventAttributes.publishedCompanyHub = isCompanyHubPublished;
        if (shouldShowPremiumUpsell) {
            if (isSiteAdmin || (0, $9wGTI.fg)('company-hub-pseudo-app')) {
                /**
				 * SSR compatibility: CompanyHomeBuilderUpsellPage uses UpsellLooknFeel/SectionMessage
				 * which lacks SSR support. Rendering during SSR would cause:
				 * - Hydration mismatches between server/client renders
				 * - Visible layout shift (CLS) during client hydration since SectionMessage
				 *   appears at the top of the content area
				 *
				 * For now, client-side rendering only, until components are refactored for SSR support.
				 */ if (renderServerPlaceholder) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d561062df6e47d30$export$4047609c83584c4b), {
                    featureName: "companyHub"
                });
            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
                name: (0, $1NBp8.HOME).name
            });
        }
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3f49c0dd8d66c83c$export$c09c08db0e42b276), {
            error: creationError
        });
        if (!isCompanyHubEntryPointEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.HOME).name
        });
        // The only different between SPA and SSR is we don't render space base in SSR
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $0d72b6e269966c48$export$83316d703678f96f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
            spaceKey: spaceKey,
            contentId: ""
        }));
    };
    const screenEventAttributes = {
        navdexPointType: (0, $dEBDF.START_TOUCH),
        // Company Hub hides its space from the user, doesn't refer to its page
        // as such, is rather presented to the user as "a new surface", and thus
        // doesn't constitute space usage from the perspective of the user.
        screenIsInSpace: false
    };
    /**
	 * Warning: Though the function NAVIGATION_PARAMS is invoked during render,
	 * each route has its own implementation. Consequently, it cannot invoke
	 * hooks or, during route transitions between implementations that invoke
	 * different hooks, the rule of hooks to invoke a hook the same number of
	 * times during each render would be violated and an error would be thrown
	 * by React that would damage the DOM.
	 */ CompanyHubRoute.NAVIGATION_PARAMS = ()=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHub',
                    id: spaceKey,
                    // Warning: The value of the analytics event attribute
                    // publishedCompanyHub that ScreenEvent sends will be
                    // inaccurate on initial SPA load without SSR, because
                    // ScreenEvent sends before SPAViewContext has loaded.
                    attributes: screenEventAttributes
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                    routeName: (0, $1NBp8.COMPANY_HUB).name
                }
            },
            MainLayout: {
                navView: (0, $4l6Wo.PRODUCT_HOME_ID),
                spaceKey: spaceKey,
                isViewPage: true
            }
        };
    };
    return (0, $13aed4a881b0bcc1$export$f5fe5ef796a4c528)(CompanyHubRoute);
}
const $8d67d674949172ba$export$ea13ab632841088 = $8d67d674949172ba$export$d135e6fd61f0ae86((0, $4NvKO.SpaceOverviewLoader));



var $gwFzn = parcelRequire("gwFzn");

var $cEgMD = parcelRequire("cEgMD");

var $4l6Wo = parcelRequire("4l6Wo");


var $8NC5Z = parcelRequire("8NC5Z");

var $1NBp8 = parcelRequire("1NBp8");


var $eqNP8 = parcelRequire("eqNP8");

var $ep3mz = parcelRequire("ep3mz");

var $dPJCf = parcelRequire("dPJCf");

var $dEBDF = parcelRequire("dEBDF");


var $gwFzn = parcelRequire("gwFzn");

var $8NC5Z = parcelRequire("8NC5Z");

var $5gmpn = parcelRequire("5gmpn");

var $iJ8K8 = parcelRequire("iJ8K8");

var $jmjWc = parcelRequire("jmjWc");
var $2w2Hu = parcelRequire("2w2Hu");

const $e7545f5dec589966$export$99fa8db8497fb663 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "rBMHt",
    name: 'EditPageLoaderServer',
    loader: async ()=>(await (parcelRequire("PWqGR"))).EditPageLoaderServer,
    _mustPreloadWhenRenderingSPA: [
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicEditorContextProviderLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).NativeCollabLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).FullPageEditorLoader
    ]
});



var $8dwdz = parcelRequire("8dwdz");

var $4l6Wo = parcelRequire("4l6Wo");

var $1NBp8 = parcelRequire("1NBp8");

var $cEgMD = parcelRequire("cEgMD");

var $3PXtn = parcelRequire("3PXtn");
function $ef4380efcf1da8eb$export$b5c57a98f1ddfa55(uri) {
    return uri.includes('/edit-v2/');
}
function $ef4380efcf1da8eb$export$4ceedc3d36a46889(query) {
    const draftShareId = query?.draftShareId;
    return Array.isArray(draftShareId) ? draftShareId?.[0] : draftShareId;
}


const $ec45f4b8e7cc34aa$export$6a3218472cdf374a = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey }, query: query })=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)({
        skip: !isCompanyHub
    });
    const contentType = name === (0, $1NBp8.EDIT_PAGE_V2).name || name === (0, $1NBp8.COMPANY_HUB_EDIT).name ? 'page' : 'blogpost';
    const draftShareId = (0, $ef4380efcf1da8eb$export$4ceedc3d36a46889)(query);
    const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3PXtn.BannerContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e7545f5dec589966$export$99fa8db8497fb663), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }));
    //
    // navView
    //
    let navView = (0, $4l6Wo.CONTAINER_HOME_ID);
    if (isCompanyHub) {
        if (shouldShowPremiumUpsell) return null;
        else if (name === (0, $1NBp8.COMPANY_HUB_EDIT).name) // CompanyHubEditRoute provides its own Screen and MainLayout.
        return children;
        navView = (0, $4l6Wo.PRODUCT_HOME_ID);
    } else if (contentType === 'blogpost') navView = (0, $4l6Wo.CONTAINER_BLOG_ID);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iJ8K8.Screen), {
        showPremiumOnboarding: false,
        pageState: {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType
        },
        screenEvent: {
            name: 'editPageScreen',
            id: contentId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5gmpn.MainLayout), {
        enableNavigation: !(0, $8dwdz.shouldShowMobileWeb)(),
        spaceKey: spaceKey,
        navView: navView,
        isViewPage: true
    }, children));
};



function $aa6dab5502f2e37f$export$39a78a0252c20555(component) {
    const CompanyHubEditRoute = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const [queriedContentId, setQueriedContentId] = (0, $gwFzn.useState)(null);
        const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $6d8995f9c98e457c$export$567b73f497a151cb)({
            onSuccess: (homepageId)=>{
                setQueriedContentId(homepageId);
                setQueryParams({
                    redirect: 'first-time'
                });
            },
            onExists: (homepageId)=>{
                setQueriedContentId(homepageId);
            },
            route: (0, $1NBp8.COMPANY_HUB_EDIT).pattern
        });
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3f49c0dd8d66c83c$export$c09c08db0e42b276), {
            error: creationError
        });
        if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d561062df6e47d30$export$4047609c83584c4b), {
            featureName: "companyHub"
        });
        // If there is no contentId in SSR then we will just see the FullPageLoadingScreen being rendered
        // So we skip the loading screen component to ensure the EditPageRoute is rendered instead
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ((isCreatingHub || !queriedContentId && !contentId) && true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        const Component = component;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
            ...routeProps,
            params: {
                contentId: contentId ?? (queriedContentId || ''),
                spaceKey: spaceKey,
                contentType: 'pages'
            }
        });
    };
    CompanyHubEditRoute.NAVIGATION_PARAMS = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHubEditScreen',
                    id: spaceKey,
                    attributes: {
                        navdexPointType: (0, $dEBDF.END),
                        // Company Hub hides its space from the user, doesn't refer to its page
                        // as such, is rather presented to the user as "a new surface", and thus
                        // doesn't constitute space usage from the perspective of the user.
                        screenIsInSpace: false
                    }
                },
                // When no contentId is passed, Screen.js handles querying it and updating pageState with it.
                // usually, this is done by the Screen.js component, but in this case, we need to do it here
                // because contentId is not getting queried properly on route creation.
                pageState: {
                    spaceKey: spaceKey,
                    contentId: routeProps?.query?.contentId
                }
            },
            MainLayout: {
                navView: (0, $4l6Wo.PRODUCT_HOME_ID)
            }
        };
    };
    return (0, $13aed4a881b0bcc1$export$f5fe5ef796a4c528)(CompanyHubEditRoute);
}
const $aa6dab5502f2e37f$export$31ce72eecdb1dd8 = $aa6dab5502f2e37f$export$39a78a0252c20555((0, $ec45f4b8e7cc34aa$export$6a3218472cdf374a));





var $jiJCD = parcelRequire("jiJCD");

var $gwFzn = parcelRequire("gwFzn");

var $cKyDI = parcelRequire("cKyDI");

var $kJOOQ = parcelRequire("kJOOQ");
parcelRequire("lwdd5");

var $aTWRz = parcelRequire("aTWRz");
var $iyEDi = parcelRequire("iyEDi");
const $8012954d5e28a430$export$33ab8fb3f76d8b14 = ()=>{
    const location = (0, $cKyDI.useSelector)((0, $iyEDi.getLocation));
    const dispatch = (0, $cKyDI.useDispatch)();
    (0, $gwFzn.useEffect)(()=>{
        const { query: query, pathname: pathname } = location;
        let contentType;
        if (pathname.indexOf('/createpage.action') !== -1 || pathname.indexOf('/createpage-entervariables.action') !== -1) contentType = 'pages';
        else if (pathname.indexOf('/createblogpost.action') !== -1) contentType = 'blog';
        else {
            dispatch((0, $kJOOQ.replace)({
                pathname: (0, $aTWRz.CONTEXT_PATH)
            }));
            return;
        }
        let spaceKey;
        if (typeof query.spaceKey !== 'undefined' && query.spaceKey) spaceKey = query.spaceKey;
        else if (typeof query.draftId !== 'undefined' && /^[0-9]+$/.test(query.draftId)) spaceKey = 'byDraft';
        else {
            dispatch((0, $kJOOQ.replace)({
                pathname: (0, $aTWRz.CONTEXT_PATH)
            }));
            return;
        }
        const newQuery = {};
        Object.keys(query).filter((param)=>param !== 'spaceKey').forEach((param)=>newQuery[param] = query[param]);
        const nextLocation = {
            ...location,
            pathname: `${(0, $aTWRz.CONTEXT_PATH)}/spaces/${spaceKey}/${contentType}/create`,
            query: newQuery,
            search: (0, $jiJCD.format)({
                query: newQuery
            })
        };
        dispatch((0, $kJOOQ.replace)(nextLocation));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
$8012954d5e28a430$export$33ab8fb3f76d8b14.NAVIGATION_PARAMS = ()=>false;



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $c1cdb40c21dd0ca3$export$6e2f6a8db94682b4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "93O33",
    name: "ForgeGlobalSettingsExtensionPoint",
    loader: async ()=>(await (parcelRequire("bbXjt"))).GlobalSettings
});


const $d553d8b4da7f3160$export$25552d6a584e1fb8 = ({ params: { id: id } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c1cdb40c21dd0ca3$export$6e2f6a8db94682b4), {
        key: id,
        id: id
    });
$d553d8b4da7f3160$export$25552d6a584e1fb8.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminForgeApps'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $47940fef216e9562$export$2709da4acd7d0aec = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Q3Ruy",
    name: "AdvancedSearch",
    loader: async ()=>(await (parcelRequire("dVLZi"))).AdvancedSearch
});



var $9wGTI = parcelRequire("9wGTI");
const $f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $47940fef216e9562$export$2709da4acd7d0aec), null);
$f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: (0, $9wGTI.fg)('unified_search_in_confluence') ? null : {
            screenEvent: {
                name: 'advancedSearchScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    };
};


/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $f9284ca1d97b2b7a$export$32926c3a37851958 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Rr_Hq",
    name: "BetaFeaturesSiteSettingsPageLoader",
    loader: async ()=>(await (parcelRequire("6gUNV"))).BetaFeaturesSiteSettingsPage
});


const $7949c11e9e78d917$export$39279dc1d0cb138f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f9284ca1d97b2b7a$export$32926c3a37851958), null);
$7949c11e9e78d917$export$39279dc1d0cb138f.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'betaFeaturesScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $kb9X9 = parcelRequire("kb9X9");
const $c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD = `confluence.fabric.content.renderer.download`;

var $c3f88486f5953222$export$2e2bcd8739ae039 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cDY9-",
    name: 'ClassicContentRendererLoader',
    loader: async ()=>{
        (0, $kb9X9.performanceMarkInProd)(`${$c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD}.start`);
        const module = await (parcelRequire("izaXd"));
        (0, $kb9X9.performanceMarkInProd)(`${$c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD}.end`);
        return module;
    }
});





var $78QFu = parcelRequire("78QFu");

var $jmjWc = parcelRequire("jmjWc");

const $b4ceb88d52b227e6$var$ExternalSharePageLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "d8xw-",
    name: "ExternalSharePageLoader",
    loader: async ()=>(await (parcelRequire("41sCE"))).ExternalSharePage
});
const $b4ceb88d52b227e6$export$2f64eafbbfb5bb9f = ({ params: { contentId: contentId, externalToken: externalToken }, hash: hash })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b4ceb88d52b227e6$var$ExternalSharePageLoader, {
        siteUrl: window.location.hostname,
        contentId: contentId === 'undefined' ? undefined : contentId,
        shareToken: externalToken,
        queryHash: hash,
        ContentRenderer: (0, $c3f88486f5953222$export$2e2bcd8739ae039)
    });
$b4ceb88d52b227e6$export$2f64eafbbfb5bb9f.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'viewPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: true,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                routeName: name
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $2a1308b9f924bd74$export$dceb5680f254ba0d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4i8AJ",
    name: "ForgeGlobalPageExtensionPoint",
    loader: async ()=>(await (parcelRequire("3bJ78"))).GlobalPage
});



var $9wGTI = parcelRequire("9wGTI");
const $88f9531119605f50$export$a0e2b6c59fd25a4e = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2a1308b9f924bd74$export$dceb5680f254ba0d), {
        key: `${appId}-${envId}-${forgeManifestRoute}`,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    });
$88f9531119605f50$export$a0e2b6c59fd25a4e.NAVIGATION_PARAMS = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>{
    return (0, $9wGTI.fg)('forge-ui-enable-fpa-route') ? false : {
        Screen: {
            screenEvent: {
                name: 'globalPageScreen',
                id: appId,
                attributes: {
                    appId: appId,
                    envId: envId,
                    forgeManifestRoute: forgeManifestRoute
                }
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    };
};



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $5651b1434c6bae88$var$SitePermissions = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8YbJt",
    name: "SitePermissions",
    loader: async ()=>(await (parcelRequire("6TdGc"))).SitePermissions
});
const $5651b1434c6bae88$export$72e24cb8f0330a61 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5651b1434c6bae88$var$SitePermissions, null);
$5651b1434c6bae88$export$72e24cb8f0330a61.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $ayyKy = parcelRequire("ayyKy");


var $jmjWc = parcelRequire("jmjWc");

var $agglT = parcelRequire("agglT");

const $b11848dc615e604f$export$b212d6e1ccf8d345 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uZr6h",
    loader: async ()=>(await (parcelRequire("jlDGT"))).CompanyHubSettingsPage,
    name: 'CompanyHubSettingsPage'
});


var $agglT = parcelRequire("agglT");

var $8NC5Z = parcelRequire("8NC5Z");

var $cEgMD = parcelRequire("cEgMD");

var $1ytiN = parcelRequire("1ytiN");




var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $ayyKy = parcelRequire("ayyKy");

var $cEgMD = parcelRequire("cEgMD");

var $kE2cJ = parcelRequire("kE2cJ");

var $1NBp8 = parcelRequire("1NBp8");

var $9wGTI = parcelRequire("9wGTI");

const $3dace45d43821ccc$var$SpacePermissionsSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3C38l",
    name: "SpacePermissionsSettingsRouteComponent",
    loader: async ()=>(parcelRequire("8usNm"))
});
const $3dace45d43821ccc$var$DEFAULT_TAB = 'users';
const $3dace45d43821ccc$export$c4e68572e7b94bc6 = ({ name: routeName, params: { spaceKey: spaceKey, tab: tab = $3dace45d43821ccc$var$DEFAULT_TAB } })=>{
    //
    // Warning:
    // "Hub permissions" is a customization of "Space permissions" predating RBAC so
    // "Hub permissions" is to be used in the Company Hub-type of space and
    // "Space permisisons" or RBAC are to be used in all other types of space!
    //
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    if (isCompanyHub) {
        if (routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name,
            params: {
                tab: 'users'
            }
        });
    } else {
        //RBAC Milestone 2 Redirect Logic in case users try to access via url
        const isSpacePermissionsTab = tab === 'users' || tab === 'groups' || tab === 'guests';
        if (isSpacePermissionsTab && (0, $9wGTI.fg)('cc_perms_exp_rbac_fe_milestone_2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.SPACE_MEMBERS).name,
            params: {
                spaceKey: spaceKey
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3dace45d43821ccc$var$SpacePermissionsSettingsRouteComponent, {
        spaceKey: spaceKey,
        tab: tab
    });
};
$3dace45d43821ccc$export$c4e68572e7b94bc6.NAVIGATION_PARAMS = (routeMatch, isNav4Enabled)=>{
    const { name: name, params: { spaceKey: spaceKey, tab: tab = $3dace45d43821ccc$var$DEFAULT_TAB } } = routeMatch;
    return {
        Screen: {
            screenEvent: {
                name: tab === 'public-links' ? 'spacePermissionsPublicLinksScreen' : `${tab}SpacePermissionsScreen`,
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: $3dace45d43821ccc$var$getSideNav(routeMatch, isNav4Enabled),
            spaceKey: spaceKey
        }
    };
};
const $3dace45d43821ccc$var$getSideNav = (routeMatch, isNav4Enabled)=>(0, $cEgMD.isCompanyHubSpaceKey)(routeMatch.params.spaceKey) && (0, $ayyKy.getCompanyHubSideNav)(routeMatch) ? (0, $4l6Wo.ADMIN_HOME_ID) : isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID);


/**
 * The routes "Company Hub settings > Users" and "Hub permissions" in the Confluence app.
 * `AdminCompanyHubPermissionsRoute` wraps this one to implement the Company Hub pseudo app.
 */ function $ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute({ params: params, ...props }) {
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    if (isSiteAdmin && shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d561062df6e47d30$export$4047609c83584c4b), {
        featureName: "companyHubPermissions"
    });
    if (!params.tab) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), {
        tab: (0, $agglT.CompanyHubSettingsPageTabsType).USERS
    });
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3dace45d43821ccc$export$c4e68572e7b94bc6), {
        ...props,
        params: {
            spaceKey: spaceKey,
            ...params
        }
    });
}
$ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute.NAVIGATION_PARAMS = (routeMatch)=>{
    const { name: name, params: params } = routeMatch;
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    const navView = (0, $ayyKy.getCompanyHubSideNav)(routeMatch) ? (0, $4l6Wo.ADMIN_HOME_ID) : (0, $4l6Wo.COMPANY_HUB_SETTINGS_ID);
    return {
        Screen: {
            screenEvent: {
                name: `${params.tab || 'consolidated'}HubPermissionsScreen`,
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: navView,
            spaceKey: spaceKey
        }
    };
};
const $ce2a2ee7f6871785$export$eeb7368e8bf944ac = (0, $13aed4a881b0bcc1$export$f5fe5ef796a4c528)($ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute);



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");

const $4fa13b181dc663ad$var$CustomizeNavigation = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Ss1hK",
    name: "CustomizeNavigation",
    loader: async ()=>(await (parcelRequire("2eDnn"))).CustomizeNavigation
});
const $4fa13b181dc663ad$export$3206f56dd9eda6e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4fa13b181dc663ad$var$CustomizeNavigation, null);
$4fa13b181dc663ad$export$3206f56dd9eda6e.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'customizeNavigationScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });
const $4fa13b181dc663ad$export$5744f34ed241a45c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name
    });
$4fa13b181dc663ad$export$5744f34ed241a45c.NAVIGATION_PARAMS = ()=>false;



var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $9dff8dc763109b25$export$a4a7c409f3d3e524 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LLjB-",
    name: "GlobalAutomationRoute",
    loader: async ()=>(await (parcelRequire("lVWBn"))).Automation
});
$9dff8dc763109b25$export$a4a7c409f3d3e524.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'globalAutomationRoute'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $3e17cd15ad9a2d77$var$UserDetails = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4otHM",
    name: "UserDetails",
    loader: async ()=>(await (parcelRequire("8o0Cg"))).UserDetails
});
const $3e17cd15ad9a2d77$export$ef0ae9b94af7599 = ({ params: { accountId: accountId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3e17cd15ad9a2d77$var$UserDetails, {
        accountId: accountId
    });
$3e17cd15ad9a2d77$export$ef0ae9b94af7599.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsUserDetailsScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $a311429dbe08f666$export$6b6e4f47fea5bdb9 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "w4gXW",
    name: "ViewPagePdfExportLoader",
    loader: async ()=>(await (parcelRequire("gXCXf"))).ViewPagePdfExportPage
});



var $f1JyU = parcelRequire("f1JyU");

var $f5aR2 = parcelRequire("f5aR2");

var $iqZzD = parcelRequire("iqZzD");
const $de365c057d45c0f8$export$d4d3fe32e0af1ab9 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a311429dbe08f666$export$6b6e4f47fea5bdb9), {
        contentId: String(contentId),
        spaceKey: String(spaceKey),
        classicComments: (0, $f1JyU.CommentsSectionLoader)
    })));
$de365c057d45c0f8$export$d4d3fe32e0af1ab9.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                contentId: contentId,
                routeName: name,
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'pdfExportScreen'
            }
        },
        MainLayout: {
            enableNavigation: false,
            spaceKey: spaceKey
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $iJ8K8 = parcelRequire("iJ8K8");

var $4NvKO = parcelRequire("4NvKO");

var $f5aR2 = parcelRequire("f5aR2");

var $iqZzD = parcelRequire("iqZzD");
const $cdc5bb1b4ce25ace$export$f10520cd46ef45dd = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4NvKO.SpaceOverviewLoader), {
        spaceKey: String(spaceKey)
    })));
$cdc5bb1b4ce25ace$export$f10520cd46ef45dd.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                routeName: name,
                contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'pdfExportScreen'
            },
            spaceKey: spaceKey
        },
        MainLayout: {
            enableNavigation: false
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $1wgMJ = parcelRequire("1wgMJ");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $dEBDF = parcelRequire("dEBDF");

const $24a857c7c96255d7$var$PeopleDirectory = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zWQBJ",
    name: "PeopleDirectory",
    loader: async ()=>(await (parcelRequire("b8an5"))).PeopleDirectory
});
const $24a857c7c96255d7$export$c7bf94fd367d52ef = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($24a857c7c96255d7$var$PeopleDirectory, {
        statusCodeHandlers: {
            401: (0, $1wgMJ.redirectToLoginPage)
        }
    });
$24a857c7c96255d7$export$c7bf94fd367d52ef.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: {
            name: 'inProdPeopleDirectory',
            attributes: {
                navdexPointType: (0, $dEBDF.START_TOUCH)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    };
};



var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $1NBp8 = parcelRequire("1NBp8");

const $a6aaee7eaacb3bc0$export$1696ac6f866195be = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "MGscQ",
    name: "MarketplaceRoute",
    loader: async ()=>(await (parcelRequire("lzjGS"))).Marketplace
});
$a6aaee7eaacb3bc0$export$1696ac6f866195be.NAVIGATION_PARAMS = ({ name: name })=>{
    let eventName = '';
    let navView = (0, $4l6Wo.PRODUCT_HOME_ID);
    if (name === (0, $1NBp8.MARKETPLACE_FIND_APPS).name) {
        eventName = 'marketplaceFindApps';
        navView = (0, $4l6Wo.PRODUCT_HOME_ID);
    } else if (name === (0, $1NBp8.MARKETPLACE_APP_REQUESTS).name) {
        eventName = 'marketplaceAppRequests';
        navView = (0, $4l6Wo.ADMIN_HOME_ID);
    } else if ((0, $1NBp8.MARKETPLACE_MANAGE_PROMOTIONS).name) {
        eventName = 'marketplacePromotions';
        navView = (0, $4l6Wo.ADMIN_HOME_ID);
    }
    return {
        Screen: {
            screenEvent: {
                name: eventName,
                id: eventName
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $3dce15286068fd34$export$f2df3d24f362ca75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "QJy0w",
    name: "ForgeSpacePageExtensionPoint",
    loader: async ()=>(await (parcelRequire("5zmKh"))).SpacePage
});



var $iqZzD = parcelRequire("iqZzD");
const $e20a45805838a7c5$export$16cbc228d727cb5e = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3dce15286068fd34$export$f2df3d24f362ca75), {
        key: appId + envId + forgeManifestRoute,
        spaceKey: spaceKey,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    }));
};
$e20a45805838a7c5$export$16cbc228d727cb5e.NAVIGATION_PARAMS = ({ name: name, params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceForgeApps',
                id: spaceKey,
                attributes: {
                    appId: appId,
                    envId: envId,
                    forgeManifestRoute: forgeManifestRoute
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });


/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $70d1956925899c9e$var$SpaceSettingsForgeAppsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zXYF3",
    name: "SpaceSettingsForgeAppsRouteComponent",
    loader: ()=>(parcelRequire("iWtnm"))
});
const $70d1956925899c9e$export$21a09e0ddc77eafe = ({ params: { appId: appId, forgeManifestRoute: forgeManifestRoute, envId: envId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($70d1956925899c9e$var$SpaceSettingsForgeAppsRouteComponent, {
        spaceKey: spaceKey,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    });
$70d1956925899c9e$export$21a09e0ddc77eafe.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, appId: appId, envId: envId } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsForgeApps',
                id: spaceKey,
                attributes: {
                    appId: appId,
                    envId: envId
                }
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $3d2592d831aaf97c$var$SpaceSettingsArchiveSpaceRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZLKey",
    name: "SpaceSettingsArchiveSpaceRouteComponent",
    loader: ()=>(parcelRequire("ft1IA"))
});
const $3d2592d831aaf97c$export$c5e406a0947cdc56 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3d2592d831aaf97c$var$SpaceSettingsArchiveSpaceRouteComponent, {
        spaceKey: spaceKey
    });
$3d2592d831aaf97c$export$c5e406a0947cdc56.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsArchiveSpace',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $c1c9698c93be07c8$var$SpaceSettingsEditorConversionRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "640l2",
    name: "SpaceSettingsEditorConversionRouteComponent",
    loader: ()=>(parcelRequire("2Tacf"))
});
const $c1c9698c93be07c8$export$698dfc3fe326e6d2 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c1c9698c93be07c8$var$SpaceSettingsEditorConversionRouteComponent, {
        spaceKey: spaceKey
    });
$c1c9698c93be07c8$export$698dfc3fe326e6d2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsEditorConversion',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $ada82682e35c0989$var$SpaceSettingsContentStateRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "dJgx9",
    name: "SpaceSettingsContentStateRouteComponent",
    loader: ()=>(parcelRequire("3Deu1"))
});
const $ada82682e35c0989$export$9cf7aa4fa48eb220 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ada82682e35c0989$var$SpaceSettingsContentStateRouteComponent, {
        spaceKey: spaceKey
    });
$ada82682e35c0989$export$9cf7aa4fa48eb220.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsContentState',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $5fd2607ebf0fb934$var$SpaceSettingsRelatedPagesRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "z-Bup",
    name: "SpaceSettingsRelatedPagesRouteComponent",
    loader: async ()=>(await (parcelRequire("5baWg"))).SpaceSettingsRelatedPagesRouteComponent
});
const $5fd2607ebf0fb934$export$50efde5a87cc8957 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5fd2607ebf0fb934$var$SpaceSettingsRelatedPagesRouteComponent, {
        spaceKey: spaceKey
    });
$5fd2607ebf0fb934$export$50efde5a87cc8957.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsRelatedPages',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $c991c60ce35a3f45$var$SpaceSettingsEditFeaturesRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "iFso2",
    name: "SpaceSettingsEditFeaturesRouteComponent",
    loader: async ()=>(await (parcelRequire("8wlfd"))).SpaceSettingsEditFeaturesRouteComponent
});
const $c991c60ce35a3f45$export$769dfef0447f3a55 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c991c60ce35a3f45$var$SpaceSettingsEditFeaturesRouteComponent, {
        spaceKey: spaceKey
    });
$c991c60ce35a3f45$export$769dfef0447f3a55.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsEditFeatures',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $feuG2 = parcelRequire("feuG2");

var $kE2cJ = parcelRequire("kE2cJ");

var $64KID = parcelRequire("64KID");

var $4l6Wo = parcelRequire("4l6Wo");

var $iqZzD = parcelRequire("iqZzD");

var $9wGTI = parcelRequire("9wGTI");
const $ae6364090fd3faa0$export$45c01163cd56b3a2 = ({ params: { spaceKey: spaceKey } })=>{
    if ((0, $9wGTI.fg)('confluence-fe-space-settings-space-details')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $feuG2.LazySpaceDetailsPage), {
        spaceKey: spaceKey
    }));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $64KID.namedRoutes).SPACE_SETTINGS.name,
        params: {
            spaceKey: spaceKey
        }
    });
};
$ae6364090fd3faa0$export$45c01163cd56b3a2.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: (0, $feuG2.SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $4l6Wo = parcelRequire("4l6Wo");

const $ea3042d7dfb4b938$var$SpaceLookAndFeelSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EJBqs",
    name: "SpaceLookAndFeelSettingsRouteComponent",
    loader: async ()=>(parcelRequire("6RKjm"))
});
const $ea3042d7dfb4b938$export$9ebf5b01b0356442 = ({ params: { spaceKey: spaceKey, tab: tab } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ea3042d7dfb4b938$var$SpaceLookAndFeelSettingsRouteComponent, {
        spaceKey: spaceKey,
        tab: tab
    });
};
$ea3042d7dfb4b938$export$9ebf5b01b0356442.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingLookAndFeelPage',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $8dwdz = parcelRequire("8dwdz");

var $iqZzD = parcelRequire("iqZzD");

const $6079beeead36a4aa$var$ArchivedPagesListContainer = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "mIHzp",
    name: "ArchivedPagesListContainer",
    loader: async ()=>(await (parcelRequire("iiV7G"))).ArchivedPagesListContainer
});
const $6079beeead36a4aa$export$77792abc2bfae7a1 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6079beeead36a4aa$var$ArchivedPagesListContainer, {
        spaceKey: spaceKey
    }));
};
$6079beeead36a4aa$export$77792abc2bfae7a1.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>{
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    return {
        Screen: {
            screenEvent: {
                name: 'spaceArchivedPages',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            enableNavigation: !isMobile
        }
    };
};


/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $9ad8ac092b3ce6dd$var$SpaceSettingsDataClassificationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EYcHq",
    name: "SpaceSettingsDataClassificationRouteComponent",
    loader: ()=>(parcelRequire("5oZuH"))
});
const $9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9ad8ac092b3ce6dd$var$SpaceSettingsDataClassificationRouteComponent, {
        spaceKey: spaceKey
    });
$9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsDataClassification',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $ltKTq = parcelRequire("ltKTq");

var $4H46k = parcelRequire("4H46k");
function $e84d6ad8839aa142$export$355693d248632c9a() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyTeamCalendars), {
        calendarContext: (0, $ltKTq.CALENDAR_CONTEXT).MY_CALENDARS
    });
}
$e84d6ad8839aa142$export$355693d248632c9a.NAVIGATION_PARAMS = ({ spaceKey: spaceKey })=>({
        Screen: {
            screenEvent: {
                name: 'myCalendarsScreen',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey
        }
    });


/* eslint-disable react/prop-types */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $ltKTq = parcelRequire("ltKTq");

const $116a232d5237eb91$var$SpaceTeamCalendarsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "tO6zv",
    name: "SpaceTeamCalendarsRouteComponent",
    loader: ()=>(parcelRequire("fjPoa"))
});
const $116a232d5237eb91$export$c1ba174e1a668b1a = ({ params: { subCalendarId: subCalendarId } })=>{
    const calendarContext = subCalendarId ? (0, $ltKTq.CALENDAR_CONTEXT).SPACE_SUBCALENDAR : (0, $ltKTq.CALENDAR_CONTEXT).SPACE_CALENDARS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($116a232d5237eb91$var$SpaceTeamCalendarsRouteComponent, {
        subCalendarId: subCalendarId,
        calendarContext: calendarContext
    });
};
$116a232d5237eb91$export$c1ba174e1a668b1a.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, subCalendarId: subCalendarId } })=>{
    return {
        Screen: {
            screenEvent: {
                name: 'spaceTeamCalendarsScreen',
                id: spaceKey,
                attributes: {
                    isSingleCalendar: !!subCalendarId
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    };
};



var $gwFzn = parcelRequire("gwFzn");

var $ltKTq = parcelRequire("ltKTq");

var $4H46k = parcelRequire("4H46k");
const $40c2c72cc1663e14$export$b6ba0c14cb68dffc = ({ params: { subCalendarId: subCalendarId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyTeamCalendars), {
        calendarContext: (0, $ltKTq.CALENDAR_CONTEXT).EMBEDDED_SUBCALENDAR,
        subCalendarId: subCalendarId
    });
};
$40c2c72cc1663e14$export$b6ba0c14cb68dffc.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, subCalendarId: subCalendarId } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceEmbeddedSubcalendarScreen',
                id: spaceKey,
                attributes: {
                    subCalendarId: subCalendarId
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            enableNavigation: false,
            spaceKey: spaceKey
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $ku3HK = parcelRequire("ku3HK");
const $6b9376eebbcdd446$export$e2f6c7ec524fdd6a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ku3HK.LazySpaceDirectory), null);
$6b9376eebbcdd446$export$e2f6c7ec524fdd6a.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceDirectoryScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $cEgMD = parcelRequire("cEgMD");

var $kE2cJ = parcelRequire("kE2cJ");

var $1NBp8 = parcelRequire("1NBp8");

const $bdfe305fbc319d8d$var$SpaceSettingsLandingPageRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EHSjL",
    name: "SpaceSettingsLandingPageRouteComponent",
    loader: ()=>(parcelRequire("wRQQ8"))
});
const $bdfe305fbc319d8d$export$b0e13503df86295 = ({ params: { spaceKey: spaceKey } })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name,
        params: {
            spaceKey: spaceKey,
            tab: 'users'
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bdfe305fbc319d8d$var$SpaceSettingsLandingPageRouteComponent, {
        spaceKey: spaceKey
    });
};
$bdfe305fbc319d8d$export$b0e13503df86295.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsLandingPage',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });




var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");

var $1iSzD = parcelRequire("1iSzD");

var $ep3mz = parcelRequire("ep3mz");

var $4NvKO = parcelRequire("4NvKO");

var $480xA = parcelRequire("480xA");

var $f1JyU = parcelRequire("f1JyU");

var $6O2BV = parcelRequire("6O2BV");

var $f5aR2 = parcelRequire("f5aR2");

var $iqZzD = parcelRequire("iqZzD");

var $4H46k = parcelRequire("4H46k");

var $9pOEz = parcelRequire("9pOEz");

var $9wGTI = parcelRequire("9wGTI");
const $6c697104f01a0e5d$var$EmbeddedSpaceOverview = ({ spaceKey: spaceKey, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $480xA.EmbeddedViewPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        classicComments: (0, $f1JyU.CommentsSectionLoader),
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader),
        showHeaderButtons: false
    }));
};
const $6c697104f01a0e5d$var$SpaceOverview = ({ spaceKey: spaceKey })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4NvKO.SpaceOverviewLoader), {
        spaceKey: spaceKey
    });
};
const $6c697104f01a0e5d$export$495cec58911c040d = ({ spaceKey: spaceKey })=>{
    const [contextContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = contextContentId ?? '';
    const component = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6c697104f01a0e5d$var$EmbeddedSpaceOverview, {
        contentId: contentId,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6c697104f01a0e5d$var$SpaceOverview, {
        spaceKey: spaceKey
    });
    if ((0, $9wGTI.fg)('confluence_frontend_ssr_space_base')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9pOEz.CommentContextWrapper), null, component)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyDwellTime), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), {
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9pOEz.CommentContextWrapper), null, component))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyDwellTime), null));
};
var $6c697104f01a0e5d$export$2e2bcd8739ae039 = $6c697104f01a0e5d$export$495cec58911c040d;


const $8290afb66ac54848$export$200c90655ff1c697 = (0, $3dad7419d64a8662$export$3731f94d374dc29b)((0, $6c697104f01a0e5d$export$495cec58911c040d));




const $f6b27607b6d81126$export$d8819c37d45ffdfc = (0, $8d67d674949172ba$export$d135e6fd61f0ae86)((0, $6c697104f01a0e5d$export$495cec58911c040d));



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");


var $agglT = parcelRequire("agglT");

var $8NC5Z = parcelRequire("8NC5Z");

var $1NBp8 = parcelRequire("1NBp8");

var $cEgMD = parcelRequire("cEgMD");

/**
 * The route "Company Hub settings > Analytics" in the Confluence app.
 * `CompanyHubAnalyticsRoute` wraps this one to implement the Company Hub pseudo app.
 */ function $b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute() {
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d561062df6e47d30$export$4047609c83584c4b), {
        featureName: "companyHub"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), {
        tab: (0, $agglT.CompanyHubSettingsPageTabsType).ANALYTICS
    });
}
$b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute.NAVIGATION_PARAMS = (_routeMatch, isNav4Enabled)=>{
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    const navView = isNav4Enabled ? (0, $4l6Wo.COMPANY_HUB_SETTINGS_ID) : (0, $4l6Wo.PRODUCT_HOME_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'companyHubAnalytics'
            },
            pageState: {
                routeName: (0, $1NBp8.COMPANY_HUB_ANALYTICS).name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};
const $b5f6e0dacae3f98e$export$ccf9c625603cc873 = (0, $13aed4a881b0bcc1$export$f5fe5ef796a4c528)($b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute);



var $gwFzn = parcelRequire("gwFzn");

var $eXODy = parcelRequire("eXODy");

var $gwFzn = parcelRequire("gwFzn");

var $hnvzE = parcelRequire("hnvzE");

var $jXpbL = parcelRequire("jXpbL");

var $dHX7l = parcelRequire("dHX7l");

var $eqNP8 = parcelRequire("eqNP8");

var $kE2cJ = parcelRequire("kE2cJ");

var $1NBp8 = parcelRequire("1NBp8");

var $gTyTP = parcelRequire("gTyTP");

var $2MhGC = parcelRequire("2MhGC");
const $3a3f581332e861b8$var$EditPageLoaderInternal = ({ contentId: contentId, spaceKey: spaceKey, draftShareId: draftShareId, contentType: contentType, ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader })=>{
    const [prevContentId, setPrevContentId] = (0, $gwFzn.useState)(contentId);
    const [prevContentType, setPrevContentType] = (0, $gwFzn.useState)(contentType);
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { referredFromLivePage: referredFromLivePage } = (0, $2MhGC.useEditPageLoadingValues)();
    const { loadEditor: setEditPageLoadingValues } = (0, $2MhGC.useEditPageLoadingActions)();
    const [livePageTransitionHandled, setLivePageTransitionHandled] = (0, $gwFzn.useState)(false);
    // This useEffect allows us to unmount and remount the ClassicEditorContextProvider,
    // NativeCollabLoader, and FullPageEditor when switching from one edit page to another edit page.
    // This is necessary to reset the editor properly for edit -> edit transitions.
    (0, $gwFzn.useEffect)(()=>{
        setPrevContentId(contentId);
        setLivePageTransitionHandled(false);
    }, [
        contentId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        setPrevContentType(contentType);
    }, [
        contentType
    ]);
    // Be careful when modifying this useEffect as this can break live page -> edit page transitions
    // This effect is a temporary solution to address an issue where the editor does not reset properly when navigating from a live page.
    // The editor tends to hold onto state from the previous page, causing problems when switching between pages if a full unmount doesn't occur.
    // This effects resets the editor by force-unmounting it by showing the loading screen when it detects a transition from a live page.
    (0, $gwFzn.useEffect)(()=>{
        // livePageTransitionHandled is used to prevent the editor from showing the loading screen endlessly
        if (referredFromLivePage && !livePageTransitionHandled) {
            setLivePageTransitionHandled(true);
            // Need to reset this property or it'll be retained when the browser back button is used.
            // In that case, it doesn't go through the flow that sets the value again.
            setEditPageLoadingValues({
                referredFromLivePage: undefined
            });
        }
    }, [
        referredFromLivePage,
        livePageTransitionHandled,
        setEditPageLoadingValues
    ]);
    if (contentId !== prevContentId || contentType !== prevContentType || referredFromLivePage && !livePageTransitionHandled) // isLoading is set to true by a state change, which does not happen immediately after content id changes
    // To make sure loading screen shows up immediately after content id changes, compare new content id with the content id in ref
    // This is smilar to how componentWillUpdate works in a classic react component
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
    const EditPageWrapper = ClassicEditorContextProviderLoader ?? (({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            "data-testid": "edit-page-default-wrapper"
        }, children));
    return(// @ts-ignore - Property 'isWithinEditor' is missing in type '{ children: Element; }' but required in type '{ children: any; isWithinEditor: any; }'
    // This error was introduced after upgrading to TypeScript 5
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(EditPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jXpbL.NativeCollabPresenceStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jXpbL.NativeCollabLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        permissionTokenRefresh: (0, $jXpbL.fetchCollabPermissionToken)(contentId, draftShareId)
    }, (propsFromNativeCollab)=>propsFromNativeCollab.subType === 'live' && !propsFromNativeCollab.isOverviewPage && isLivePagesFeatureEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.VIEW_PAGE).name,
            params: {
                contentId: contentId,
                spaceKey: spaceKey
            }
        }) : // This TreeRootForServerPlaceholderWrapper placed here to ensure the proper lookup of the placeholders for
        // SSRed loadables. Due to different component trees between server (EditPageLoader) and client (EditPageLoaderServer)
        // the placeholder ids hierarchy is different. This wrapper terminates the lookup for placeholder ids on the common parent,
        // so it matches on both server and client.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dHX7l.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dHX7l.FullPageEditorLoader), {
            ...propsFromNativeCollab,
            extensionContextProvider: {
                ClassicEditorContextProvider: ClassicEditorContextProviderLoader
            }
        }))))));
};
const $3a3f581332e861b8$export$b6d447abe5222d2c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hnvzE.default), {
        name: "edit-page-loader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3a3f581332e861b8$var$EditPageLoaderInternal, props));
};




var $34NZw = parcelRequire("34NZw");

var $5vi32 = parcelRequire("5vi32");

var $78QFu = parcelRequire("78QFu");

var $dEBDF = parcelRequire("dEBDF");

var $4l6Wo = parcelRequire("4l6Wo");

var $cEgMD = parcelRequire("cEgMD");

var $cZa7r = parcelRequire("cZa7r");

var $kE2cJ = parcelRequire("kE2cJ");

var $1NBp8 = parcelRequire("1NBp8");

var $6O2BV = parcelRequire("6O2BV");
const $0e80cf500c4229e5$export$5cc0e8d070ec38e9 = ({ params: { contentId: contentId, spaceKey: spaceKey, contentType: editRouteTypeParam }, query: query, pathname: pathname })=>{
    const draftShareId = typeof query?.draftShareId === 'string' ? query.draftShareId : undefined;
    // editRouteTypeParam !== contentType !== pageType
    // editContentType is blog or pages
    // contentType is blogpost or page
    // pageType is blog or page
    const contentType = editRouteTypeParam === 'blog' ? 'blogpost' : 'page';
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const shouldRedirectCompanyHubEditRoute = isCompanyHub && (0, $1NBp8.COMPANY_HUB_EDIT).pattern !== pathname;
    if (shouldRedirectCompanyHubEditRoute) // The company hub edit route should handle upsell scenarios and other cases
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.COMPANY_HUB_EDIT).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cZa7r.AnnotationsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e7545f5dec589966$export$99fa8db8497fb663), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3a3f581332e861b8$export$b6d447abe5222d2c), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $34NZw.PageShownPublicLinksEventLoader), {
        contentId: contentId,
        isPage: editRouteTypeParam === 'page',
        isEditPage: true
    })));
};
$0e80cf500c4229e5$export$5cc0e8d070ec38e9.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentType: editRouteTypeParam } })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    const isPageLikeContent = editRouteTypeParam === 'pages' || editRouteTypeParam === 'blog';
    const isBlog = editRouteTypeParam === 'blog';
    // editRouteTypeParam !== contentType
    // editRouteTypeParam is blog or pages
    // contentType is blogpost or page
    const contentType = editRouteTypeParam === 'blog' ? 'blogpost' : 'page';
    let viewId = (0, $4l6Wo.CONTAINER_HOME_ID);
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) viewId = (0, $4l6Wo.PRODUCT_HOME_ID);
    else if (isBlog) viewId = (0, $4l6Wo.CONTAINER_BLOG_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)(),
                    navdexPointType: (0, $dEBDF.END)
                }
            },
            pageState: {
                routeName: routeName,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType
            },
            showPremiumOnboarding: isPageLikeContent ? showPremiumOnboarding : false
        },
        MainLayout: {
            navView: viewId,
            spaceKey: spaceKey,
            editorPreloader: isPageLikeContent ? (0, $eXODy.getEditorPreloader) : undefined,
            disableMinWidth: true,
            isViewPage: true,
            isEdit: true
        }
    };
};



const $1f7939e43bf6965f$export$335f265b0f783405 = (0, $aa6dab5502f2e37f$export$39a78a0252c20555)((0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9));



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");


var $1NBp8 = parcelRequire("1NBp8");

var $cEgMD = parcelRequire("cEgMD");

/**
 * The route "Company Hub settings" in the Confluence app.
 * `CompanyHubSettingsRoute` wraps this one to implement the Company Hub pseudo app.
 */ const $dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), null);
$dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute.NAVIGATION_PARAMS = (_routeMatch, isNav4Enabled)=>{
    const navView = isNav4Enabled ? (0, $4l6Wo.COMPANY_HUB_SETTINGS_ID) : (0, $4l6Wo.PRODUCT_HOME_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'companyHubSettingsScreen',
                attributes: {
                    // Company Hub hides its space from the user, doesn't refer to its page
                    // as such, is rather presented to the user as "a new surface", and thus
                    // doesn't constitute space usage from the perspective of the user.
                    screenIsInSpace: false
                }
            },
            pageState: {
                routeName: (0, $1NBp8.COMPANY_HUB_SETTINGS).name,
                spaceKey: (0, $cEgMD.getCompanyHubSpaceKey)()
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};
const $dbfb738401d21a8a$export$5df4bb70a888e6ef = (0, $13aed4a881b0bcc1$export$f5fe5ef796a4c528)($dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute);



var $gwFzn = parcelRequire("gwFzn");

var $eXODy = parcelRequire("eXODy");

var $jmjWc = parcelRequire("jmjWc");

var $4l6Wo = parcelRequire("4l6Wo");

var $dEBDF = parcelRequire("dEBDF");

var $iqZzD = parcelRequire("iqZzD");

const $3ae3b5e6a32b9f05$var$SpacePages = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Mg0yj",
    name: "SpacePages",
    loader: async ()=>(await (parcelRequire("dMDTH"))).SpacePages
});
const $3ae3b5e6a32b9f05$export$64ef8a59e56631d4 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3ae3b5e6a32b9f05$var$SpacePages, null));
};
$3ae3b5e6a32b9f05$export$64ef8a59e56631d4.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spacePagesScreen',
                attributes: {
                    navigationLayer: 'container',
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            disableMinWidth: true
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $iqZzD = parcelRequire("iqZzD");

var $4H46k = parcelRequire("4H46k");
const $5fbf62dcc2c7f9c7$export$59ba7d1ff575355e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazySpaceBlogRedirect), null));
$5fbf62dcc2c7f9c7$export$59ba7d1ff575355e.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'blogHomeScreen'
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_BLOG_ID),
            spaceKey: spaceKey
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $604611f3b9c6a1bd$export$6fe611e4bd8a9f83 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "KbMaW",
    name: 'ManagePagesLoader',
    loader: async ()=>{
        return (await (parcelRequire("hT3pQ"))).ManagePagesV2;
    }
});



var $cEgMD = parcelRequire("cEgMD");

var $lt6Lx = parcelRequire("lt6Lx");

var $gllul = parcelRequire("gllul");

var $iqZzD = parcelRequire("iqZzD");
const $95e685c28d9f350e$export$690ececaf2f5ac01 = ({ params: { spaceKey: spaceKey } })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lt6Lx.DocumentContentTitle), {
        notFound: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gllul.NotFound), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $604611f3b9c6a1bd$export$6fe611e4bd8a9f83), {
        spaceKey: spaceKey
    }));
};
$95e685c28d9f350e$export$690ececaf2f5ac01.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceBulkTools',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $c51c7f4fbe27db1f$export$e8ec235e2dc3d2c4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1mKe4",
    name: "TemplateMigrationPreviewLoader",
    loader: async ()=>(await (parcelRequire("klRqn"))).TemplateMigrationPreview
});


const $a310d6589e3c6137$export$2549ad5558b468ce = ({ params: { contentId: contentId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c51c7f4fbe27db1f$export$e8ec235e2dc3d2c4), {
        templateId: contentId
    });
$a310d6589e3c6137$export$2549ad5558b468ce.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'templateMigrationPreviewScreen'
            },
            pageState: {
                routeName: name,
                contentId: contentId
            }
        },
        MainLayout: false
    });



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $ab6a74840300f72c$export$8cf1c696fd3c0922 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-xoDL",
    name: "TemplateEditorLoader",
    loader: async ()=>{
        const { TemplateEditor: TemplateEditor } = await (parcelRequire("5NkoD"));
        return TemplateEditor;
    }
});



var $6O2BV = parcelRequire("6O2BV");
function $db60bab822fccf44$var$getId(params) {
    const { contentId: contentId, pluginKey: pluginKey, moduleKey: moduleKey } = params;
    return !contentId && moduleKey ? `${pluginKey}:${moduleKey}` : contentId;
}
const $db60bab822fccf44$export$b015e9e7191a93bd = ({ params: params })=>{
    const id = $db60bab822fccf44$var$getId(params);
    const { spaceKey: spaceKey } = params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ab6a74840300f72c$export$8cf1c696fd3c0922), {
        templateId: id,
        spaceKey: spaceKey
    }));
};
$db60bab822fccf44$export$b015e9e7191a93bd.NAVIGATION_PARAMS = ({ params: params })=>{
    const id = $db60bab822fccf44$var$getId(params);
    const { spaceKey: spaceKey } = params;
    return {
        Screen: {
            screenEvent: {
                name: 'editTemplatePageScreen',
                id: id || ''
            },
            pageState: {
                contentId: id,
                spaceKey: spaceKey
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    };
};



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $e6c819a73b1c7672$export$70238cd3868b67c9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gd8xC",
    name: "Onboarding",
    loader: async ()=>(await (parcelRequire("gui5I"))).Onboarding
});



var $dIouf = parcelRequire("dIouf");
const $52219feed318a69e$export$329ee42b27a3306e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).FLYWHEEL_ACTIVATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e6c819a73b1c7672$export$70238cd3868b67c9), null));
$52219feed318a69e$export$329ee42b27a3306e.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'onboardingContainerScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: false
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $cEgMD = parcelRequire("cEgMD");

var $jmjWc = parcelRequire("jmjWc");

const $72fe25ca1dda155a$export$e5cc8897c2b49b25 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "P5sQM",
    name: "ContentHistoryLoader",
    loader: async ()=>(await (parcelRequire("hp6Gv"))).ContentHistory
});



const $48c85dee1e05da94$var$ContentHistoryRouteComponent = ({ params: { spaceKey: spaceKey, contentId: contentId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $72fe25ca1dda155a$export$e5cc8897c2b49b25), {
        spaceKey: spaceKey,
        contentId: contentId,
        stack: "classic"
    });
$48c85dee1e05da94$var$ContentHistoryRouteComponent.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, contentId: contentId, contentSlug: contentSlug } })=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    return {
        Screen: {
            screenEvent: {
                name: isCompanyHub ? 'hubHistoryScreen' : 'pageHistoryScreen',
                id: contentId
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId,
                contentSlug: contentSlug
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: isCompanyHub ? (0, $4l6Wo.COMPANY_HUB_SETTINGS_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    };
};
const $48c85dee1e05da94$export$e510023ce2e8f364 = (0, $13aed4a881b0bcc1$export$f5fe5ef796a4c528)($48c85dee1e05da94$var$ContentHistoryRouteComponent, (route)=>(0, $cEgMD.isCompanyHubSpaceKey)(route?.params?.spaceKey));



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $64e99ecf69e59c34$export$9defecaf7509c9ff = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "NjYCL",
    name: "TemplateGalleryLoader",
    loader: async ()=>(await (parcelRequire("bG22E"))).TemplateGallery
});


const $0f81c6a8d9931e4d$export$e2ed88affe37abdc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $64e99ecf69e59c34$export$9defecaf7509c9ff), null);
$0f81c6a8d9931e4d$export$e2ed88affe37abdc.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'templateGalleryScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $7b810fd40f00ac37$var$MobileAppTakeoverPageLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oLwa7",
    name: "MobileAppTakeoverPageLoader",
    loader: async ()=>(await (parcelRequire("crxf7"))).MobileAppTakeoverPage
});
const $7b810fd40f00ac37$export$1a98ae7373202607 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7b810fd40f00ac37$var$MobileAppTakeoverPageLoader, null);
$7b810fd40f00ac37$export$1a98ae7373202607.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'mobileTakeoverPage'
            }
        },
        MainLayout: false
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $3Up8V = parcelRequire("3Up8V");
const $75f6c666a9c742b2$export$e5707bd7e32dbf9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Up8V.SiteHomepageRedirectLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Up8V.GoToHomeLoader), null));
$75f6c666a9c742b2$export$e5707bd7e32dbf9b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'wikiScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $eXODy = parcelRequire("eXODy");

var $4l6Wo = parcelRequire("4l6Wo");

var $3Up8V = parcelRequire("3Up8V");

var $dEBDF = parcelRequire("dEBDF");
const $4625b8b3d160569d$export$48d3d184aade51b1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Up8V.GoToHomeLoader), null);
$4625b8b3d160569d$export$48d3d184aade51b1.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'homeScreen',
                attributes: {
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID),
            editorPreloader: (0, $eXODy.getEditorPreloader)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4H46k = parcelRequire("4H46k");

var $dEBDF = parcelRequire("dEBDF");
const $92a0e12da2d6b5f0$export$bf305e48a79a981b = {
    attributes: {
        navdexPointType: (0, $dEBDF.END)
    }
};


const $c3c08e13adc00b49$export$daeca97aa431dd80 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazySpaceCreatePage), {
        contentType: "blogpost"
    });
$c3c08e13adc00b49$export$daeca97aa431dd80.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });



var $gwFzn = parcelRequire("gwFzn");

var $4H46k = parcelRequire("4H46k");

const $93e08279e521422d$export$92431fd1ef2a3e02 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazySpaceCreatePage), {
        contentType: "page"
    });
$93e08279e521422d$export$92431fd1ef2a3e02.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });



var $gwFzn = parcelRequire("gwFzn");

var $78QFu = parcelRequire("78QFu");


var $8MiHL = parcelRequire("8MiHL");
const $2807fe6645e49e0b$export$6a3218472cdf374a = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8MiHL.LazyRouteToRightEditor), {
        contentType: "pages",
        contentId: contentId,
        spaceKey: spaceKey
    });
$2807fe6645e49e0b$export$6a3218472cdf374a.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b).attributes,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });



var $gwFzn = parcelRequire("gwFzn");

var $8MiHL = parcelRequire("8MiHL");

var $78QFu = parcelRequire("78QFu");
const $cdf2efa932a544ee$export$657999c2675036a8 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8MiHL.LazyRouteToRightEditor), {
        contentType: "blog",
        contentId: contentId,
        spaceKey: spaceKey
    });
$cdf2efa932a544ee$export$657999c2675036a8.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'blogpost'
            }
        },
        MainLayout: false
    });




var $gwFzn = parcelRequire("gwFzn");

var $480xA = parcelRequire("480xA");

var $6O2BV = parcelRequire("6O2BV");

const $dde5e37bf0f94188$export$a338f76d183c610 = ({ params: { contentId: contentId, spaceKey: spaceKey }, query: { draftShareId: draftShareId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $480xA.EmbeddedEditPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: String(draftShareId),
        contentType: "page"
    }));
$dde5e37bf0f94188$export$a338f76d183c610.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageEmbedScreen',
                id: contentId,
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'page'
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });


/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $d6b8391ba067d418$var$SpaceSettingsAutomationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xxPa8",
    name: "SpaceSettingsAutomationRouteComponent",
    loader: ()=>(parcelRequire("7nFWC"))
});
const $d6b8391ba067d418$export$3e7656e40361b9c3 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d6b8391ba067d418$var$SpaceSettingsAutomationRouteComponent, {
        spaceKey: spaceKey
    });
$d6b8391ba067d418$export$3e7656e40361b9c3.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingAutomationRoute',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $90cab0c9e6efa470$export$c5b2c959a5ee5a4a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Lsv8X",
    name: "ConnectSpaceCustomContentListView",
    loader: async ()=>(await (parcelRequire("9OZS4"))).ConnectSpaceCustomContentListView
});


const $25fdeb0a789de125$export$1045fc666c352ae6 = ({ params: { spaceKey: spaceKey, type: type } })=>{
    const [stateKey, setStateKey] = (0, $gwFzn.useState)(history?.state?.key || Math.random());
    // Updating a key state and reload ConnectSpaceCustomContentListView component.
    //
    // Connect Apps can have an inner history state (created with AP.history), which add
    // hashtag to URL (for example: #!state1)
    // When user navigates to this route again the URL is reset to initial state and
    // hashtag is removed, but inner app does not get any notifications about that and
    // don't reset inner app state.
    //
    // To fix this issue we are listening history.state.key, and when it's changed
    // (user create a new entry in history) refresh component
    (0, $gwFzn.useEffect)(()=>{
        // We rely on history.state.key that is not documented, but major browsers have it
        if (history?.state?.key) setStateKey(history.state.key);
        else if (!history?.state?._AP) setStateKey(Math.random());
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        history?.state,
        setStateKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $90cab0c9e6efa470$export$c5b2c959a5ee5a4a), {
        spaceKey: spaceKey,
        type: type,
        key: stateKey
    });
};
$25fdeb0a789de125$export$1045fc666c352ae6.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, type: type } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceCustomContent',
                id: spaceKey,
                attributes: {
                    type: type
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $ae3041c2a586590e$export$cc376322db18bf6e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sjwPy",
    name: "CustomContentOnPageComponentLoader",
    loader: async ()=>(await (parcelRequire("jTgA8"))).CustomContentOnPageComponent
});



var $4l6Wo = parcelRequire("4l6Wo");
const $4af991445198673b$export$80477c996ae74379 = ({ params: { contentId: contentId, spaceKey: spaceKey, type: type } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ae3041c2a586590e$export$cc376322db18bf6e), {
        contentId: contentId,
        spaceKey: spaceKey,
        type: type === 'undefined' ? '' : type
    });
};
$4af991445198673b$export$80477c996ae74379.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'customContentOnPage',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $95bd051929613722$export$f536037c46d4c012 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9X2ye",
    name: "CustomContentView",
    loader: async ()=>(await (parcelRequire("i7tNq"))).CustomContentView
});


const $c7473af47fe3192c$export$b836ebd0f49cc9f5 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $95bd051929613722$export$f536037c46d4c012), {
        spaceKey: spaceKey,
        contentId: contentId
    });
};
$c7473af47fe3192c$export$b836ebd0f49cc9f5.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'customContentView',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $4l6Wo = parcelRequire("4l6Wo");

const $0960da40109465b4$var$PublicLinksSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rP97Y",
    name: "PublicLinksSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("bBT0W"))
});
const $0960da40109465b4$export$af4daa43ca1332b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0960da40109465b4$var$PublicLinksSettingsPageRouteComponent, null);
$0960da40109465b4$export$af4daa43ca1332b9.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'publicLinksSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $95bdd88deead3c11$export$ecc44bd892306adb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "00c23",
    name: "ContactAdministratorRoute",
    loader: async ()=>(await (parcelRequire("c0zF3"))).ContactAdministratorPage
});
$95bdd88deead3c11$export$ecc44bd892306adb.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: {
            screenEvent: {
                name: 'contactAdministratorScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    };
};




var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $4l6Wo = parcelRequire("4l6Wo");

const $e77b8eed9c4fe03f$var$AdminAnnouncementBannerRenderer = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LCRNu",
    name: "AdminAnnouncementBannerRenderer",
    loader: async ()=>(await (parcelRequire("4VJHa"))).AdminAnnouncementBannerRenderer
});
const $e77b8eed9c4fe03f$export$81a4ecf687c4a61b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e77b8eed9c4fe03f$var$AdminAnnouncementBannerRenderer, null);
};
$e77b8eed9c4fe03f$export$81a4ecf687c4a61b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminAnnouncementBannerRenderer'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $4l6Wo = parcelRequire("4l6Wo");

var $bQm3c = parcelRequire("bQm3c");

const $36a63e56cd2b2984$var$AdminCenterPage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yN5_D",
    name: "AdminCenterPage",
    loader: async ()=>(await (parcelRequire("gbGOI"))).AdminCenterPage
});
const $36a63e56cd2b2984$export$60c1a30975370191 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($36a63e56cd2b2984$var$AdminCenterPage, null);
$36a63e56cd2b2984$export$60c1a30975370191.NAVIGATION_PARAMS = ()=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'adminCenter',
                attributes: {
                    edition: edition
                }
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    };
};



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $4l6Wo = parcelRequire("4l6Wo");

var $bQm3c = parcelRequire("bQm3c");

var $iqZzD = parcelRequire("iqZzD");

const $015145ca08e6a13a$var$AdminCenterSpacePage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "1dPKI",
    name: "AdminCenterSpacePage",
    loader: async ()=>(await (parcelRequire("gbGOI"))).AdminCenterSpacePage
});
const $015145ca08e6a13a$export$bd929b984ffc4a9 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($015145ca08e6a13a$var$AdminCenterSpacePage, {
        spaceKey: spaceKey
    }));
};
$015145ca08e6a13a$export$bd929b984ffc4a9.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'adminCenterSpace',
                id: spaceKey,
                attributes: {
                    edition: edition
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    };
};



var $gwFzn = parcelRequire("gwFzn");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");
const $6f06338c7fe23a44$export$44bc7d6c094dc951 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (edition === (0, $euL71.ConfluenceEdition).PREMIUM) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CENTER).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CONFIGURATION).name
    });
};
$6f06338c7fe23a44$export$44bc7d6c094dc951.NAVIGATION_PARAMS = ()=>false;


/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $e2d8d9818dde6381$var$SpaceSettingsExportSpaceUnavailableRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HYdso",
    name: "SpaceSettingsExportSpaceUnavailableRouteComponent",
    loader: ()=>(parcelRequire("1b4bl"))
});
const $e2d8d9818dde6381$export$1d1f8d0ef7c7a185 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e2d8d9818dde6381$var$SpaceSettingsExportSpaceUnavailableRouteComponent, {
        spaceKey: spaceKey
    });
$e2d8d9818dde6381$export$1d1f8d0ef7c7a185.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsExportSpaceUnavailable',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $9TVBV = parcelRequire("9TVBV");

const $55b7ec62080e1638$export$98f6226b8f451523 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "TMJ6c",
    loader: async ()=>(await (parcelRequire("dCXIs"))).BulkSpacePermissionsPortal,
    name: 'BulkSpacePermissionsPortal'
});

const $55b7ec62080e1638$export$405a6cc8f1c994c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LzFeC",
    loader: async ()=>(await Promise.resolve((parcelRequire("9TVBV")))).BulkSpacePermissionsPage,
    name: 'BulkSpacePermissionsPage'
});


var $9TVBV = parcelRequire("9TVBV");

var $jmjWc = parcelRequire("jmjWc");


const $fe2917192dc4f6b9$export$db2035bfb5892b74 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VMbza",
    loader: async ()=>(await Promise.resolve((parcelRequire("kAGh9")))).BulkAccessManagementPage,
    name: 'BulkAccessManagementPage'
});


const $4255a2123073399b$export$a1ed7a563d6f8c80 = ()=>(0, $9wGTI.fg)('confluence_rbac_spaces_beta_opt_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fe2917192dc4f6b9$export$db2035bfb5892b74), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $55b7ec62080e1638$export$405a6cc8f1c994c8), null);
$4255a2123073399b$export$a1ed7a563d6f8c80.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $9TVBV.ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");
parcelRequire("bDjCi");
var $e8WZK = parcelRequire("e8WZK");
var $bDjCi = parcelRequire("bDjCi");
const $d1361d4d835db3f1$export$5164e66822dc5aec = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (edition !== (0, $euL71.ConfluenceEdition).PREMIUM) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bDjCi.LazyTeamCalendarSiteSettingsPage), null);
};
$d1361d4d835db3f1$export$5164e66822dc5aec.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $e8WZK.ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $daea30cdb73fa105$export$9a9547459861b1d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyConfigurationPage), null);
$daea30cdb73fa105$export$9a9547459861b1d.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_CONFIGURATION_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $cf2a30228181ae7a$export$12cd952fb663f2a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyDefaultSpaceLogoConfigPage), null);
$cf2a30228181ae7a$export$12cd952fb663f2a5.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_DEFAULT_SPACE_LOGO_CONFIG_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $d9d1782c5d23f713$export$66aaa3e4fa4fb446 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyHeaderAndFooterPage), null);
$d9d1782c5d23f713$export$66aaa3e4fa4fb446.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $3de5f90ca85ac387$export$fb8cddd2e05884ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyTemplatesAndBlueprintsPage), null);
$3de5f90ca85ac387$export$fb8cddd2e05884ff.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });


/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $2eKSp = parcelRequire("2eKSp");
const $5035325f0c8b9a13$export$65794158c09a379 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2eKSp.LazyNotificationsSiteSettingsPageLoader), null);
$5035325f0c8b9a13$export$65794158c09a379.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $2eKSp.ADMIN_NOTIFICATIONS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $i6ccO = parcelRequire("i6ccO");

const $13b2a397a1cc2782$export$bac0713ec898bd76 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CRbee",
    name: "LazySpaceReportsSiteSettings",
    loader: async ()=>(await (parcelRequire("lFEIy"))).SpaceReports
});


var $i6ccO = parcelRequire("i6ccO");
const $ba2c2ff5f89f0551$export$2667c61817b129fd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $13b2a397a1cc2782$export$bac0713ec898bd76), null);
$ba2c2ff5f89f0551$export$2667c61817b129fd.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $i6ccO.ADMIN_SPACE_REPORT_SCREEN)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $2e9a50b174f89446$export$761483e0f415164e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyCodeMacroConfigurationPage), null);
$2e9a50b174f89446$export$761483e0f415164e.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");
const $0fb617f0ce9f4007$export$8984debadcec9d93 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name
    });
$0fb617f0ce9f4007$export$8984debadcec9d93.NAVIGATION_PARAMS = ()=>false;



var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $7fe52c8ec8c71cab$export$b882bc9c4e633e9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazySecurityConfigurationPage), null);
$7fe52c8ec8c71cab$export$b882bc9c4e633e9b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $98f73671c286928d$export$55ff18e8dde17771 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyApplicationNavigatorPage), null);
$98f73671c286928d$export$55ff18e8dde17771.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $2395a25321aca708$export$1e71122b3eac56e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyMacroUsagePage), null);
$2395a25321aca708$export$1e71122b3eac56e4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_MACRO_USAGE_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $b9260b374d11ae03$export$154b40ed25137a69 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyTrashedSpacesPage), null);
$b9260b374d11ae03$export$154b40ed25137a69.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $d9481fcbb25a62a6$export$6078cc5c61cdb00c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyImportSpacesPage), null);
$d9481fcbb25a62a6$export$6078cc5c61cdb00c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $3ed31ec1d64e85a3$export$1162e5a60ee7576b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyJiraMacroRepairPage), null);
$3ed31ec1d64e85a3$export$1162e5a60ee7576b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $95678b1264993b8d$export$cdc2bb4346e935c9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyThemesPage), null);
$95678b1264993b8d$export$cdc2bb4346e935c9.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_THEMES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $d726f64aa7b98b71$export$81e12ffb7d442c0c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyPdfExportPage), null);
$d726f64aa7b98b71$export$81e12ffb7d442c0c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_PDF_EXPORT_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $e47e098edb382ee6$export$5078a97f36c3dee4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9b7TL",
    name: "WorkflowsLoader",
    loader: async ()=>(await (parcelRequire("j3YCh"))).WorkflowAccessWrapper
});


const $3cf65e45646e5c33$export$471cbe8a2659b8c5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e47e098edb382ee6$export$5078a97f36c3dee4), null);
$3cf65e45646e5c33$export$471cbe8a2659b8c5.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'workflowsAdminScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $8Nhaa = parcelRequire("8Nhaa");
var $jmjWc = parcelRequire("jmjWc");

const $b39b3b8c8cb41baf$export$9334d2c8540310e3 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ge6Hg",
    name: "SpaceManagerLoader",
    loader: async ()=>(await (parcelRequire("3Zt4d"))).SpaceManager
});


const $244c44f585122129$export$986d179bc3f7f637 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b39b3b8c8cb41baf$export$9334d2c8540310e3), null);
$244c44f585122129$export$986d179bc3f7f637.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $8Nhaa.SPACE_MANAGER_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $jmjWc = parcelRequire("jmjWc");

const $94454e5f287d76d5$export$a9d78c41686becfd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "2UE21",
    loader: async ()=>(await (parcelRequire("3ka5g"))).SpaceRoleManagementPage,
    name: 'SpaceRoleManagementPage'
});



var $4l6Wo = parcelRequire("4l6Wo");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");
const $f9fff28badc7670c$export$214350c926cc60f2 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $9wGTI.fg)('cc_perms_exp_rbac_fe_milestone_2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $94454e5f287d76d5$export$a9d78c41686becfd), {
        spaceKey: spaceKey
    });
};
$f9fff28badc7670c$export$214350c926cc60f2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceMembersScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });


/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $d3d38e453fe82603$var$LazyDefaultSpacePermissionsPage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9HaD7",
    name: "LazyDefaultSpacePermissionsPage",
    loader: async ()=>(await (parcelRequire("334xJ"))).DefaultSpacePermissionsPage
});
const $d3d38e453fe82603$export$6b4028c8cfa4e9e1 = (routeMatch)=>{
    const { params: { tab: tab } } = routeMatch;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d3d38e453fe82603$var$LazyDefaultSpacePermissionsPage, {
        activeTab: tab
    });
};
$d3d38e453fe82603$export$6b4028c8cfa4e9e1.NAVIGATION_PARAMS = (routeMatch)=>({
        Screen: {
            screenEvent: {
                name: 'siteSpacePermissionsScreen',
                attributes: {
                    tab: routeMatch.params.tab
                }
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");
function $09759410f0cf9b55$export$e7dd35a659f967b8({ params: { key: key, spaceKey: spaceKey }, query: query }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: key || spaceKey,
            query: query
        }
    });
}
$09759410f0cf9b55$export$e7dd35a659f967b8.NAVIGATION_PARAMS = ()=>false;



var $gwFzn = parcelRequire("gwFzn");

var $kE2cJ = parcelRequire("kE2cJ");

var $1NBp8 = parcelRequire("1NBp8");
function $26b63860644dba7c$export$7bc70d297bcfbf4f(extra) {
    const redirectComponent = ({ query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.HOME).name,
            params: {
                query: {
                    ...query,
                    ...extra
                }
            }
        });
    redirectComponent.NAVIGATION_PARAMS = ()=>false;
    return redirectComponent;
}



var $gwFzn = parcelRequire("gwFzn");

var $kE2cJ = parcelRequire("kE2cJ");

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $iJ8K8 = parcelRequire("iJ8K8");

var $5gmpn = parcelRequire("5gmpn");

var $4H46k = parcelRequire("4H46k");
function $1cae7e3e681988dd$export$271f9f08425019c7() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iJ8K8.Screen), {
        screenEvent: {
            name: 'notFoundScreen'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5gmpn.MainLayout), {
        navView: (0, $4l6Wo.PRODUCT_HOME_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyConfluenceNotFound), null)));
}


const $7cf8f51aa88b9ccf$export$df2de76576f721a1 = ({ pathname: pathname, search: search, query: query })=>{
    if (query['unmatched-route']) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1cae7e3e681988dd$export$271f9f08425019c7), null);
    search = search.startsWith('?') ? `${search}&unmatched-route=true` : `?unmatched-route=true`;
    return(//Redirect for .action pages that forces a full page reload
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        href: `${pathname}${search}`,
        forceReload: true
    }));
};
$7cf8f51aa88b9ccf$export$df2de76576f721a1.NAVIGATION_PARAMS = ()=>false;



var $gwFzn = parcelRequire("gwFzn");

var $kE2cJ = parcelRequire("kE2cJ");

var $1NBp8 = parcelRequire("1NBp8");
const $0a13ad86816c36c0$export$cdc5cf7d787e5e31 = ({ pathname: pathname, search: search, query: query })=>{
    const { draftId: draftId } = query;
    if (typeof draftId !== 'string' || !/^[0-9]+$/.test(draftId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.WIKI).name
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        href: `${pathname}${search}`,
        forceReload: true
    });
};
$0a13ad86816c36c0$export$cdc5cf7d787e5e31.NAVIGATION_PARAMS = ()=>false;



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $d73E7 = parcelRequire("d73E7");
const $09a888bb83dd7791$export$d584a39bdee41574 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d73E7.WhiteboardRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId
    });
$09a888bb83dd7791$export$d584a39bdee41574.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'whiteboardScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'whiteboard',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $iqZzD = parcelRequire("iqZzD");

var $4H46k = parcelRequire("4H46k");
const $b6c9bc2bdd6b7233$export$dfdc537122102d50 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyJiraProjectBoard), {
        spaceKey: spaceKey
    }));
};
$b6c9bc2bdd6b7233$export$dfdc537122102d50.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'jiraProjectBoardScreen'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $18b64a781b16c69e$export$e1e87cd6ad2f9497 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yFgQP",
    name: "FolderRedirectLoader",
    loader: async ()=>(await (parcelRequire("6b7s3"))).FolderRedirect
});



var $jmjWc = parcelRequire("jmjWc");

const $ab5acfcef8296b21$export$cdb01b3d24a21485 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "1C8qv",
    name: "FolderContainerLoader",
    loader: async ()=>(await (parcelRequire("lX2jh"))).FolderContainer
});



var $9wGTI = parcelRequire("9wGTI");
const $6e131d5d0e81b5af$export$110a009c083fc1fc = ({ params: { contentId: contentId } })=>(0, $9wGTI.fg)('confluence_cloud_folder_view') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ab5acfcef8296b21$export$cdb01b3d24a21485), {
        contentId: contentId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $18b64a781b16c69e$export$e1e87cd6ad2f9497), {
        contentId: contentId
    });
$6e131d5d0e81b5af$export$110a009c083fc1fc.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'folderScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'folder',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $dpPtd = parcelRequire("dpPtd");

var $jmjWc = parcelRequire("jmjWc");

const $1f4e11c8ff1e70c5$export$e1cd63b567cc2910 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LWjU2",
    name: "EmbedRouteLoader",
    loader: async ()=>(await (parcelRequire("k9rXZ"))).EmbedContainer
});



var $4l6Wo = parcelRequire("4l6Wo");

var $iqZzD = parcelRequire("iqZzD");

var $4H46k = parcelRequire("4H46k");
const $a86e8bdaaaef979c$export$1a870b21a11af9ae = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1f4e11c8ff1e70c5$export$e1cd63b567cc2910), {
        contentId: contentId,
        spaceKey: spaceKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "EmbedViewRoute"
    }));
$a86e8bdaaaef979c$export$1a870b21a11af9ae.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'smartLinkEmbedPageScreen',
                id: contentId,
                attributes: {
                    contentId: contentId,
                    contentType: 'embed'
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'embed',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $ff966974ac17a8ae$export$d5b2cc659cf7a894 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "K1tWi",
    name: "DatabaseContainerLoader",
    loader: async ()=>(await (parcelRequire("fZ1oS"))).DatabaseContainer
});



var $4l6Wo = parcelRequire("4l6Wo");

var $bwC5h = parcelRequire("bwC5h");

var $4H46k = parcelRequire("4H46k");
const $b443bc65ee980e3b$export$2b633aba04c212bb = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bwC5h.default), {
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ff966974ac17a8ae$export$d5b2cc659cf7a894), {
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "DatabaseViewRoute"
    }));
$b443bc65ee980e3b$export$2b633aba04c212bb.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'databaseScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'database',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");

const $88d3e4eaff5b722d$export$4c4704aeef10cf08 = (0, $3dad7419d64a8662$export$3731f94d374dc29b)(({ spaceKey: spaceKey, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: spaceKey,
            query: query
        }
    }));



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $79a774581f86de14$export$e7975a21b41d4767 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "hYSgM",
    name: "LazyLoader",
    loader: ()=>(parcelRequire("eDPHu"))
});



var $eXODy = parcelRequire("eXODy");

var $4l6Wo = parcelRequire("4l6Wo");

var $iufgB = parcelRequire("iufgB");

var $5vi32 = parcelRequire("5vi32");



var $6CEg5 = parcelRequire("6CEg5");

var $d73E7 = parcelRequire("d73E7");
const $4da47b9dcf27590f$export$9af206dbb2b6a483 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iufgB.CreateContentRouteComponentLoader), {
        preloadWhiteboardRouteComponent: (0, $d73E7.WhiteboardRouteComponentLoader).preload,
        preloadDatabaseRouteComponent: (0, $ff966974ac17a8ae$export$d5b2cc659cf7a894).preload,
        preloadPageAndBlogRouteComponent: (0, $79a774581f86de14$export$e7975a21b41d4767).preload,
        preloadSmartLinkEmbedRouteComponent: (0, $1f4e11c8ff1e70c5$export$e1cd63b567cc2910).preload
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6CEg5.PerformanceStart), {
        subject: "PageTree",
        subjectId: "newContentRendered"
    }));
$4da47b9dcf27590f$export$9af206dbb2b6a483.NAVIGATION_PARAMS = ({ name: routeName, params: { spaceKey: spaceKey, contentType: createRouteTypeParam }, query: query })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    // spaceKey comes from query object while on creation route
    const currentSpaceKey = spaceKey || query?.spaceKey;
    const isPageLikeContent = createRouteTypeParam === 'page' || createRouteTypeParam === 'blog';
    return {
        Screen: {
            screenEvent: {
                name: 'createContentScreen'
            },
            pageState: {
                spaceKey: currentSpaceKey,
                routeName: routeName
            },
            showPremiumOnboarding: isPageLikeContent ? showPremiumOnboarding : false
        },
        MainLayout: {
            // CREATE_CONTENT route can return an undefined spaceKey during creation so we render a loading screen
            navView: query.spaceKey ? (0, $4l6Wo.CONTAINER_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_LOADING_ID),
            spaceKey: currentSpaceKey,
            editorPreloader: isPageLikeContent ? (0, $eXODy.getEditorPreloader) : undefined,
            disableMinWidth: true,
            isViewPage: true,
            isEdit: true
        }
    };
};



var $gwFzn = parcelRequire("gwFzn");

var $eXODy = parcelRequire("eXODy");

var $9wGTI = parcelRequire("9wGTI");

var $1NBp8 = parcelRequire("1NBp8");

var $8dwdz = parcelRequire("8dwdz");

var $5vi32 = parcelRequire("5vi32");

var $78QFu = parcelRequire("78QFu");

var $4l6Wo = parcelRequire("4l6Wo");

var $ko9Ek = parcelRequire("ko9Ek");

var $gwFzn = parcelRequire("gwFzn");

var $78QFu = parcelRequire("78QFu");

var $iJ8K8 = parcelRequire("iJ8K8");

var $1NBp8 = parcelRequire("1NBp8");

var $dIouf = parcelRequire("dIouf");

var $a9BSL = parcelRequire("a9BSL");

var $6Evf5 = parcelRequire("6Evf5");

var $f5aR2 = parcelRequire("f5aR2");

var $iqZzD = parcelRequire("iqZzD");

var $4H46k = parcelRequire("4H46k");
const $92d3732f6f6decb7$export$e537bc4c45dc607c = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } })=>{
    const isPage = routeName === (0, $1NBp8.VIEW_PAGE).name;
    const isBlog = routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name || routeName === (0, $1NBp8.VIEW_BLOG).name;
    let contentType;
    // any one of VIEW_BLOG_DATE_LEGACY, VIEW_BLOG or VIEW_PAGE route can end up here from ViewPageOrBlogRoute
    if (isBlog) contentType = 'blogpost';
    else if (isPage) contentType = 'page';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iJ8K8.Screen), {
        showPremiumOnboarding: false,
        screenEvent: {
            name: 'viewPageScreen',
            id: contentId,
            attributes: {
                isPublicView: false,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            },
            objectType: contentType,
            objectId: contentId
        },
        pageState: {
            contentId: contentId,
            spaceKey: spaceKey,
            routeName: routeName,
            contentSlug: contentSlug,
            isLite: true,
            contentType: contentType
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a9BSL.ViewPageLiteHeaderLoader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a9BSL.ViewPageLiteLoader), {
        spaceKey: spaceKey,
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6Evf5.default), {
        pageType: contentType
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "ViewPageLiteRoute"
    }));
};


function $7a7b7faa4141aa1d$var$isLite(query) {
    return Boolean(query?.lite);
}
function $7a7b7faa4141aa1d$var$parseContentSlugFromSSR() {
    if (!(0, $9wGTI.fg)('confluence_skip_ssr_redirect_incorrect_slug')) return '';
    return window?.__SSR_RENDERED__ && window?.__DELAYED_CONTENT_REDIRECTION__?.contentSlug || '';
}
const $7a7b7faa4141aa1d$export$51ff3cc323c1250d = (props)=>{
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { name: name, params: params, query: query } = props;
    const { contentId: contentId, spaceKey: spaceKey } = params;
    const isViewPage = name === (0, $1NBp8.VIEW_PAGE).name;
    if ($7a7b7faa4141aa1d$var$isLite(query)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $92d3732f6f6decb7$export$e537bc4c45dc607c), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ko9Ek.ViewPageRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId,
        isMobile: isMobile,
        isPage: isViewPage,
        isEmbeddedConfluence: isEmbeddedConfluence
    }));
};
$7a7b7faa4141aa1d$export$51ff3cc323c1250d.NAVIGATION_PARAMS = ({ name: name, params: params, query: query })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    const { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } = params;
    const isViewBlog = name === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name || name === (0, $1NBp8.VIEW_BLOG).name;
    const contentType = isViewBlog ? 'blogpost' : 'page';
    if ($7a7b7faa4141aa1d$var$isLite(query)) return false;
    // Use contentSlug from SSR delayed-redirection if available
    const correctContentSlug = $7a7b7faa4141aa1d$var$parseContentSlugFromSSR() || contentSlug || '';
    return {
        Screen: {
            screenEvent: {
                name: 'viewPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                objectType: contentType,
                objectId: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType,
                contentSlug: correctContentSlug
            },
            showPremiumOnboarding: showPremiumOnboarding
        },
        MainLayout: {
            navView: isViewBlog ? (0, $4l6Wo.CONTAINER_BLOG_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            isViewPage: true
        }
    };
};



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $674c97fafa39ddaa$export$c8774699c65926c8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "djuV7",
    name: "TopicHomepage",
    loader: async ()=>(await (parcelRequire("ePWfS"))).TopicHomepageComponent
});



var $4l6Wo = parcelRequire("4l6Wo");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");

var $9wGTI = parcelRequire("9wGTI");
const $ad7e3274b7fede14$export$54f890efdb9a624 = ({ params: { topicId: topicId } })=>{
    const topicsEnabled = (0, $9wGTI.fg)('confluence_enable_ai_topics_homepage');
    if (!topicsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $674c97fafa39ddaa$export$c8774699c65926c8), {
        topicId: topicId
    });
};
$ad7e3274b7fede14$export$54f890efdb9a624.NAVIGATION_PARAMS = ({ params: { topicId: topicId } })=>({
        Screen: {
            screenEvent: {
                name: 'topicsScreen'
            },
            pageState: {
                topicId: topicId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID),
            topicId: topicId
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $44ff6e33806985ff$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ULKKd",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("9RZdh"))
});
const $44ff6e33806985ff$export$384dd5b6b76557b1 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($44ff6e33806985ff$var$QuestionsRouteComponent, {
        spaceKey: spaceKey
    });
};
$44ff6e33806985ff$export$384dd5b6b76557b1.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'questionsScreen'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $4H46k = parcelRequire("4H46k");
function $281ce5bf20714bdc$export$aea18e9fd89afe15({ params: { spaceKey: spaceKey, questionId: questionId } }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyQuestions), {
        spaceKey: spaceKey,
        questionId: questionId
    });
}
$281ce5bf20714bdc$export$aea18e9fd89afe15.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, questionId: questionId } })=>({
        Screen: {
            screenEvent: {
                name: 'questionScreen',
                questionId: questionId
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $bnIxr = parcelRequire("bnIxr");

var $4l6Wo = parcelRequire("4l6Wo");
const $63dcc013c61b21bf$export$ccfda76403f5bd22 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bnIxr.SiteAnalyticsPageLoader), null);
};
$63dcc013c61b21bf$export$ccfda76403f5bd22.NAVIGATION_PARAMS = ({ name: name, params: { tab: tab } })=>{
    return {
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                routeName: name,
                tab: tab
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    };
};



var $gwFzn = parcelRequire("gwFzn");

var $blHIE = parcelRequire("blHIE");

var $bnIxr = parcelRequire("bnIxr");

var $4l6Wo = parcelRequire("4l6Wo");
const $2dd41eaa3836b7ed$export$7ed59daacefa1324 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bnIxr.SitePermissionsPageLoader), null);
};
$2dd41eaa3836b7ed$export$7ed59daacefa1324.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $blHIE.SITE_ANALYTICS_PERMISSIONS_EVENTS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $bnIxr = parcelRequire("bnIxr");

var $4l6Wo = parcelRequire("4l6Wo");
const $2ddeeae61cd450c5$export$77b30b491c5d0ee0 = ({ params: { contentId: contentId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bnIxr.PageAnalyticsPageLoader), {
        contentId: contentId
    });
};
$2ddeeae61cd450c5$export$77b30b491c5d0ee0.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, contentId: contentId, tab: tab } })=>({
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId,
                tab: tab
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $bnIxr = parcelRequire("bnIxr");

var $4l6Wo = parcelRequire("4l6Wo");

var $iqZzD = parcelRequire("iqZzD");
const $e76c2474e57ea114$export$af7907eff44c835f = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bnIxr.SpaceAnalyticsPageLoader), {
        spaceKey: spaceKey
    }));
};
$e76c2474e57ea114$export$af7907eff44c835f.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, tab: tab } }, isNav4Enabled)=>({
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                tab: tab
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $blHIE = parcelRequire("blHIE");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");
const $4a724484ea837e6c$export$703d82918dc06325 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
            spaceKey: spaceKey,
            tab: 'analytics'
        })
    });
$4a724484ea837e6c$export$703d82918dc06325.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: (0, $blHIE.SPACE_ANALYTICS_PERMISSIONS_EVENTS_SOURCE),
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $49LNg = parcelRequire("49LNg");
const $c4bba5ee88869a52$export$45dbe3e1239d2b94 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyUserAccessPage), null);
$c4bba5ee88869a52$export$45dbe3e1239d2b94.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_USER_ACCESS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

const $9bccec1d57ac1fa9$export$5343fffe319eadf6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e47e098edb382ee6$export$5078a97f36c3dee4), null);
$9bccec1d57ac1fa9$export$5343fffe319eadf6.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'workflowsScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $jmjWc = parcelRequire("jmjWc");

var $fppBw = parcelRequire("fppBw");

var $4l6Wo = parcelRequire("4l6Wo");

var $kE2cJ = parcelRequire("kE2cJ");

var $1NBp8 = parcelRequire("1NBp8");
const $69b9df17dc76bcc3$export$31b05ec87f8c8c11 = 'confluence-fe-space-settings-enable-afm-pdf';

const $69b9df17dc76bcc3$var$LazyExportSpaceRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EoQbw",
    name: "LazyExportSpaceRouteComponent",
    loader: async ()=>(await (parcelRequire("5yf3x"))).ExportSpaceRouteComponent
});
const $69b9df17dc76bcc3$export$4d1bd2808cfd2f38 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $dh538.fg)($69b9df17dc76bcc3$export$31b05ec87f8c8c11)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.LEGACY_SPACE_PDF_EXPORT).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($69b9df17dc76bcc3$var$LazyExportSpaceRouteComponent, {
        spaceKey: spaceKey
    });
};
$69b9df17dc76bcc3$export$4d1bd2808cfd2f38.propTypes = {
    params: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).shape({
        spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired
    }).isRequired
};
$69b9df17dc76bcc3$export$4d1bd2808cfd2f38.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'ExportSpaceScreen'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $8e1d38472579226f$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yT4rd",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("9RZdh"))
});
const $8e1d38472579226f$export$6cff3d6e80ecc64 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8e1d38472579226f$var$QuestionsRouteComponent, {
        isGlobalPage: true
    });
};
$8e1d38472579226f$export$6cff3d6e80ecc64.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'globalQuestionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $a488bad1e68dd6a7$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6VNHf",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("9RZdh"))
});
const $a488bad1e68dd6a7$export$5c0c86e79c0609bd = ({ params: { questionId: questionId, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($a488bad1e68dd6a7$var$QuestionsRouteComponent, {
        questionId: questionId,
        isGlobalPage: true,
        spaceKey: spaceKey
    });
};
$a488bad1e68dd6a7$export$5c0c86e79c0609bd.NAVIGATION_PARAMS = ({ params: { questionId: questionId } })=>({
        Screen: {
            screenEvent: {
                name: 'globalQuestionScreen',
                questionId: questionId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    });



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $bbdc62a401f33c5d$export$2135677046c2be56 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "M3kPP",
    name: 'SmartCreatePromptLoader',
    loader: async ()=>(await (parcelRequire("vFVYi"))).SmartCreatePrompt
});



var $4l6Wo = parcelRequire("4l6Wo");

var $9wGTI = parcelRequire("9wGTI");
const $f6f49145b6f2d1ff$export$70efe747345ffd1f = (routeMatch)=>{
    if (!(0, $9wGTI.fg)('confluence_ai_create_menu_item')) return;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bbdc62a401f33c5d$export$2135677046c2be56), {
        spaceKey: routeMatch?.query?.spaceKey || ''
    });
};
$f6f49145b6f2d1ff$export$70efe747345ffd1f.NAVIGATION_PARAMS = (routeMatch)=>{
    const spaceKey = routeMatch?.query?.spaceKey ?? '';
    return {
        Screen: {
            screenEvent: {
                name: 'smartCreatePromptScreen'
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: routeMatch.name
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    };
};



var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $9ab50fb164cbfbde$export$dd9490b68a84a0bc = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nwZgf",
    name: "PremiumAdminFeaturesPageLoader",
    loader: async ()=>(await (parcelRequire("6iTV5"))).PremiumAdminFeaturesPageContainer
});



var $bQm3c = parcelRequire("bQm3c");
const $d159621a32e8ccb1$export$400e9e9431ca8a0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ab50fb164cbfbde$export$dd9490b68a84a0bc), null);
$d159621a32e8ccb1$export$400e9e9431ca8a0.NAVIGATION_PARAMS = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'premiumAdminFeaturesScreen',
                attributes: {
                    edition: edition
                }
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    };
};



var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $89890ffd0e65684a$export$5db89f273a075771 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "q5hy0",
    name: 'SmartCreateSession',
    loader: async ()=>(await (parcelRequire("1oZpX"))).SmartCreateSession
});



var $4l6Wo = parcelRequire("4l6Wo");

var $9wGTI = parcelRequire("9wGTI");
const $34b167dbf36a3476$export$e5aba8e833bde761 = (routeMatch)=>{
    if (!(0, $9wGTI.fg)('confluence_ai_create_menu_item')) return;
    const sessionId = routeMatch?.params?.sessionId;
    const spaceKey = routeMatch?.query?.spaceKey || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $89890ffd0e65684a$export$5db89f273a075771), {
        spaceKey: spaceKey,
        sessionId: sessionId
    });
};
$34b167dbf36a3476$export$e5aba8e833bde761.NAVIGATION_PARAMS = (routeMatch)=>{
    const spaceKey = routeMatch?.query?.spaceKey ?? '';
    return {
        Screen: {
            screenEvent: {
                name: 'smartCreateSessionScreen'
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: routeMatch.name
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    };
};


function $c6a4b2258628a516$var$redirect(name) {
    const redirectComponent = ({ params: params = {} })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: name,
            params: params
        });
    redirectComponent.NAVIGATION_PARAMS = ()=>false;
    return redirectComponent;
}
const $c6a4b2258628a516$export$4d9abfe5519d76c6 = (0, $6a421125f8ad1b8e$export$5ce5fb2a75a2a873)({
    [(0, $64KID.namedRoutes).BASE.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).WIKI.name),
    [(0, $64KID.namedRoutes).WIKI.name]: (0, $75f6c666a9c742b2$export$e5707bd7e32dbf9b),
    [(0, $64KID.namedRoutes).HOME.name]: (0, $4625b8b3d160569d$export$48d3d184aade51b1),
    [(0, $64KID.namedRoutes).MOBILE_TAKEOVER_PAGE.name]: (0, $7b810fd40f00ac37$export$1a98ae7373202607),
    [(0, $64KID.namedRoutes).TEMPLATE_GALLERY.name]: (0, $0f81c6a8d9931e4d$export$e2ed88affe37abdc),
    [(0, $64KID.namedRoutes).EDIT_PAGE.name]: (0, $2807fe6645e49e0b$export$6a3218472cdf374a),
    [(0, $64KID.namedRoutes).EDIT_BLOG.name]: (0, $cdf2efa932a544ee$export$657999c2675036a8),
    [(0, $64KID.namedRoutes).EDIT_PAGE_V2.name]: (0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9),
    [(0, $64KID.namedRoutes).EDIT_BLOG_V2.name]: (0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9),
    [(0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name]: (0, $dde5e37bf0f94188$export$a338f76d183c610),
    [(0, $64KID.namedRoutes).CREATE_CONTENT.name]: (0, $4da47b9dcf27590f$export$9af206dbb2b6a483),
    [(0, $64KID.namedRoutes).CREATE_PAGE.name]: (0, $93e08279e521422d$export$92431fd1ef2a3e02),
    [(0, $64KID.namedRoutes).CREATE_BLOG.name]: (0, $c3c08e13adc00b49$export$daeca97aa431dd80),
    [(0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    [(0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    [(0, $64KID.namedRoutes).CREATE_PAGE_VARIABLES_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    [(0, $64KID.namedRoutes).RESUME_DRAFT_LEGACY.name]: (0, $0a13ad86816c36c0$export$cdc5cf7d787e5e31),
    [(0, $64KID.namedRoutes).COPY_PAGE_LEGACY.name]: (0, $e9270d50e13c4524$export$58ad04e57ec143c3),
    [(0, $64KID.namedRoutes).DASHBOARD_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).SPA_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).INDEX_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).VIEW_PAGE_ACTION_LEGACY.name]: (0, $1547fdfac1788133$export$70a5a4ee184a1106),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW_INDEX_ACTION_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    [(0, $64KID.namedRoutes).SPACE_INDEX_ACTION_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    // it should be after "INDEX_ACTION_LEGACY", and can't be the last one, as it will brake navigation to space settings
    [(0, $64KID.namedRoutes).ACTION_REDIRECT_LEGACY.name]: (0, $7cf8f51aa88b9ccf$export$df2de76576f721a1),
    [(0, $64KID.namedRoutes).SPACE_DIRECTORY.name]: (0, $6b9376eebbcdd446$export$e2f6c7ec524fdd6a),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW_REDIRECT_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    [(0, $64KID.namedRoutes).SPACE_INDEX.name]: (0, $88d3e4eaff5b722d$export$4c4704aeef10cf08),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW.name]: (0, $8290afb66ac54848$export$200c90655ff1c697),
    [(0, $64KID.namedRoutes).COMPANY_HUB.name]: (0, $f6b27607b6d81126$export$d8819c37d45ffdfc),
    [(0, $64KID.namedRoutes).COMPANY_HUB_ANALYTICS.name]: (0, $b5f6e0dacae3f98e$export$ccf9c625603cc873),
    [(0, $64KID.namedRoutes).COMPANY_HUB_EDIT.name]: (0, $1f7939e43bf6965f$export$335f265b0f783405),
    [(0, $64KID.namedRoutes).COMPANY_HUB_SETTINGS.name]: (0, $dbfb738401d21a8a$export$5df4bb70a888e6ef),
    [(0, $64KID.namedRoutes).GLOBAL_PAGE_FORGE.name]: (0, $88f9531119605f50$export$a0e2b6c59fd25a4e),
    [(0, $64KID.namedRoutes).SPACE_PAGES.name]: (0, $3ae3b5e6a32b9f05$export$64ef8a59e56631d4),
    [(0, $64KID.namedRoutes).VIEW_PAGE.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    [(0, $64KID.namedRoutes).BLOG_HOME.name]: (0, $5fbf62dcc2c7f9c7$export$59ba7d1ff575355e),
    [(0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    [(0, $64KID.namedRoutes).VIEW_BLOG.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    [(0, $64KID.namedRoutes).WHITEBOARD_HOME.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).SPACE_PAGES.name),
    [(0, $64KID.namedRoutes).WHITEBOARD_BOARD.name]: (0, $09a888bb83dd7791$export$d584a39bdee41574),
    [(0, $64KID.namedRoutes).DATABASE_VIEW.name]: (0, $b443bc65ee980e3b$export$2b633aba04c212bb),
    [(0, $64KID.namedRoutes).EMBED_VIEW.name]: (0, $a86e8bdaaaef979c$export$1a870b21a11af9ae),
    [(0, $64KID.namedRoutes).FOLDER_VIEW.name]: (0, $6e131d5d0e81b5af$export$110a009c083fc1fc),
    [(0, $64KID.namedRoutes).CONTACT_ADMINISTRATOR.name]: (0, $95bdd88deead3c11$export$ecc44bd892306adb),
    [(0, $64KID.namedRoutes).SPACE_CALENDARS.name]: (0, $116a232d5237eb91$export$c1ba174e1a668b1a),
    [(0, $64KID.namedRoutes).SPACE_CALENDARS_SUBCALENDAR.name]: (0, $116a232d5237eb91$export$c1ba174e1a668b1a),
    [(0, $64KID.namedRoutes).SPACE_EMBEDDED_SUBCALENDAR.name]: (0, $40c2c72cc1663e14$export$b6ba0c14cb68dffc),
    [(0, $64KID.namedRoutes).DISCOVER.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: ''
    }),
    [(0, $64KID.namedRoutes).ALL_UPDATES.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: 0
    }),
    [(0, $64KID.namedRoutes).POPULAR.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: 1,
        feedType: 'POPULAR'
    }),
    [(0, $64KID.namedRoutes).MY_WORK_HOME.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1
    }),
    [(0, $64KID.namedRoutes).MY_WORK_DRAFTS.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 2
    }),
    [(0, $64KID.namedRoutes).RECENT_DRAFTS.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 2
    }),
    [(0, $64KID.namedRoutes).MY_WORK_RECENT.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1,
        filter: 'WORKED_ON'
    }),
    [(0, $64KID.namedRoutes).RECENT_PAGES.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1
    }),
    [(0, $64KID.namedRoutes).MY_RECENTLY_VISITED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 0
    }),
    [(0, $64KID.namedRoutes).RECENT_VISITED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 0
    }),
    [(0, $64KID.namedRoutes).MY_SAVED_FOR_LATER.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 3
    }),
    [(0, $64KID.namedRoutes).RECENT_SAVED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 3
    }),
    [(0, $64KID.namedRoutes).TEMPLATE_MIGRATION_PREVIEW.name]: (0, $a310d6589e3c6137$export$2549ad5558b468ce),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE_BLUEPRINT.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE_SPACE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).CREATE_TEMPLATE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).CREATE_TEMPLATE_SPACE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).ADVANCED_SEARCH.name]: (0, $f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f),
    [(0, $64KID.namedRoutes).EXTERNAL_SHARE.name]: (0, $b4ceb88d52b227e6$export$2f64eafbbfb5bb9f),
    [(0, $64KID.namedRoutes).PEOPLE_DIRECTORY.name]: (0, $24a857c7c96255d7$export$c7bf94fd367d52ef),
    [(0, $64KID.namedRoutes).MARKETPLACE_APP_REQUESTS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    [(0, $64KID.namedRoutes).MARKETPLACE_MANAGE_PROMOTIONS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    [(0, $64KID.namedRoutes).MARKETPLACE_FIND_APPS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    [(0, $64KID.namedRoutes).CONTENT_HISTORY.name]: (0, $48c85dee1e05da94$export$e510023ce2e8f364),
    [(0, $64KID.namedRoutes).ONBOARDING.name]: (0, $52219feed318a69e$export$329ee42b27a3306e),
    [(0, $64KID.namedRoutes).ADMIN_GLOBAL_AUTOMATION.name]: (0, $9dff8dc763109b25$export$a4a7c409f3d3e524),
    [(0, $64KID.namedRoutes).ADMIN_NEW_GLOBAL_PERMISSIONS.name]: (0, $5651b1434c6bae88$export$72e24cb8f0330a61),
    [(0, $64KID.namedRoutes).ADMIN_COMPANY_HUB_PERMISSIONS.name]: (0, $ce2a2ee7f6871785$export$eeb7368e8bf944ac),
    [(0, $64KID.namedRoutes).ADMIN_COMPANY_HOME_BUILDER.name]: (0, $4fa13b181dc663ad$export$5744f34ed241a45c),
    [(0, $64KID.namedRoutes).ADMIN_CUSTOMIZE_NAVIGATION.name]: (0, $4fa13b181dc663ad$export$3206f56dd9eda6e),
    [(0, $64KID.namedRoutes).ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS.name]: (0, $3e17cd15ad9a2d77$export$ef0ae9b94af7599),
    [(0, $64KID.namedRoutes).ADMIN_EDIT_EXTERNAL_SHARING.name]: (0, $0960da40109465b4$export$af4daa43ca1332b9),
    [(0, $64KID.namedRoutes).ADMIN_FORGE_APPS.name]: (0, $d553d8b4da7f3160$export$25552d6a584e1fb8),
    [(0, $64KID.namedRoutes).ADMIN_BETA_FEATURES.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).ADMIN_NEW_FEATURES.name),
    [(0, $64KID.namedRoutes).ADMIN_NEW_FEATURES.name]: (0, $7949c11e9e78d917$export$39279dc1d0cb138f),
    [(0, $64KID.namedRoutes).ADMIN_NOTIFICATIONS.name]: (0, $5035325f0c8b9a13$export$65794158c09a379),
    [(0, $64KID.namedRoutes).SITE_ANALYTICS.name]: (0, $63dcc013c61b21bf$export$ccfda76403f5bd22),
    [(0, $64KID.namedRoutes).SITE_ANALYTICS_PERMISSIONS.name]: (0, $2dd41eaa3836b7ed$export$7ed59daacefa1324),
    [(0, $64KID.namedRoutes).SPACE_ANALYTICS.name]: (0, $e76c2474e57ea114$export$af7907eff44c835f),
    [(0, $64KID.namedRoutes).SPACE_ANALYTICS_PERMISSIONS.name]: (0, $4a724484ea837e6c$export$703d82918dc06325),
    [(0, $64KID.namedRoutes).PAGE_ANALYTICS.name]: (0, $2ddeeae61cd450c5$export$77b30b491c5d0ee0),
    [(0, $64KID.namedRoutes).SPACE_ARCHIVED_PAGES.name]: (0, $6079beeead36a4aa$export$77792abc2bfae7a1),
    [(0, $64KID.namedRoutes).SPACE_BULK_TOOLS.name]: (0, $95e685c28d9f350e$export$690ececaf2f5ac01),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE.name]: (0, $bdfe305fbc319d8d$export$b0e13503df86295),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE_ALT.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE.name),
    [(0, $64KID.namedRoutes).SPACE_FORGE_APPS.name]: (0, $e20a45805838a7c5$export$16cbc228d727cb5e),
    [(0, $64KID.namedRoutes).SPACE_CUSTOM_CONTENT_LIST.name]: (0, $25fdeb0a789de125$export$1045fc666c352ae6),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_FORGE_APPS.name]: (0, $70d1956925899c9e$export$21a09e0ddc77eafe),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_ARCHIVE_SPACE.name]: (0, $3d2592d831aaf97c$export$c5e406a0947cdc56),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EDITOR_CONVERSION.name]: (0, $c1c9698c93be07c8$export$698dfc3fe326e6d2),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AUTOMATION.name]: (0, $d6b8391ba067d418$export$3e7656e40361b9c3),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AVATARS_AND_STATUS.name]: (0, $ada82682e35c0989$export$9cf7aa4fa48eb220),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_CONTENT_STATE.name]: (0, $ada82682e35c0989$export$9cf7aa4fa48eb220),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_DATA_CLASSIFICATION.name]: (0, $9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE.name]: (0, $e2d8d9818dde6381$export$1d1f8d0ef7c7a185),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EXPORT.name]: (0, $69b9df17dc76bcc3$export$4d1bd2808cfd2f38),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_RELATED_PAGES.name]: (0, $5fd2607ebf0fb934$export$50efde5a87cc8957),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EDIT_FEATURES.name]: (0, $c991c60ce35a3f45$export$769dfef0447f3a55),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_DETAILS.name]: (0, $ae6364090fd3faa0$export$45c01163cd56b3a2),
    [(0, $64KID.namedRoutes).SPACE_QUESTIONS_NATIVE.name]: (0, $44ff6e33806985ff$export$384dd5b6b76557b1),
    [(0, $64KID.namedRoutes).SPACE_QUESTION_NATIVE.name]: (0, $281ce5bf20714bdc$export$aea18e9fd89afe15),
    [(0, $64KID.namedRoutes).QUESTIONS_NATIVE.name]: (0, $8e1d38472579226f$export$6cff3d6e80ecc64),
    [(0, $64KID.namedRoutes).QUESTION_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    [(0, $64KID.namedRoutes).MY_CALENDAR.name]: (0, $e84d6ad8839aa142$export$355693d248632c9a),
    [(0, $64KID.namedRoutes).PDF_EXPORT_PAGE.name]: (0, $de365c057d45c0f8$export$d4d3fe32e0af1ab9),
    [(0, $64KID.namedRoutes).PDF_EXPORT_SPACE.name]: (0, $cdc5bb1b4ce25ace$export$f10520cd46ef45dd),
    [(0, $64KID.namedRoutes).CUSTOM_CONTENTS_ON_PAGE_LIST.name]: (0, $4af991445198673b$export$80477c996ae74379),
    [(0, $64KID.namedRoutes).CUSTOM_CONTENT_VIEW.name]: (0, $c7473af47fe3192c$export$b836ebd0f49cc9f5),
    [(0, $64KID.namedRoutes).SPACE_PERMISSIONS_SETTINGS.name]: (0, $3dace45d43821ccc$export$c4e68572e7b94bc6),
    [(0, $64KID.namedRoutes).SPACE_LOOK_AND_FEEL_SETTINGS.name]: (0, $ea3042d7dfb4b938$export$9ebf5b01b0356442),
    [(0, $64KID.namedRoutes).ADMIN_ANNOUNCEMENT_BANNER_RENDERER.name]: (0, $e77b8eed9c4fe03f$export$81a4ecf687c4a61b),
    [(0, $64KID.namedRoutes).SPACE_MANAGER.name]: (0, $244c44f585122129$export$986d179bc3f7f637),
    [(0, $64KID.namedRoutes).USER_ACCESS.name]: (0, $c4bba5ee88869a52$export$45dbe3e1239d2b94),
    [(0, $64KID.namedRoutes).ADMIN_CENTER.name]: (0, $36a63e56cd2b2984$export$60c1a30975370191),
    [(0, $64KID.namedRoutes).ADMIN_CENTER_SPACE.name]: (0, $015145ca08e6a13a$export$bd929b984ffc4a9),
    [(0, $64KID.namedRoutes).ADMIN_SETTINGS.name]: (0, $6f06338c7fe23a44$export$44bc7d6c094dc951),
    [(0, $64KID.namedRoutes).ADMIN_BULK_PERMISSIONS.name]: (0, $4255a2123073399b$export$a1ed7a563d6f8c80),
    [(0, $64KID.namedRoutes).ADMIN_SITE_SPACE_PERMISSIONS.name]: (0, $d3d38e453fe82603$export$6b4028c8cfa4e9e1),
    [(0, $64KID.namedRoutes).ADMIN_TEAM_CALENDARS.name]: (0, $d1361d4d835db3f1$export$5164e66822dc5aec),
    [(0, $64KID.namedRoutes).ADMIN_CONFIGURATION.name]: (0, $daea30cdb73fa105$export$9a9547459861b1d),
    [(0, $64KID.namedRoutes).ADMIN_DEFAULT_SPACE_LOGO.name]: (0, $cf2a30228181ae7a$export$12cd952fb663f2a5),
    [(0, $64KID.namedRoutes).ADMIN_HEADER_AND_FOOTER.name]: (0, $d9d1782c5d23f713$export$66aaa3e4fa4fb446),
    [(0, $64KID.namedRoutes).ADMIN_TEMPLATES_AND_BLUEPRINTS.name]: (0, $3de5f90ca85ac387$export$fb8cddd2e05884ff),
    [(0, $64KID.namedRoutes).ADMIN_CODE_MACRO_CONFIGURATION.name]: (0, $2e9a50b174f89446$export$761483e0f415164e),
    [(0, $64KID.namedRoutes).ADMIN_COLOR_SCHEME.name]: (0, $0fb617f0ce9f4007$export$8984debadcec9d93),
    [(0, $64KID.namedRoutes).ADMIN_SECURITY_CONFIGURATION.name]: (0, $7fe52c8ec8c71cab$export$b882bc9c4e633e9b),
    [(0, $64KID.namedRoutes).ADMIN_SPACE_REPORTS.name]: (0, $ba2c2ff5f89f0551$export$2667c61817b129fd),
    [(0, $64KID.namedRoutes).ADMIN_APPLICATION_NAVIGATOR.name]: (0, $98f73671c286928d$export$55ff18e8dde17771),
    [(0, $64KID.namedRoutes).ADMIN_TRASHED_SPACES.name]: (0, $b9260b374d11ae03$export$154b40ed25137a69),
    [(0, $64KID.namedRoutes).ADMIN_IMPORT_SPACES.name]: (0, $d9481fcbb25a62a6$export$6078cc5c61cdb00c),
    [(0, $64KID.namedRoutes).ADMIN_JIRA_MACRO_REPAIR.name]: (0, $3ed31ec1d64e85a3$export$1162e5a60ee7576b),
    [(0, $64KID.namedRoutes).ADMIN_MACRO_USAGE.name]: (0, $2395a25321aca708$export$1e71122b3eac56e4),
    [(0, $64KID.namedRoutes).ADMIN_THEMES.name]: (0, $95678b1264993b8d$export$cdc2bb4346e935c9),
    [(0, $64KID.namedRoutes).ADMIN_PDF_EXPORT.name]: (0, $d726f64aa7b98b71$export$81e12ffb7d442c0c),
    [(0, $64KID.namedRoutes).ADMIN_WORKFLOWS.name]: (0, $3cf65e45646e5c33$export$471cbe8a2659b8c5),
    [(0, $64KID.namedRoutes).SPACE_JIRA_PROJECT_BOARD.name]: (0, $b6c9bc2bdd6b7233$export$dfdc537122102d50),
    [(0, $64KID.namedRoutes).SPACE_MEMBERS.name]: (0, $f9fff28badc7670c$export$214350c926cc60f2),
    [(0, $64KID.namedRoutes).TOPICS.name]: (0, $ad7e3274b7fede14$export$54f890efdb9a624),
    [(0, $64KID.namedRoutes).WORKFLOWS.name]: (0, $9bccec1d57ac1fa9$export$5343fffe319eadf6),
    [(0, $64KID.namedRoutes).SMART_CREATE_PROMPT.name]: (0, $f6f49145b6f2d1ff$export$70efe747345ffd1f),
    [(0, $64KID.namedRoutes).PREMIUM_ADMIN_FEATURES_EXPERIMENT.name]: (0, $d159621a32e8ccb1$export$400e9e9431ca8a0),
    [(0, $64KID.namedRoutes).SMART_CREATE_SESSION.name]: (0, $34b167dbf36a3476$export$e5aba8e833bde761)
});






var $9wGTI = parcelRequire("9wGTI");
const $fcc81ac864e755d2$export$ac4cd9f30299a490 = 0.8;
const $fcc81ac864e755d2$export$632c6346c3a8c3e2 = 10000; // 10 seconds
const $fcc81ac864e755d2$export$de8f032132af9697 = 30000; // Normal pages have around 10-20k event listeners
let $fcc81ac864e755d2$var$routeName = 'unknown';
let $fcc81ac864e755d2$var$analyticsClient = null;
let $fcc81ac864e755d2$var$memoryMonitorInterval = null;
let $fcc81ac864e755d2$var$eventListenerCount = 0;
let $fcc81ac864e755d2$var$initializedEventListeners = false;
function $fcc81ac864e755d2$var$bytesToMB(bytes) {
    const MB = 1048576;
    return bytes / MB;
}
function $fcc81ac864e755d2$export$5ed8144ed56e505a() {
    if (!$fcc81ac864e755d2$var$analyticsClient) return false;
    if (performance.memory) {
        const { jsHeapSizeLimit: jsHeapSizeLimit, usedJSHeapSize: usedJSHeapSize } = performance.memory;
        const heapThreshold = jsHeapSizeLimit * $fcc81ac864e755d2$export$ac4cd9f30299a490;
        if (usedJSHeapSize > heapThreshold) $fcc81ac864e755d2$var$analyticsClient.sendOperationalEvent({
            source: 'confluence-memory-monitor',
            action: 'measured',
            actionSubject: 'highHeapUsage',
            attributes: {
                heapUsagePercent: Math.floor(usedJSHeapSize / jsHeapSizeLimit * 100),
                heapUsageMB: Math.floor($fcc81ac864e755d2$var$bytesToMB(usedJSHeapSize)),
                maxHeapSizeMB: Math.floor($fcc81ac864e755d2$var$bytesToMB(jsHeapSizeLimit)),
                route: $fcc81ac864e755d2$var$routeName
            }
        });
    }
    if ($fcc81ac864e755d2$var$initializedEventListeners && $fcc81ac864e755d2$var$eventListenerCount > $fcc81ac864e755d2$export$de8f032132af9697) $fcc81ac864e755d2$var$analyticsClient.sendOperationalEvent({
        source: 'confluence-memory-monitor',
        action: 'measured',
        actionSubject: 'highEventListenerCount',
        attributes: {
            eventListenerCount: $fcc81ac864e755d2$var$eventListenerCount,
            route: $fcc81ac864e755d2$var$routeName
        }
    });
    return true;
}
function $fcc81ac864e755d2$export$76f12cc80b7fd2f3(client) {
    if (!(0, $9wGTI.fg)('confluence_frontend_memory_monitor')) return null;
    $fcc81ac864e755d2$var$analyticsClient = client;
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    const originalRemoveEventListener = EventTarget.prototype.removeEventListener;
    if (!$fcc81ac864e755d2$var$initializedEventListeners) {
        EventTarget.prototype.addEventListener = function(type, listener, options) {
            $fcc81ac864e755d2$var$eventListenerCount++;
            originalAddEventListener.call(this, type, listener, options);
        };
        EventTarget.prototype.removeEventListener = function(type, listener, options) {
            $fcc81ac864e755d2$var$eventListenerCount--;
            originalRemoveEventListener.call(this, type, listener, options);
        };
        $fcc81ac864e755d2$var$initializedEventListeners = true;
    }
    if (!$fcc81ac864e755d2$var$memoryMonitorInterval) $fcc81ac864e755d2$var$memoryMonitorInterval = setInterval($fcc81ac864e755d2$export$5ed8144ed56e505a, $fcc81ac864e755d2$export$632c6346c3a8c3e2);
    return true;
}
function $fcc81ac864e755d2$export$d0c8b02fd4ae0022(name) {
    $fcc81ac864e755d2$var$routeName = name;
}
function $fcc81ac864e755d2$export$b35196bdb32e40c9() {
    if ($fcc81ac864e755d2$var$memoryMonitorInterval) {
        clearInterval($fcc81ac864e755d2$var$memoryMonitorInterval);
        $fcc81ac864e755d2$var$memoryMonitorInterval = null;
    }
}



var $arkw6 = parcelRequire("arkw6");

var $3j0Cc = parcelRequire("3j0Cc");

var $jwv1p = parcelRequire("jwv1p");

var $aiAUl = parcelRequire("aiAUl");

var $4QflW = parcelRequire("4QflW");

var $jmjWc = parcelRequire("jmjWc");

const $a409a9cb99445cc0$var$ShortcutsProvider = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zhDj6",
    name: "ShortcutsProvider",
    loader: ()=>(parcelRequire("14MBR"))
});
var $a409a9cb99445cc0$export$2e2bcd8739ae039 = $a409a9cb99445cc0$var$ShortcutsProvider;



var $jmjWc = parcelRequire("jmjWc");

var $d6d9861065b5c0df$export$2e2bcd8739ae039 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "yQebH",
    name: "packages.confluence-frontend-server.src.components.EngagementMessages.EngagementMessages",
    loader: ()=>(parcelRequire("e77A8"))
});



var $kM8fE = parcelRequire("kM8fE");

var $9wGTI = parcelRequire("9wGTI");

var $jwv1p = parcelRequire("jwv1p");




const $1f18aab14ff5333d$export$6ae808826fa58f6d = async (url, isTransition)=>{
    const shouldPreload = isTransition || !window.__SSR_RENDERED__;
    const match = (0, $kM8fE.matchHome)(url);
    if (match) (await (parcelRequire("3Flev"))).preloadHome(match);
    else if ((0, $kM8fE.matchSpaceOverview)(url) && shouldPreload) (0, $jwv1p.preloadSpaceOverview)();
    else if ((0, $kM8fE.matchLivePage)(url) && shouldPreload && (0, $9wGTI.fg)('confluence_live_page_preload_livepage_route')) (0, $jwv1p.preloadLivePagesComponents)();
    else if ((0, $kM8fE.matchViewPage)(url) && shouldPreload) (0, $jwv1p.preloadViewPageComponents)();
    else if ((0, $kM8fE.matchFabricEditor)(url)) (await Promise.resolve((parcelRequire("eXODy")))).nativeEditorComponentsPreloader();
    else if ((0, $kM8fE.matchCreateContent)(url)) (await (parcelRequire("1B9Op"))).preloadCreateContentRoute();
    else if ((0, $kM8fE.matchWhiteboardPage)(url)) (await (parcelRequire("gq6QA"))).preloadWhiteboardPage();
};



var $jmjWc = parcelRequire("jmjWc");

var $50adebb1075ad3af$export$2e2bcd8739ae039 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "exd9t",
    name: "packages.confluence-frontend-server.src.components.ReduxError.src.index",
    loader: ()=>(parcelRequire("8vGbU"))
});


const $126a66f6ad21916b$var$browserHistory = (0, $hmRc4.getBrowserHistory)();
function $126a66f6ad21916b$export$86fbec116b87613f({ sessionData: sessionData }) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).performance.mark('CFP-63.app-component-render');
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const { isDesktop: isDesktop } = (0, $2JYae.useIsDesktop)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    // When loading confluence from the mobile app, we need the theme to respect the system color mode of the app
    const initialTheme = isMobileApp ? (0, $3WLLD.mobileAppTheme) : undefined;
    // Initializing the theme in a non-blocking way, instead of using <ThemeContainer>, so
    // that the app does not flash and re-paint after the SPA loads on top of the SSR page.
    (0, $0f25e4f8facf0d0e$export$913cb5ed19d2180b)(initialTheme);
    // Lite Mode™ check outside of the router
    // For certain pages supporting lite mode some functionality is not needed
    const isLite = (0, $aFbGo.isViewPageLite)();
    const onRoute = (0, $gwFzn.useCallback)(async (match, transitionId)=>{
        // Reset window.__APOLLO_STATS__ on transition
        (0, $eHj6r.resetApolloStats)();
        // transitionId = 0 when it is initial load, and 0 is falsey
        if (transitionId) {
            // The page can't be rendered by SSR if is a transition
            (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5)))['__SSR_RENDERED__'] = false;
            //hydrateRoot and related logic should not be enabled on transitions
            //as its only for ssr rendered page
            (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5)))['__HYDRATABLE__'] = false;
            (0, $KcDWk.releaseSSRedLegacyMacros)();
            // Delayed content redirection is not needed on transitions
            (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5)))['__DELAYED_CONTENT_REDIRECTION__'] = {};
            if (0, $itS9i.debuggerEnabled) (0, $itS9i.clearAnalyticsDebugger)();
        } else (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).performance.mark('CFP-63.route-manager-initialized');
        (0, $78QFu.setUniquePageLoadId)(match?.name ?? '', match, transitionId, sessionData);
        (0, $8Ss4E.startExperienceForRoute)(match, transitionId, sessionData);
        (0, $fcc81ac864e755d2$export$d0c8b02fd4ae0022)(match?.name ?? 'unknown');
        (0, $2ba6133bff070823$export$8c5248f0cec8446d).stream([
            {
                type: 'page-transition',
                ID: transitionId
            }
        ]);
        //if the new editor metrics FF is on, start BM here only if the route is not edit page or if it is initial load, or an embedded editor.
        if (!(0, $gEtAQ.isEditPage)(match?.name) || transitionId === 0 || (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()) {
            (0, $jfrcs.startBrowserMetricsPageLoad)(match?.name ?? '', match?.ufoName, transitionId, match?.params.contentId);
            (0, $cbc8g.addUFOCustomData)({
                isDesktop: isDesktop
            });
            //If it is an embedded editor, start the BM right here since it does a full page relaod
            if ((0, $gEtAQ.isEditPage)(match?.name) && (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()) {
                (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EMBEDDED_EDIT_FMP_ACTION));
                (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EMBEDDED_EDIT_TTI_ACTION));
            }
        }
        // mark edit experience after transition to new route is complete
        (0, $192302f00fa5cc0a$export$8c3a984654991d73)(match?.name);
        (0, $5ZqQS.getMonitoringClient)().updateContext({
            pageName: match?.name ?? 'unknown',
            transitionId: transitionId,
            product: (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? 'embeddedConfluence' : 'confluence'
        });
    }, [
        sessionData,
        isDesktop
    ]);
    /**
   * Please note this App is a pure component.
   * This means following components will NOT re-render when user navigates.
   * Please be careful when adding any component that requires router information.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $852a6819cc9585c3$export$5f8d39834fd61797), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iV00x.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $008c5cd8cb4c3a95$export$4e5ff544be3ec09b), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dBmJE.ConnectedRouter), {
        history: $126a66f6ad21916b$var$browserHistory,
        context: (0, $cKyDI.ReactReduxContext)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kCeSx.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a5952995c9c756c1$export$355d4724e049b0df), {
        path: $126a66f6ad21916b$var$browserHistory.location.pathname
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $NAPtM.CreateDialogContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jHo7b.EditPageLoadingContextProvider), {
        nativeEditorComponentsPreloader: (0, $eXODy.nativeEditorComponentsPreloader),
        livePageComponentsPreloader: (0, $jwv1p.preloadLivePagesComponents)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8n9tL.RouteManager), {
        routeComponents: (0, $c6a4b2258628a516$export$4d9abfe5519d76c6),
        namedRoutes: (0, $64KID.namedRoutes),
        notFound: (0, $1cae7e3e681988dd$export$271f9f08425019c7),
        onInitialize: onRoute,
        onTransition: onRoute,
        onPreload: $126a66f6ad21916b$var$onPreloadRoute,
        routePolicy: routePolicy,
        setBrowserHistoryListener: (0, $hmRc4.setBrowserHistoryListener)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4QflW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $af5e1b3a6aa255af$export$38f39b921d5551c1), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cBuRD.NotificationLandedEvent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f6158bccfa436061$export$560b992b8a813cfb), null), (0, $9wGTI.fg)('post-office-new-confluence-router-listener') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $074500c4d6f25c0d$export$9f8d3084fd3d5fc0), null), !isLite && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bbp3G.Dialogs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $arkw6.LazyCreateDialogQueryRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3j0Cc.LazyCreateDialogBlueprintWizardRenderer), null)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bEdUx.HighlightActionsProviderForNav3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aiAUl.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8bd37d13e213b9df$export$529640d4682c2), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a409a9cb99445cc0$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $50adebb1075ad3af$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iJELi.ConnectSupport), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $25MM7.Flags), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e4d79357fba42d43$export$b2c5189af5b5e948), null), !isLite && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $le1Dp.CopySpacePermissionsForLegacyNewSpace), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d6d9861065b5c0df$export$2e2bcd8739ae039), null)))));
}
$126a66f6ad21916b$export$86fbec116b87613f.propTypes = {
    sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object.isRequired
};
function $126a66f6ad21916b$var$onPreloadRoute({ url: url }, previousMatch, options) {
    (0, $1f18aab14ff5333d$export$6ae808826fa58f6d)(url, true);
    if (options?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJS) return;
    (0, $e80763d537fd4542$export$57d895781a697848)(url, true, previousMatch, options);
    if (options?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJSAndCriticalData) return;
    (0, $e80763d537fd4542$export$6aefe8c2dfd7fe98)(url);
}


class $2652ca00a3968b71$export$2e2bcd8739ae039 extends (0, $gwFzn.Component) {
    getChildContext() {
        const { context: context } = this.props;
        const noop = ()=>{};
        return {
            insertCss: context.insertCss || noop
        };
    }
    render() {
        window.performance.mark('CFP-63.root-component-render');
        const { store: store, apolloClient: apolloClient, sessionData: sessionData } = this.props;
        return(// This is at the top because the root-level UnstatedProvider must not re-render
        // otherwise it will lose and recreate its instances
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Provider), {
            inject: [
                new (0, $3PXtn.BannerStateContainer)({
                    initialState: {
                        banners: window.__SSR_BANNERS__
                    }
                }),
                ...(0, $9wGTI.fg)('confluence_populate_content_state_from_ssr') ? [
                    new (0, $5zuN8.ContentStateStateContainer)(window.__SSR_CONTENT_STATE__)
                ] : [],
                ...(0, $9wGTI.fg)('confluence_populate_emoji_title_container_ssr') ? [
                    new (0, $ktUCG.EmojiTitleStateContainer)(window.__SSR_EMOJI_TITLE__)
                ] : []
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.ApolloProvider), {
            client: apolloClient
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cKyDI.Provider), {
            store: store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f7i8j.SessionDataContext).Provider, {
            value: sessionData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cryCi.Provider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1ytiN.SPAViewContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
            value: (0, $fGzMp.getExperienceTracker)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bLJr5.I18nProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $70d683a301b7be27$export$d900e4062895cd7c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3pfAb.default), {
            client: (0, $04e9M.getAnalyticsWebClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dEBDF.NavdexListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $97W74.EngagementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d5ap9.ConfluenceAnalyticsListener), {
            apolloClient: apolloClient
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fcF01.UpFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $685338b3d2a4b0a3$export$2e865a7ec399eb55), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fN9wG.XProductUserInviteProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $brNvA.ReattachCommentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $074500c4d6f25c0d$export$fb465b6e855c1e85), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $126a66f6ad21916b$export$86fbec116b87613f), {
            sessionData: sessionData
        }), !(0, $9wGTI.fg)('post-office-new-confluence-router-listener') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $074500c4d6f25c0d$export$9f8d3084fd3d5fc0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccd0dc06d2167081$export$f6564e60882bdf90), null))))))))))))))))))));
    }
}
$2652ca00a3968b71$export$2e2bcd8739ae039.displayName = 'Root';
$2652ca00a3968b71$export$2e2bcd8739ae039.childContextTypes = {
    /**
   * Handler for css injection in components.
   */ insertCss: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired
};
$2652ca00a3968b71$export$2e2bcd8739ae039.propTypes = {
    /**
   * Global store
   */ store: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object.isRequired,
    /**
   * Context including the css handler (It has different versions for client and server rendering)
   */ context: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).shape({
        insertCss: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func
    }),
    apolloClient: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object.isRequired,
    sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object.isRequired
};




var $7RVQB = parcelRequire("7RVQB");


var $04e9M = parcelRequire("04e9M");
const $64ffce910ca717e1$var$ErrorType = Object.freeze({
    REMOVE_CHILD_ERROR: 'removeChildError',
    INSERT_BEFORE_ERROR: 'insertBeforeError'
});
function $64ffce910ca717e1$export$d1215808cd22e615() {
    if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function(child) {
            if (child.parentNode !== this) {
                if (console) {
                    console.error('Cannot remove a child from a different parent', child, this);
                    $64ffce910ca717e1$var$sendRemoveChildErrorAnalyticsEvent(child);
                }
                return child;
            }
            return originalRemoveChild.apply(this, arguments);
        };
        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function(newNode, referenceNode) {
            if (referenceNode && referenceNode.parentNode !== this) {
                if (console) {
                    console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
                    $64ffce910ca717e1$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode);
                }
                return newNode;
            }
            return originalInsertBefore.apply(this, arguments);
        };
    }
}
/**
 * Send an analytics event when a 'removeChild' error occurs. This function helps to track the occurrence of this suppressed error.
 * @param {Node} childNode - The node that is attempted to be removed.
 */ function $64ffce910ca717e1$var$sendRemoveChildErrorAnalyticsEvent(childNode) {
    const nodeData = {
        nodeToBeRemoved: $64ffce910ca717e1$var$extractNodeData(childNode)
    };
    $64ffce910ca717e1$var$sendAnalyticsEvent($64ffce910ca717e1$var$ErrorType.REMOVE_CHILD_ERROR, nodeData);
}
/**
 * Send an analytics event when an 'insertBefore' error occurs.  This function helps to track the occurrence of this suppressed error.
 * @param {Node} referenceNode - The existing node in the DOM tree. The new node is intended to be inserted before this node.
 * @param {Node} newNode - The new node that is attempted to be inserted.
 */ function $64ffce910ca717e1$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode) {
    const nodeData = {
        newNode: $64ffce910ca717e1$var$extractNodeData(newNode),
        referenceNode: $64ffce910ca717e1$var$extractNodeData(referenceNode)
    };
    $64ffce910ca717e1$var$sendAnalyticsEvent($64ffce910ca717e1$var$ErrorType.INSERT_BEFORE_ERROR, nodeData);
}
function $64ffce910ca717e1$var$sendAnalyticsEvent(action, nodeData) {
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            source: 'confluenceFrontendServer',
            actionSubject: 'domManipulationError',
            action: 'error',
            attributes: {
                suppressedError: action,
                ...nodeData
            }
        });
    });
}
function $64ffce910ca717e1$var$extractNodeData(node) {
    if (!node) return {};
    return {
        nodeName: node.nodeName,
        parentElementNodeName: node.parentElement?.nodeName,
        isConnected: node.isConnected
    };
}



var $feRZU = parcelRequire("feRZU");

var $7LuKf = parcelRequire("7LuKf");
if (window?.performance) {
    window.performance.mark('CFP-63.app');
    window.performance.mark('navigation-fmp.NavigationFMP.start');
    window.performance.mark('side-navigation-fmp.SideNavigationFMP.start');
}
const $67148092cd3543c6$var$EMOTION_CACHE_KEY = 'cc';
const $67148092cd3543c6$var$initializeVCObserver = (rootNode)=>{
    const vcObserver = (0, $2DIgf.getVCObserver)();
    vcObserver.setSSRElement(rootNode);
    vcObserver.setReactRootRenderStart();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            vcObserver.setReactRootRenderStop();
        });
    });
};

(async function() {
    /**
   * setupUFOGlobalErrorHandler MUST be the first thing executed before any rendering operations.
   * This ensures we catch and track any errors that occur during the app's initialization,
   * including async operations and React rendering. Moving this call later would risk missing
   * early errors.
   * it provides ufo:errors:globalCount is the count of all errors which occurred on the client all up
   */ (0, $5QpZa.default)();
    const isUFOInitialized = (0, $57685508af60afdd$export$7c8267660020a63e)(window.__SSR_INIT_UFO_DATA__);
    // When page is being refreshed or redirected from server we run into a condition when redirect
    // url requested from the server and SPA (which resources are loaded via early HTML flush) is
    // being initialized at the same time. We don't want to waste browser resources/make network
    // calls when page is going to be redirected anyway, so bail out early.
    if (document.querySelector(`meta[http-equiv="Refresh"]`)) return;
    // collect SSR placeholder dimensions at the start of initialization
    // to bypass capturing of intermediate loading states in dimensions check
    if (window.__DELAY_COLLECT_SSR_PLACEHOLDERS__) (0, $5nRL1.collectSSRPlaceholderDimensions)(document, window);
    const rootNode = document.getElementById('confluence-ui');
    if (window.__HYDRATABLE__) // remove nonce attributes from style tags to support react hydration
    document.querySelectorAll('style[nonce]').forEach((styleTag)=>{
        styleTag.removeAttribute('nonce');
    });
    const client = (0, $hp2SH.getApolloClient)();
    const aggClient = (0, $gKr8t.getAGGClient)();
    let initializeEmbeddedConfluencePromise;
    if ((0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()) initializeEmbeddedConfluencePromise = (await (parcelRequire("3A8WH"))).initialize();
    let browserNotSupported;
    // Must call this before any browser-helper functions, to ensure user agent has been set first
    (0, $cMvQV.setUserAgent)();
    // Bypass browser compatibility checks in the case of the Confluence native mobile app;
    // it is the responsibility of the mobile app to ensure the rendering of Confluence
    const shouldCheckBrowserCompatibility = !(0, $cMvQV.isNativeMobile)();
    if (shouldCheckBrowserCompatibility) {
        browserNotSupported = (0, $2DVQX.coreBrowserNotSupported)();
        if (browserNotSupported) // eslint-disable-next-line react/no-deprecated
        return void (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9j59h.BrowserNotSupportedLoader), null), rootNode);
    }
    const sessionDataPromise = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_SESSION_DATA, async ()=>{
        await (0, $jLfE2.initializePreloaderFnContext)();
        (0, $e80763d537fd4542$export$bd8e570400e2d126)();
        // HOT-89887: server is giving 403 errors on an expired token, causing Apollo
        // to throw. Uncaught, the React app wouldn't start, and can't acknowledge
        // messages from the service worker; thus the service worker can't trigger a
        // redirect to the login page; thus user gets stuck at the Confluence logo
        // screen. By catching here, we can at least bootstrap the app and proceed to
        // the redirect.
        //
        // https://jira.atlassian.com/browse/CONFCLOUD-71974: IP allowlisting is
        // causing a 403 scenario similar to HOT-89887 above.
        return (0, $ge2sX.getSessionData)().then((0, $feRZU.postProcessSessionData), (0, $iC5L0.getEmptySessionData));
    });
    // Here we are reading from a value that injected by Monolith in DOM to get the locale.
    // We should really read it from session data. However we can't because we will need to wait for session data to come back.
    const translationPromise = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_TRANSLATION, ()=>(0, $bLJr5.loadTranslation)((0, $7RVQB.lazyLanguage)));
    // Preload loadable id defined in the global __LOADABLE__ array
    // If the page is rendered by React SSR service this promise will be blocking.
    // On normal SPA it is not blocking.
    const preloadLoadablePromise = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_LOADABLE, ()=>(0, $3GQl6.preloadLoadable)());
    // Captures the media sources in the current view port as early as possible while SSR response is displaying.
    (0, $2bffd0a48908e22c$export$daa1e83127b2f677)();
    // Preload components/JS chunks as early as possible, when entry point is loaded and
    // route is known, so they'll be ready by the moment when they're actually used.
    (0, $1f18aab14ff5333d$export$6ae808826fa58f6d)(window.location.toString(), false);
    Promise.all([
        sessionDataPromise,
        translationPromise,
        preloadLoadablePromise,
        initializeEmbeddedConfluencePromise
    ]).then(([sessionData])=>{
        if (!(0, $9wGTI.fg)('defer_server_placeholder_collection')) {
            // Initialize Loadable by reading server markup to be used as loadable components' placeholders.
            (0, $ezH4I.initLoadablePlaceholders)();
            // Scan loaded document to collect DOM elements for legacy macros.
            (0, $KcDWk.collectSSRedLegacyMacros)();
        }
        // If cloudId is not present in sessionData, we can assume sessionData did not load successfully. Instead of
        // allowing the app to render the red error message, we can render our simplified Error App that fires key analytics
        // events and shows a more pleasing error UI.
        if (sessionData.cloudId === '' && !(0, $9wGTI.fg)('confluence_fe_error_app_disabled')) {
            const root = (0, $dkxAr.createRoot)(rootNode);
            root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $94ecb5e99e218b76$export$b602c35a55c29946), {
                entryPoint: "confluence-frontend"
            }));
            return;
        }
        // Initialize VCObserver before any rendering logic
        if (rootNode && (0, $9wGTI.fg)('confluence_frontend_vc_observer_initialization')) $67148092cd3543c6$var$initializeVCObserver(rootNode);
        (0, $ae045ed661bc53ec$export$efcab8bd082cbc1f)(sessionData);
        if (!isUFOInitialized) (0, $57685508af60afdd$export$af995ee1d7017fea)(sessionData);
        // Redux store
        const store = (0, $3Tw8v.default)();
        (0, $9F7Qb.subscribe)(store);
        // When __APOLLO_STATE__ is available in the global variable it means we are bootstrapping SPA over a SSR rendered page.
        // __APOLLO_STATE__ is the serialized apollo cache that is enough to render everything that has already preloaded in preloadLoadable.
        // We are disabling network so on the first render so the components will read from cache only not firing queries again.
        // See https://github.com/apollographql/apollo-client/issues/4814
        if (window['__APOLLO_STATE__']) client.disableNetworkFetches = true;
        if (window['__APOLLO_AGG_STATE__']) aggClient.disableNetworkFetches = true;
        // Workaround for this google translate problem https://github.com/facebook/react/issues/11538#issuecomment-417504600
        // which is causing this issue https://product-fabric.atlassian.net/browse/CCP-2409, affecting view page reliability
        (0, $64ffce910ca717e1$export$d1215808cd22e615)();
        // code for regression drill logic. Systematic way of indentifying and tracking performance regressions in web pages
        // will be used to test out criterion, a new perfomacne tracking software
        // for more info visit https://hello.atlassian.net/wiki/spaces/CVMAI/pages/3761808800/Regression+Drill+Plan
        const delayValueForRegression = (0, $4VJDS.default).getNumber('confluence_frontend_preprod_slow', 0);
        const cache = (0, $9i0Rp.default)({
            key: $67148092cd3543c6$var$EMOTION_CACHE_KEY
        });
        const App = (0, $9wGTI.fg)('confluence_frontend_remove_emotion_cache') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hnvzE.default), {
            name: "confluence-root"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d847caf3274d14b7$export$f3385cdc6645f7e3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $799291abed68198f$export$640957ec8f6fdf34), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2652ca00a3968b71$export$2e2bcd8739ae039), {
            store: store,
            context: {
                insertCss: (styles)=>styles._insertCss()
            },
            apolloClient: client,
            sessionData: sessionData
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8714b2bec379cfae$export$bd148a921cde8da1), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hnvzE.default), {
            name: "confluence-root"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d847caf3274d14b7$export$f3385cdc6645f7e3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ja596.C), {
            value: cache
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $799291abed68198f$export$640957ec8f6fdf34), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2652ca00a3968b71$export$2e2bcd8739ae039), {
            store: store,
            context: {
                insertCss: (styles)=>styles._insertCss()
            },
            apolloClient: client,
            sessionData: sessionData
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8714b2bec379cfae$export$bd148a921cde8da1), null));
        const renderCallback = ()=>{
            if (window['__APOLLO_STATE__']) client.disableNetworkFetches = false;
            if (window['__APOLLO_AGG_STATE__']) aggClient.disableNetworkFetches = false;
            (0, $7LuKf.initialization)(sessionData);
            // Inside of cleanUpLoadablePlaceholders function, it delayed cleaning up loadable placeholders.
            (0, $ezH4I.cleanUpLoadablePlaceholders)();
            (0, $KcDWk.releaseUnusedSSRedLegacyMacrosWithDelay)();
            const userAgentParser = new (0, (/*@__PURE__*/$parcel$interopDefault($7eXBl)))(navigator.userAgent);
            const { name: browserName, version: browserVersion } = userAgentParser.getBrowser();
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsClient)=>{
                // GASv3 analytics client is initialized inside of initialization() so we
                // must call the analytics client after that function has been called.
                if (shouldCheckBrowserCompatibility) analyticsClient.sendOperationalEvent({
                    source: 'confluenceRoot',
                    action: 'executed',
                    actionSubject: 'browserRuntimeCheck',
                    attributes: {
                        failedCoreBrowserCheck: browserNotSupported,
                        browserName: browserName,
                        browserVersion: browserVersion
                    }
                });
                (0, $fcc81ac864e755d2$export$76f12cc80b7fd2f3)(analyticsClient);
            });
            if (rootNode && !(0, $9wGTI.fg)('confluence_frontend_vc_observer_initialization')) $67148092cd3543c6$var$initializeVCObserver(rootNode);
        };
        //adding a call to the flag to fix for ssr FF statsig exposures not getting captured
        (0, $9wGTI.fg)('confluence_ssr_load_after_paint_loadables_as_paint');
        (0, $9wGTI.fg)('confluence_ssr_enable_hydration');
        (0, $9wGTI.fg)('confluence_ssr_enable_hydration_home');
        (0, $9wGTI.fg)('confluence_createroot_in_full_cycle_render');
        (0, $9wGTI.fg)('confluence_ssr_enable_hydration_space_overview');
        const urlParams = new URLSearchParams(window?.location?.search);
        const legacyModeParam = urlParams.has('LEGACY_MODE', '1');
        if (!legacyModeParam && (0, $9wGTI.fg)('confluence_frontend_use_modern_rendering_engine')) {
            const ConcurrentApp = ()=>{
                (0, $gwFzn.useEffect)(()=>{
                    renderCallback();
                }, []);
                return App;
            };
            if (window['__HYDRATABLE__']) {
                window['__HYDRATION_FAILED__'] = false;
                (0, $dkxAr.hydrateRoot)(rootNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ConcurrentApp, null), {
                    onRecoverableError: (error)=>{
                        if (window['__HYDRATION_ERRORS__'] && error?.message) window['__HYDRATION_ERRORS__'].push({
                            type: 'ERROR_MESSAGES_FROM_REACT',
                            msg: error.message
                        });
                        const { hydrationFailed: hydrationFailed, friendlyMessage: friendlyMessage, docLink: docLink } = (0, $dtDUi.matchHydrationError)(error);
                        if (hydrationFailed) window['__HYDRATION_FAILED__'] = true;
                    }
                });
            } else {
                const concurrentRoot = (0, $dkxAr.createRoot)(rootNode);
                concurrentRoot.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ConcurrentApp, null));
            }
        } else {
            // eslint-disable-next-line react/no-deprecated
            const renderFn = window['__HYDRATABLE__'] ? (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).hydrate : (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).render;
            renderFn(App, rootNode, renderCallback);
        }
    });
})();


//# sourceMappingURL=dashboard-spa-container-jquery3.932905de.js.map
